import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: any;
  /** The `Decimal` scalar type represents a decimal floating-point number. */
  Decimal: any;
  /** The `LocalDate` scalar type represents a ISO date string, represented as UTF-8 character sequences YYYY-MM-DD. The scalar follows the specification defined in RFC3339 */
  LocalDate: any;
};

export type AccommodationMaintenanceLogFilterInput = {
  and?: InputMaybe<Array<AccommodationMaintenanceLogFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  investment?: InputMaybe<AccommodationWorkInvestmentFilterInput>;
  investmentId?: InputMaybe<IntOperationFilterInput>;
  logRooms?: InputMaybe<ListFilterInputTypeOfAccommodationMaintenanceLogRoomFilterInput>;
  maintenanceType?: InputMaybe<AccommodationMaintenanceTypeFilterInput>;
  maintenanceTypeId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<AccommodationMaintenanceLogFilterInput>>;
  paidType?: InputMaybe<PaidTypesOperationFilterInput>;
  work?: InputMaybe<AccommodationWorkMaintenanceFilterInput>;
  workId?: InputMaybe<IntOperationFilterInput>;
};

export type AccommodationMaintenanceLogInput = {
  id: Scalars['Int'];
  investmentId?: InputMaybe<Scalars['Int']>;
  logRooms?: InputMaybe<Array<AccommodationMaintenanceLogRoomInput>>;
  maintenanceTypeId: Scalars['Int'];
  paidType: PaidTypes;
  workId: Scalars['Int'];
};

export type AccommodationMaintenanceLogRoomFilterInput = {
  and?: InputMaybe<Array<AccommodationMaintenanceLogRoomFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  log?: InputMaybe<AccommodationMaintenanceLogFilterInput>;
  logId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<AccommodationMaintenanceLogRoomFilterInput>>;
  room?: InputMaybe<RoomFilterInput>;
  roomId?: InputMaybe<IntOperationFilterInput>;
};

export type AccommodationMaintenanceLogRoomInput = {
  id: Scalars['Int'];
  log?: InputMaybe<AccommodationMaintenanceLogInput>;
  logId: Scalars['Int'];
  room?: InputMaybe<RoomInput>;
  roomId: Scalars['Int'];
};

export type AccommodationMaintenanceLogRoomSortInput = {
  id?: InputMaybe<SortEnumType>;
  log?: InputMaybe<AccommodationMaintenanceLogSortInput>;
  logId?: InputMaybe<SortEnumType>;
  room?: InputMaybe<RoomSortInput>;
  roomId?: InputMaybe<SortEnumType>;
};

export type AccommodationMaintenanceLogSortInput = {
  id?: InputMaybe<SortEnumType>;
  investment?: InputMaybe<AccommodationWorkInvestmentSortInput>;
  investmentId?: InputMaybe<SortEnumType>;
  logRooms?: InputMaybe<ListSortInputTypeAccommodationMaintenanceLogRoom>;
  maintenanceType?: InputMaybe<AccommodationMaintenanceTypeSortInput>;
  maintenanceTypeId?: InputMaybe<SortEnumType>;
  paidType?: InputMaybe<SortEnumType>;
  work?: InputMaybe<AccommodationWorkMaintenanceSortInput>;
  workId?: InputMaybe<SortEnumType>;
};

export type AccommodationMaintenanceTypeFilterInput = {
  and?: InputMaybe<Array<AccommodationMaintenanceTypeFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  logs?: InputMaybe<ListFilterInputTypeOfAccommodationMaintenanceLogFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AccommodationMaintenanceTypeFilterInput>>;
};

export type AccommodationMaintenanceTypeInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type AccommodationMaintenanceTypeSortInput = {
  id?: InputMaybe<SortEnumType>;
  logs?: InputMaybe<ListSortInputTypeAccommodationMaintenanceLog>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
};

export type AccommodationWorkFilterInput = {
  and?: InputMaybe<Array<AccommodationWorkFilterInput>>;
  category?: InputMaybe<WorkCategoriesOperationFilterInput>;
  endDate?: InputMaybe<LocalDateOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AccommodationWorkFilterInput>>;
  season?: InputMaybe<SeasonFilterInput>;
  seasonId?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<LocalDateOperationFilterInput>;
  type?: InputMaybe<AccommodationWorkTypesOperationFilterInput>;
  workers?: InputMaybe<ListFilterInputTypeOfWorkerFilterInput>;
};

export type AccommodationWorkInvestmentFilterInput = {
  and?: InputMaybe<Array<AccommodationWorkInvestmentFilterInput>>;
  category?: InputMaybe<WorkCategoriesOperationFilterInput>;
  endDate?: InputMaybe<LocalDateOperationFilterInput>;
  expense?: InputMaybe<ExpenseFilterInput>;
  expenseId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  investmentType?: InputMaybe<InvestmentTypesOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AccommodationWorkInvestmentFilterInput>>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  season?: InputMaybe<SeasonFilterInput>;
  seasonId?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<LocalDateOperationFilterInput>;
  total?: InputMaybe<DecimalOperationFilterInput>;
  type?: InputMaybe<AccommodationWorkTypesOperationFilterInput>;
  unit?: InputMaybe<UnitsOperationFilterInput>;
  unitPrice?: InputMaybe<DecimalOperationFilterInput>;
  workers?: InputMaybe<ListFilterInputTypeOfWorkerFilterInput>;
};

export type AccommodationWorkInvestmentInput = {
  endDate?: InputMaybe<Scalars['LocalDate']>;
  id: Scalars['Int'];
  investmentType: InvestmentTypes;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Decimal'];
  seasonId: Scalars['Int'];
  startDate: Scalars['LocalDate'];
  total: Scalars['Decimal'];
  unit: Units;
  unitPrice: Scalars['Decimal'];
  workers: Array<WorkerInput>;
};

export type AccommodationWorkInvestmentSortInput = {
  category?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  expense?: InputMaybe<ExpenseSortInput>;
  expenseId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  investmentType?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  season?: InputMaybe<SeasonSortInput>;
  seasonId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  total?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  unit?: InputMaybe<SortEnumType>;
  unitPrice?: InputMaybe<SortEnumType>;
  workers?: InputMaybe<ListSortInputTypeWorker>;
};

export type AccommodationWorkMaintenanceFilterInput = {
  and?: InputMaybe<Array<AccommodationWorkMaintenanceFilterInput>>;
  category?: InputMaybe<WorkCategoriesOperationFilterInput>;
  endDate?: InputMaybe<LocalDateOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  logs?: InputMaybe<ListFilterInputTypeOfAccommodationMaintenanceLogFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AccommodationWorkMaintenanceFilterInput>>;
  season?: InputMaybe<SeasonFilterInput>;
  seasonId?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<LocalDateOperationFilterInput>;
  type?: InputMaybe<AccommodationWorkTypesOperationFilterInput>;
  workers?: InputMaybe<ListFilterInputTypeOfWorkerFilterInput>;
};

export type AccommodationWorkMaintenanceInput = {
  endDate?: InputMaybe<Scalars['LocalDate']>;
  id: Scalars['Int'];
  logs?: InputMaybe<Array<AccommodationMaintenanceLogInput>>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  seasonId: Scalars['Int'];
  startDate: Scalars['LocalDate'];
  workers: Array<WorkerInput>;
};

export type AccommodationWorkMaintenanceSortInput = {
  category?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  logs?: InputMaybe<ListSortInputTypeAccommodationMaintenanceLog>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  season?: InputMaybe<SeasonSortInput>;
  seasonId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  workers?: InputMaybe<ListSortInputTypeWorker>;
};

export type AccommodationWorkSortInput = {
  category?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  season?: InputMaybe<SeasonSortInput>;
  seasonId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  workers?: InputMaybe<ListSortInputTypeWorker>;
};

export enum AccommodationWorkTypes {
  Cleaning = 'CLEANING',
  Investment = 'INVESTMENT',
  Maintenance = 'MAINTENANCE',
  Other = 'OTHER'
}

export type AccommodationWorkTypesOperationFilterInput = {
  eq?: InputMaybe<AccommodationWorkTypes>;
  in?: InputMaybe<Array<AccommodationWorkTypes>>;
  neq?: InputMaybe<AccommodationWorkTypes>;
  nin?: InputMaybe<Array<AccommodationWorkTypes>>;
};

export type AgricultureWorkFilterInput = {
  and?: InputMaybe<Array<AgricultureWorkFilterInput>>;
  category?: InputMaybe<WorkCategoriesOperationFilterInput>;
  endDate?: InputMaybe<LocalDateOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AgricultureWorkFilterInput>>;
  season?: InputMaybe<SeasonFilterInput>;
  seasonId?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<LocalDateOperationFilterInput>;
  type?: InputMaybe<AgricultureWorkTypesOperationFilterInput>;
  workers?: InputMaybe<ListFilterInputTypeOfWorkerFilterInput>;
};

export type AgricultureWorkInvestmentFilterInput = {
  and?: InputMaybe<Array<AgricultureWorkInvestmentFilterInput>>;
  category?: InputMaybe<WorkCategoriesOperationFilterInput>;
  endDate?: InputMaybe<LocalDateOperationFilterInput>;
  expense?: InputMaybe<ExpenseFilterInput>;
  expenseId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  investmentType?: InputMaybe<InvestmentTypesOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AgricultureWorkInvestmentFilterInput>>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  season?: InputMaybe<SeasonFilterInput>;
  seasonId?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<LocalDateOperationFilterInput>;
  total?: InputMaybe<DecimalOperationFilterInput>;
  type?: InputMaybe<AgricultureWorkTypesOperationFilterInput>;
  unit?: InputMaybe<UnitsOperationFilterInput>;
  unitPrice?: InputMaybe<DecimalOperationFilterInput>;
  workers?: InputMaybe<ListFilterInputTypeOfWorkerFilterInput>;
};

export type AgricultureWorkInvestmentInput = {
  endDate?: InputMaybe<Scalars['LocalDate']>;
  id: Scalars['Int'];
  investmentType: InvestmentTypes;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Decimal'];
  seasonId: Scalars['Int'];
  startDate: Scalars['LocalDate'];
  total: Scalars['Decimal'];
  unit: Units;
  unitPrice: Scalars['Decimal'];
  workers: Array<WorkerInput>;
};

export type AgricultureWorkInvestmentSortInput = {
  category?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  expense?: InputMaybe<ExpenseSortInput>;
  expenseId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  investmentType?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  season?: InputMaybe<SeasonSortInput>;
  seasonId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  total?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  unit?: InputMaybe<SortEnumType>;
  unitPrice?: InputMaybe<SortEnumType>;
  workers?: InputMaybe<ListSortInputTypeWorker>;
};

export type AgricultureWorkSortInput = {
  category?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  season?: InputMaybe<SeasonSortInput>;
  seasonId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  workers?: InputMaybe<ListSortInputTypeWorker>;
};

export type AgricultureWorkTemplateFilterInput = {
  and?: InputMaybe<Array<AgricultureWorkTemplateFilterInput>>;
  category?: InputMaybe<WorkCategoriesOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AgricultureWorkTemplateFilterInput>>;
  season?: InputMaybe<SeasonFilterInput>;
  seasonId?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  type?: InputMaybe<AgricultureWorkTypesOperationFilterInput>;
  workers?: InputMaybe<ListFilterInputTypeOfWorkerTemplateFilterInput>;
};

export type AgricultureWorkTemplateSortInput = {
  category?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  season?: InputMaybe<SeasonSortInput>;
  seasonId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  workers?: InputMaybe<ListSortInputTypeWorkerTemplate>;
};

export enum AgricultureWorkTypes {
  Harvest = 'HARVEST',
  Investment = 'INVESTMENT',
  Maintenance = 'MAINTENANCE'
}

export type AgricultureWorkTypesOperationFilterInput = {
  eq?: InputMaybe<AgricultureWorkTypes>;
  in?: InputMaybe<Array<AgricultureWorkTypes>>;
  neq?: InputMaybe<AgricultureWorkTypes>;
  nin?: InputMaybe<Array<AgricultureWorkTypes>>;
};

export type ApiTokenFilterInput = {
  and?: InputMaybe<Array<ApiTokenFilterInput>>;
  createdBy?: InputMaybe<UserFilterInput>;
  createdById?: InputMaybe<IntOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  expiredAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ApiTokenFilterInput>>;
  token?: InputMaybe<StringOperationFilterInput>;
  updatedBy?: InputMaybe<UserFilterInput>;
  updatedById?: InputMaybe<IntOperationFilterInput>;
};

export type ApiTokenSortInput = {
  createdBy?: InputMaybe<UserSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  expiredAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  token?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<UserSortInput>;
  updatedById?: InputMaybe<SortEnumType>;
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

export enum AuthProvider {
  Google = 'GOOGLE',
  Microsoft = 'MICROSOFT'
}

export type AuthProviderOperationFilterInput = {
  eq?: InputMaybe<AuthProvider>;
  in?: InputMaybe<Array<AuthProvider>>;
  neq?: InputMaybe<AuthProvider>;
  nin?: InputMaybe<Array<AuthProvider>>;
};

export type BookingAdditionalChargeFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<BookingAdditionalChargeFilterInput>>;
  booking?: InputMaybe<BookingFilterInput>;
  bookingId?: InputMaybe<IntOperationFilterInput>;
  date?: InputMaybe<LocalDateOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isIncome?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BookingAdditionalChargeFilterInput>>;
};

export type BookingAdditionalChargeInput = {
  amount: Scalars['Decimal'];
  bookingId: Scalars['Int'];
  date: Scalars['LocalDate'];
  id: Scalars['Int'];
  isIncome: Scalars['Boolean'];
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
};

export type BookingAdditionalChargeListNumberFunctionPropertyItemSortInputType = {
  amount?: InputMaybe<SortEnumType>;
  booking?: InputMaybe<BookingListObjectPropertyItemSortInputType>;
};

export type BookingAdditionalChargeSortInput = {
  amount?: InputMaybe<SortEnumType>;
  booking?: InputMaybe<BookingSortInput>;
  bookingId?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isIncome?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
};

export enum BookingAdditionalChargesCalculationTypes {
  Fix = 'FIX',
  Percentage = 'PERCENTAGE',
  PerNight = 'PER_NIGHT',
  PerNightPerPerson = 'PER_NIGHT_PER_PERSON',
  PerPerson = 'PER_PERSON'
}

export type BookingAdditionalChargesTemplateFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<BookingAdditionalChargesTemplateFilterInput>>;
  calculationType?: InputMaybe<CalculationTypesOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isIncome?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BookingAdditionalChargesTemplateFilterInput>>;
};

export type BookingAdditionalChargesTemplateInput = {
  amount: Scalars['Decimal'];
  calculationType: BookingAdditionalChargesCalculationTypes;
  id: Scalars['Int'];
  isIncome: Scalars['Boolean'];
  name: Scalars['String'];
};

export type BookingAdditionalChargesTemplateSortInput = {
  amount?: InputMaybe<SortEnumType>;
  calculationType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isIncome?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
};

export type BookingAttachmentFilterInput = {
  and?: InputMaybe<Array<BookingAttachmentFilterInput>>;
  booking?: InputMaybe<BookingFilterInput>;
  bookingId?: InputMaybe<IntOperationFilterInput>;
  contentType?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BookingAttachmentFilterInput>>;
};

export type BookingAttachmentSortInput = {
  booking?: InputMaybe<BookingSortInput>;
  bookingId?: InputMaybe<SortEnumType>;
  contentType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
};

export type BookingBookingChannelFilterInput = {
  and?: InputMaybe<Array<BookingBookingChannelFilterInput>>;
  booking?: InputMaybe<BookingFilterInput>;
  bookingId?: InputMaybe<IntOperationFilterInput>;
  channel?: InputMaybe<BookingChannelFilterInput>;
  channelId?: InputMaybe<IntOperationFilterInput>;
  externalReference?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isCancelled?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<BookingBookingChannelFilterInput>>;
  total?: InputMaybe<DecimalOperationFilterInput>;
};

export type BookingBookingChannelListNumberFunctionPropertyItemSortInputType = {
  booking?: InputMaybe<BookingListObjectPropertyItemSortInputType>;
  channel?: InputMaybe<BookingChannelListObjectPropertyItemSortInputType>;
  total?: InputMaybe<SortEnumType>;
};

export type BookingBookingChannelListObjectPropertyItemSortInputType = {
  booking?: InputMaybe<BookingListObjectPropertyItemSortInputType>;
  channel?: InputMaybe<BookingChannelListObjectPropertyItemSortInputType>;
  total?: InputMaybe<SortEnumType>;
};

export type BookingBookingChannelSortInput = {
  booking?: InputMaybe<BookingSortInput>;
  bookingId?: InputMaybe<SortEnumType>;
  channel?: InputMaybe<BookingChannelSortInput>;
  channelId?: InputMaybe<SortEnumType>;
  externalReference?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isCancelled?: InputMaybe<SortEnumType>;
  total?: InputMaybe<SortEnumType>;
};

export type BookingChannelFilterInput = {
  and?: InputMaybe<Array<BookingChannelFilterInput>>;
  bookings?: InputMaybe<ListFilterInputTypeOfBookingBookingChannelFilterInput>;
  color?: InputMaybe<StringOperationFilterInput>;
  commission?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BookingChannelFilterInput>>;
  roomTypeDefultPrices?: InputMaybe<ListFilterInputTypeOfRoomTypeChannelDefultPriceFilterInput>;
  type?: InputMaybe<CommissionTypesOperationFilterInput>;
};

export type BookingChannelInput = {
  color?: InputMaybe<Scalars['String']>;
  commission: Scalars['Decimal'];
  id: Scalars['Int'];
  name: Scalars['String'];
  roomTypeDefultPrices?: InputMaybe<Array<InputMaybe<RoomTypeChannelDefultPriceInput>>>;
  type: CommissionTypes;
};

export type BookingChannelListObjectPropertyItemSortInputType = {
  bookings?: InputMaybe<ListSortInputTypeBookingBookingChannel>;
  commission?: InputMaybe<SortEnumType>;
  roomTypeDefultPrices?: InputMaybe<ListSortInputTypeRoomTypeChannelDefultPrice>;
};

export type BookingChannelSortInput = {
  bookings?: InputMaybe<ListSortInputTypeBookingBookingChannel>;
  color?: InputMaybe<SortEnumType>;
  commission?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  roomTypeDefultPrices?: InputMaybe<ListSortInputTypeRoomTypeChannelDefultPrice>;
  type?: InputMaybe<SortEnumType>;
};

export type BookingDetailsFilterInput = {
  and?: InputMaybe<Array<BookingDetailsFilterInput>>;
  booking?: InputMaybe<BookingFilterInput>;
  bookingId?: InputMaybe<IntOperationFilterInput>;
  date?: InputMaybe<LocalDateOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<BookingDetailsFilterInput>>;
  price?: InputMaybe<DecimalOperationFilterInput>;
  room?: InputMaybe<RoomFilterInput>;
  roomId?: InputMaybe<IntOperationFilterInput>;
};

export type BookingDetailsInput = {
  date: Scalars['LocalDate'];
  id: Scalars['Int'];
  price: Scalars['Decimal'];
  roomId: Scalars['Int'];
};

export type BookingDetailsListNumberFunctionPropertyItemSortInputType = {
  booking?: InputMaybe<BookingListObjectPropertyItemSortInputType>;
  price?: InputMaybe<SortEnumType>;
  room?: InputMaybe<RoomListObjectPropertyItemSortInputType>;
};

export type BookingDetailsSortInput = {
  booking?: InputMaybe<BookingSortInput>;
  bookingId?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  price?: InputMaybe<SortEnumType>;
  room?: InputMaybe<RoomSortInput>;
  roomId?: InputMaybe<SortEnumType>;
};

export type BookingEventFilterInput = {
  and?: InputMaybe<Array<BookingEventFilterInput>>;
  assignee?: InputMaybe<PersonFilterInput>;
  assigneeId?: InputMaybe<IntOperationFilterInput>;
  booking?: InputMaybe<BookingFilterInput>;
  bookingId?: InputMaybe<IntOperationFilterInput>;
  date?: InputMaybe<LocalDateOperationFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  insertType?: InputMaybe<InsertTypesOperationFilterInput>;
  isDone?: InputMaybe<BooleanOperationFilterInput>;
  logs?: InputMaybe<ListFilterInputTypeOfBookingEventLogFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BookingEventFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
};

export type BookingEventListNumberFunctionPropertyItemSortInputType = {
  assignee?: InputMaybe<PersonListObjectPropertyItemSortInputType>;
  booking?: InputMaybe<BookingListObjectPropertyItemSortInputType>;
  logs?: InputMaybe<ListSortInputTypeBookingEventLog>;
  order?: InputMaybe<SortEnumType>;
};

export type BookingEventListObjectPropertyItemSortInputType = {
  assignee?: InputMaybe<PersonListObjectPropertyItemSortInputType>;
  booking?: InputMaybe<BookingListObjectPropertyItemSortInputType>;
  logs?: InputMaybe<ListSortInputTypeBookingEventLog>;
  order?: InputMaybe<SortEnumType>;
};

export type BookingEventLogFilterInput = {
  and?: InputMaybe<Array<BookingEventLogFilterInput>>;
  assignee?: InputMaybe<PersonFilterInput>;
  assigneeId?: InputMaybe<IntOperationFilterInput>;
  author?: InputMaybe<UserFilterInput>;
  authorId?: InputMaybe<IntOperationFilterInput>;
  booking?: InputMaybe<BookingFilterInput>;
  bookingId?: InputMaybe<IntOperationFilterInput>;
  changeDate?: InputMaybe<DateTimeOperationFilterInput>;
  date?: InputMaybe<LocalDateOperationFilterInput>;
  entity?: InputMaybe<BookingEventFilterInput>;
  entityId?: InputMaybe<IntOperationFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  insertType?: InputMaybe<InsertTypesOperationFilterInput>;
  isDone?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BookingEventLogFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
};

export type BookingEventLogListNumberFunctionPropertyItemSortInputType = {
  assignee?: InputMaybe<PersonListObjectPropertyItemSortInputType>;
  booking?: InputMaybe<BookingListObjectPropertyItemSortInputType>;
  entity?: InputMaybe<BookingEventListObjectPropertyItemSortInputType>;
  order?: InputMaybe<SortEnumType>;
};

export type BookingEventLogSortInput = {
  assignee?: InputMaybe<PersonSortInput>;
  assigneeId?: InputMaybe<SortEnumType>;
  author?: InputMaybe<UserSortInput>;
  authorId?: InputMaybe<SortEnumType>;
  booking?: InputMaybe<BookingSortInput>;
  bookingId?: InputMaybe<SortEnumType>;
  changeDate?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  entity?: InputMaybe<BookingEventSortInput>;
  entityId?: InputMaybe<SortEnumType>;
  group?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  insertType?: InputMaybe<SortEnumType>;
  isDone?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
};

export type BookingEventSortInput = {
  assignee?: InputMaybe<PersonSortInput>;
  assigneeId?: InputMaybe<SortEnumType>;
  booking?: InputMaybe<BookingSortInput>;
  bookingId?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  group?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  insertType?: InputMaybe<SortEnumType>;
  isDone?: InputMaybe<SortEnumType>;
  logs?: InputMaybe<ListSortInputTypeBookingEventLog>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
};

export type BookingFilterInput = {
  additionalCharge?: InputMaybe<ListFilterInputTypeOfBookingAdditionalChargeFilterInput>;
  and?: InputMaybe<Array<BookingFilterInput>>;
  attachments?: InputMaybe<ListFilterInputTypeOfBookingAttachmentFilterInput>;
  bookingDate?: InputMaybe<DateTimeOperationFilterInput>;
  cancelledDate?: InputMaybe<DateTimeOperationFilterInput>;
  channel?: InputMaybe<BookingBookingChannelFilterInput>;
  children?: InputMaybe<StringOperationFilterInput>;
  details?: InputMaybe<ListFilterInputTypeOfBookingDetailsFilterInput>;
  events?: InputMaybe<ListFilterInputTypeOfBookingEventFilterInput>;
  guestCount?: InputMaybe<IntOperationFilterInput>;
  guestReservationLinkExtension?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  inDate?: InputMaybe<LocalDateOperationFilterInput>;
  inSeasonId?: InputMaybe<IntOperationFilterInput>;
  income?: InputMaybe<IncomeFilterInput>;
  incomeId?: InputMaybe<IntOperationFilterInput>;
  isCancelled?: InputMaybe<BooleanOperationFilterInput>;
  isNoShowCancellation?: InputMaybe<BooleanOperationFilterInput>;
  logs?: InputMaybe<ListFilterInputTypeOfBookingLogFilterInput>;
  nights?: InputMaybe<IntOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BookingFilterInput>>;
  outDate?: InputMaybe<LocalDateOperationFilterInput>;
  paidAmount?: InputMaybe<DecimalOperationFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  personId?: InputMaybe<IntOperationFilterInput>;
  preferredRoom?: InputMaybe<RoomFilterInput>;
  preferredRoomId?: InputMaybe<IntOperationFilterInput>;
  roomType?: InputMaybe<RoomTypeFilterInput>;
  roomTypeId?: InputMaybe<IntOperationFilterInput>;
  season?: InputMaybe<SeasonFilterInput>;
  seasonId?: InputMaybe<IntOperationFilterInput>;
  total?: InputMaybe<DecimalOperationFilterInput>;
};

export type BookingListNumberFunctionPropertyItemSortInputType = {
  additionalCharge?: InputMaybe<ListSortInputTypeBookingAdditionalCharge>;
  attachments?: InputMaybe<ListSortInputTypeBookingAttachment>;
  channel?: InputMaybe<BookingBookingChannelListObjectPropertyItemSortInputType>;
  details?: InputMaybe<ListSortInputTypeBookingDetails>;
  events?: InputMaybe<ListSortInputTypeBookingEvent>;
  guestCount?: InputMaybe<SortEnumType>;
  income?: InputMaybe<IncomeListObjectPropertyItemSortInputType>;
  logs?: InputMaybe<ListSortInputTypeBookingLog>;
  nights?: InputMaybe<SortEnumType>;
  paidAmount?: InputMaybe<SortEnumType>;
  person?: InputMaybe<PersonListObjectPropertyItemSortInputType>;
  preferredRoom?: InputMaybe<RoomListObjectPropertyItemSortInputType>;
  roomType?: InputMaybe<RoomTypeListObjectPropertyItemSortInputType>;
  season?: InputMaybe<SeasonListObjectPropertyItemSortInputType>;
  total?: InputMaybe<SortEnumType>;
};

export type BookingListObjectPropertyItemSortInputType = {
  additionalCharge?: InputMaybe<ListSortInputTypeBookingAdditionalCharge>;
  attachments?: InputMaybe<ListSortInputTypeBookingAttachment>;
  channel?: InputMaybe<BookingBookingChannelListObjectPropertyItemSortInputType>;
  details?: InputMaybe<ListSortInputTypeBookingDetails>;
  events?: InputMaybe<ListSortInputTypeBookingEvent>;
  guestCount?: InputMaybe<SortEnumType>;
  income?: InputMaybe<IncomeListObjectPropertyItemSortInputType>;
  logs?: InputMaybe<ListSortInputTypeBookingLog>;
  nights?: InputMaybe<SortEnumType>;
  paidAmount?: InputMaybe<SortEnumType>;
  person?: InputMaybe<PersonListObjectPropertyItemSortInputType>;
  preferredRoom?: InputMaybe<RoomListObjectPropertyItemSortInputType>;
  roomType?: InputMaybe<RoomTypeListObjectPropertyItemSortInputType>;
  season?: InputMaybe<SeasonListObjectPropertyItemSortInputType>;
  total?: InputMaybe<SortEnumType>;
};

export type BookingLogFilterInput = {
  and?: InputMaybe<Array<BookingLogFilterInput>>;
  author?: InputMaybe<UserFilterInput>;
  authorId?: InputMaybe<IntOperationFilterInput>;
  bookingDate?: InputMaybe<DateTimeOperationFilterInput>;
  cancelledDate?: InputMaybe<DateTimeOperationFilterInput>;
  changeDate?: InputMaybe<DateTimeOperationFilterInput>;
  channel?: InputMaybe<BookingBookingChannelFilterInput>;
  children?: InputMaybe<StringOperationFilterInput>;
  entity?: InputMaybe<BookingFilterInput>;
  entityId?: InputMaybe<IntOperationFilterInput>;
  guestCount?: InputMaybe<IntOperationFilterInput>;
  guestReservationLinkExtension?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  inDate?: InputMaybe<LocalDateOperationFilterInput>;
  inSeasonId?: InputMaybe<IntOperationFilterInput>;
  income?: InputMaybe<IncomeFilterInput>;
  incomeId?: InputMaybe<IntOperationFilterInput>;
  isCancelled?: InputMaybe<BooleanOperationFilterInput>;
  isNoShowCancellation?: InputMaybe<BooleanOperationFilterInput>;
  nights?: InputMaybe<IntOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BookingLogFilterInput>>;
  outDate?: InputMaybe<LocalDateOperationFilterInput>;
  paidAmount?: InputMaybe<DecimalOperationFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  personId?: InputMaybe<IntOperationFilterInput>;
  preferredRoom?: InputMaybe<RoomFilterInput>;
  preferredRoomId?: InputMaybe<IntOperationFilterInput>;
  roomType?: InputMaybe<RoomTypeFilterInput>;
  roomTypeId?: InputMaybe<IntOperationFilterInput>;
  season?: InputMaybe<SeasonFilterInput>;
  seasonId?: InputMaybe<IntOperationFilterInput>;
  total?: InputMaybe<DecimalOperationFilterInput>;
};

export type BookingLogListNumberFunctionPropertyItemSortInputType = {
  channel?: InputMaybe<BookingBookingChannelListObjectPropertyItemSortInputType>;
  entity?: InputMaybe<BookingListObjectPropertyItemSortInputType>;
  guestCount?: InputMaybe<SortEnumType>;
  income?: InputMaybe<IncomeListObjectPropertyItemSortInputType>;
  nights?: InputMaybe<SortEnumType>;
  paidAmount?: InputMaybe<SortEnumType>;
  person?: InputMaybe<PersonListObjectPropertyItemSortInputType>;
  preferredRoom?: InputMaybe<RoomListObjectPropertyItemSortInputType>;
  roomType?: InputMaybe<RoomTypeListObjectPropertyItemSortInputType>;
  season?: InputMaybe<SeasonListObjectPropertyItemSortInputType>;
  total?: InputMaybe<SortEnumType>;
};

export type BookingLogSortInput = {
  author?: InputMaybe<UserSortInput>;
  authorId?: InputMaybe<SortEnumType>;
  bookingDate?: InputMaybe<SortEnumType>;
  cancelledDate?: InputMaybe<SortEnumType>;
  changeDate?: InputMaybe<SortEnumType>;
  channel?: InputMaybe<BookingBookingChannelSortInput>;
  children?: InputMaybe<SortEnumType>;
  entity?: InputMaybe<BookingSortInput>;
  entityId?: InputMaybe<SortEnumType>;
  guestCount?: InputMaybe<SortEnumType>;
  guestReservationLinkExtension?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inDate?: InputMaybe<SortEnumType>;
  inSeasonId?: InputMaybe<SortEnumType>;
  income?: InputMaybe<IncomeSortInput>;
  incomeId?: InputMaybe<SortEnumType>;
  isCancelled?: InputMaybe<SortEnumType>;
  isNoShowCancellation?: InputMaybe<SortEnumType>;
  nights?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  outDate?: InputMaybe<SortEnumType>;
  paidAmount?: InputMaybe<SortEnumType>;
  person?: InputMaybe<PersonSortInput>;
  personId?: InputMaybe<SortEnumType>;
  preferredRoom?: InputMaybe<RoomSortInput>;
  preferredRoomId?: InputMaybe<SortEnumType>;
  roomType?: InputMaybe<RoomTypeSortInput>;
  roomTypeId?: InputMaybe<SortEnumType>;
  season?: InputMaybe<SeasonSortInput>;
  seasonId?: InputMaybe<SortEnumType>;
  total?: InputMaybe<SortEnumType>;
};

export type BookingSortInput = {
  additionalCharge?: InputMaybe<ListSortInputTypeBookingAdditionalCharge>;
  attachments?: InputMaybe<ListSortInputTypeBookingAttachment>;
  bookingDate?: InputMaybe<SortEnumType>;
  cancelledDate?: InputMaybe<SortEnumType>;
  channel?: InputMaybe<BookingBookingChannelSortInput>;
  children?: InputMaybe<SortEnumType>;
  details?: InputMaybe<ListSortInputTypeBookingDetails>;
  events?: InputMaybe<ListSortInputTypeBookingEvent>;
  guestCount?: InputMaybe<SortEnumType>;
  guestReservationLinkExtension?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inDate?: InputMaybe<SortEnumType>;
  inSeasonId?: InputMaybe<SortEnumType>;
  income?: InputMaybe<IncomeSortInput>;
  incomeId?: InputMaybe<SortEnumType>;
  isCancelled?: InputMaybe<SortEnumType>;
  isNoShowCancellation?: InputMaybe<SortEnumType>;
  logs?: InputMaybe<ListSortInputTypeBookingLog>;
  nights?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  outDate?: InputMaybe<SortEnumType>;
  paidAmount?: InputMaybe<SortEnumType>;
  person?: InputMaybe<PersonSortInput>;
  personId?: InputMaybe<SortEnumType>;
  preferredRoom?: InputMaybe<RoomSortInput>;
  preferredRoomId?: InputMaybe<SortEnumType>;
  roomType?: InputMaybe<RoomTypeSortInput>;
  roomTypeId?: InputMaybe<SortEnumType>;
  season?: InputMaybe<SeasonSortInput>;
  seasonId?: InputMaybe<SortEnumType>;
  total?: InputMaybe<SortEnumType>;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  neq?: InputMaybe<Scalars['Boolean']>;
};

export type CalculationTypesOperationFilterInput = {
  eq?: InputMaybe<BookingAdditionalChargesCalculationTypes>;
  in?: InputMaybe<Array<BookingAdditionalChargesCalculationTypes>>;
  neq?: InputMaybe<BookingAdditionalChargesCalculationTypes>;
  nin?: InputMaybe<Array<BookingAdditionalChargesCalculationTypes>>;
};

export enum CommissionTypes {
  Percent = 'PERCENT',
  Total = 'TOTAL'
}

export type CommissionTypesOperationFilterInput = {
  eq?: InputMaybe<CommissionTypes>;
  in?: InputMaybe<Array<CommissionTypes>>;
  neq?: InputMaybe<CommissionTypes>;
  nin?: InputMaybe<Array<CommissionTypes>>;
};

export type Country = {
  __typename?: 'Country';
  alpha2Code: Scalars['String'];
  alpha3Code: Scalars['String'];
  callingCodes: Array<Scalars['String']>;
  flag: Scalars['String'];
  name: Scalars['String'];
  region: Scalars['String'];
  subregion: Scalars['String'];
  translate?: Maybe<Scalars['String']>;
  translations: Array<CountryTranslation>;
};


export type CountryTranslateArgs = {
  lang: Scalars['String'];
};

export type CountryFilterInput = {
  alpha2Code?: InputMaybe<StringOperationFilterInput>;
  alpha3Code?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CountryFilterInput>>;
  callingCodes?: InputMaybe<ListStringOperationFilterInput>;
  flag?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CountryFilterInput>>;
  region?: InputMaybe<StringOperationFilterInput>;
  subregion?: InputMaybe<StringOperationFilterInput>;
  translations?: InputMaybe<ListFilterInputTypeOfCountryTranslationFilterInput>;
};

export type CountrySortInput = {
  alpha2Code?: InputMaybe<SortEnumType>;
  alpha3Code?: InputMaybe<SortEnumType>;
  flag?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  region?: InputMaybe<SortEnumType>;
  subregion?: InputMaybe<SortEnumType>;
};

export type CountryTranslation = {
  __typename?: 'CountryTranslation';
  language: Scalars['String'];
  name: Scalars['String'];
};

export type CountryTranslationFilterInput = {
  and?: InputMaybe<Array<CountryTranslationFilterInput>>;
  language?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CountryTranslationFilterInput>>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  neq?: InputMaybe<Scalars['Decimal']>;
  ngt?: InputMaybe<Scalars['Decimal']>;
  ngte?: InputMaybe<Scalars['Decimal']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  nlt?: InputMaybe<Scalars['Decimal']>;
  nlte?: InputMaybe<Scalars['Decimal']>;
};

export type EventTemplateFilterInput = {
  and?: InputMaybe<Array<EventTemplateFilterInput>>;
  assignee?: InputMaybe<PersonFilterInput>;
  assigneeId?: InputMaybe<IntOperationFilterInput>;
  changeDynamicly?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isSystem?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  onDay?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<EventTemplateFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  repeat?: InputMaybe<BooleanOperationFilterInput>;
};

export type EventTemplateInput = {
  assigneeId?: InputMaybe<Scalars['Int']>;
  changeDynamicly: Scalars['Boolean'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  onDay?: InputMaybe<Scalars['Int']>;
  order: Scalars['Int'];
  repeat: Scalars['Boolean'];
};

export type EventTemplateListNumberFunctionPropertyItemSortInputType = {
  assignee?: InputMaybe<PersonListObjectPropertyItemSortInputType>;
  onDay?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
};

export type EventTemplateSortInput = {
  assignee?: InputMaybe<PersonSortInput>;
  assigneeId?: InputMaybe<SortEnumType>;
  changeDynamicly?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isSystem?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  onDay?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
  repeat?: InputMaybe<SortEnumType>;
};

export type ExpenseFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<ExpenseFilterInput>>;
  date?: InputMaybe<LocalDateOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ExpenseFilterInput>>;
  paid?: InputMaybe<BooleanOperationFilterInput>;
};

export type ExpenseListObjectPropertyItemSortInputType = {
  amount?: InputMaybe<SortEnumType>;
};

export type ExpenseSortInput = {
  amount?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  paid?: InputMaybe<SortEnumType>;
};

export type FruitCategoryFilterInput = {
  and?: InputMaybe<Array<FruitCategoryFilterInput>>;
  fruit?: InputMaybe<FruitFilterInput>;
  fruitId?: InputMaybe<IntOperationFilterInput>;
  harvestFruitCategories?: InputMaybe<ListFilterInputTypeOfHarvestFruitCategoryFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FruitCategoryFilterInput>>;
  sales?: InputMaybe<ListFilterInputTypeOfSaleFilterInput>;
};

export type FruitCategoryInput = {
  fruitId: Scalars['Int'];
  harvestFruitCategories?: InputMaybe<Array<HarvestFruitCategoryInput>>;
  id: Scalars['Int'];
  name: Scalars['String'];
  sales?: InputMaybe<Array<SaleInput>>;
};

export type FruitCategoryListObjectPropertyItemSortInputType = {
  fruit?: InputMaybe<FruitListObjectPropertyItemSortInputType>;
  harvestFruitCategories?: InputMaybe<ListSortInputTypeHarvestFruitCategory>;
  sales?: InputMaybe<ListSortInputTypeSale>;
};

export type FruitCategorySortInput = {
  fruit?: InputMaybe<FruitSortInput>;
  fruitId?: InputMaybe<SortEnumType>;
  harvestFruitCategories?: InputMaybe<ListSortInputTypeHarvestFruitCategory>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  sales?: InputMaybe<ListSortInputTypeSale>;
};

export type FruitFilterInput = {
  and?: InputMaybe<Array<FruitFilterInput>>;
  categories?: InputMaybe<ListFilterInputTypeOfFruitCategoryFilterInput>;
  groups?: InputMaybe<ListFilterInputTypeOfFruitGroupFilterInput>;
  harvests?: InputMaybe<ListFilterInputTypeOfHarvestFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FruitFilterInput>>;
  sales?: InputMaybe<ListFilterInputTypeOfSaleFilterInput>;
};

export type FruitGroupFilterInput = {
  and?: InputMaybe<Array<FruitGroupFilterInput>>;
  fruit?: InputMaybe<FruitFilterInput>;
  fruitId?: InputMaybe<IntOperationFilterInput>;
  harvestFruitGroupTemplates?: InputMaybe<ListFilterInputTypeOfHarvestFruitGroupTemplateFilterInput>;
  harvestFruitGroups?: InputMaybe<ListFilterInputTypeOfHarvestFruitGroupFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  maintenanceLogFruitGroup?: InputMaybe<ListFilterInputTypeOfMaintenanceLogFruitGroupFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FruitGroupFilterInput>>;
};

export type FruitGroupInput = {
  fruitId: Scalars['Int'];
  harvestFruitGroupTemplates?: InputMaybe<Array<HarvestFruitGroupTemplateInput>>;
  harvestFruitGroups?: InputMaybe<Array<HarvestFruitGroupInput>>;
  id: Scalars['Int'];
  maintenanceLogFruitGroup?: InputMaybe<Array<InputMaybe<MaintenanceLogFruitGroupInput>>>;
  name: Scalars['String'];
};

export type FruitGroupSortInput = {
  fruit?: InputMaybe<FruitSortInput>;
  fruitId?: InputMaybe<SortEnumType>;
  harvestFruitGroupTemplates?: InputMaybe<ListSortInputTypeHarvestFruitGroupTemplate>;
  harvestFruitGroups?: InputMaybe<ListSortInputTypeHarvestFruitGroup>;
  id?: InputMaybe<SortEnumType>;
  maintenanceLogFruitGroup?: InputMaybe<ListSortInputTypeMaintenanceLogFruitGroup>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
};

export type FruitInput = {
  categories: Array<FruitCategoryInput>;
  groups: Array<FruitGroupInput>;
  harvests?: InputMaybe<Array<HarvestInput>>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type FruitListObjectPropertyItemSortInputType = {
  categories?: InputMaybe<ListSortInputTypeFruitCategory>;
  groups?: InputMaybe<ListSortInputTypeFruitGroup>;
  harvests?: InputMaybe<ListSortInputTypeHarvest>;
  sales?: InputMaybe<ListSortInputTypeSale>;
};

export type FruitSortInput = {
  categories?: InputMaybe<ListSortInputTypeFruitCategory>;
  groups?: InputMaybe<ListSortInputTypeFruitGroup>;
  harvests?: InputMaybe<ListSortInputTypeHarvest>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  sales?: InputMaybe<ListSortInputTypeSale>;
};

export type HarvestAgricultureWorkFilterInput = {
  and?: InputMaybe<Array<HarvestAgricultureWorkFilterInput>>;
  category?: InputMaybe<WorkCategoriesOperationFilterInput>;
  endDate?: InputMaybe<LocalDateOperationFilterInput>;
  harvests?: InputMaybe<ListFilterInputTypeOfHarvestFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<HarvestAgricultureWorkFilterInput>>;
  season?: InputMaybe<SeasonFilterInput>;
  seasonId?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<LocalDateOperationFilterInput>;
  type?: InputMaybe<AgricultureWorkTypesOperationFilterInput>;
  workers?: InputMaybe<ListFilterInputTypeOfWorkerFilterInput>;
};

export type HarvestAgricultureWorkInput = {
  endDate?: InputMaybe<Scalars['LocalDate']>;
  harvests: Array<HarvestInput>;
  id: Scalars['Int'];
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  seasonId: Scalars['Int'];
  startDate: Scalars['LocalDate'];
  workers: Array<WorkerInput>;
};

export type HarvestAgricultureWorkListObjectPropertyItemSortInputType = {
  harvests?: InputMaybe<ListSortInputTypeHarvest>;
  season?: InputMaybe<SeasonListObjectPropertyItemSortInputType>;
  workers?: InputMaybe<ListSortInputTypeWorker>;
};

export type HarvestAgricultureWorkSortInput = {
  category?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  harvests?: InputMaybe<ListSortInputTypeHarvest>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  season?: InputMaybe<SeasonSortInput>;
  seasonId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  workers?: InputMaybe<ListSortInputTypeWorker>;
};

export type HarvestAgricultureWorkTemplateFilterInput = {
  and?: InputMaybe<Array<HarvestAgricultureWorkTemplateFilterInput>>;
  category?: InputMaybe<WorkCategoriesOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  harvests?: InputMaybe<ListFilterInputTypeOfHarvestTemplateFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<HarvestAgricultureWorkTemplateFilterInput>>;
  season?: InputMaybe<SeasonFilterInput>;
  seasonId?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  type?: InputMaybe<AgricultureWorkTypesOperationFilterInput>;
  workers?: InputMaybe<ListFilterInputTypeOfWorkerTemplateFilterInput>;
};

export type HarvestAgricultureWorkTemplateInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  harvests: Array<HarvestTemplateInput>;
  id: Scalars['Int'];
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  seasonId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  workers?: InputMaybe<Array<WorkerTemplateInput>>;
};

export type HarvestAgricultureWorkTemplateListObjectPropertyItemSortInputType = {
  harvests?: InputMaybe<ListSortInputTypeHarvestTemplate>;
  season?: InputMaybe<SeasonListObjectPropertyItemSortInputType>;
  workers?: InputMaybe<ListSortInputTypeWorkerTemplate>;
};

export type HarvestAgricultureWorkTemplateSortInput = {
  category?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  harvests?: InputMaybe<ListSortInputTypeHarvestTemplate>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  season?: InputMaybe<SeasonSortInput>;
  seasonId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  workers?: InputMaybe<ListSortInputTypeWorkerTemplate>;
};

export type HarvestFilterInput = {
  and?: InputMaybe<Array<HarvestFilterInput>>;
  cartQuantity?: InputMaybe<IntOperationFilterInput>;
  fruit?: InputMaybe<FruitFilterInput>;
  fruitId?: InputMaybe<IntOperationFilterInput>;
  harvestFruitCategories?: InputMaybe<ListFilterInputTypeOfHarvestFruitCategoryFilterInput>;
  harvestFruitGroups?: InputMaybe<ListFilterInputTypeOfHarvestFruitGroupFilterInput>;
  hideFromMultiUpdate?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  kg?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<HarvestFilterInput>>;
  work?: InputMaybe<HarvestAgricultureWorkFilterInput>;
  workId?: InputMaybe<IntOperationFilterInput>;
};

export type HarvestFruitCategoryFilterInput = {
  and?: InputMaybe<Array<HarvestFruitCategoryFilterInput>>;
  fruitCategory?: InputMaybe<FruitCategoryFilterInput>;
  fruitCategoryId?: InputMaybe<IntOperationFilterInput>;
  harvest?: InputMaybe<HarvestFilterInput>;
  harvestId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<HarvestFruitCategoryFilterInput>>;
};

export type HarvestFruitCategoryInput = {
  fruitCategoryId: Scalars['Int'];
  harvestId: Scalars['Int'];
  id: Scalars['Int'];
};

export type HarvestFruitCategorySortInput = {
  fruitCategory?: InputMaybe<FruitCategorySortInput>;
  fruitCategoryId?: InputMaybe<SortEnumType>;
  harvest?: InputMaybe<HarvestSortInput>;
  harvestId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

export type HarvestFruitCategoryTemplateFilterInput = {
  and?: InputMaybe<Array<HarvestFruitCategoryTemplateFilterInput>>;
  fruitCategory?: InputMaybe<FruitCategoryFilterInput>;
  fruitCategoryId?: InputMaybe<IntOperationFilterInput>;
  harvest?: InputMaybe<HarvestTemplateFilterInput>;
  harvestId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<HarvestFruitCategoryTemplateFilterInput>>;
};

export type HarvestFruitCategoryTemplateInput = {
  fruitCategoryId: Scalars['Int'];
  harvestId: Scalars['Int'];
  id: Scalars['Int'];
};

export type HarvestFruitCategoryTemplateSortInput = {
  fruitCategory?: InputMaybe<FruitCategorySortInput>;
  fruitCategoryId?: InputMaybe<SortEnumType>;
  harvest?: InputMaybe<HarvestTemplateSortInput>;
  harvestId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

export type HarvestFruitGroupFilterInput = {
  and?: InputMaybe<Array<HarvestFruitGroupFilterInput>>;
  fruitGroup?: InputMaybe<FruitGroupFilterInput>;
  fruitGroupId?: InputMaybe<IntOperationFilterInput>;
  harvest?: InputMaybe<HarvestFilterInput>;
  harvestId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<HarvestFruitGroupFilterInput>>;
};

export type HarvestFruitGroupInput = {
  fruitGroupId: Scalars['Int'];
  harvestId: Scalars['Int'];
  id: Scalars['Int'];
};

export type HarvestFruitGroupSortInput = {
  fruitGroup?: InputMaybe<FruitGroupSortInput>;
  fruitGroupId?: InputMaybe<SortEnumType>;
  harvest?: InputMaybe<HarvestSortInput>;
  harvestId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

export type HarvestFruitGroupTemplateFilterInput = {
  and?: InputMaybe<Array<HarvestFruitGroupTemplateFilterInput>>;
  fruitGroup?: InputMaybe<FruitGroupFilterInput>;
  fruitGroupId?: InputMaybe<IntOperationFilterInput>;
  harvest?: InputMaybe<HarvestTemplateFilterInput>;
  harvestId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<HarvestFruitGroupTemplateFilterInput>>;
};

export type HarvestFruitGroupTemplateInput = {
  fruitGroupId: Scalars['Int'];
  harvestId: Scalars['Int'];
  id: Scalars['Int'];
};

export type HarvestFruitGroupTemplateSortInput = {
  fruitGroup?: InputMaybe<FruitGroupSortInput>;
  fruitGroupId?: InputMaybe<SortEnumType>;
  harvest?: InputMaybe<HarvestTemplateSortInput>;
  harvestId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

export type HarvestInput = {
  cartQuantity: Scalars['Int'];
  fruitId: Scalars['Int'];
  harvestFruitCategories: Array<HarvestFruitCategoryInput>;
  harvestFruitGroups: Array<HarvestFruitGroupInput>;
  hideFromMultiUpdate: Scalars['Boolean'];
  id: Scalars['Int'];
  kg: Scalars['Decimal'];
  workId: Scalars['Int'];
};

export type HarvestListNumberFunctionPropertyItemSortInputType = {
  cartQuantity?: InputMaybe<SortEnumType>;
  fruit?: InputMaybe<FruitListObjectPropertyItemSortInputType>;
  harvestFruitCategories?: InputMaybe<ListSortInputTypeHarvestFruitCategory>;
  harvestFruitGroups?: InputMaybe<ListSortInputTypeHarvestFruitGroup>;
  kg?: InputMaybe<SortEnumType>;
  work?: InputMaybe<HarvestAgricultureWorkListObjectPropertyItemSortInputType>;
};

export type HarvestMultiUpdateInput = {
  cartQuantity: Scalars['Int'];
  id: Scalars['Int'];
  kg: Scalars['Decimal'];
};

export type HarvestSortInput = {
  cartQuantity?: InputMaybe<SortEnumType>;
  fruit?: InputMaybe<FruitSortInput>;
  fruitId?: InputMaybe<SortEnumType>;
  harvestFruitCategories?: InputMaybe<ListSortInputTypeHarvestFruitCategory>;
  harvestFruitGroups?: InputMaybe<ListSortInputTypeHarvestFruitGroup>;
  hideFromMultiUpdate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  kg?: InputMaybe<SortEnumType>;
  work?: InputMaybe<HarvestAgricultureWorkSortInput>;
  workId?: InputMaybe<SortEnumType>;
};

export type HarvestTemplateFilterInput = {
  and?: InputMaybe<Array<HarvestTemplateFilterInput>>;
  cartQuantity?: InputMaybe<IntOperationFilterInput>;
  fruit?: InputMaybe<FruitFilterInput>;
  fruitId?: InputMaybe<IntOperationFilterInput>;
  harvestFruitCategories?: InputMaybe<ListFilterInputTypeOfHarvestFruitCategoryTemplateFilterInput>;
  harvestFruitGroups?: InputMaybe<ListFilterInputTypeOfHarvestFruitGroupTemplateFilterInput>;
  hideFromMultiUpdate?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  kg?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<HarvestTemplateFilterInput>>;
  work?: InputMaybe<HarvestAgricultureWorkTemplateFilterInput>;
  workId?: InputMaybe<IntOperationFilterInput>;
};

export type HarvestTemplateInput = {
  cartQuantity?: InputMaybe<Scalars['Int']>;
  fruitId?: InputMaybe<Scalars['Int']>;
  harvestFruitCategories: Array<HarvestFruitCategoryTemplateInput>;
  harvestFruitGroups: Array<HarvestFruitGroupTemplateInput>;
  hideFromMultiUpdate: Scalars['Boolean'];
  id: Scalars['Int'];
  kg?: InputMaybe<Scalars['Decimal']>;
  workId: Scalars['Int'];
};

export type HarvestTemplateListNumberFunctionPropertyItemSortInputType = {
  cartQuantity?: InputMaybe<SortEnumType>;
  fruit?: InputMaybe<FruitListObjectPropertyItemSortInputType>;
  harvestFruitCategories?: InputMaybe<ListSortInputTypeHarvestFruitCategoryTemplate>;
  harvestFruitGroups?: InputMaybe<ListSortInputTypeHarvestFruitGroupTemplate>;
  kg?: InputMaybe<SortEnumType>;
  work?: InputMaybe<HarvestAgricultureWorkTemplateListObjectPropertyItemSortInputType>;
};

export type HarvestTemplateSortInput = {
  cartQuantity?: InputMaybe<SortEnumType>;
  fruit?: InputMaybe<FruitSortInput>;
  fruitId?: InputMaybe<SortEnumType>;
  harvestFruitCategories?: InputMaybe<ListSortInputTypeHarvestFruitCategoryTemplate>;
  harvestFruitGroups?: InputMaybe<ListSortInputTypeHarvestFruitGroupTemplate>;
  hideFromMultiUpdate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  kg?: InputMaybe<SortEnumType>;
  work?: InputMaybe<HarvestAgricultureWorkTemplateSortInput>;
  workId?: InputMaybe<SortEnumType>;
};

export type IncomeFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<IncomeFilterInput>>;
  bookings?: InputMaybe<ListFilterInputTypeOfBookingFilterInput>;
  date?: InputMaybe<LocalDateOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IncomeFilterInput>>;
  paid?: InputMaybe<BooleanOperationFilterInput>;
};

export type IncomeListObjectPropertyItemSortInputType = {
  amount?: InputMaybe<SortEnumType>;
  bookings?: InputMaybe<ListSortInputTypeBooking>;
};

export type IncomeSortInput = {
  amount?: InputMaybe<SortEnumType>;
  bookings?: InputMaybe<ListSortInputTypeBooking>;
  date?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  paid?: InputMaybe<SortEnumType>;
};

export enum InsertTypes {
  System = 'SYSTEM',
  User = 'USER'
}

export type InsertTypesOperationFilterInput = {
  eq?: InputMaybe<InsertTypes>;
  in?: InputMaybe<Array<InsertTypes>>;
  neq?: InputMaybe<InsertTypes>;
  nin?: InputMaybe<Array<InsertTypes>>;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
};

export enum InvestmentTypes {
  Chemicals = 'CHEMICALS',
  Equipments = 'EQUIPMENTS',
  Other = 'OTHER'
}

export type InvestmentTypesOperationFilterInput = {
  eq?: InputMaybe<InvestmentTypes>;
  in?: InputMaybe<Array<InvestmentTypes>>;
  neq?: InputMaybe<InvestmentTypes>;
  nin?: InputMaybe<Array<InvestmentTypes>>;
};

export type ListFilterInputTypeOfAccommodationMaintenanceLogFilterInput = {
  all?: InputMaybe<AccommodationMaintenanceLogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AccommodationMaintenanceLogFilterInput>;
  some?: InputMaybe<AccommodationMaintenanceLogFilterInput>;
};

export type ListFilterInputTypeOfAccommodationMaintenanceLogRoomFilterInput = {
  all?: InputMaybe<AccommodationMaintenanceLogRoomFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AccommodationMaintenanceLogRoomFilterInput>;
  some?: InputMaybe<AccommodationMaintenanceLogRoomFilterInput>;
};

export type ListFilterInputTypeOfBookingAdditionalChargeFilterInput = {
  all?: InputMaybe<BookingAdditionalChargeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BookingAdditionalChargeFilterInput>;
  some?: InputMaybe<BookingAdditionalChargeFilterInput>;
};

export type ListFilterInputTypeOfBookingAttachmentFilterInput = {
  all?: InputMaybe<BookingAttachmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BookingAttachmentFilterInput>;
  some?: InputMaybe<BookingAttachmentFilterInput>;
};

export type ListFilterInputTypeOfBookingBookingChannelFilterInput = {
  all?: InputMaybe<BookingBookingChannelFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BookingBookingChannelFilterInput>;
  some?: InputMaybe<BookingBookingChannelFilterInput>;
};

export type ListFilterInputTypeOfBookingDetailsFilterInput = {
  all?: InputMaybe<BookingDetailsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BookingDetailsFilterInput>;
  some?: InputMaybe<BookingDetailsFilterInput>;
};

export type ListFilterInputTypeOfBookingEventFilterInput = {
  all?: InputMaybe<BookingEventFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BookingEventFilterInput>;
  some?: InputMaybe<BookingEventFilterInput>;
};

export type ListFilterInputTypeOfBookingEventLogFilterInput = {
  all?: InputMaybe<BookingEventLogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BookingEventLogFilterInput>;
  some?: InputMaybe<BookingEventLogFilterInput>;
};

export type ListFilterInputTypeOfBookingFilterInput = {
  all?: InputMaybe<BookingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BookingFilterInput>;
  some?: InputMaybe<BookingFilterInput>;
};

export type ListFilterInputTypeOfBookingLogFilterInput = {
  all?: InputMaybe<BookingLogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BookingLogFilterInput>;
  some?: InputMaybe<BookingLogFilterInput>;
};

export type ListFilterInputTypeOfCountryTranslationFilterInput = {
  all?: InputMaybe<CountryTranslationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CountryTranslationFilterInput>;
  some?: InputMaybe<CountryTranslationFilterInput>;
};

export type ListFilterInputTypeOfEventTemplateFilterInput = {
  all?: InputMaybe<EventTemplateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EventTemplateFilterInput>;
  some?: InputMaybe<EventTemplateFilterInput>;
};

export type ListFilterInputTypeOfFruitCategoryFilterInput = {
  all?: InputMaybe<FruitCategoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<FruitCategoryFilterInput>;
  some?: InputMaybe<FruitCategoryFilterInput>;
};

export type ListFilterInputTypeOfFruitGroupFilterInput = {
  all?: InputMaybe<FruitGroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<FruitGroupFilterInput>;
  some?: InputMaybe<FruitGroupFilterInput>;
};

export type ListFilterInputTypeOfHarvestFilterInput = {
  all?: InputMaybe<HarvestFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<HarvestFilterInput>;
  some?: InputMaybe<HarvestFilterInput>;
};

export type ListFilterInputTypeOfHarvestFruitCategoryFilterInput = {
  all?: InputMaybe<HarvestFruitCategoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<HarvestFruitCategoryFilterInput>;
  some?: InputMaybe<HarvestFruitCategoryFilterInput>;
};

export type ListFilterInputTypeOfHarvestFruitCategoryTemplateFilterInput = {
  all?: InputMaybe<HarvestFruitCategoryTemplateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<HarvestFruitCategoryTemplateFilterInput>;
  some?: InputMaybe<HarvestFruitCategoryTemplateFilterInput>;
};

export type ListFilterInputTypeOfHarvestFruitGroupFilterInput = {
  all?: InputMaybe<HarvestFruitGroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<HarvestFruitGroupFilterInput>;
  some?: InputMaybe<HarvestFruitGroupFilterInput>;
};

export type ListFilterInputTypeOfHarvestFruitGroupTemplateFilterInput = {
  all?: InputMaybe<HarvestFruitGroupTemplateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<HarvestFruitGroupTemplateFilterInput>;
  some?: InputMaybe<HarvestFruitGroupTemplateFilterInput>;
};

export type ListFilterInputTypeOfHarvestTemplateFilterInput = {
  all?: InputMaybe<HarvestTemplateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<HarvestTemplateFilterInput>;
  some?: InputMaybe<HarvestTemplateFilterInput>;
};

export type ListFilterInputTypeOfMaintenanceLogFilterInput = {
  all?: InputMaybe<MaintenanceLogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MaintenanceLogFilterInput>;
  some?: InputMaybe<MaintenanceLogFilterInput>;
};

export type ListFilterInputTypeOfMaintenanceLogFruitGroupFilterInput = {
  all?: InputMaybe<MaintenanceLogFruitGroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MaintenanceLogFruitGroupFilterInput>;
  some?: InputMaybe<MaintenanceLogFruitGroupFilterInput>;
};

export type ListFilterInputTypeOfMaintenanceLogFruitGroupTemplateFilterInput = {
  all?: InputMaybe<MaintenanceLogFruitGroupTemplateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MaintenanceLogFruitGroupTemplateFilterInput>;
  some?: InputMaybe<MaintenanceLogFruitGroupTemplateFilterInput>;
};

export type ListFilterInputTypeOfMaintenanceLogTemplateFilterInput = {
  all?: InputMaybe<MaintenanceLogTemplateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MaintenanceLogTemplateFilterInput>;
  some?: InputMaybe<MaintenanceLogTemplateFilterInput>;
};

export type ListFilterInputTypeOfNotificationConfigFilterInput = {
  all?: InputMaybe<NotificationConfigFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<NotificationConfigFilterInput>;
  some?: InputMaybe<NotificationConfigFilterInput>;
};

export type ListFilterInputTypeOfPersonContactInfoFilterInput = {
  all?: InputMaybe<PersonContactInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PersonContactInfoFilterInput>;
  some?: InputMaybe<PersonContactInfoFilterInput>;
};

export type ListFilterInputTypeOfPersonTagLinkFilterInput = {
  all?: InputMaybe<PersonTagLinkFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PersonTagLinkFilterInput>;
  some?: InputMaybe<PersonTagLinkFilterInput>;
};

export type ListFilterInputTypeOfPushNotificationSubscriptionFilterInput = {
  all?: InputMaybe<PushNotificationSubscriptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PushNotificationSubscriptionFilterInput>;
  some?: InputMaybe<PushNotificationSubscriptionFilterInput>;
};

export type ListFilterInputTypeOfRoomFilterInput = {
  all?: InputMaybe<RoomFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RoomFilterInput>;
  some?: InputMaybe<RoomFilterInput>;
};

export type ListFilterInputTypeOfRoomTypeChannelDefultPriceFilterInput = {
  all?: InputMaybe<RoomTypeChannelDefultPriceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RoomTypeChannelDefultPriceFilterInput>;
  some?: InputMaybe<RoomTypeChannelDefultPriceFilterInput>;
};

export type ListFilterInputTypeOfSaleFilterInput = {
  all?: InputMaybe<SaleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SaleFilterInput>;
  some?: InputMaybe<SaleFilterInput>;
};

export type ListFilterInputTypeOfUserAuthDataFilterInput = {
  all?: InputMaybe<UserAuthDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UserAuthDataFilterInput>;
  some?: InputMaybe<UserAuthDataFilterInput>;
};

export type ListFilterInputTypeOfUserRoleFilterInput = {
  all?: InputMaybe<UserRoleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UserRoleFilterInput>;
  some?: InputMaybe<UserRoleFilterInput>;
};

export type ListFilterInputTypeOfWalletFilterInput = {
  all?: InputMaybe<WalletFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WalletFilterInput>;
  some?: InputMaybe<WalletFilterInput>;
};

export type ListFilterInputTypeOfWalletTransactionFilterInput = {
  all?: InputMaybe<WalletTransactionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WalletTransactionFilterInput>;
  some?: InputMaybe<WalletTransactionFilterInput>;
};

export type ListFilterInputTypeOfWorkFilterInput = {
  all?: InputMaybe<WorkFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkFilterInput>;
  some?: InputMaybe<WorkFilterInput>;
};

export type ListFilterInputTypeOfWorkerFilterInput = {
  all?: InputMaybe<WorkerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkerFilterInput>;
  some?: InputMaybe<WorkerFilterInput>;
};

export type ListFilterInputTypeOfWorkerTemplateFilterInput = {
  all?: InputMaybe<WorkerTemplateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkerTemplateFilterInput>;
  some?: InputMaybe<WorkerTemplateFilterInput>;
};

export type ListSortInputTypeAccommodationMaintenanceLog = {
  count?: InputMaybe<SortEnumType>;
};

export type ListSortInputTypeAccommodationMaintenanceLogRoom = {
  count?: InputMaybe<SortEnumType>;
};

export type ListSortInputTypeBooking = {
  average?: InputMaybe<BookingListNumberFunctionPropertyItemSortInputType>;
  count?: InputMaybe<SortEnumType>;
  sum?: InputMaybe<BookingListNumberFunctionPropertyItemSortInputType>;
};

export type ListSortInputTypeBookingAdditionalCharge = {
  average?: InputMaybe<BookingAdditionalChargeListNumberFunctionPropertyItemSortInputType>;
  count?: InputMaybe<SortEnumType>;
  sum?: InputMaybe<BookingAdditionalChargeListNumberFunctionPropertyItemSortInputType>;
};

export type ListSortInputTypeBookingAttachment = {
  count?: InputMaybe<SortEnumType>;
};

export type ListSortInputTypeBookingBookingChannel = {
  average?: InputMaybe<BookingBookingChannelListNumberFunctionPropertyItemSortInputType>;
  count?: InputMaybe<SortEnumType>;
  sum?: InputMaybe<BookingBookingChannelListNumberFunctionPropertyItemSortInputType>;
};

export type ListSortInputTypeBookingDetails = {
  average?: InputMaybe<BookingDetailsListNumberFunctionPropertyItemSortInputType>;
  count?: InputMaybe<SortEnumType>;
  sum?: InputMaybe<BookingDetailsListNumberFunctionPropertyItemSortInputType>;
};

export type ListSortInputTypeBookingEvent = {
  average?: InputMaybe<BookingEventListNumberFunctionPropertyItemSortInputType>;
  count?: InputMaybe<SortEnumType>;
  sum?: InputMaybe<BookingEventListNumberFunctionPropertyItemSortInputType>;
};

export type ListSortInputTypeBookingEventLog = {
  average?: InputMaybe<BookingEventLogListNumberFunctionPropertyItemSortInputType>;
  count?: InputMaybe<SortEnumType>;
  sum?: InputMaybe<BookingEventLogListNumberFunctionPropertyItemSortInputType>;
};

export type ListSortInputTypeBookingLog = {
  average?: InputMaybe<BookingLogListNumberFunctionPropertyItemSortInputType>;
  count?: InputMaybe<SortEnumType>;
  sum?: InputMaybe<BookingLogListNumberFunctionPropertyItemSortInputType>;
};

export type ListSortInputTypeEventTemplate = {
  average?: InputMaybe<EventTemplateListNumberFunctionPropertyItemSortInputType>;
  count?: InputMaybe<SortEnumType>;
  sum?: InputMaybe<EventTemplateListNumberFunctionPropertyItemSortInputType>;
};

export type ListSortInputTypeFruitCategory = {
  count?: InputMaybe<SortEnumType>;
};

export type ListSortInputTypeFruitGroup = {
  count?: InputMaybe<SortEnumType>;
};

export type ListSortInputTypeHarvest = {
  average?: InputMaybe<HarvestListNumberFunctionPropertyItemSortInputType>;
  count?: InputMaybe<SortEnumType>;
  sum?: InputMaybe<HarvestListNumberFunctionPropertyItemSortInputType>;
};

export type ListSortInputTypeHarvestFruitCategory = {
  count?: InputMaybe<SortEnumType>;
};

export type ListSortInputTypeHarvestFruitCategoryTemplate = {
  count?: InputMaybe<SortEnumType>;
};

export type ListSortInputTypeHarvestFruitGroup = {
  count?: InputMaybe<SortEnumType>;
};

export type ListSortInputTypeHarvestFruitGroupTemplate = {
  count?: InputMaybe<SortEnumType>;
};

export type ListSortInputTypeHarvestTemplate = {
  average?: InputMaybe<HarvestTemplateListNumberFunctionPropertyItemSortInputType>;
  count?: InputMaybe<SortEnumType>;
  sum?: InputMaybe<HarvestTemplateListNumberFunctionPropertyItemSortInputType>;
};

export type ListSortInputTypeMaintenanceLog = {
  count?: InputMaybe<SortEnumType>;
};

export type ListSortInputTypeMaintenanceLogFruitGroup = {
  count?: InputMaybe<SortEnumType>;
};

export type ListSortInputTypeMaintenanceLogFruitGroupTemplate = {
  count?: InputMaybe<SortEnumType>;
};

export type ListSortInputTypeMaintenanceLogTemplate = {
  count?: InputMaybe<SortEnumType>;
};

export type ListSortInputTypeNotificationConfig = {
  count?: InputMaybe<SortEnumType>;
};

export type ListSortInputTypePersonContactInfo = {
  count?: InputMaybe<SortEnumType>;
};

export type ListSortInputTypePersonTagLink = {
  count?: InputMaybe<SortEnumType>;
};

export type ListSortInputTypePushNotificationSubscription = {
  count?: InputMaybe<SortEnumType>;
};

export type ListSortInputTypeRoom = {
  average?: InputMaybe<RoomListNumberFunctionPropertyItemSortInputType>;
  count?: InputMaybe<SortEnumType>;
  sum?: InputMaybe<RoomListNumberFunctionPropertyItemSortInputType>;
};

export type ListSortInputTypeRoomTypeChannelDefultPrice = {
  average?: InputMaybe<RoomTypeChannelDefultPriceListNumberFunctionPropertyItemSortInputType>;
  count?: InputMaybe<SortEnumType>;
  sum?: InputMaybe<RoomTypeChannelDefultPriceListNumberFunctionPropertyItemSortInputType>;
};

export type ListSortInputTypeSale = {
  average?: InputMaybe<SaleListNumberFunctionPropertyItemSortInputType>;
  count?: InputMaybe<SortEnumType>;
  sum?: InputMaybe<SaleListNumberFunctionPropertyItemSortInputType>;
};

export type ListSortInputTypeUserAuthData = {
  count?: InputMaybe<SortEnumType>;
};

export type ListSortInputTypeUserRole = {
  count?: InputMaybe<SortEnumType>;
};

export type ListSortInputTypeWallet = {
  average?: InputMaybe<WalletListNumberFunctionPropertyItemSortInputType>;
  count?: InputMaybe<SortEnumType>;
  sum?: InputMaybe<WalletListNumberFunctionPropertyItemSortInputType>;
};

export type ListSortInputTypeWalletTransaction = {
  average?: InputMaybe<WalletTransactionListNumberFunctionPropertyItemSortInputType>;
  count?: InputMaybe<SortEnumType>;
  sum?: InputMaybe<WalletTransactionListNumberFunctionPropertyItemSortInputType>;
};

export type ListSortInputTypeWork = {
  count?: InputMaybe<SortEnumType>;
};

export type ListSortInputTypeWorker = {
  average?: InputMaybe<WorkerListNumberFunctionPropertyItemSortInputType>;
  count?: InputMaybe<SortEnumType>;
  sum?: InputMaybe<WorkerListNumberFunctionPropertyItemSortInputType>;
};

export type ListSortInputTypeWorkerTemplate = {
  average?: InputMaybe<WorkerTemplateListNumberFunctionPropertyItemSortInputType>;
  count?: InputMaybe<SortEnumType>;
  sum?: InputMaybe<WorkerTemplateListNumberFunctionPropertyItemSortInputType>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type LocalDateOperationFilterInput = {
  eq?: InputMaybe<Scalars['LocalDate']>;
  gt?: InputMaybe<Scalars['LocalDate']>;
  gte?: InputMaybe<Scalars['LocalDate']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']>>>;
  lt?: InputMaybe<Scalars['LocalDate']>;
  lte?: InputMaybe<Scalars['LocalDate']>;
  neq?: InputMaybe<Scalars['LocalDate']>;
  ngt?: InputMaybe<Scalars['LocalDate']>;
  ngte?: InputMaybe<Scalars['LocalDate']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']>>>;
  nlt?: InputMaybe<Scalars['LocalDate']>;
  nlte?: InputMaybe<Scalars['LocalDate']>;
};

export type MaintenanceAgricultureWorkFilterInput = {
  and?: InputMaybe<Array<MaintenanceAgricultureWorkFilterInput>>;
  category?: InputMaybe<WorkCategoriesOperationFilterInput>;
  endDate?: InputMaybe<LocalDateOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  logs?: InputMaybe<ListFilterInputTypeOfMaintenanceLogFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MaintenanceAgricultureWorkFilterInput>>;
  season?: InputMaybe<SeasonFilterInput>;
  seasonId?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<LocalDateOperationFilterInput>;
  type?: InputMaybe<AgricultureWorkTypesOperationFilterInput>;
  workers?: InputMaybe<ListFilterInputTypeOfWorkerFilterInput>;
};

export type MaintenanceAgricultureWorkInput = {
  endDate?: InputMaybe<Scalars['LocalDate']>;
  id: Scalars['Int'];
  logs: Array<MaintenanceLogInput>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  seasonId: Scalars['Int'];
  startDate: Scalars['LocalDate'];
  workers: Array<WorkerInput>;
};

export type MaintenanceAgricultureWorkSortInput = {
  category?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  logs?: InputMaybe<ListSortInputTypeMaintenanceLog>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  season?: InputMaybe<SeasonSortInput>;
  seasonId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  workers?: InputMaybe<ListSortInputTypeWorker>;
};

export type MaintenanceAgricultureWorkTemplateFilterInput = {
  and?: InputMaybe<Array<MaintenanceAgricultureWorkTemplateFilterInput>>;
  category?: InputMaybe<WorkCategoriesOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  logs?: InputMaybe<ListFilterInputTypeOfMaintenanceLogTemplateFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MaintenanceAgricultureWorkTemplateFilterInput>>;
  season?: InputMaybe<SeasonFilterInput>;
  seasonId?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  type?: InputMaybe<AgricultureWorkTypesOperationFilterInput>;
  workers?: InputMaybe<ListFilterInputTypeOfWorkerTemplateFilterInput>;
};

export type MaintenanceAgricultureWorkTemplateSortInput = {
  category?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  logs?: InputMaybe<ListSortInputTypeMaintenanceLogTemplate>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  season?: InputMaybe<SeasonSortInput>;
  seasonId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  workers?: InputMaybe<ListSortInputTypeWorkerTemplate>;
};

export type MaintenanceLogFilterInput = {
  and?: InputMaybe<Array<MaintenanceLogFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  investment?: InputMaybe<AgricultureWorkInvestmentFilterInput>;
  investmentId?: InputMaybe<IntOperationFilterInput>;
  maintenanceLogFruitGroups?: InputMaybe<ListFilterInputTypeOfMaintenanceLogFruitGroupFilterInput>;
  or?: InputMaybe<Array<MaintenanceLogFilterInput>>;
  type?: InputMaybe<MaintenanceLogTypeFilterInput>;
  typeId?: InputMaybe<IntOperationFilterInput>;
  work?: InputMaybe<MaintenanceAgricultureWorkFilterInput>;
  workId?: InputMaybe<IntOperationFilterInput>;
};

export type MaintenanceLogFruitGroupFilterInput = {
  and?: InputMaybe<Array<MaintenanceLogFruitGroupFilterInput>>;
  fruitGroup?: InputMaybe<FruitGroupFilterInput>;
  fruitGroupId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  log?: InputMaybe<MaintenanceLogFilterInput>;
  logId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<MaintenanceLogFruitGroupFilterInput>>;
};

export type MaintenanceLogFruitGroupInput = {
  fruitGroupId: Scalars['Int'];
  id: Scalars['Int'];
  logId: Scalars['Int'];
};

export type MaintenanceLogFruitGroupSortInput = {
  fruitGroup?: InputMaybe<FruitGroupSortInput>;
  fruitGroupId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  log?: InputMaybe<MaintenanceLogSortInput>;
  logId?: InputMaybe<SortEnumType>;
};

export type MaintenanceLogFruitGroupTemplateFilterInput = {
  and?: InputMaybe<Array<MaintenanceLogFruitGroupTemplateFilterInput>>;
  fruitGroup?: InputMaybe<FruitGroupFilterInput>;
  fruitGroupId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  log?: InputMaybe<MaintenanceLogTemplateFilterInput>;
  logId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<MaintenanceLogFruitGroupTemplateFilterInput>>;
};

export type MaintenanceLogFruitGroupTemplateInput = {
  fruitGroup?: InputMaybe<FruitGroupInput>;
  fruitGroupId: Scalars['Int'];
  id: Scalars['Int'];
  log?: InputMaybe<MaintenanceLogTemplateInput>;
  logId: Scalars['Int'];
};

export type MaintenanceLogFruitGroupTemplateSortInput = {
  fruitGroup?: InputMaybe<FruitGroupSortInput>;
  fruitGroupId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  log?: InputMaybe<MaintenanceLogTemplateSortInput>;
  logId?: InputMaybe<SortEnumType>;
};

export type MaintenanceLogInput = {
  id: Scalars['Int'];
  investmentId?: InputMaybe<Scalars['Int']>;
  maintenanceLogFruitGroups?: InputMaybe<Array<InputMaybe<MaintenanceLogFruitGroupInput>>>;
  typeId: Scalars['Int'];
  workId: Scalars['Int'];
};

export type MaintenanceLogSortInput = {
  id?: InputMaybe<SortEnumType>;
  investment?: InputMaybe<AgricultureWorkInvestmentSortInput>;
  investmentId?: InputMaybe<SortEnumType>;
  maintenanceLogFruitGroups?: InputMaybe<ListSortInputTypeMaintenanceLogFruitGroup>;
  type?: InputMaybe<MaintenanceLogTypeSortInput>;
  typeId?: InputMaybe<SortEnumType>;
  work?: InputMaybe<MaintenanceAgricultureWorkSortInput>;
  workId?: InputMaybe<SortEnumType>;
};

export type MaintenanceLogTemplateFilterInput = {
  and?: InputMaybe<Array<MaintenanceLogTemplateFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  maintenanceLogFruitGroups?: InputMaybe<ListFilterInputTypeOfMaintenanceLogFruitGroupTemplateFilterInput>;
  or?: InputMaybe<Array<MaintenanceLogTemplateFilterInput>>;
  type?: InputMaybe<MaintenanceLogTypeFilterInput>;
  typeId?: InputMaybe<IntOperationFilterInput>;
  work?: InputMaybe<MaintenanceAgricultureWorkTemplateFilterInput>;
  workId?: InputMaybe<IntOperationFilterInput>;
};

export type MaintenanceLogTemplateInput = {
  id: Scalars['Int'];
  maintenanceLogFruitGroups?: InputMaybe<Array<MaintenanceLogFruitGroupTemplateInput>>;
  typeId: Scalars['Int'];
  workId: Scalars['Int'];
};

export type MaintenanceLogTemplateSortInput = {
  id?: InputMaybe<SortEnumType>;
  maintenanceLogFruitGroups?: InputMaybe<ListSortInputTypeMaintenanceLogFruitGroupTemplate>;
  type?: InputMaybe<MaintenanceLogTypeSortInput>;
  typeId?: InputMaybe<SortEnumType>;
  work?: InputMaybe<MaintenanceAgricultureWorkTemplateSortInput>;
  workId?: InputMaybe<SortEnumType>;
};

export type MaintenanceLogTypeFilterInput = {
  and?: InputMaybe<Array<MaintenanceLogTypeFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  maintenances?: InputMaybe<ListFilterInputTypeOfMaintenanceLogFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  nameTranslationKey?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MaintenanceLogTypeFilterInput>>;
};

export type MaintenanceLogTypeInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type MaintenanceLogTypeSortInput = {
  id?: InputMaybe<SortEnumType>;
  maintenances?: InputMaybe<ListSortInputTypeMaintenanceLog>;
  name?: InputMaybe<SortEnumType>;
  nameTranslationKey?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
};

export type Mutation = {
  __typename?: 'Mutation';
  accommodationMaintenanceType?: Maybe<AccommodationMaintenanceType>;
  /** update or save sale */
  accommodationMaintenanceTypeDelete: Scalars['Boolean'];
  accommodationWorkInvestment?: Maybe<AccommodationWorkInvestment>;
  /** update or save sale */
  accommodationWorkInvestmentDelete: Scalars['Boolean'];
  accommodationWorkMaintenance?: Maybe<AccommodationWorkMaintenance>;
  /** update or save sale */
  accommodationWorkMaintenanceDelete: Scalars['Boolean'];
  active: Scalars['Boolean'];
  agricultureWorkInvestment?: Maybe<AgricultureWorkInvestment>;
  /** update or save sale */
  agricultureWorkInvestmentDelete: Scalars['Boolean'];
  amount: Scalars['Decimal'];
  archived: Scalars['Boolean'];
  assignee?: Maybe<Person>;
  assigneeId?: Maybe<Scalars['Int']>;
  booking?: Maybe<Booking>;
  bookingAdditionalCharge?: Maybe<BookingAdditionalCharge>;
  /** update or save sale */
  bookingAdditionalChargeDelete: Scalars['Boolean'];
  /** Add additional charge from template */
  bookingAdditionalChargeFromTemplate?: Maybe<Array<Maybe<BookingAdditionalCharge>>>;
  bookingAdditionalChargesTemplate?: Maybe<BookingAdditionalChargesTemplate>;
  /** update or save sale */
  bookingAdditionalChargesTemplateDelete: Scalars['Boolean'];
  bookingChannel?: Maybe<BookingChannel>;
  /** update or save sale */
  bookingChannelDelete: Scalars['Boolean'];
  bookingDetails?: Maybe<BookingDetails>;
  /** update or save sale */
  bookingDetailsDelete: Scalars['Boolean'];
  bookingEvents?: Maybe<Array<BookingEvent>>;
  bookingId: Scalars['Int'];
  bookings?: Maybe<Array<BookingBookingChannel>>;
  calculate: Scalars['Decimal'];
  calculationType: BookingAdditionalChargesCalculationTypes;
  cartQuantity: Scalars['Int'];
  categories?: Maybe<Array<FruitCategory>>;
  category: WorkCategories;
  categoryId?: Maybe<Scalars['Int']>;
  chamber: Scalars['Boolean'];
  changeDynamicly: Scalars['Boolean'];
  channel?: Maybe<BookingChannel>;
  channelDefultPrices?: Maybe<Array<RoomTypeChannelDefultPrice>>;
  channelId: Scalars['Int'];
  color?: Maybe<Scalars['String']>;
  commission: Scalars['Decimal'];
  contactInfo?: Maybe<Array<PersonContactInfo>>;
  country?: Maybe<Country>;
  countryCode?: Maybe<Scalars['String']>;
  date: Scalars['LocalDate'];
  defaultPrice: Scalars['Decimal'];
  deposit: Scalars['Decimal'];
  endDate?: Maybe<Scalars['LocalDate']>;
  eventTemplate?: Maybe<EventTemplate>;
  /** update or save sale */
  eventTemplateDelete: Scalars['Boolean'];
  eventTemplates?: Maybe<Array<EventTemplate>>;
  expense?: Maybe<Expense>;
  expenseId?: Maybe<Scalars['Int']>;
  fruit?: Maybe<Fruit>;
  /** update or save sale */
  fruitDelete: Scalars['Boolean'];
  fruitGroup?: Maybe<FruitGroup>;
  fruitGroupId: Scalars['Int'];
  fruitId: Scalars['Int'];
  groups?: Maybe<Array<FruitGroup>>;
  harvestAgricultureWork?: Maybe<HarvestAgricultureWork>;
  /** update or save sale */
  harvestAgricultureWorkDelete: Scalars['Boolean'];
  harvestAgricultureWorkTemplate?: Maybe<HarvestAgricultureWorkTemplate>;
  /** update or save sale */
  harvestAgricultureWorkTemplateDelete: Scalars['Boolean'];
  harvestFruitCategories?: Maybe<Array<HarvestFruitCategory>>;
  harvestFruitGroups?: Maybe<Array<HarvestFruitGroup>>;
  /** Update multiple harvest */
  harvestMultiUpdate?: Maybe<Scalars['Boolean']>;
  harvests?: Maybe<Array<Harvest>>;
  hideFromMultiUpdate: Scalars['Boolean'];
  id: Scalars['Int'];
  income?: Maybe<Income>;
  incomeId?: Maybe<Scalars['Int']>;
  investment?: Maybe<AgricultureWorkInvestment>;
  investmentId?: Maybe<Scalars['Int']>;
  investmentType: InvestmentTypes;
  isActive: Scalars['Boolean'];
  isIncome: Scalars['Boolean'];
  isSystem: Scalars['Boolean'];
  kg: Scalars['Decimal'];
  log?: Maybe<MaintenanceLog>;
  logId: Scalars['Int'];
  logs?: Maybe<Array<AccommodationMaintenanceLog>>;
  maintenanceAgricultureWork?: Maybe<MaintenanceAgricultureWork>;
  /** update or save sale */
  maintenanceAgricultureWorkDelete: Scalars['Boolean'];
  maintenanceLog?: Maybe<MaintenanceLog>;
  /** update or save sale */
  maintenanceLogDelete: Scalars['Boolean'];
  maintenanceLogFruitGroup?: Maybe<MaintenanceLogFruitGroup>;
  /** update or save sale */
  maintenanceLogFruitGroupDelete: Scalars['Boolean'];
  maintenanceLogFruitGroups?: Maybe<Array<MaintenanceLogFruitGroupTemplate>>;
  maintenanceLogTemplate?: Maybe<MaintenanceLogTemplate>;
  /** update or save sale */
  maintenanceLogTemplateDelete: Scalars['Boolean'];
  maintenanceLogType?: Maybe<MaintenanceLogType>;
  /** update or save sale */
  maintenanceLogTypeDelete: Scalars['Boolean'];
  maintenances?: Maybe<Array<MaintenanceLog>>;
  name: Scalars['String'];
  nameTranslationKey: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  onDay?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  person?: Maybe<Person>;
  /** update or save sale */
  personDelete: Scalars['Boolean'];
  personId: Scalars['Int'];
  personTag?: Maybe<PersonTag>;
  /** update or save sale */
  personTagDelete: Scalars['Boolean'];
  personTagLink?: Maybe<PersonTagLink>;
  /** update or save sale */
  personTagLinkDelete: Scalars['Boolean'];
  personTagLinks?: Maybe<Array<PersonTagLink>>;
  price: Scalars['Decimal'];
  pricePerKg: Scalars['Decimal'];
  quantity: Scalars['Decimal'];
  repeat: Scalars['Boolean'];
  room?: Maybe<Room>;
  /** update or save sale */
  roomDelete: Scalars['Boolean'];
  roomId: Scalars['Int'];
  roomType?: Maybe<RoomType>;
  roomTypeChannelDefultPrice?: Maybe<RoomTypeChannelDefultPrice>;
  /** update or save sale */
  roomTypeChannelDefultPriceDelete: Scalars['Boolean'];
  roomTypeDefultPrices?: Maybe<Array<RoomTypeChannelDefultPrice>>;
  /** update or save sale */
  roomTypeDelete: Scalars['Boolean'];
  roomTypeId: Scalars['Int'];
  rooms?: Maybe<Array<Room>>;
  sale?: Maybe<Sale>;
  /** update or save sale */
  saleDelete: Scalars['Boolean'];
  /** Update multiple sales */
  saleMultiUpdate?: Maybe<Scalars['Boolean']>;
  saleTemplate?: Maybe<SaleTemplate>;
  /** update or save sale */
  saleTemplateDelete: Scalars['Boolean'];
  sales?: Maybe<Array<Sale>>;
  season?: Maybe<Season>;
  /** update or save sale */
  seasonDelete: Scalars['Boolean'];
  seasonId: Scalars['Int'];
  seasonYear: Scalars['Int'];
  startDate: Scalars['LocalDate'];
  tag?: Maybe<PersonTag>;
  tagId: Scalars['Int'];
  tags?: Maybe<Array<PersonTagLink>>;
  total: Scalars['Decimal'];
  transactionDate: Scalars['DateTime'];
  transactionId?: Maybe<Scalars['String']>;
  transactions?: Maybe<Array<WalletTransaction>>;
  type: CommissionTypes;
  typeId: Scalars['Int'];
  unit: Units;
  unitPrice: Scalars['Decimal'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
  wallet?: Maybe<Wallet>;
  /** update or save sale */
  walletDelete: Scalars['Boolean'];
  walletId?: Maybe<Scalars['Int']>;
  walletTransaction?: Maybe<WalletTransaction>;
  /** update or save sale */
  walletTransactionDelete: Scalars['Boolean'];
  wallets?: Maybe<Array<Wallet>>;
  work?: Maybe<HarvestAgricultureWork>;
  workId: Scalars['Int'];
  workers?: Maybe<Array<Worker>>;
  worklogs?: Maybe<Array<AccommodationMaintenanceLogRoom>>;
  works?: Maybe<Array<Work>>;
};


export type MutationAccommodationMaintenanceTypeArgs = {
  model: AccommodationMaintenanceTypeInput;
};


export type MutationAccommodationMaintenanceTypeDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccommodationMaintenanceTypeFilterInput>;
};


export type MutationAccommodationWorkInvestmentArgs = {
  model: AccommodationWorkInvestmentInput;
};


export type MutationAccommodationWorkInvestmentDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccommodationWorkInvestmentFilterInput>;
};


export type MutationAccommodationWorkMaintenanceArgs = {
  model: AccommodationWorkMaintenanceInput;
};


export type MutationAccommodationWorkMaintenanceDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccommodationWorkMaintenanceFilterInput>;
};


export type MutationAgricultureWorkInvestmentArgs = {
  model: AgricultureWorkInvestmentInput;
};


export type MutationAgricultureWorkInvestmentDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AgricultureWorkInvestmentFilterInput>;
};


export type MutationBookingAdditionalChargeArgs = {
  model: BookingAdditionalChargeInput;
};


export type MutationBookingAdditionalChargeDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingAdditionalChargeFilterInput>;
};


export type MutationBookingAdditionalChargeFromTemplateArgs = {
  bookingId: Scalars['Int'];
  count?: InputMaybe<Scalars['Int']>;
  templateId: Scalars['Int'];
};


export type MutationBookingAdditionalChargesTemplateArgs = {
  model: BookingAdditionalChargesTemplateInput;
};


export type MutationBookingAdditionalChargesTemplateDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingAdditionalChargesTemplateFilterInput>;
};


export type MutationBookingChannelArgs = {
  model: BookingChannelInput;
};


export type MutationBookingChannelDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingChannelFilterInput>;
};


export type MutationBookingDetailsArgs = {
  model: BookingDetailsInput;
};


export type MutationBookingDetailsDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingDetailsFilterInput>;
};


export type MutationCalculateArgs = {
  total?: InputMaybe<Scalars['Decimal']>;
};


export type MutationEventTemplateArgs = {
  model: EventTemplateInput;
};


export type MutationEventTemplateDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventTemplateFilterInput>;
};


export type MutationFruitArgs = {
  model: FruitInput;
};


export type MutationFruitDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FruitFilterInput>;
};


export type MutationHarvestAgricultureWorkArgs = {
  model: HarvestAgricultureWorkInput;
};


export type MutationHarvestAgricultureWorkDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestAgricultureWorkFilterInput>;
};


export type MutationHarvestAgricultureWorkTemplateArgs = {
  model: HarvestAgricultureWorkTemplateInput;
};


export type MutationHarvestAgricultureWorkTemplateDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestAgricultureWorkTemplateFilterInput>;
};


export type MutationHarvestMultiUpdateArgs = {
  harvests: Array<HarvestMultiUpdateInput>;
};


export type MutationMaintenanceAgricultureWorkArgs = {
  model: MaintenanceAgricultureWorkInput;
};


export type MutationMaintenanceAgricultureWorkDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceAgricultureWorkFilterInput>;
};


export type MutationMaintenanceLogArgs = {
  model: MaintenanceLogInput;
};


export type MutationMaintenanceLogDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceLogFilterInput>;
};


export type MutationMaintenanceLogFruitGroupArgs = {
  model: MaintenanceLogFruitGroupInput;
};


export type MutationMaintenanceLogFruitGroupDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceLogFruitGroupFilterInput>;
};


export type MutationMaintenanceLogTemplateArgs = {
  model: MaintenanceLogTemplateInput;
};


export type MutationMaintenanceLogTemplateDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceLogTemplateFilterInput>;
};


export type MutationMaintenanceLogTypeArgs = {
  model: MaintenanceLogTypeInput;
};


export type MutationMaintenanceLogTypeDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceLogTypeFilterInput>;
};


export type MutationPersonArgs = {
  model: PersonInput;
};


export type MutationPersonDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PersonFilterInput>;
};


export type MutationPersonTagArgs = {
  model: PersonTagInput;
};


export type MutationPersonTagDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PersonTagFilterInput>;
};


export type MutationPersonTagLinkArgs = {
  model: PersonTagLinkInput;
};


export type MutationPersonTagLinkDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PersonTagLinkFilterInput>;
};


export type MutationRoomArgs = {
  model: RoomInput;
};


export type MutationRoomDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RoomFilterInput>;
};


export type MutationRoomTypeArgs = {
  model: RoomTypeInput;
};


export type MutationRoomTypeChannelDefultPriceArgs = {
  model: RoomTypeChannelDefultPriceInput;
};


export type MutationRoomTypeChannelDefultPriceDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RoomTypeChannelDefultPriceFilterInput>;
};


export type MutationRoomTypeDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RoomTypeFilterInput>;
};


export type MutationSaleArgs = {
  model: SaleInput;
};


export type MutationSaleDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SaleFilterInput>;
};


export type MutationSaleMultiUpdateArgs = {
  sales: Array<SaleMultiUpdateInput>;
};


export type MutationSaleTemplateArgs = {
  model: SaleTemplateInput;
};


export type MutationSaleTemplateDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SaleTemplateFilterInput>;
};


export type MutationSeasonArgs = {
  model: SeasonInput;
};


export type MutationSeasonDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeasonFilterInput>;
};


export type MutationWalletArgs = {
  model: WalletInput;
};


export type MutationWalletDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WalletFilterInput>;
};


export type MutationWalletTransactionArgs = {
  model: WalletTransactionInput;
};


export type MutationWalletTransactionDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WalletTransactionFilterInput>;
};

export type NotificationConfigFilterInput = {
  and?: InputMaybe<Array<NotificationConfigFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isEmailNotificationEnabled?: InputMaybe<BooleanOperationFilterInput>;
  isNtfyNotificationEnabled?: InputMaybe<BooleanOperationFilterInput>;
  isPushNotificationEnabled?: InputMaybe<BooleanOperationFilterInput>;
  notificationGroup?: InputMaybe<NotificationGroupsOperationFilterInput>;
  notificationType?: InputMaybe<NotificationTypesOperationFilterInput>;
  or?: InputMaybe<Array<NotificationConfigFilterInput>>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<IntOperationFilterInput>;
};

export type NotificationConfigSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isEmailNotificationEnabled?: InputMaybe<SortEnumType>;
  isNtfyNotificationEnabled?: InputMaybe<SortEnumType>;
  isPushNotificationEnabled?: InputMaybe<SortEnumType>;
  notificationGroup?: InputMaybe<SortEnumType>;
  notificationType?: InputMaybe<SortEnumType>;
  user?: InputMaybe<UserSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

export enum NotificationGroups {
  Accommodation = 'ACCOMMODATION',
  Agriculture = 'AGRICULTURE'
}

export type NotificationGroupsOperationFilterInput = {
  eq?: InputMaybe<NotificationGroups>;
  in?: InputMaybe<Array<NotificationGroups>>;
  neq?: InputMaybe<NotificationGroups>;
  nin?: InputMaybe<Array<NotificationGroups>>;
};

export enum NotificationTypes {
  AccommodationAgendaToday = 'ACCOMMODATION_AGENDA_TODAY',
  AccommodationAgendaTomorrow = 'ACCOMMODATION_AGENDA_TOMORROW',
  AccommodationEventNew = 'ACCOMMODATION_EVENT_NEW',
  AccommodationEventUpdate = 'ACCOMMODATION_EVENT_UPDATE',
  AccommodationReservationCancellation = 'ACCOMMODATION_RESERVATION_CANCELLATION',
  AccommodationReservationModification = 'ACCOMMODATION_RESERVATION_MODIFICATION',
  AccommodationReservationNew = 'ACCOMMODATION_RESERVATION_NEW',
  AccommodationReservationPaymentUpdate = 'ACCOMMODATION_RESERVATION_PAYMENT_UPDATE',
  AgricultureHarvestNew = 'AGRICULTURE_HARVEST_NEW',
  AgricultureHarvestUpdate = 'AGRICULTURE_HARVEST_UPDATE',
  AgricultureSaleNew = 'AGRICULTURE_SALE_NEW',
  AgricultureSaleUpdate = 'AGRICULTURE_SALE_UPDATE'
}

export type NotificationTypesOperationFilterInput = {
  eq?: InputMaybe<NotificationTypes>;
  in?: InputMaybe<Array<NotificationTypes>>;
  neq?: InputMaybe<NotificationTypes>;
  nin?: InputMaybe<Array<NotificationTypes>>;
};

export type NullableOfTypesOperationFilterInput = {
  eq?: InputMaybe<SaleTypes>;
  in?: InputMaybe<Array<InputMaybe<SaleTypes>>>;
  neq?: InputMaybe<SaleTypes>;
  nin?: InputMaybe<Array<InputMaybe<SaleTypes>>>;
};

export enum PaidTypes {
  PerDay = 'PER_DAY',
  PerHour = 'PER_HOUR',
  PerRoom = 'PER_ROOM',
  Total = 'TOTAL'
}

export type PaidTypesOperationFilterInput = {
  eq?: InputMaybe<PaidTypes>;
  in?: InputMaybe<Array<PaidTypes>>;
  neq?: InputMaybe<PaidTypes>;
  nin?: InputMaybe<Array<PaidTypes>>;
};

export type PersonContactInfoFilterInput = {
  and?: InputMaybe<Array<PersonContactInfoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  link?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PersonContactInfoFilterInput>>;
  person?: InputMaybe<PersonFilterInput>;
  personId?: InputMaybe<IntOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type PersonContactInfoInput = {
  id?: InputMaybe<Scalars['Int']>;
  link?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  personId: Scalars['Int'];
  value: Scalars['String'];
};

export type PersonContactInfoSortInput = {
  id?: InputMaybe<SortEnumType>;
  link?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  person?: InputMaybe<PersonSortInput>;
  personId?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

export type PersonFilterInput = {
  and?: InputMaybe<Array<PersonFilterInput>>;
  bookingEvents?: InputMaybe<ListFilterInputTypeOfBookingEventFilterInput>;
  bookings?: InputMaybe<ListFilterInputTypeOfBookingFilterInput>;
  contactInfo?: InputMaybe<ListFilterInputTypeOfPersonContactInfoFilterInput>;
  country?: InputMaybe<CountryFilterInput>;
  countryCode?: InputMaybe<StringOperationFilterInput>;
  eventTemplates?: InputMaybe<ListFilterInputTypeOfEventTemplateFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PersonFilterInput>>;
  sales?: InputMaybe<ListFilterInputTypeOfSaleFilterInput>;
  tags?: InputMaybe<ListFilterInputTypeOfPersonTagLinkFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<IntOperationFilterInput>;
  wallets?: InputMaybe<ListFilterInputTypeOfWalletFilterInput>;
  workers?: InputMaybe<ListFilterInputTypeOfWorkerFilterInput>;
};

export type PersonInput = {
  contactInfo?: InputMaybe<Array<PersonContactInfoInput>>;
  countryCode?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<PersonTagLinkInput>>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type PersonListObjectPropertyItemSortInputType = {
  bookingEvents?: InputMaybe<ListSortInputTypeBookingEvent>;
  bookings?: InputMaybe<ListSortInputTypeBooking>;
  contactInfo?: InputMaybe<ListSortInputTypePersonContactInfo>;
  eventTemplates?: InputMaybe<ListSortInputTypeEventTemplate>;
  sales?: InputMaybe<ListSortInputTypeSale>;
  tags?: InputMaybe<ListSortInputTypePersonTagLink>;
  wallets?: InputMaybe<ListSortInputTypeWallet>;
  workers?: InputMaybe<ListSortInputTypeWorker>;
};

export type PersonSortInput = {
  bookingEvents?: InputMaybe<ListSortInputTypeBookingEvent>;
  bookings?: InputMaybe<ListSortInputTypeBooking>;
  contactInfo?: InputMaybe<ListSortInputTypePersonContactInfo>;
  country?: InputMaybe<CountrySortInput>;
  countryCode?: InputMaybe<SortEnumType>;
  eventTemplates?: InputMaybe<ListSortInputTypeEventTemplate>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  sales?: InputMaybe<ListSortInputTypeSale>;
  tags?: InputMaybe<ListSortInputTypePersonTagLink>;
  user?: InputMaybe<UserSortInput>;
  userId?: InputMaybe<SortEnumType>;
  wallets?: InputMaybe<ListSortInputTypeWallet>;
  workers?: InputMaybe<ListSortInputTypeWorker>;
};

export type PersonTagFilterInput = {
  and?: InputMaybe<Array<PersonTagFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PersonTagFilterInput>>;
  personTagLinks?: InputMaybe<ListFilterInputTypeOfPersonTagLinkFilterInput>;
};

export type PersonTagInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type PersonTagLinkFilterInput = {
  and?: InputMaybe<Array<PersonTagLinkFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PersonTagLinkFilterInput>>;
  person?: InputMaybe<PersonFilterInput>;
  personId?: InputMaybe<IntOperationFilterInput>;
  tag?: InputMaybe<PersonTagFilterInput>;
  tagId?: InputMaybe<IntOperationFilterInput>;
};

export type PersonTagLinkInput = {
  id: Scalars['Int'];
  personId: Scalars['Int'];
  tagId: Scalars['Int'];
};

export type PersonTagLinkSortInput = {
  id?: InputMaybe<SortEnumType>;
  person?: InputMaybe<PersonSortInput>;
  personId?: InputMaybe<SortEnumType>;
  tag?: InputMaybe<PersonTagSortInput>;
  tagId?: InputMaybe<SortEnumType>;
};

export type PersonTagSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  personTagLinks?: InputMaybe<ListSortInputTypePersonTagLink>;
};

export type PushNotificationSubscriptionFilterInput = {
  and?: InputMaybe<Array<PushNotificationSubscriptionFilterInput>>;
  auth?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  endpoint?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PushNotificationSubscriptionFilterInput>>;
  p256dh?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<IntOperationFilterInput>;
};

export type PushNotificationSubscriptionSortInput = {
  auth?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  endpoint?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  p256dh?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  user?: InputMaybe<UserSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

export type Query = {
  __typename?: 'Query';
  /** Get accommodationMaintenanceLog item by query */
  accommodationMaintenanceLog?: Maybe<AccommodationMaintenanceLog>;
  /** Get accommodationMaintenanceLogRoom item by query */
  accommodationMaintenanceLogRoom?: Maybe<AccommodationMaintenanceLogRoom>;
  /** Get accommodationMaintenanceLogRooms list */
  accommodationMaintenanceLogRooms?: Maybe<AccommodationMaintenanceLogRooms>;
  /** Get accommodationMaintenanceLogs list */
  accommodationMaintenanceLogs?: Maybe<AccommodationMaintenanceLogs>;
  /** Get accommodationMaintenanceType item by query */
  accommodationMaintenanceType?: Maybe<AccommodationMaintenanceType>;
  /** Get accommodationMaintenanceTypes list */
  accommodationMaintenanceTypes?: Maybe<AccommodationMaintenanceTypes>;
  /** Get accommodationWork item by query */
  accommodationWork?: Maybe<AccommodationWork>;
  /** Get accommodationWorkInvestment item by query */
  accommodationWorkInvestment?: Maybe<AccommodationWorkInvestment>;
  /** Get accommodationWorkInvestments list */
  accommodationWorkInvestments?: Maybe<AccommodationWorkInvestments>;
  /** Get accommodationWorkMaintenance item by query */
  accommodationWorkMaintenance?: Maybe<AccommodationWorkMaintenance>;
  /** Get accommodationWorkMaintenances list */
  accommodationWorkMaintenances?: Maybe<AccommodationWorkMaintenances>;
  /** Get accommodationWorks list */
  accommodationWorks?: Maybe<AccommodationWorks>;
  /** Get agricultureWork item by query */
  agricultureWork?: Maybe<AgricultureWork>;
  /** Get agricultureWorkInvestment item by query */
  agricultureWorkInvestment?: Maybe<AgricultureWorkInvestment>;
  /** Get agricultureWorkInvestments list */
  agricultureWorkInvestments?: Maybe<AgricultureWorkInvestments>;
  /** Get agricultureWorkTemplate item by query */
  agricultureWorkTemplate?: Maybe<AgricultureWorkTemplate>;
  /** Get agricultureWorkTemplates list */
  agricultureWorkTemplates?: Maybe<AgricultureWorkTemplates>;
  /** Get agricultureWorks list */
  agricultureWorks?: Maybe<AgricultureWorks>;
  allRoles: Array<Maybe<Scalars['String']>>;
  /** Get apiToken item by query */
  apiToken?: Maybe<ApiToken>;
  /** Get apiTokens list */
  apiTokens?: Maybe<ApiTokens>;
  /** Get booking item by query */
  booking?: Maybe<Booking>;
  /** Get bookingAdditionalCharge item by query */
  bookingAdditionalCharge?: Maybe<BookingAdditionalCharge>;
  /** Get bookingAdditionalCharges list */
  bookingAdditionalCharges?: Maybe<BookingAdditionalCharges>;
  /** Get bookingAdditionalChargesTemplate item by query */
  bookingAdditionalChargesTemplate?: Maybe<BookingAdditionalChargesTemplate>;
  /** Get bookingAdditionalChargesTemplates list */
  bookingAdditionalChargesTemplates?: Maybe<BookingAdditionalChargesTemplates>;
  /** Get bookingAttachment item by query */
  bookingAttachment?: Maybe<BookingAttachment>;
  /** Get bookingAttachments list */
  bookingAttachments?: Maybe<BookingAttachments>;
  /** Get bookingBookingChannel item by query */
  bookingBookingChannel?: Maybe<BookingBookingChannel>;
  /** Get bookingBookingChannels list */
  bookingBookingChannels?: Maybe<BookingBookingChannels>;
  /** Get bookingChannel item by query */
  bookingChannel?: Maybe<BookingChannel>;
  /** Get bookingChannels list */
  bookingChannels?: Maybe<BookingChannels>;
  /** Get bookingDetails item by query */
  bookingDetails?: Maybe<BookingDetails>;
  /** Get bookingDetailss list */
  bookingDetailss?: Maybe<BookingDetailss>;
  /** Get bookingEvent item by query */
  bookingEvent?: Maybe<BookingEvent>;
  /** Get bookingEventLog item by query */
  bookingEventLog?: Maybe<BookingEventLog>;
  /** Get bookingEventLogs list */
  bookingEventLogs?: Maybe<BookingEventLogs>;
  /** Get bookingEvents list */
  bookingEvents?: Maybe<BookingEvents>;
  /** Get bookingLog item by query */
  bookingLog?: Maybe<BookingLog>;
  /** Get bookingLogs list */
  bookingLogs?: Maybe<BookingLogs>;
  /** Get bookings list */
  bookings?: Maybe<Bookings>;
  /** Get eventTemplate item by query */
  eventTemplate?: Maybe<EventTemplate>;
  /** Get eventTemplates list */
  eventTemplates?: Maybe<EventTemplates>;
  /** Get expense item by query */
  expense?: Maybe<Expense>;
  /** Get expenses list */
  expenses?: Maybe<Expenses>;
  /** Get fruit item by query */
  fruit?: Maybe<Fruit>;
  /** Get fruitCategiry item by query */
  fruitCategiry?: Maybe<FruitCategory>;
  /** Get fruitCategories list */
  fruitCategories?: Maybe<FruitCategories>;
  /** Get fruitGroup item by query */
  fruitGroup?: Maybe<FruitGroup>;
  /** Get fruitGroups list */
  fruitGroups?: Maybe<FruitGroups>;
  /** Get fruits list */
  fruits?: Maybe<Fruits>;
  /** Get harvest item by query */
  harvest?: Maybe<Harvest>;
  /** Get harvestAgricultureWork item by query */
  harvestAgricultureWork?: Maybe<HarvestAgricultureWork>;
  /** Get harvestAgricultureWorkTemplate item by query */
  harvestAgricultureWorkTemplate?: Maybe<HarvestAgricultureWorkTemplate>;
  /** Get harvestAgricultureWorkTemplates list */
  harvestAgricultureWorkTemplates?: Maybe<HarvestAgricultureWorkTemplates>;
  /** Get harvestAgricultureWorks list */
  harvestAgricultureWorks?: Maybe<HarvestAgricultureWorks>;
  /** Get harvestFruitCategory item by query */
  harvestFruitCategory?: Maybe<HarvestFruitCategory>;
  /** Get harvestFruitCategoryTemplate item by query */
  harvestFruitCategoryTemplate?: Maybe<HarvestFruitCategoryTemplate>;
  /** Get harvestFruitCategoryTemplates list */
  harvestFruitCategoryTemplates?: Maybe<HarvestFruitCategoryTemplates>;
  /** Get harvestFruitCategorys list */
  harvestFruitCategorys?: Maybe<HarvestFruitCategorys>;
  /** Get harvestFruitGroup item by query */
  harvestFruitGroup?: Maybe<HarvestFruitGroup>;
  /** Get harvestFruitGroupTemplate item by query */
  harvestFruitGroupTemplate?: Maybe<HarvestFruitGroupTemplate>;
  /** Get harvestFruitGroupTemplates list */
  harvestFruitGroupTemplates?: Maybe<HarvestFruitGroupTemplates>;
  /** Get harvestFruitGroups list */
  harvestFruitGroups?: Maybe<HarvestFruitGroups>;
  /** Get harvestTemplate item by query */
  harvestTemplate?: Maybe<HarvestTemplate>;
  /** Get harvestTemplates list */
  harvestTemplates?: Maybe<HarvestTemplates>;
  /** Get harvests list */
  harvests?: Maybe<Harvests>;
  /** Get income item by query */
  income?: Maybe<Income>;
  /** Get incomes list */
  incomes?: Maybe<Incomes>;
  /** Get maintenanceAgricultureWork item by query */
  maintenanceAgricultureWork?: Maybe<MaintenanceAgricultureWork>;
  /** Get maintenanceAgricultureWorkTemplate item by query */
  maintenanceAgricultureWorkTemplate?: Maybe<MaintenanceAgricultureWorkTemplate>;
  /** Get maintenanceAgricultureWorkTemplates list */
  maintenanceAgricultureWorkTemplates?: Maybe<MaintenanceAgricultureWorkTemplates>;
  /** Get maintenanceAgricultureWorks list */
  maintenanceAgricultureWorks?: Maybe<MaintenanceAgricultureWorks>;
  /** Get maintenanceLog item by query */
  maintenanceLog?: Maybe<MaintenanceLog>;
  /** Get maintenanceLogFruitGroup item by query */
  maintenanceLogFruitGroup?: Maybe<MaintenanceLogFruitGroup>;
  /** Get maintenanceLogFruitGroupTemplate item by query */
  maintenanceLogFruitGroupTemplate?: Maybe<MaintenanceLogFruitGroupTemplate>;
  /** Get maintenanceLogFruitGroupTemplates list */
  maintenanceLogFruitGroupTemplates?: Maybe<MaintenanceLogFruitGroupTemplates>;
  /** Get maintenanceLogFruitGroups list */
  maintenanceLogFruitGroups?: Maybe<MaintenanceLogFruitGroups>;
  /** Get maintenanceLogTemplate item by query */
  maintenanceLogTemplate?: Maybe<MaintenanceLogTemplate>;
  /** Get maintenanceLogTemplates list */
  maintenanceLogTemplates?: Maybe<MaintenanceLogTemplates>;
  /** Get maintenanceLogType item by query */
  maintenanceLogType?: Maybe<MaintenanceLogType>;
  /** Get maintenanceLogTypes list */
  maintenanceLogTypes?: Maybe<MaintenanceLogTypes>;
  /** Get maintenanceLogs list */
  maintenanceLogs?: Maybe<MaintenanceLogs>;
  /** Get logged user data */
  me?: Maybe<User>;
  /** Get notificationConfig item by query */
  notificationConfig?: Maybe<NotificationConfig>;
  /** Get notificationConfigs list */
  notificationConfigs?: Maybe<NotificationConfigs>;
  /** Get people list */
  people?: Maybe<People>;
  /** Get person item by query */
  person?: Maybe<Person>;
  /** Get personContactInfo item by query */
  personContactInfo?: Maybe<PersonContactInfo>;
  /** Get personContactInfos list */
  personContactInfos?: Maybe<PersonContactInfos>;
  /** Get personTag item by query */
  personTag?: Maybe<PersonTag>;
  /** Get personTagLink item by query */
  personTagLink?: Maybe<PersonTagLink>;
  /** Get personTagLinks list */
  personTagLinks?: Maybe<PersonTagLinks>;
  /** Get personTags list */
  personTags?: Maybe<PersonTags>;
  /** Get pushNotificationSubscription item by query */
  pushNotificationSubscription?: Maybe<PushNotificationSubscription>;
  /** Get pushNotificationSubscriptions list */
  pushNotificationSubscriptions?: Maybe<PushNotificationSubscriptions>;
  /** Get room item by query */
  room?: Maybe<Room>;
  /** Get roomType item by query */
  roomType?: Maybe<RoomType>;
  /** Get roomTypeChannelDefultPrice item by query */
  roomTypeChannelDefultPrice?: Maybe<RoomTypeChannelDefultPrice>;
  /** Get roomTypeChannelDefultPrices list */
  roomTypeChannelDefultPrices?: Maybe<RoomTypeChannelDefultPrices>;
  /** Get roomTypes list */
  roomTypes?: Maybe<RoomTypes>;
  /** Get rooms list */
  rooms?: Maybe<Rooms>;
  /** Get sale item by query */
  sale?: Maybe<Sale>;
  /** Get saleTemplate item by query */
  saleTemplate?: Maybe<SaleTemplate>;
  /** Get saleTemplates list */
  saleTemplates?: Maybe<SaleTemplates>;
  /** Get sales list */
  sales?: Maybe<Sales>;
  /** Get season item by query */
  season?: Maybe<Season>;
  /** Get seasons list */
  seasons?: Maybe<Seasons>;
  /** Get user item by query */
  user?: Maybe<User>;
  /** Get userAuthData item by query */
  userAuthData?: Maybe<UserAuthData>;
  /** Get userAuthDatas list */
  userAuthDatas?: Maybe<UserAuthDatas>;
  /** Get userRole item by query */
  userRole?: Maybe<UserRole>;
  /** Get userRoles list */
  userRoles?: Maybe<UserRoles>;
  /** Get users list */
  users?: Maybe<Users>;
  /** Get wallet item by query */
  wallet?: Maybe<Wallet>;
  /** Get walletTransaction item by query */
  walletTransaction?: Maybe<WalletTransaction>;
  /** Get walletTransactions list */
  walletTransactions?: Maybe<WalletTransactions>;
  /** Get wallets list */
  wallets?: Maybe<Wallets>;
  /** Get work item by query */
  work?: Maybe<Work>;
  /** Get workTemplate item by query */
  workTemplate?: Maybe<WorkTemplate>;
  /** Get workTemplates list */
  workTemplates?: Maybe<WorkTemplates>;
  /** Get worker item by query */
  worker?: Maybe<Worker>;
  /** Get workerTemplate item by query */
  workerTemplate?: Maybe<WorkerTemplate>;
  /** Get workerTemplates list */
  workerTemplates?: Maybe<WorkerTemplates>;
  /** Get workers list */
  workers?: Maybe<Workers>;
  /** Get works list */
  works?: Maybe<Works>;
};


export type QueryAccommodationMaintenanceLogArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<AccommodationMaintenanceLogSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccommodationMaintenanceLogFilterInput>;
};


export type QueryAccommodationMaintenanceLogRoomArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<AccommodationMaintenanceLogRoomSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccommodationMaintenanceLogRoomFilterInput>;
};


export type QueryAccommodationMaintenanceTypeArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<AccommodationMaintenanceTypeSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccommodationMaintenanceTypeFilterInput>;
};


export type QueryAccommodationWorkArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<AccommodationWorkSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccommodationWorkFilterInput>;
};


export type QueryAccommodationWorkInvestmentArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<AccommodationWorkInvestmentSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccommodationWorkInvestmentFilterInput>;
};


export type QueryAccommodationWorkMaintenanceArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<AccommodationWorkMaintenanceSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccommodationWorkMaintenanceFilterInput>;
};


export type QueryAgricultureWorkArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<AgricultureWorkSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AgricultureWorkFilterInput>;
};


export type QueryAgricultureWorkInvestmentArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<AgricultureWorkInvestmentSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AgricultureWorkInvestmentFilterInput>;
};


export type QueryAgricultureWorkTemplateArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<AgricultureWorkTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AgricultureWorkTemplateFilterInput>;
};


export type QueryApiTokenArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<ApiTokenSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApiTokenFilterInput>;
};


export type QueryBookingArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<BookingSortInput>>;
  ref?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingFilterInput>;
};


export type QueryBookingAdditionalChargeArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<BookingAdditionalChargeSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingAdditionalChargeFilterInput>;
};


export type QueryBookingAdditionalChargesTemplateArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<BookingAdditionalChargesTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingAdditionalChargesTemplateFilterInput>;
};


export type QueryBookingAttachmentArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<BookingAttachmentSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingAttachmentFilterInput>;
};


export type QueryBookingBookingChannelArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<BookingBookingChannelSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingBookingChannelFilterInput>;
};


export type QueryBookingChannelArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<BookingChannelSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingChannelFilterInput>;
};


export type QueryBookingDetailsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<BookingDetailsSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingDetailsFilterInput>;
};


export type QueryBookingEventArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<BookingEventSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingEventFilterInput>;
};


export type QueryBookingEventLogArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<BookingEventLogSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingEventLogFilterInput>;
};


export type QueryBookingLogArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<BookingLogSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type QueryEventTemplateArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<EventTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventTemplateFilterInput>;
};


export type QueryExpenseArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<ExpenseSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ExpenseFilterInput>;
};


export type QueryFruitArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<FruitSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FruitFilterInput>;
};


export type QueryFruitCategiryArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<FruitCategorySortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FruitCategoryFilterInput>;
};


export type QueryFruitGroupArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<FruitGroupSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FruitGroupFilterInput>;
};


export type QueryHarvestArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<HarvestSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestFilterInput>;
};


export type QueryHarvestAgricultureWorkArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<HarvestAgricultureWorkSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestAgricultureWorkFilterInput>;
};


export type QueryHarvestAgricultureWorkTemplateArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<HarvestAgricultureWorkTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestAgricultureWorkTemplateFilterInput>;
};


export type QueryHarvestFruitCategoryArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<HarvestFruitCategorySortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestFruitCategoryFilterInput>;
};


export type QueryHarvestFruitCategoryTemplateArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<HarvestFruitCategoryTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestFruitCategoryTemplateFilterInput>;
};


export type QueryHarvestFruitGroupArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<HarvestFruitGroupSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestFruitGroupFilterInput>;
};


export type QueryHarvestFruitGroupTemplateArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<HarvestFruitGroupTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestFruitGroupTemplateFilterInput>;
};


export type QueryHarvestTemplateArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<HarvestTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestTemplateFilterInput>;
};


export type QueryIncomeArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<IncomeSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IncomeFilterInput>;
};


export type QueryMaintenanceAgricultureWorkArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<MaintenanceAgricultureWorkSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceAgricultureWorkFilterInput>;
};


export type QueryMaintenanceAgricultureWorkTemplateArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<MaintenanceAgricultureWorkTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceAgricultureWorkTemplateFilterInput>;
};


export type QueryMaintenanceLogArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<MaintenanceLogSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceLogFilterInput>;
};


export type QueryMaintenanceLogFruitGroupArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<MaintenanceLogFruitGroupSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceLogFruitGroupFilterInput>;
};


export type QueryMaintenanceLogFruitGroupTemplateArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<MaintenanceLogFruitGroupTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceLogFruitGroupTemplateFilterInput>;
};


export type QueryMaintenanceLogTemplateArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<MaintenanceLogTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceLogTemplateFilterInput>;
};


export type QueryMaintenanceLogTypeArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<MaintenanceLogTypeSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceLogTypeFilterInput>;
};


export type QueryNotificationConfigArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<NotificationConfigSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NotificationConfigFilterInput>;
};


export type QueryPersonArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<PersonSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PersonFilterInput>;
};


export type QueryPersonContactInfoArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<PersonContactInfoSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PersonContactInfoFilterInput>;
};


export type QueryPersonTagArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<PersonTagSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PersonTagFilterInput>;
};


export type QueryPersonTagLinkArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<PersonTagLinkSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PersonTagLinkFilterInput>;
};


export type QueryPushNotificationSubscriptionArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<PushNotificationSubscriptionSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PushNotificationSubscriptionFilterInput>;
};


export type QueryRoomArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<RoomSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RoomFilterInput>;
};


export type QueryRoomTypeArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<RoomTypeSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RoomTypeFilterInput>;
};


export type QueryRoomTypeChannelDefultPriceArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<RoomTypeChannelDefultPriceSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RoomTypeChannelDefultPriceFilterInput>;
};


export type QuerySaleArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<SaleSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SaleFilterInput>;
};


export type QuerySaleTemplateArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<SaleTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SaleTemplateFilterInput>;
};


export type QuerySeasonArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<SeasonSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeasonFilterInput>;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<UserSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserFilterInput>;
};


export type QueryUserAuthDataArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<UserAuthDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserAuthDataFilterInput>;
};


export type QueryUserRoleArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<UserRoleSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserRoleFilterInput>;
};


export type QueryWalletArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<WalletSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WalletFilterInput>;
};


export type QueryWalletTransactionArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<WalletTransactionSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WalletTransactionFilterInput>;
};


export type QueryWorkArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<WorkSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkFilterInput>;
};


export type QueryWorkTemplateArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<WorkTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkTemplateFilterInput>;
};


export type QueryWorkerArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<WorkerSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkerFilterInput>;
};


export type QueryWorkerTemplateArgs = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<WorkerTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkerTemplateFilterInput>;
};

export type RoomFilterInput = {
  and?: InputMaybe<Array<RoomFilterInput>>;
  bookingDetails?: InputMaybe<ListFilterInputTypeOfBookingDetailsFilterInput>;
  bookings?: InputMaybe<ListFilterInputTypeOfBookingFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RoomFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  roomType?: InputMaybe<RoomTypeFilterInput>;
  roomTypeId?: InputMaybe<IntOperationFilterInput>;
  worklogs?: InputMaybe<ListFilterInputTypeOfAccommodationMaintenanceLogRoomFilterInput>;
};

export type RoomInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  roomTypeId: Scalars['Int'];
};

export type RoomListNumberFunctionPropertyItemSortInputType = {
  bookingDetails?: InputMaybe<ListSortInputTypeBookingDetails>;
  bookings?: InputMaybe<ListSortInputTypeBooking>;
  order?: InputMaybe<SortEnumType>;
  roomType?: InputMaybe<RoomTypeListObjectPropertyItemSortInputType>;
  worklogs?: InputMaybe<ListSortInputTypeAccommodationMaintenanceLogRoom>;
};

export type RoomListObjectPropertyItemSortInputType = {
  bookingDetails?: InputMaybe<ListSortInputTypeBookingDetails>;
  bookings?: InputMaybe<ListSortInputTypeBooking>;
  order?: InputMaybe<SortEnumType>;
  roomType?: InputMaybe<RoomTypeListObjectPropertyItemSortInputType>;
  worklogs?: InputMaybe<ListSortInputTypeAccommodationMaintenanceLogRoom>;
};

export type RoomSortInput = {
  bookingDetails?: InputMaybe<ListSortInputTypeBookingDetails>;
  bookings?: InputMaybe<ListSortInputTypeBooking>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
  roomType?: InputMaybe<RoomTypeSortInput>;
  roomTypeId?: InputMaybe<SortEnumType>;
  worklogs?: InputMaybe<ListSortInputTypeAccommodationMaintenanceLogRoom>;
};

export type RoomTypeChannelDefultPriceFilterInput = {
  and?: InputMaybe<Array<RoomTypeChannelDefultPriceFilterInput>>;
  channel?: InputMaybe<BookingChannelFilterInput>;
  channelId?: InputMaybe<IntOperationFilterInput>;
  defaultPrice?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RoomTypeChannelDefultPriceFilterInput>>;
  roomType?: InputMaybe<RoomTypeFilterInput>;
  roomTypeId?: InputMaybe<IntOperationFilterInput>;
};

export type RoomTypeChannelDefultPriceInput = {
  channelId: Scalars['Int'];
  defaultPrice: Scalars['Decimal'];
  id: Scalars['Int'];
  roomTypeId: Scalars['Int'];
};

export type RoomTypeChannelDefultPriceListNumberFunctionPropertyItemSortInputType = {
  channel?: InputMaybe<BookingChannelListObjectPropertyItemSortInputType>;
  defaultPrice?: InputMaybe<SortEnumType>;
  roomType?: InputMaybe<RoomTypeListObjectPropertyItemSortInputType>;
};

export type RoomTypeChannelDefultPriceSortInput = {
  channel?: InputMaybe<BookingChannelSortInput>;
  channelId?: InputMaybe<SortEnumType>;
  defaultPrice?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  roomType?: InputMaybe<RoomTypeSortInput>;
  roomTypeId?: InputMaybe<SortEnumType>;
};

export type RoomTypeFilterInput = {
  and?: InputMaybe<Array<RoomTypeFilterInput>>;
  bookings?: InputMaybe<ListFilterInputTypeOfBookingFilterInput>;
  channelDefultPrices?: InputMaybe<ListFilterInputTypeOfRoomTypeChannelDefultPriceFilterInput>;
  color?: InputMaybe<StringOperationFilterInput>;
  defaultPrice?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RoomTypeFilterInput>>;
  rooms?: InputMaybe<ListFilterInputTypeOfRoomFilterInput>;
};

export type RoomTypeInput = {
  channelDefultPrices?: InputMaybe<Array<InputMaybe<RoomTypeChannelDefultPriceInput>>>;
  color?: InputMaybe<Scalars['String']>;
  defaultPrice?: InputMaybe<Scalars['Decimal']>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type RoomTypeListObjectPropertyItemSortInputType = {
  bookings?: InputMaybe<ListSortInputTypeBooking>;
  channelDefultPrices?: InputMaybe<ListSortInputTypeRoomTypeChannelDefultPrice>;
  defaultPrice?: InputMaybe<SortEnumType>;
  rooms?: InputMaybe<ListSortInputTypeRoom>;
};

export type RoomTypeSortInput = {
  bookings?: InputMaybe<ListSortInputTypeBooking>;
  channelDefultPrices?: InputMaybe<ListSortInputTypeRoomTypeChannelDefultPrice>;
  color?: InputMaybe<SortEnumType>;
  defaultPrice?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  rooms?: InputMaybe<ListSortInputTypeRoom>;
};

export type Sale = {
  __typename?: 'Sale';
  cartQuantity: Scalars['Int'];
  category?: Maybe<FruitCategory>;
  categoryId?: Maybe<Scalars['Int']>;
  chamber: Scalars['Boolean'];
  date: Scalars['LocalDate'];
  fruit: Fruit;
  fruitId: Scalars['Int'];
  id: Scalars['Int'];
  income?: Maybe<Income>;
  incomeId?: Maybe<Scalars['Int']>;
  kg: Scalars['Decimal'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  person: Person;
  personId: Scalars['Int'];
  pricePerKg: Scalars['Decimal'];
  season: Season;
  seasonId: Scalars['Int'];
  total: Scalars['Decimal'];
  type?: Maybe<SaleTypes>;
  wallet?: Maybe<Wallet>;
  walletId?: Maybe<Scalars['Int']>;
};

export type SaleFilterInput = {
  and?: InputMaybe<Array<SaleFilterInput>>;
  cartQuantity?: InputMaybe<IntOperationFilterInput>;
  category?: InputMaybe<FruitCategoryFilterInput>;
  categoryId?: InputMaybe<IntOperationFilterInput>;
  chamber?: InputMaybe<BooleanOperationFilterInput>;
  date?: InputMaybe<LocalDateOperationFilterInput>;
  fruit?: InputMaybe<FruitFilterInput>;
  fruitId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  income?: InputMaybe<IncomeFilterInput>;
  incomeId?: InputMaybe<IntOperationFilterInput>;
  kg?: InputMaybe<DecimalOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SaleFilterInput>>;
  person?: InputMaybe<PersonFilterInput>;
  personId?: InputMaybe<IntOperationFilterInput>;
  pricePerKg?: InputMaybe<DecimalOperationFilterInput>;
  season?: InputMaybe<SeasonFilterInput>;
  seasonId?: InputMaybe<IntOperationFilterInput>;
  total?: InputMaybe<DecimalOperationFilterInput>;
  type?: InputMaybe<TypesOperationFilterInput>;
  wallet?: InputMaybe<WalletFilterInput>;
  walletId?: InputMaybe<IntOperationFilterInput>;
};

export type SaleInput = {
  cartQuantity: Scalars['Int'];
  categoryId?: InputMaybe<Scalars['Int']>;
  chamber: Scalars['Boolean'];
  date: Scalars['LocalDate'];
  fruitId: Scalars['Int'];
  id: Scalars['Int'];
  incomeId?: InputMaybe<Scalars['Int']>;
  kg: Scalars['Decimal'];
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  personId: Scalars['Int'];
  pricePerKg: Scalars['Decimal'];
  seasonId: Scalars['Int'];
  total: Scalars['Decimal'];
  type: SaleTypes;
  walletId?: InputMaybe<Scalars['Int']>;
};

export type SaleListNumberFunctionPropertyItemSortInputType = {
  cartQuantity?: InputMaybe<SortEnumType>;
  category?: InputMaybe<FruitCategoryListObjectPropertyItemSortInputType>;
  fruit?: InputMaybe<FruitListObjectPropertyItemSortInputType>;
  income?: InputMaybe<IncomeListObjectPropertyItemSortInputType>;
  kg?: InputMaybe<SortEnumType>;
  person?: InputMaybe<PersonListObjectPropertyItemSortInputType>;
  pricePerKg?: InputMaybe<SortEnumType>;
  season?: InputMaybe<SeasonListObjectPropertyItemSortInputType>;
  total?: InputMaybe<SortEnumType>;
  wallet?: InputMaybe<WalletListObjectPropertyItemSortInputType>;
};

export type SaleMultiUpdateInput = {
  id: Scalars['Int'];
  kg: Scalars['Decimal'];
  pricePerKg: Scalars['Decimal'];
  total: Scalars['Decimal'];
  walletId?: InputMaybe<Scalars['Int']>;
};

export type SaleSortInput = {
  cartQuantity?: InputMaybe<SortEnumType>;
  category?: InputMaybe<FruitCategorySortInput>;
  categoryId?: InputMaybe<SortEnumType>;
  chamber?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  fruit?: InputMaybe<FruitSortInput>;
  fruitId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  income?: InputMaybe<IncomeSortInput>;
  incomeId?: InputMaybe<SortEnumType>;
  kg?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  person?: InputMaybe<PersonSortInput>;
  personId?: InputMaybe<SortEnumType>;
  pricePerKg?: InputMaybe<SortEnumType>;
  season?: InputMaybe<SeasonSortInput>;
  seasonId?: InputMaybe<SortEnumType>;
  total?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  wallet?: InputMaybe<WalletSortInput>;
  walletId?: InputMaybe<SortEnumType>;
};

export type SaleTemplateFilterInput = {
  and?: InputMaybe<Array<SaleTemplateFilterInput>>;
  cartQuantity?: InputMaybe<IntOperationFilterInput>;
  category?: InputMaybe<FruitCategoryFilterInput>;
  categoryId?: InputMaybe<IntOperationFilterInput>;
  chamber?: InputMaybe<BooleanOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  fruit?: InputMaybe<FruitFilterInput>;
  fruitId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  kg?: InputMaybe<DecimalOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SaleTemplateFilterInput>>;
  person?: InputMaybe<PersonFilterInput>;
  personId?: InputMaybe<IntOperationFilterInput>;
  pricePerKg?: InputMaybe<DecimalOperationFilterInput>;
  season?: InputMaybe<SeasonFilterInput>;
  seasonId?: InputMaybe<IntOperationFilterInput>;
  total?: InputMaybe<DecimalOperationFilterInput>;
  type?: InputMaybe<NullableOfTypesOperationFilterInput>;
};

export type SaleTemplateInput = {
  cartQuantity?: InputMaybe<Scalars['Int']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  chamber?: InputMaybe<Scalars['Boolean']>;
  date?: InputMaybe<Scalars['DateTime']>;
  fruitId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  kg?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['Int']>;
  pricePerKg?: InputMaybe<Scalars['Decimal']>;
  seasonId?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['Decimal']>;
  type?: InputMaybe<SaleTypes>;
};

export type SaleTemplateSortInput = {
  cartQuantity?: InputMaybe<SortEnumType>;
  category?: InputMaybe<FruitCategorySortInput>;
  categoryId?: InputMaybe<SortEnumType>;
  chamber?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  fruit?: InputMaybe<FruitSortInput>;
  fruitId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  kg?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  person?: InputMaybe<PersonSortInput>;
  personId?: InputMaybe<SortEnumType>;
  pricePerKg?: InputMaybe<SortEnumType>;
  season?: InputMaybe<SeasonSortInput>;
  seasonId?: InputMaybe<SortEnumType>;
  total?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export enum SaleTypes {
  Retail = 'RETAIL',
  Wholesale = 'WHOLESALE'
}

export type SeasonFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<SeasonFilterInput>>;
  bookings?: InputMaybe<ListFilterInputTypeOfBookingFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SeasonFilterInput>>;
  sales?: InputMaybe<ListFilterInputTypeOfSaleFilterInput>;
  seasonYear?: InputMaybe<IntOperationFilterInput>;
  works?: InputMaybe<ListFilterInputTypeOfWorkFilterInput>;
};

export type SeasonInput = {
  active: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type SeasonListObjectPropertyItemSortInputType = {
  bookings?: InputMaybe<ListSortInputTypeBooking>;
  sales?: InputMaybe<ListSortInputTypeSale>;
  seasonYear?: InputMaybe<SortEnumType>;
  works?: InputMaybe<ListSortInputTypeWork>;
};

export type SeasonSortInput = {
  active?: InputMaybe<SortEnumType>;
  bookings?: InputMaybe<ListSortInputTypeBooking>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  sales?: InputMaybe<ListSortInputTypeSale>;
  seasonYear?: InputMaybe<SortEnumType>;
  works?: InputMaybe<ListSortInputTypeWork>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum Statuses {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  PaddingApproval = 'PADDING_APPROVAL'
}

export type StatusesOperationFilterInput = {
  eq?: InputMaybe<Statuses>;
  in?: InputMaybe<Array<Statuses>>;
  neq?: InputMaybe<Statuses>;
  nin?: InputMaybe<Array<Statuses>>;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ncontains?: InputMaybe<Scalars['String']>;
  nendsWith?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nstartsWith?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type TypesOperationFilterInput = {
  eq?: InputMaybe<SaleTypes>;
  in?: InputMaybe<Array<SaleTypes>>;
  neq?: InputMaybe<SaleTypes>;
  nin?: InputMaybe<Array<SaleTypes>>;
};

export enum Units {
  Item = 'ITEM',
  Kg = 'KG',
  L = 'L'
}

export type UnitsOperationFilterInput = {
  eq?: InputMaybe<Units>;
  in?: InputMaybe<Array<Units>>;
  neq?: InputMaybe<Units>;
  nin?: InputMaybe<Array<Units>>;
};

export type UserAuthDataFilterInput = {
  and?: InputMaybe<Array<UserAuthDataFilterInput>>;
  externalUserId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  identifier?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserAuthDataFilterInput>>;
  provider?: InputMaybe<AuthProviderOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<IntOperationFilterInput>;
};

export type UserAuthDataSortInput = {
  externalUserId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  identifier?: InputMaybe<SortEnumType>;
  provider?: InputMaybe<SortEnumType>;
  user?: InputMaybe<UserSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

export type UserFilterInput = {
  and?: InputMaybe<Array<UserFilterInput>>;
  authData?: InputMaybe<ListFilterInputTypeOfUserAuthDataFilterInput>;
  forceReAuthentication?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  notificationConfigs?: InputMaybe<ListFilterInputTypeOfNotificationConfigFilterInput>;
  or?: InputMaybe<Array<UserFilterInput>>;
  pushNotificationSubscriptions?: InputMaybe<ListFilterInputTypeOfPushNotificationSubscriptionFilterInput>;
  roles?: InputMaybe<ListFilterInputTypeOfUserRoleFilterInput>;
  status?: InputMaybe<StatusesOperationFilterInput>;
  username?: InputMaybe<StringOperationFilterInput>;
};

export type UserRoleFilterInput = {
  and?: InputMaybe<Array<UserRoleFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<UserRoleFilterInput>>;
  role?: InputMaybe<StringOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<IntOperationFilterInput>;
};

export type UserRoleSortInput = {
  id?: InputMaybe<SortEnumType>;
  role?: InputMaybe<SortEnumType>;
  user?: InputMaybe<UserSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

export type UserSortInput = {
  authData?: InputMaybe<ListSortInputTypeUserAuthData>;
  forceReAuthentication?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  notificationConfigs?: InputMaybe<ListSortInputTypeNotificationConfig>;
  pushNotificationSubscriptions?: InputMaybe<ListSortInputTypePushNotificationSubscription>;
  roles?: InputMaybe<ListSortInputTypeUserRole>;
  status?: InputMaybe<SortEnumType>;
  username?: InputMaybe<SortEnumType>;
};

export type WalletFilterInput = {
  and?: InputMaybe<Array<WalletFilterInput>>;
  archived?: InputMaybe<BooleanOperationFilterInput>;
  deposit?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WalletFilterInput>>;
  person?: InputMaybe<PersonFilterInput>;
  personId?: InputMaybe<IntOperationFilterInput>;
  sales?: InputMaybe<ListFilterInputTypeOfSaleFilterInput>;
  transactions?: InputMaybe<ListFilterInputTypeOfWalletTransactionFilterInput>;
};

export type WalletInput = {
  archived: Scalars['Boolean'];
  deposit: Scalars['Decimal'];
  id: Scalars['Int'];
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  personId: Scalars['Int'];
};

export type WalletListNumberFunctionPropertyItemSortInputType = {
  deposit?: InputMaybe<SortEnumType>;
  person?: InputMaybe<PersonListObjectPropertyItemSortInputType>;
  sales?: InputMaybe<ListSortInputTypeSale>;
  transactions?: InputMaybe<ListSortInputTypeWalletTransaction>;
};

export type WalletListObjectPropertyItemSortInputType = {
  deposit?: InputMaybe<SortEnumType>;
  person?: InputMaybe<PersonListObjectPropertyItemSortInputType>;
  sales?: InputMaybe<ListSortInputTypeSale>;
  transactions?: InputMaybe<ListSortInputTypeWalletTransaction>;
};

export type WalletSortInput = {
  archived?: InputMaybe<SortEnumType>;
  deposit?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  person?: InputMaybe<PersonSortInput>;
  personId?: InputMaybe<SortEnumType>;
  sales?: InputMaybe<ListSortInputTypeSale>;
  transactions?: InputMaybe<ListSortInputTypeWalletTransaction>;
};

export type WalletTransactionFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<WalletTransactionFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WalletTransactionFilterInput>>;
  transactionDate?: InputMaybe<DateTimeOperationFilterInput>;
  transactionId?: InputMaybe<StringOperationFilterInput>;
  wallet?: InputMaybe<WalletFilterInput>;
  walletId?: InputMaybe<IntOperationFilterInput>;
};

export type WalletTransactionInput = {
  amount: Scalars['Decimal'];
  id: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
  transactionDate: Scalars['DateTime'];
  transactionId?: InputMaybe<Scalars['String']>;
  walletId: Scalars['Int'];
};

export type WalletTransactionListNumberFunctionPropertyItemSortInputType = {
  amount?: InputMaybe<SortEnumType>;
  wallet?: InputMaybe<WalletListObjectPropertyItemSortInputType>;
};

export type WalletTransactionSortInput = {
  amount?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  transactionDate?: InputMaybe<SortEnumType>;
  transactionId?: InputMaybe<SortEnumType>;
  wallet?: InputMaybe<WalletSortInput>;
  walletId?: InputMaybe<SortEnumType>;
};

export enum WorkCategories {
  Accommodation = 'ACCOMMODATION',
  Agriculture = 'AGRICULTURE'
}

export type WorkCategoriesOperationFilterInput = {
  eq?: InputMaybe<WorkCategories>;
  in?: InputMaybe<Array<WorkCategories>>;
  neq?: InputMaybe<WorkCategories>;
  nin?: InputMaybe<Array<WorkCategories>>;
};

export type WorkFilterInput = {
  and?: InputMaybe<Array<WorkFilterInput>>;
  category?: InputMaybe<WorkCategoriesOperationFilterInput>;
  endDate?: InputMaybe<LocalDateOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WorkFilterInput>>;
  season?: InputMaybe<SeasonFilterInput>;
  seasonId?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<LocalDateOperationFilterInput>;
  workers?: InputMaybe<ListFilterInputTypeOfWorkerFilterInput>;
};

export type WorkListObjectPropertyItemSortInputType = {
  season?: InputMaybe<SeasonListObjectPropertyItemSortInputType>;
  workers?: InputMaybe<ListSortInputTypeWorker>;
};

export type WorkSortInput = {
  category?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  season?: InputMaybe<SeasonSortInput>;
  seasonId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  workers?: InputMaybe<ListSortInputTypeWorker>;
};

export type WorkTemplateFilterInput = {
  and?: InputMaybe<Array<WorkTemplateFilterInput>>;
  category?: InputMaybe<WorkCategoriesOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WorkTemplateFilterInput>>;
  season?: InputMaybe<SeasonFilterInput>;
  seasonId?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  workers?: InputMaybe<ListFilterInputTypeOfWorkerTemplateFilterInput>;
};

export type WorkTemplateListObjectPropertyItemSortInputType = {
  season?: InputMaybe<SeasonListObjectPropertyItemSortInputType>;
  workers?: InputMaybe<ListSortInputTypeWorkerTemplate>;
};

export type WorkTemplateSortInput = {
  category?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  season?: InputMaybe<SeasonSortInput>;
  seasonId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  workers?: InputMaybe<ListSortInputTypeWorkerTemplate>;
};

export type WorkerFilterInput = {
  and?: InputMaybe<Array<WorkerFilterInput>>;
  date?: InputMaybe<LocalDateOperationFilterInput>;
  expense?: InputMaybe<ExpenseFilterInput>;
  expenseId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<WorkerFilterInput>>;
  person?: InputMaybe<PersonFilterInput>;
  personId?: InputMaybe<IntOperationFilterInput>;
  price?: InputMaybe<DecimalOperationFilterInput>;
  work?: InputMaybe<WorkFilterInput>;
  workId?: InputMaybe<IntOperationFilterInput>;
};

export type WorkerInput = {
  date: Scalars['LocalDate'];
  expenseId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  personId: Scalars['Int'];
  price: Scalars['Decimal'];
  workId?: InputMaybe<Scalars['Int']>;
};

export type WorkerListNumberFunctionPropertyItemSortInputType = {
  expense?: InputMaybe<ExpenseListObjectPropertyItemSortInputType>;
  person?: InputMaybe<PersonListObjectPropertyItemSortInputType>;
  price?: InputMaybe<SortEnumType>;
  work?: InputMaybe<WorkListObjectPropertyItemSortInputType>;
};

export type WorkerSortInput = {
  date?: InputMaybe<SortEnumType>;
  expense?: InputMaybe<ExpenseSortInput>;
  expenseId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  person?: InputMaybe<PersonSortInput>;
  personId?: InputMaybe<SortEnumType>;
  price?: InputMaybe<SortEnumType>;
  work?: InputMaybe<WorkSortInput>;
  workId?: InputMaybe<SortEnumType>;
};

export type WorkerTemplateFilterInput = {
  and?: InputMaybe<Array<WorkerTemplateFilterInput>>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  expense?: InputMaybe<ExpenseFilterInput>;
  expenseId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<WorkerTemplateFilterInput>>;
  person?: InputMaybe<PersonFilterInput>;
  personId?: InputMaybe<IntOperationFilterInput>;
  price?: InputMaybe<DecimalOperationFilterInput>;
  work?: InputMaybe<WorkTemplateFilterInput>;
  workId?: InputMaybe<IntOperationFilterInput>;
};

export type WorkerTemplateInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  expenseId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  personId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Decimal']>;
  workId?: InputMaybe<Scalars['Int']>;
};

export type WorkerTemplateListNumberFunctionPropertyItemSortInputType = {
  expense?: InputMaybe<ExpenseListObjectPropertyItemSortInputType>;
  person?: InputMaybe<PersonListObjectPropertyItemSortInputType>;
  price?: InputMaybe<SortEnumType>;
  work?: InputMaybe<WorkTemplateListObjectPropertyItemSortInputType>;
};

export type WorkerTemplateSortInput = {
  date?: InputMaybe<SortEnumType>;
  expense?: InputMaybe<ExpenseSortInput>;
  expenseId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  person?: InputMaybe<PersonSortInput>;
  personId?: InputMaybe<SortEnumType>;
  price?: InputMaybe<SortEnumType>;
  work?: InputMaybe<WorkTemplateSortInput>;
  workId?: InputMaybe<SortEnumType>;
};

export type AccommodationMaintenanceLog = {
  __typename?: 'accommodationMaintenanceLog';
  id: Scalars['Int'];
  investment?: Maybe<AccommodationWorkInvestment>;
  investmentId?: Maybe<Scalars['Int']>;
  logRooms: AccommodationMaintenanceLogRooms;
  maintenanceType: AccommodationMaintenanceType;
  maintenanceTypeId: Scalars['Int'];
  paidType: PaidTypes;
  work: AccommodationWorkMaintenance;
  workId: Scalars['Int'];
};

export type AccommodationMaintenanceLogRoom = {
  __typename?: 'accommodationMaintenanceLogRoom';
  id: Scalars['Int'];
  log: AccommodationMaintenanceLog;
  logId: Scalars['Int'];
  room: Room;
  roomId: Scalars['Int'];
};

export type AccommodationMaintenanceLogRooms = {
  __typename?: 'accommodationMaintenanceLogRooms';
  /** Get AccommodationMaintenanceLogRooms any */
  any: Scalars['Boolean'];
  /** Get AccommodationMaintenanceLogRooms count */
  count: Scalars['Int'];
  /** Get AccommodationMaintenanceLogRooms idAverage */
  idAverage: Scalars['Decimal'];
  /** Get AccommodationMaintenanceLogRooms idSum */
  idSum: Scalars['Decimal'];
  /** Get $AccommodationMaintenanceLogRooms list */
  items: Array<AccommodationMaintenanceLogRoom>;
  /** Get AccommodationMaintenanceLogRooms logIdAverage */
  logIdAverage: Scalars['Decimal'];
  /** Get AccommodationMaintenanceLogRooms logIdSum */
  logIdSum: Scalars['Decimal'];
  /** Get AccommodationMaintenanceLogRooms roomIdAverage */
  roomIdAverage: Scalars['Decimal'];
  /** Get AccommodationMaintenanceLogRooms roomIdSum */
  roomIdSum: Scalars['Decimal'];
};


export type AccommodationMaintenanceLogRoomsAnyArgs = {
  where?: InputMaybe<AccommodationMaintenanceLogRoomFilterInput>;
};


export type AccommodationMaintenanceLogRoomsCountArgs = {
  where?: InputMaybe<AccommodationMaintenanceLogRoomFilterInput>;
};


export type AccommodationMaintenanceLogRoomsIdAverageArgs = {
  order?: InputMaybe<Array<AccommodationMaintenanceLogRoomSortInput>>;
  where?: InputMaybe<AccommodationMaintenanceLogRoomFilterInput>;
};


export type AccommodationMaintenanceLogRoomsIdSumArgs = {
  order?: InputMaybe<Array<AccommodationMaintenanceLogRoomSortInput>>;
  where?: InputMaybe<AccommodationMaintenanceLogRoomFilterInput>;
};


export type AccommodationMaintenanceLogRoomsItemsArgs = {
  order?: InputMaybe<Array<AccommodationMaintenanceLogRoomSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccommodationMaintenanceLogRoomFilterInput>;
};


export type AccommodationMaintenanceLogRoomsLogIdAverageArgs = {
  order?: InputMaybe<Array<AccommodationMaintenanceLogRoomSortInput>>;
  where?: InputMaybe<AccommodationMaintenanceLogRoomFilterInput>;
};


export type AccommodationMaintenanceLogRoomsLogIdSumArgs = {
  order?: InputMaybe<Array<AccommodationMaintenanceLogRoomSortInput>>;
  where?: InputMaybe<AccommodationMaintenanceLogRoomFilterInput>;
};


export type AccommodationMaintenanceLogRoomsRoomIdAverageArgs = {
  order?: InputMaybe<Array<AccommodationMaintenanceLogRoomSortInput>>;
  where?: InputMaybe<AccommodationMaintenanceLogRoomFilterInput>;
};


export type AccommodationMaintenanceLogRoomsRoomIdSumArgs = {
  order?: InputMaybe<Array<AccommodationMaintenanceLogRoomSortInput>>;
  where?: InputMaybe<AccommodationMaintenanceLogRoomFilterInput>;
};

export type AccommodationMaintenanceLogs = {
  __typename?: 'accommodationMaintenanceLogs';
  /** Get AccommodationMaintenanceLogs any */
  any: Scalars['Boolean'];
  /** Get AccommodationMaintenanceLogs count */
  count: Scalars['Int'];
  /** Get AccommodationMaintenanceLogs idAverage */
  idAverage: Scalars['Decimal'];
  /** Get AccommodationMaintenanceLogs idSum */
  idSum: Scalars['Decimal'];
  /** Get AccommodationMaintenanceLogs investmentIdAverage */
  investmentIdAverage: Scalars['Decimal'];
  /** Get AccommodationMaintenanceLogs investmentIdSum */
  investmentIdSum: Scalars['Decimal'];
  /** Get $AccommodationMaintenanceLogs list */
  items: Array<AccommodationMaintenanceLog>;
  /** Get AccommodationMaintenanceLogs maintenanceTypeIdAverage */
  maintenanceTypeIdAverage: Scalars['Decimal'];
  /** Get AccommodationMaintenanceLogs maintenanceTypeIdSum */
  maintenanceTypeIdSum: Scalars['Decimal'];
  /** Get AccommodationMaintenanceLogs workIdAverage */
  workIdAverage: Scalars['Decimal'];
  /** Get AccommodationMaintenanceLogs workIdSum */
  workIdSum: Scalars['Decimal'];
};


export type AccommodationMaintenanceLogsAnyArgs = {
  where?: InputMaybe<AccommodationMaintenanceLogFilterInput>;
};


export type AccommodationMaintenanceLogsCountArgs = {
  where?: InputMaybe<AccommodationMaintenanceLogFilterInput>;
};


export type AccommodationMaintenanceLogsIdAverageArgs = {
  order?: InputMaybe<Array<AccommodationMaintenanceLogSortInput>>;
  where?: InputMaybe<AccommodationMaintenanceLogFilterInput>;
};


export type AccommodationMaintenanceLogsIdSumArgs = {
  order?: InputMaybe<Array<AccommodationMaintenanceLogSortInput>>;
  where?: InputMaybe<AccommodationMaintenanceLogFilterInput>;
};


export type AccommodationMaintenanceLogsInvestmentIdAverageArgs = {
  order?: InputMaybe<Array<AccommodationMaintenanceLogSortInput>>;
  where?: InputMaybe<AccommodationMaintenanceLogFilterInput>;
};


export type AccommodationMaintenanceLogsInvestmentIdSumArgs = {
  order?: InputMaybe<Array<AccommodationMaintenanceLogSortInput>>;
  where?: InputMaybe<AccommodationMaintenanceLogFilterInput>;
};


export type AccommodationMaintenanceLogsItemsArgs = {
  order?: InputMaybe<Array<AccommodationMaintenanceLogSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccommodationMaintenanceLogFilterInput>;
};


export type AccommodationMaintenanceLogsMaintenanceTypeIdAverageArgs = {
  order?: InputMaybe<Array<AccommodationMaintenanceLogSortInput>>;
  where?: InputMaybe<AccommodationMaintenanceLogFilterInput>;
};


export type AccommodationMaintenanceLogsMaintenanceTypeIdSumArgs = {
  order?: InputMaybe<Array<AccommodationMaintenanceLogSortInput>>;
  where?: InputMaybe<AccommodationMaintenanceLogFilterInput>;
};


export type AccommodationMaintenanceLogsWorkIdAverageArgs = {
  order?: InputMaybe<Array<AccommodationMaintenanceLogSortInput>>;
  where?: InputMaybe<AccommodationMaintenanceLogFilterInput>;
};


export type AccommodationMaintenanceLogsWorkIdSumArgs = {
  order?: InputMaybe<Array<AccommodationMaintenanceLogSortInput>>;
  where?: InputMaybe<AccommodationMaintenanceLogFilterInput>;
};

export type AccommodationMaintenanceType = {
  __typename?: 'accommodationMaintenanceType';
  id: Scalars['Int'];
  logs: AccommodationMaintenanceLogs;
  name: Scalars['String'];
  normalizedName: Scalars['String'];
};

export type AccommodationMaintenanceTypes = {
  __typename?: 'accommodationMaintenanceTypes';
  /** Get AccommodationMaintenanceTypes any */
  any: Scalars['Boolean'];
  /** Get AccommodationMaintenanceTypes count */
  count: Scalars['Int'];
  /** Get AccommodationMaintenanceTypes idAverage */
  idAverage: Scalars['Decimal'];
  /** Get AccommodationMaintenanceTypes idSum */
  idSum: Scalars['Decimal'];
  /** Get $AccommodationMaintenanceTypes list */
  items: Array<AccommodationMaintenanceType>;
};


export type AccommodationMaintenanceTypesAnyArgs = {
  where?: InputMaybe<AccommodationMaintenanceTypeFilterInput>;
};


export type AccommodationMaintenanceTypesCountArgs = {
  where?: InputMaybe<AccommodationMaintenanceTypeFilterInput>;
};


export type AccommodationMaintenanceTypesIdAverageArgs = {
  order?: InputMaybe<Array<AccommodationMaintenanceTypeSortInput>>;
  where?: InputMaybe<AccommodationMaintenanceTypeFilterInput>;
};


export type AccommodationMaintenanceTypesIdSumArgs = {
  order?: InputMaybe<Array<AccommodationMaintenanceTypeSortInput>>;
  where?: InputMaybe<AccommodationMaintenanceTypeFilterInput>;
};


export type AccommodationMaintenanceTypesItemsArgs = {
  order?: InputMaybe<Array<AccommodationMaintenanceTypeSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccommodationMaintenanceTypeFilterInput>;
};

export type AccommodationWork = {
  __typename?: 'accommodationWork';
  category: WorkCategories;
  endDate?: Maybe<Scalars['LocalDate']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  season: Season;
  seasonId: Scalars['Int'];
  startDate: Scalars['LocalDate'];
  type: AccommodationWorkTypes;
  workers: Workers;
};

export type AccommodationWorkInvestment = {
  __typename?: 'accommodationWorkInvestment';
  category: WorkCategories;
  endDate?: Maybe<Scalars['LocalDate']>;
  expense?: Maybe<Expense>;
  expenseId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  investmentType: InvestmentTypes;
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  quantity: Scalars['Decimal'];
  season: Season;
  seasonId: Scalars['Int'];
  startDate: Scalars['LocalDate'];
  total: Scalars['Decimal'];
  type: AccommodationWorkTypes;
  unit: Units;
  unitPrice: Scalars['Decimal'];
  workers: Workers;
};

export type AccommodationWorkInvestments = {
  __typename?: 'accommodationWorkInvestments';
  /** Get AccommodationWorkInvestments any */
  any: Scalars['Boolean'];
  /** Get AccommodationWorkInvestments count */
  count: Scalars['Int'];
  /** Get $AccommodationWorkInvestments list */
  items: Array<AccommodationWorkInvestment>;
  /** Get AccommodationWorkInvestments quantityAverage */
  quantityAverage: Scalars['Decimal'];
  /** Get AccommodationWorkInvestments quantitySum */
  quantitySum: Scalars['Decimal'];
  /** Get AccommodationWorkInvestments totalAverage */
  totalAverage: Scalars['Decimal'];
  /** Get AccommodationWorkInvestments totalSum */
  totalSum: Scalars['Decimal'];
};


export type AccommodationWorkInvestmentsAnyArgs = {
  where?: InputMaybe<AccommodationWorkInvestmentFilterInput>;
};


export type AccommodationWorkInvestmentsCountArgs = {
  where?: InputMaybe<AccommodationWorkInvestmentFilterInput>;
};


export type AccommodationWorkInvestmentsItemsArgs = {
  order?: InputMaybe<Array<AccommodationWorkInvestmentSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccommodationWorkInvestmentFilterInput>;
};


export type AccommodationWorkInvestmentsQuantityAverageArgs = {
  order?: InputMaybe<Array<AccommodationWorkInvestmentSortInput>>;
  where?: InputMaybe<AccommodationWorkInvestmentFilterInput>;
};


export type AccommodationWorkInvestmentsQuantitySumArgs = {
  order?: InputMaybe<Array<AccommodationWorkInvestmentSortInput>>;
  where?: InputMaybe<AccommodationWorkInvestmentFilterInput>;
};


export type AccommodationWorkInvestmentsTotalAverageArgs = {
  order?: InputMaybe<Array<AccommodationWorkInvestmentSortInput>>;
  where?: InputMaybe<AccommodationWorkInvestmentFilterInput>;
};


export type AccommodationWorkInvestmentsTotalSumArgs = {
  order?: InputMaybe<Array<AccommodationWorkInvestmentSortInput>>;
  where?: InputMaybe<AccommodationWorkInvestmentFilterInput>;
};

export type AccommodationWorkMaintenance = {
  __typename?: 'accommodationWorkMaintenance';
  category: WorkCategories;
  endDate?: Maybe<Scalars['LocalDate']>;
  id: Scalars['Int'];
  logs: AccommodationMaintenanceLogs;
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  season: Season;
  seasonId: Scalars['Int'];
  startDate: Scalars['LocalDate'];
  type: AccommodationWorkTypes;
  workers: Workers;
};

export type AccommodationWorkMaintenances = {
  __typename?: 'accommodationWorkMaintenances';
  /** Get AccommodationWorkMaintenances any */
  any: Scalars['Boolean'];
  /** Get AccommodationWorkMaintenances count */
  count: Scalars['Int'];
  /** Get $AccommodationWorkMaintenances list */
  items: Array<AccommodationWorkMaintenance>;
};


export type AccommodationWorkMaintenancesAnyArgs = {
  where?: InputMaybe<AccommodationWorkMaintenanceFilterInput>;
};


export type AccommodationWorkMaintenancesCountArgs = {
  where?: InputMaybe<AccommodationWorkMaintenanceFilterInput>;
};


export type AccommodationWorkMaintenancesItemsArgs = {
  order?: InputMaybe<Array<AccommodationWorkMaintenanceSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccommodationWorkMaintenanceFilterInput>;
};

export type AccommodationWorks = {
  __typename?: 'accommodationWorks';
  /** Get AccommodationWorks any */
  any: Scalars['Boolean'];
  /** Get AccommodationWorks count */
  count: Scalars['Int'];
  /** Get $AccommodationWorks list */
  items: Array<AccommodationWork>;
};


export type AccommodationWorksAnyArgs = {
  where?: InputMaybe<AccommodationWorkFilterInput>;
};


export type AccommodationWorksCountArgs = {
  where?: InputMaybe<AccommodationWorkFilterInput>;
};


export type AccommodationWorksItemsArgs = {
  order?: InputMaybe<Array<AccommodationWorkSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccommodationWorkFilterInput>;
};

export type AgricultureWork = {
  __typename?: 'agricultureWork';
  category: WorkCategories;
  endDate?: Maybe<Scalars['LocalDate']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  season: Season;
  seasonId: Scalars['Int'];
  startDate: Scalars['LocalDate'];
  type: AgricultureWorkTypes;
  workers: Workers;
};

export type AgricultureWorkInvestment = {
  __typename?: 'agricultureWorkInvestment';
  category: WorkCategories;
  endDate?: Maybe<Scalars['LocalDate']>;
  expense?: Maybe<Expense>;
  expenseId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  investmentType: InvestmentTypes;
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  quantity: Scalars['Decimal'];
  season: Season;
  seasonId: Scalars['Int'];
  startDate: Scalars['LocalDate'];
  total: Scalars['Decimal'];
  type: AgricultureWorkTypes;
  unit: Units;
  unitPrice: Scalars['Decimal'];
  workers: Workers;
};

export type AgricultureWorkInvestments = {
  __typename?: 'agricultureWorkInvestments';
  /** Get AgricultureWorkInvestments any */
  any: Scalars['Boolean'];
  /** Get AgricultureWorkInvestments count */
  count: Scalars['Int'];
  /** Get $AgricultureWorkInvestments list */
  items: Array<AgricultureWorkInvestment>;
  /** Get AgricultureWorkInvestments quantityAverage */
  quantityAverage: Scalars['Decimal'];
  /** Get AgricultureWorkInvestments quantitySum */
  quantitySum: Scalars['Decimal'];
  /** Get AgricultureWorkInvestments totalAverage */
  totalAverage: Scalars['Decimal'];
  /** Get AgricultureWorkInvestments totalSum */
  totalSum: Scalars['Decimal'];
};


export type AgricultureWorkInvestmentsAnyArgs = {
  where?: InputMaybe<AgricultureWorkInvestmentFilterInput>;
};


export type AgricultureWorkInvestmentsCountArgs = {
  where?: InputMaybe<AgricultureWorkInvestmentFilterInput>;
};


export type AgricultureWorkInvestmentsItemsArgs = {
  order?: InputMaybe<Array<AgricultureWorkInvestmentSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AgricultureWorkInvestmentFilterInput>;
};


export type AgricultureWorkInvestmentsQuantityAverageArgs = {
  order?: InputMaybe<Array<AgricultureWorkInvestmentSortInput>>;
  where?: InputMaybe<AgricultureWorkInvestmentFilterInput>;
};


export type AgricultureWorkInvestmentsQuantitySumArgs = {
  order?: InputMaybe<Array<AgricultureWorkInvestmentSortInput>>;
  where?: InputMaybe<AgricultureWorkInvestmentFilterInput>;
};


export type AgricultureWorkInvestmentsTotalAverageArgs = {
  order?: InputMaybe<Array<AgricultureWorkInvestmentSortInput>>;
  where?: InputMaybe<AgricultureWorkInvestmentFilterInput>;
};


export type AgricultureWorkInvestmentsTotalSumArgs = {
  order?: InputMaybe<Array<AgricultureWorkInvestmentSortInput>>;
  where?: InputMaybe<AgricultureWorkInvestmentFilterInput>;
};

export type AgricultureWorkTemplate = {
  __typename?: 'agricultureWorkTemplate';
  category: WorkCategories;
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  season?: Maybe<Season>;
  seasonId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  type: AgricultureWorkTypes;
  workers: WorkerTemplates;
};

export type AgricultureWorkTemplates = {
  __typename?: 'agricultureWorkTemplates';
  /** Get AgricultureWorkTemplates any */
  any: Scalars['Boolean'];
  /** Get AgricultureWorkTemplates count */
  count: Scalars['Int'];
  /** Get $AgricultureWorkTemplates list */
  items: Array<AgricultureWorkTemplate>;
};


export type AgricultureWorkTemplatesAnyArgs = {
  where?: InputMaybe<AgricultureWorkTemplateFilterInput>;
};


export type AgricultureWorkTemplatesCountArgs = {
  where?: InputMaybe<AgricultureWorkTemplateFilterInput>;
};


export type AgricultureWorkTemplatesItemsArgs = {
  order?: InputMaybe<Array<AgricultureWorkTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AgricultureWorkTemplateFilterInput>;
};

export type AgricultureWorks = {
  __typename?: 'agricultureWorks';
  /** Get AgricultureWorks any */
  any: Scalars['Boolean'];
  /** Get AgricultureWorks count */
  count: Scalars['Int'];
  /** Get $AgricultureWorks list */
  items: Array<AgricultureWork>;
};


export type AgricultureWorksAnyArgs = {
  where?: InputMaybe<AgricultureWorkFilterInput>;
};


export type AgricultureWorksCountArgs = {
  where?: InputMaybe<AgricultureWorkFilterInput>;
};


export type AgricultureWorksItemsArgs = {
  order?: InputMaybe<Array<AgricultureWorkSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AgricultureWorkFilterInput>;
};

export type ApiToken = {
  __typename?: 'apiToken';
  createdBy: User;
  createdById: Scalars['Int'];
  createdDate: Scalars['DateTime'];
  expiredAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['Int']>;
};

export type ApiTokens = {
  __typename?: 'apiTokens';
  /** Get ApiTokens any */
  any: Scalars['Boolean'];
  /** Get ApiTokens count */
  count: Scalars['Int'];
  /** Get ApiTokens createdByIdAverage */
  createdByIdAverage: Scalars['Decimal'];
  /** Get ApiTokens createdByIdSum */
  createdByIdSum: Scalars['Decimal'];
  /** Get ApiTokens idAverage */
  idAverage: Scalars['Decimal'];
  /** Get ApiTokens idSum */
  idSum: Scalars['Decimal'];
  /** Get $ApiTokens list */
  items: Array<ApiToken>;
  /** Get ApiTokens updatedByIdAverage */
  updatedByIdAverage: Scalars['Decimal'];
  /** Get ApiTokens updatedByIdSum */
  updatedByIdSum: Scalars['Decimal'];
};


export type ApiTokensAnyArgs = {
  where?: InputMaybe<ApiTokenFilterInput>;
};


export type ApiTokensCountArgs = {
  where?: InputMaybe<ApiTokenFilterInput>;
};


export type ApiTokensCreatedByIdAverageArgs = {
  order?: InputMaybe<Array<ApiTokenSortInput>>;
  where?: InputMaybe<ApiTokenFilterInput>;
};


export type ApiTokensCreatedByIdSumArgs = {
  order?: InputMaybe<Array<ApiTokenSortInput>>;
  where?: InputMaybe<ApiTokenFilterInput>;
};


export type ApiTokensIdAverageArgs = {
  order?: InputMaybe<Array<ApiTokenSortInput>>;
  where?: InputMaybe<ApiTokenFilterInput>;
};


export type ApiTokensIdSumArgs = {
  order?: InputMaybe<Array<ApiTokenSortInput>>;
  where?: InputMaybe<ApiTokenFilterInput>;
};


export type ApiTokensItemsArgs = {
  order?: InputMaybe<Array<ApiTokenSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApiTokenFilterInput>;
};


export type ApiTokensUpdatedByIdAverageArgs = {
  order?: InputMaybe<Array<ApiTokenSortInput>>;
  where?: InputMaybe<ApiTokenFilterInput>;
};


export type ApiTokensUpdatedByIdSumArgs = {
  order?: InputMaybe<Array<ApiTokenSortInput>>;
  where?: InputMaybe<ApiTokenFilterInput>;
};

export type Booking = {
  __typename?: 'booking';
  additionalCharge: BookingAdditionalCharges;
  attachments: BookingAttachments;
  bookingDate: Scalars['DateTime'];
  cancelledDate?: Maybe<Scalars['DateTime']>;
  channel?: Maybe<BookingBookingChannel>;
  children?: Maybe<Scalars['String']>;
  details: BookingDetailss;
  events: BookingEvents;
  guestCount: Scalars['Int'];
  guestReservationLinkExtension?: Maybe<Scalars['String']>;
  /** Check if the booking has a conflict with another booking */
  hasConflict: Scalars['Boolean'];
  id: Scalars['Int'];
  inDate: Scalars['LocalDate'];
  inSeasonId: Scalars['Int'];
  income?: Maybe<Income>;
  incomeId?: Maybe<Scalars['Int']>;
  isCancelled: Scalars['Boolean'];
  isNoShowCancellation: Scalars['Boolean'];
  logs: BookingLogs;
  nights: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  outDate: Scalars['LocalDate'];
  paidAmount?: Maybe<Scalars['Decimal']>;
  person: Person;
  personId: Scalars['Int'];
  preferredRoom?: Maybe<Room>;
  preferredRoomId?: Maybe<Scalars['Int']>;
  roomType: RoomType;
  roomTypeId: Scalars['Int'];
  season: Season;
  seasonId: Scalars['Int'];
  toLogEntity: BookingLog;
  total: Scalars['Decimal'];
};


export type BookingToLogEntityArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
};

export type BookingAdditionalCharge = {
  __typename?: 'bookingAdditionalCharge';
  amount: Scalars['Decimal'];
  booking?: Maybe<Booking>;
  bookingId: Scalars['Int'];
  date: Scalars['LocalDate'];
  id: Scalars['Int'];
  isIncome: Scalars['Boolean'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
};

export type BookingAdditionalCharges = {
  __typename?: 'bookingAdditionalCharges';
  /** Get BookingAdditionalCharges amountAverage */
  amountAverage: Scalars['Decimal'];
  /** Get BookingAdditionalCharges amountSum */
  amountSum: Scalars['Decimal'];
  /** Get BookingAdditionalCharges any */
  any: Scalars['Boolean'];
  /** Get BookingAdditionalCharges bookingIdAverage */
  bookingIdAverage: Scalars['Decimal'];
  /** Get BookingAdditionalCharges bookingIdSum */
  bookingIdSum: Scalars['Decimal'];
  /** Get BookingAdditionalCharges count */
  count: Scalars['Int'];
  /** Get BookingAdditionalCharges idAverage */
  idAverage: Scalars['Decimal'];
  /** Get BookingAdditionalCharges idSum */
  idSum: Scalars['Decimal'];
  /** Get $BookingAdditionalCharges list */
  items: Array<BookingAdditionalCharge>;
};


export type BookingAdditionalChargesAmountAverageArgs = {
  order?: InputMaybe<Array<BookingAdditionalChargeSortInput>>;
  where?: InputMaybe<BookingAdditionalChargeFilterInput>;
};


export type BookingAdditionalChargesAmountSumArgs = {
  order?: InputMaybe<Array<BookingAdditionalChargeSortInput>>;
  where?: InputMaybe<BookingAdditionalChargeFilterInput>;
};


export type BookingAdditionalChargesAnyArgs = {
  where?: InputMaybe<BookingAdditionalChargeFilterInput>;
};


export type BookingAdditionalChargesBookingIdAverageArgs = {
  order?: InputMaybe<Array<BookingAdditionalChargeSortInput>>;
  where?: InputMaybe<BookingAdditionalChargeFilterInput>;
};


export type BookingAdditionalChargesBookingIdSumArgs = {
  order?: InputMaybe<Array<BookingAdditionalChargeSortInput>>;
  where?: InputMaybe<BookingAdditionalChargeFilterInput>;
};


export type BookingAdditionalChargesCountArgs = {
  where?: InputMaybe<BookingAdditionalChargeFilterInput>;
};


export type BookingAdditionalChargesIdAverageArgs = {
  order?: InputMaybe<Array<BookingAdditionalChargeSortInput>>;
  where?: InputMaybe<BookingAdditionalChargeFilterInput>;
};


export type BookingAdditionalChargesIdSumArgs = {
  order?: InputMaybe<Array<BookingAdditionalChargeSortInput>>;
  where?: InputMaybe<BookingAdditionalChargeFilterInput>;
};


export type BookingAdditionalChargesItemsArgs = {
  order?: InputMaybe<Array<BookingAdditionalChargeSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingAdditionalChargeFilterInput>;
};

export type BookingAdditionalChargesTemplate = {
  __typename?: 'bookingAdditionalChargesTemplate';
  amount: Scalars['Decimal'];
  calculationType: BookingAdditionalChargesCalculationTypes;
  id: Scalars['Int'];
  isIncome: Scalars['Boolean'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
};

export type BookingAdditionalChargesTemplates = {
  __typename?: 'bookingAdditionalChargesTemplates';
  /** Get BookingAdditionalChargesTemplates amountAverage */
  amountAverage: Scalars['Decimal'];
  /** Get BookingAdditionalChargesTemplates amountSum */
  amountSum: Scalars['Decimal'];
  /** Get BookingAdditionalChargesTemplates any */
  any: Scalars['Boolean'];
  /** Get BookingAdditionalChargesTemplates count */
  count: Scalars['Int'];
  /** Get BookingAdditionalChargesTemplates idAverage */
  idAverage: Scalars['Decimal'];
  /** Get BookingAdditionalChargesTemplates idSum */
  idSum: Scalars['Decimal'];
  /** Get $BookingAdditionalChargesTemplates list */
  items: Array<BookingAdditionalChargesTemplate>;
};


export type BookingAdditionalChargesTemplatesAmountAverageArgs = {
  order?: InputMaybe<Array<BookingAdditionalChargesTemplateSortInput>>;
  where?: InputMaybe<BookingAdditionalChargesTemplateFilterInput>;
};


export type BookingAdditionalChargesTemplatesAmountSumArgs = {
  order?: InputMaybe<Array<BookingAdditionalChargesTemplateSortInput>>;
  where?: InputMaybe<BookingAdditionalChargesTemplateFilterInput>;
};


export type BookingAdditionalChargesTemplatesAnyArgs = {
  where?: InputMaybe<BookingAdditionalChargesTemplateFilterInput>;
};


export type BookingAdditionalChargesTemplatesCountArgs = {
  where?: InputMaybe<BookingAdditionalChargesTemplateFilterInput>;
};


export type BookingAdditionalChargesTemplatesIdAverageArgs = {
  order?: InputMaybe<Array<BookingAdditionalChargesTemplateSortInput>>;
  where?: InputMaybe<BookingAdditionalChargesTemplateFilterInput>;
};


export type BookingAdditionalChargesTemplatesIdSumArgs = {
  order?: InputMaybe<Array<BookingAdditionalChargesTemplateSortInput>>;
  where?: InputMaybe<BookingAdditionalChargesTemplateFilterInput>;
};


export type BookingAdditionalChargesTemplatesItemsArgs = {
  order?: InputMaybe<Array<BookingAdditionalChargesTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingAdditionalChargesTemplateFilterInput>;
};

export type BookingAttachment = {
  __typename?: 'bookingAttachment';
  booking: Booking;
  bookingId: Scalars['Int'];
  contentType: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
};

export type BookingAttachments = {
  __typename?: 'bookingAttachments';
  /** Get BookingAttachments any */
  any: Scalars['Boolean'];
  /** Get BookingAttachments bookingIdAverage */
  bookingIdAverage: Scalars['Decimal'];
  /** Get BookingAttachments bookingIdSum */
  bookingIdSum: Scalars['Decimal'];
  /** Get BookingAttachments count */
  count: Scalars['Int'];
  /** Get BookingAttachments idAverage */
  idAverage: Scalars['Decimal'];
  /** Get BookingAttachments idSum */
  idSum: Scalars['Decimal'];
  /** Get $BookingAttachments list */
  items: Array<BookingAttachment>;
};


export type BookingAttachmentsAnyArgs = {
  where?: InputMaybe<BookingAttachmentFilterInput>;
};


export type BookingAttachmentsBookingIdAverageArgs = {
  order?: InputMaybe<Array<BookingAttachmentSortInput>>;
  where?: InputMaybe<BookingAttachmentFilterInput>;
};


export type BookingAttachmentsBookingIdSumArgs = {
  order?: InputMaybe<Array<BookingAttachmentSortInput>>;
  where?: InputMaybe<BookingAttachmentFilterInput>;
};


export type BookingAttachmentsCountArgs = {
  where?: InputMaybe<BookingAttachmentFilterInput>;
};


export type BookingAttachmentsIdAverageArgs = {
  order?: InputMaybe<Array<BookingAttachmentSortInput>>;
  where?: InputMaybe<BookingAttachmentFilterInput>;
};


export type BookingAttachmentsIdSumArgs = {
  order?: InputMaybe<Array<BookingAttachmentSortInput>>;
  where?: InputMaybe<BookingAttachmentFilterInput>;
};


export type BookingAttachmentsItemsArgs = {
  order?: InputMaybe<Array<BookingAttachmentSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingAttachmentFilterInput>;
};

export type BookingBookingChannel = {
  __typename?: 'bookingBookingChannel';
  booking?: Maybe<Booking>;
  bookingId: Scalars['Int'];
  channel: BookingChannel;
  channelId: Scalars['Int'];
  externalReference?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isCancelled: Scalars['Boolean'];
  total: Scalars['Decimal'];
};

export type BookingBookingChannels = {
  __typename?: 'bookingBookingChannels';
  /** Get BookingBookingChannels any */
  any: Scalars['Boolean'];
  /** Get BookingBookingChannels bookingIdAverage */
  bookingIdAverage: Scalars['Decimal'];
  /** Get BookingBookingChannels bookingIdSum */
  bookingIdSum: Scalars['Decimal'];
  /** Get BookingBookingChannels channelIdAverage */
  channelIdAverage: Scalars['Decimal'];
  /** Get BookingBookingChannels channelIdSum */
  channelIdSum: Scalars['Decimal'];
  /** Get BookingBookingChannels count */
  count: Scalars['Int'];
  /** Get BookingBookingChannels idAverage */
  idAverage: Scalars['Decimal'];
  /** Get BookingBookingChannels idSum */
  idSum: Scalars['Decimal'];
  /** Get $BookingBookingChannels list */
  items: Array<BookingBookingChannel>;
  /** Get BookingBookingChannels totalAverage */
  totalAverage: Scalars['Decimal'];
  /** Get BookingBookingChannels totalSum */
  totalSum: Scalars['Decimal'];
};


export type BookingBookingChannelsAnyArgs = {
  where?: InputMaybe<BookingBookingChannelFilterInput>;
};


export type BookingBookingChannelsBookingIdAverageArgs = {
  order?: InputMaybe<Array<BookingBookingChannelSortInput>>;
  where?: InputMaybe<BookingBookingChannelFilterInput>;
};


export type BookingBookingChannelsBookingIdSumArgs = {
  order?: InputMaybe<Array<BookingBookingChannelSortInput>>;
  where?: InputMaybe<BookingBookingChannelFilterInput>;
};


export type BookingBookingChannelsChannelIdAverageArgs = {
  order?: InputMaybe<Array<BookingBookingChannelSortInput>>;
  where?: InputMaybe<BookingBookingChannelFilterInput>;
};


export type BookingBookingChannelsChannelIdSumArgs = {
  order?: InputMaybe<Array<BookingBookingChannelSortInput>>;
  where?: InputMaybe<BookingBookingChannelFilterInput>;
};


export type BookingBookingChannelsCountArgs = {
  where?: InputMaybe<BookingBookingChannelFilterInput>;
};


export type BookingBookingChannelsIdAverageArgs = {
  order?: InputMaybe<Array<BookingBookingChannelSortInput>>;
  where?: InputMaybe<BookingBookingChannelFilterInput>;
};


export type BookingBookingChannelsIdSumArgs = {
  order?: InputMaybe<Array<BookingBookingChannelSortInput>>;
  where?: InputMaybe<BookingBookingChannelFilterInput>;
};


export type BookingBookingChannelsItemsArgs = {
  order?: InputMaybe<Array<BookingBookingChannelSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingBookingChannelFilterInput>;
};


export type BookingBookingChannelsTotalAverageArgs = {
  order?: InputMaybe<Array<BookingBookingChannelSortInput>>;
  where?: InputMaybe<BookingBookingChannelFilterInput>;
};


export type BookingBookingChannelsTotalSumArgs = {
  order?: InputMaybe<Array<BookingBookingChannelSortInput>>;
  where?: InputMaybe<BookingBookingChannelFilterInput>;
};

export type BookingChannel = {
  __typename?: 'bookingChannel';
  bookings: BookingBookingChannels;
  calculate: Scalars['Decimal'];
  color?: Maybe<Scalars['String']>;
  commission: Scalars['Decimal'];
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  roomTypeDefultPrices: RoomTypeChannelDefultPrices;
  type: CommissionTypes;
};


export type BookingChannelCalculateArgs = {
  total?: InputMaybe<Scalars['Decimal']>;
};

export type BookingChannels = {
  __typename?: 'bookingChannels';
  /** Get BookingChannels any */
  any: Scalars['Boolean'];
  /** Get BookingChannels commissionAverage */
  commissionAverage: Scalars['Decimal'];
  /** Get BookingChannels commissionSum */
  commissionSum: Scalars['Decimal'];
  /** Get BookingChannels count */
  count: Scalars['Int'];
  /** Get BookingChannels idAverage */
  idAverage: Scalars['Decimal'];
  /** Get BookingChannels idSum */
  idSum: Scalars['Decimal'];
  /** Get $BookingChannels list */
  items: Array<BookingChannel>;
};


export type BookingChannelsAnyArgs = {
  where?: InputMaybe<BookingChannelFilterInput>;
};


export type BookingChannelsCommissionAverageArgs = {
  order?: InputMaybe<Array<BookingChannelSortInput>>;
  where?: InputMaybe<BookingChannelFilterInput>;
};


export type BookingChannelsCommissionSumArgs = {
  order?: InputMaybe<Array<BookingChannelSortInput>>;
  where?: InputMaybe<BookingChannelFilterInput>;
};


export type BookingChannelsCountArgs = {
  where?: InputMaybe<BookingChannelFilterInput>;
};


export type BookingChannelsIdAverageArgs = {
  order?: InputMaybe<Array<BookingChannelSortInput>>;
  where?: InputMaybe<BookingChannelFilterInput>;
};


export type BookingChannelsIdSumArgs = {
  order?: InputMaybe<Array<BookingChannelSortInput>>;
  where?: InputMaybe<BookingChannelFilterInput>;
};


export type BookingChannelsItemsArgs = {
  order?: InputMaybe<Array<BookingChannelSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingChannelFilterInput>;
};

export type BookingDetails = {
  __typename?: 'bookingDetails';
  booking: Booking;
  bookingId: Scalars['Int'];
  date: Scalars['LocalDate'];
  /** Check if the booking has a conflict with another booking */
  hasConflict: Scalars['Boolean'];
  id: Scalars['Int'];
  price: Scalars['Decimal'];
  room: Room;
  roomId: Scalars['Int'];
};

export type BookingDetailss = {
  __typename?: 'bookingDetailss';
  /** Get BookingDetailss any */
  any: Scalars['Boolean'];
  /** Get BookingDetailss bookingIdAverage */
  bookingIdAverage: Scalars['Decimal'];
  /** Get BookingDetailss bookingIdSum */
  bookingIdSum: Scalars['Decimal'];
  /** Get BookingDetailss count */
  count: Scalars['Int'];
  /** Get BookingDetailss idAverage */
  idAverage: Scalars['Decimal'];
  /** Get BookingDetailss idSum */
  idSum: Scalars['Decimal'];
  /** Get $BookingDetailss list */
  items: Array<BookingDetails>;
  /** Get BookingDetailss priceAverage */
  priceAverage: Scalars['Decimal'];
  /** Get BookingDetailss priceSum */
  priceSum: Scalars['Decimal'];
  /** Get BookingDetailss roomIdAverage */
  roomIdAverage: Scalars['Decimal'];
  /** Get BookingDetailss roomIdSum */
  roomIdSum: Scalars['Decimal'];
};


export type BookingDetailssAnyArgs = {
  where?: InputMaybe<BookingDetailsFilterInput>;
};


export type BookingDetailssBookingIdAverageArgs = {
  order?: InputMaybe<Array<BookingDetailsSortInput>>;
  where?: InputMaybe<BookingDetailsFilterInput>;
};


export type BookingDetailssBookingIdSumArgs = {
  order?: InputMaybe<Array<BookingDetailsSortInput>>;
  where?: InputMaybe<BookingDetailsFilterInput>;
};


export type BookingDetailssCountArgs = {
  where?: InputMaybe<BookingDetailsFilterInput>;
};


export type BookingDetailssIdAverageArgs = {
  order?: InputMaybe<Array<BookingDetailsSortInput>>;
  where?: InputMaybe<BookingDetailsFilterInput>;
};


export type BookingDetailssIdSumArgs = {
  order?: InputMaybe<Array<BookingDetailsSortInput>>;
  where?: InputMaybe<BookingDetailsFilterInput>;
};


export type BookingDetailssItemsArgs = {
  order?: InputMaybe<Array<BookingDetailsSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingDetailsFilterInput>;
};


export type BookingDetailssPriceAverageArgs = {
  order?: InputMaybe<Array<BookingDetailsSortInput>>;
  where?: InputMaybe<BookingDetailsFilterInput>;
};


export type BookingDetailssPriceSumArgs = {
  order?: InputMaybe<Array<BookingDetailsSortInput>>;
  where?: InputMaybe<BookingDetailsFilterInput>;
};


export type BookingDetailssRoomIdAverageArgs = {
  order?: InputMaybe<Array<BookingDetailsSortInput>>;
  where?: InputMaybe<BookingDetailsFilterInput>;
};


export type BookingDetailssRoomIdSumArgs = {
  order?: InputMaybe<Array<BookingDetailsSortInput>>;
  where?: InputMaybe<BookingDetailsFilterInput>;
};

export type BookingEvent = {
  __typename?: 'bookingEvent';
  assignee?: Maybe<Person>;
  assigneeId?: Maybe<Scalars['Int']>;
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['Int']>;
  date: Scalars['LocalDate'];
  group?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  insertType: InsertTypes;
  isDone: Scalars['Boolean'];
  logs: BookingEventLogs;
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  toLogEntity: BookingEventLog;
};


export type BookingEventToLogEntityArgs = {
  authorId?: InputMaybe<Scalars['Int']>;
};

export type BookingEventLog = {
  __typename?: 'bookingEventLog';
  assignee?: Maybe<Person>;
  assigneeId?: Maybe<Scalars['Int']>;
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['Int']>;
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['Int']>;
  changeDate: Scalars['DateTime'];
  date: Scalars['LocalDate'];
  entity: BookingEvent;
  entityId: Scalars['Int'];
  group?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  insertType: InsertTypes;
  isDone: Scalars['Boolean'];
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
};

export type BookingEventLogs = {
  __typename?: 'bookingEventLogs';
  /** Get BookingEventLogs any */
  any: Scalars['Boolean'];
  /** Get BookingEventLogs assigneeIdAverage */
  assigneeIdAverage: Scalars['Decimal'];
  /** Get BookingEventLogs assigneeIdSum */
  assigneeIdSum: Scalars['Decimal'];
  /** Get BookingEventLogs authorIdAverage */
  authorIdAverage: Scalars['Decimal'];
  /** Get BookingEventLogs authorIdSum */
  authorIdSum: Scalars['Decimal'];
  /** Get BookingEventLogs bookingIdAverage */
  bookingIdAverage: Scalars['Decimal'];
  /** Get BookingEventLogs bookingIdSum */
  bookingIdSum: Scalars['Decimal'];
  /** Get BookingEventLogs count */
  count: Scalars['Int'];
  /** Get BookingEventLogs entityIdAverage */
  entityIdAverage: Scalars['Decimal'];
  /** Get BookingEventLogs entityIdSum */
  entityIdSum: Scalars['Decimal'];
  /** Get BookingEventLogs idAverage */
  idAverage: Scalars['Decimal'];
  /** Get BookingEventLogs idSum */
  idSum: Scalars['Decimal'];
  /** Get $BookingEventLogs list */
  items: Array<BookingEventLog>;
  /** Get BookingEventLogs orderAverage */
  orderAverage: Scalars['Decimal'];
  /** Get BookingEventLogs orderSum */
  orderSum: Scalars['Decimal'];
};


export type BookingEventLogsAnyArgs = {
  where?: InputMaybe<BookingEventLogFilterInput>;
};


export type BookingEventLogsAssigneeIdAverageArgs = {
  order?: InputMaybe<Array<BookingEventLogSortInput>>;
  where?: InputMaybe<BookingEventLogFilterInput>;
};


export type BookingEventLogsAssigneeIdSumArgs = {
  order?: InputMaybe<Array<BookingEventLogSortInput>>;
  where?: InputMaybe<BookingEventLogFilterInput>;
};


export type BookingEventLogsAuthorIdAverageArgs = {
  order?: InputMaybe<Array<BookingEventLogSortInput>>;
  where?: InputMaybe<BookingEventLogFilterInput>;
};


export type BookingEventLogsAuthorIdSumArgs = {
  order?: InputMaybe<Array<BookingEventLogSortInput>>;
  where?: InputMaybe<BookingEventLogFilterInput>;
};


export type BookingEventLogsBookingIdAverageArgs = {
  order?: InputMaybe<Array<BookingEventLogSortInput>>;
  where?: InputMaybe<BookingEventLogFilterInput>;
};


export type BookingEventLogsBookingIdSumArgs = {
  order?: InputMaybe<Array<BookingEventLogSortInput>>;
  where?: InputMaybe<BookingEventLogFilterInput>;
};


export type BookingEventLogsCountArgs = {
  where?: InputMaybe<BookingEventLogFilterInput>;
};


export type BookingEventLogsEntityIdAverageArgs = {
  order?: InputMaybe<Array<BookingEventLogSortInput>>;
  where?: InputMaybe<BookingEventLogFilterInput>;
};


export type BookingEventLogsEntityIdSumArgs = {
  order?: InputMaybe<Array<BookingEventLogSortInput>>;
  where?: InputMaybe<BookingEventLogFilterInput>;
};


export type BookingEventLogsIdAverageArgs = {
  order?: InputMaybe<Array<BookingEventLogSortInput>>;
  where?: InputMaybe<BookingEventLogFilterInput>;
};


export type BookingEventLogsIdSumArgs = {
  order?: InputMaybe<Array<BookingEventLogSortInput>>;
  where?: InputMaybe<BookingEventLogFilterInput>;
};


export type BookingEventLogsItemsArgs = {
  order?: InputMaybe<Array<BookingEventLogSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingEventLogFilterInput>;
};


export type BookingEventLogsOrderAverageArgs = {
  order?: InputMaybe<Array<BookingEventLogSortInput>>;
  where?: InputMaybe<BookingEventLogFilterInput>;
};


export type BookingEventLogsOrderSumArgs = {
  order?: InputMaybe<Array<BookingEventLogSortInput>>;
  where?: InputMaybe<BookingEventLogFilterInput>;
};

export type BookingEvents = {
  __typename?: 'bookingEvents';
  /** Get BookingEvents any */
  any: Scalars['Boolean'];
  /** Get BookingEvents assigneeIdAverage */
  assigneeIdAverage: Scalars['Decimal'];
  /** Get BookingEvents assigneeIdSum */
  assigneeIdSum: Scalars['Decimal'];
  /** Get BookingEvents bookingIdAverage */
  bookingIdAverage: Scalars['Decimal'];
  /** Get BookingEvents bookingIdSum */
  bookingIdSum: Scalars['Decimal'];
  /** Get BookingEvents count */
  count: Scalars['Int'];
  /** Get BookingEvents idAverage */
  idAverage: Scalars['Decimal'];
  /** Get BookingEvents idSum */
  idSum: Scalars['Decimal'];
  /** Get $BookingEvents list */
  items: Array<BookingEvent>;
  /** Get BookingEvents orderAverage */
  orderAverage: Scalars['Decimal'];
  /** Get BookingEvents orderSum */
  orderSum: Scalars['Decimal'];
};


export type BookingEventsAnyArgs = {
  where?: InputMaybe<BookingEventFilterInput>;
};


export type BookingEventsAssigneeIdAverageArgs = {
  order?: InputMaybe<Array<BookingEventSortInput>>;
  where?: InputMaybe<BookingEventFilterInput>;
};


export type BookingEventsAssigneeIdSumArgs = {
  order?: InputMaybe<Array<BookingEventSortInput>>;
  where?: InputMaybe<BookingEventFilterInput>;
};


export type BookingEventsBookingIdAverageArgs = {
  order?: InputMaybe<Array<BookingEventSortInput>>;
  where?: InputMaybe<BookingEventFilterInput>;
};


export type BookingEventsBookingIdSumArgs = {
  order?: InputMaybe<Array<BookingEventSortInput>>;
  where?: InputMaybe<BookingEventFilterInput>;
};


export type BookingEventsCountArgs = {
  where?: InputMaybe<BookingEventFilterInput>;
};


export type BookingEventsIdAverageArgs = {
  order?: InputMaybe<Array<BookingEventSortInput>>;
  where?: InputMaybe<BookingEventFilterInput>;
};


export type BookingEventsIdSumArgs = {
  order?: InputMaybe<Array<BookingEventSortInput>>;
  where?: InputMaybe<BookingEventFilterInput>;
};


export type BookingEventsItemsArgs = {
  order?: InputMaybe<Array<BookingEventSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingEventFilterInput>;
};


export type BookingEventsOrderAverageArgs = {
  order?: InputMaybe<Array<BookingEventSortInput>>;
  where?: InputMaybe<BookingEventFilterInput>;
};


export type BookingEventsOrderSumArgs = {
  order?: InputMaybe<Array<BookingEventSortInput>>;
  where?: InputMaybe<BookingEventFilterInput>;
};

export type BookingLog = {
  __typename?: 'bookingLog';
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['Int']>;
  bookingDate: Scalars['DateTime'];
  cancelledDate?: Maybe<Scalars['DateTime']>;
  changeDate: Scalars['DateTime'];
  channel?: Maybe<BookingBookingChannel>;
  children?: Maybe<Scalars['String']>;
  entity: Booking;
  entityId: Scalars['Int'];
  guestCount: Scalars['Int'];
  guestReservationLinkExtension?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  inDate: Scalars['LocalDate'];
  inSeasonId: Scalars['Int'];
  income?: Maybe<Income>;
  incomeId?: Maybe<Scalars['Int']>;
  isCancelled: Scalars['Boolean'];
  isNoShowCancellation: Scalars['Boolean'];
  nights: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  outDate: Scalars['LocalDate'];
  paidAmount?: Maybe<Scalars['Decimal']>;
  person: Person;
  personId: Scalars['Int'];
  preferredRoom?: Maybe<Room>;
  preferredRoomId?: Maybe<Scalars['Int']>;
  roomType: RoomType;
  roomTypeId: Scalars['Int'];
  season: Season;
  seasonId: Scalars['Int'];
  total: Scalars['Decimal'];
};

export type BookingLogs = {
  __typename?: 'bookingLogs';
  /** Get BookingLogs any */
  any: Scalars['Boolean'];
  /** Get BookingLogs authorIdAverage */
  authorIdAverage: Scalars['Decimal'];
  /** Get BookingLogs authorIdSum */
  authorIdSum: Scalars['Decimal'];
  /** Get BookingLogs count */
  count: Scalars['Int'];
  /** Get BookingLogs entityIdAverage */
  entityIdAverage: Scalars['Decimal'];
  /** Get BookingLogs entityIdSum */
  entityIdSum: Scalars['Decimal'];
  /** Get BookingLogs guestCountAverage */
  guestCountAverage: Scalars['Decimal'];
  /** Get BookingLogs guestCountSum */
  guestCountSum: Scalars['Decimal'];
  /** Get BookingLogs idAverage */
  idAverage: Scalars['Decimal'];
  /** Get BookingLogs idSum */
  idSum: Scalars['Decimal'];
  /** Get BookingLogs inSeasonIdAverage */
  inSeasonIdAverage: Scalars['Decimal'];
  /** Get BookingLogs inSeasonIdSum */
  inSeasonIdSum: Scalars['Decimal'];
  /** Get BookingLogs incomeIdAverage */
  incomeIdAverage: Scalars['Decimal'];
  /** Get BookingLogs incomeIdSum */
  incomeIdSum: Scalars['Decimal'];
  /** Get $BookingLogs list */
  items: Array<BookingLog>;
  /** Get BookingLogs nightsAverage */
  nightsAverage: Scalars['Decimal'];
  /** Get BookingLogs nightsSum */
  nightsSum: Scalars['Decimal'];
  /** Get BookingLogs paidAmountAverage */
  paidAmountAverage: Scalars['Decimal'];
  /** Get BookingLogs paidAmountSum */
  paidAmountSum: Scalars['Decimal'];
  /** Get BookingLogs personIdAverage */
  personIdAverage: Scalars['Decimal'];
  /** Get BookingLogs personIdSum */
  personIdSum: Scalars['Decimal'];
  /** Get BookingLogs preferredRoomIdAverage */
  preferredRoomIdAverage: Scalars['Decimal'];
  /** Get BookingLogs preferredRoomIdSum */
  preferredRoomIdSum: Scalars['Decimal'];
  /** Get BookingLogs roomTypeIdAverage */
  roomTypeIdAverage: Scalars['Decimal'];
  /** Get BookingLogs roomTypeIdSum */
  roomTypeIdSum: Scalars['Decimal'];
  /** Get BookingLogs seasonIdAverage */
  seasonIdAverage: Scalars['Decimal'];
  /** Get BookingLogs seasonIdSum */
  seasonIdSum: Scalars['Decimal'];
  /** Get BookingLogs totalAverage */
  totalAverage: Scalars['Decimal'];
  /** Get BookingLogs totalSum */
  totalSum: Scalars['Decimal'];
};


export type BookingLogsAnyArgs = {
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsAuthorIdAverageArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsAuthorIdSumArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsCountArgs = {
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsEntityIdAverageArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsEntityIdSumArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsGuestCountAverageArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsGuestCountSumArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsIdAverageArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsIdSumArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsInSeasonIdAverageArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsInSeasonIdSumArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsIncomeIdAverageArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsIncomeIdSumArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsItemsArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsNightsAverageArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsNightsSumArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsPaidAmountAverageArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsPaidAmountSumArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsPersonIdAverageArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsPersonIdSumArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsPreferredRoomIdAverageArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsPreferredRoomIdSumArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsRoomTypeIdAverageArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsRoomTypeIdSumArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsSeasonIdAverageArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsSeasonIdSumArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsTotalAverageArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};


export type BookingLogsTotalSumArgs = {
  order?: InputMaybe<Array<BookingLogSortInput>>;
  where?: InputMaybe<BookingLogFilterInput>;
};

export type Bookings = {
  __typename?: 'bookings';
  /** Get Bookings any */
  any: Scalars['Boolean'];
  /** Get Bookings count */
  count: Scalars['Int'];
  /** Get Bookings guestCountAverage */
  guestCountAverage: Scalars['Decimal'];
  /** Get Bookings guestCountSum */
  guestCountSum: Scalars['Decimal'];
  /** Get Bookings idAverage */
  idAverage: Scalars['Decimal'];
  /** Get Bookings idSum */
  idSum: Scalars['Decimal'];
  /** Get Bookings inSeasonIdAverage */
  inSeasonIdAverage: Scalars['Decimal'];
  /** Get Bookings inSeasonIdSum */
  inSeasonIdSum: Scalars['Decimal'];
  /** Get Bookings incomeIdAverage */
  incomeIdAverage: Scalars['Decimal'];
  /** Get Bookings incomeIdSum */
  incomeIdSum: Scalars['Decimal'];
  /** Get $Bookings list */
  items: Array<Booking>;
  /** Get Bookings nightsAverage */
  nightsAverage: Scalars['Decimal'];
  /** Get Bookings nightsSum */
  nightsSum: Scalars['Decimal'];
  /** Get Bookings paidAmountAverage */
  paidAmountAverage: Scalars['Decimal'];
  /** Get Bookings paidAmountSum */
  paidAmountSum: Scalars['Decimal'];
  /** Get Bookings personIdAverage */
  personIdAverage: Scalars['Decimal'];
  /** Get Bookings personIdSum */
  personIdSum: Scalars['Decimal'];
  /** Get Bookings preferredRoomIdAverage */
  preferredRoomIdAverage: Scalars['Decimal'];
  /** Get Bookings preferredRoomIdSum */
  preferredRoomIdSum: Scalars['Decimal'];
  /** Get Bookings roomTypeIdAverage */
  roomTypeIdAverage: Scalars['Decimal'];
  /** Get Bookings roomTypeIdSum */
  roomTypeIdSum: Scalars['Decimal'];
  /** Get Bookings seasonIdAverage */
  seasonIdAverage: Scalars['Decimal'];
  /** Get Bookings seasonIdSum */
  seasonIdSum: Scalars['Decimal'];
  /** Get Bookings totalAverage */
  totalAverage: Scalars['Decimal'];
  /** Get Bookings totalSum */
  totalSum: Scalars['Decimal'];
};


export type BookingsAnyArgs = {
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsCountArgs = {
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsGuestCountAverageArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsGuestCountSumArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsIdAverageArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsIdSumArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsInSeasonIdAverageArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsInSeasonIdSumArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsIncomeIdAverageArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsIncomeIdSumArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsItemsArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsNightsAverageArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsNightsSumArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsPaidAmountAverageArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsPaidAmountSumArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsPersonIdAverageArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsPersonIdSumArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsPreferredRoomIdAverageArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsPreferredRoomIdSumArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsRoomTypeIdAverageArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsRoomTypeIdSumArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsSeasonIdAverageArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsSeasonIdSumArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsTotalAverageArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};


export type BookingsTotalSumArgs = {
  order?: InputMaybe<Array<BookingSortInput>>;
  where?: InputMaybe<BookingFilterInput>;
};

export type EventTemplate = {
  __typename?: 'eventTemplate';
  assignee?: Maybe<Person>;
  assigneeId?: Maybe<Scalars['Int']>;
  changeDynamicly: Scalars['Boolean'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  isSystem: Scalars['Boolean'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  onDay?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  repeat: Scalars['Boolean'];
};

export type EventTemplates = {
  __typename?: 'eventTemplates';
  /** Get EventTemplates any */
  any: Scalars['Boolean'];
  /** Get EventTemplates assigneeIdAverage */
  assigneeIdAverage: Scalars['Decimal'];
  /** Get EventTemplates assigneeIdSum */
  assigneeIdSum: Scalars['Decimal'];
  /** Get EventTemplates count */
  count: Scalars['Int'];
  /** Get EventTemplates idAverage */
  idAverage: Scalars['Decimal'];
  /** Get EventTemplates idSum */
  idSum: Scalars['Decimal'];
  /** Get $EventTemplates list */
  items: Array<EventTemplate>;
  /** Get EventTemplates onDayAverage */
  onDayAverage: Scalars['Decimal'];
  /** Get EventTemplates onDaySum */
  onDaySum: Scalars['Decimal'];
  /** Get EventTemplates orderAverage */
  orderAverage: Scalars['Decimal'];
  /** Get EventTemplates orderSum */
  orderSum: Scalars['Decimal'];
};


export type EventTemplatesAnyArgs = {
  where?: InputMaybe<EventTemplateFilterInput>;
};


export type EventTemplatesAssigneeIdAverageArgs = {
  order?: InputMaybe<Array<EventTemplateSortInput>>;
  where?: InputMaybe<EventTemplateFilterInput>;
};


export type EventTemplatesAssigneeIdSumArgs = {
  order?: InputMaybe<Array<EventTemplateSortInput>>;
  where?: InputMaybe<EventTemplateFilterInput>;
};


export type EventTemplatesCountArgs = {
  where?: InputMaybe<EventTemplateFilterInput>;
};


export type EventTemplatesIdAverageArgs = {
  order?: InputMaybe<Array<EventTemplateSortInput>>;
  where?: InputMaybe<EventTemplateFilterInput>;
};


export type EventTemplatesIdSumArgs = {
  order?: InputMaybe<Array<EventTemplateSortInput>>;
  where?: InputMaybe<EventTemplateFilterInput>;
};


export type EventTemplatesItemsArgs = {
  order?: InputMaybe<Array<EventTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventTemplateFilterInput>;
};


export type EventTemplatesOnDayAverageArgs = {
  order?: InputMaybe<Array<EventTemplateSortInput>>;
  where?: InputMaybe<EventTemplateFilterInput>;
};


export type EventTemplatesOnDaySumArgs = {
  order?: InputMaybe<Array<EventTemplateSortInput>>;
  where?: InputMaybe<EventTemplateFilterInput>;
};


export type EventTemplatesOrderAverageArgs = {
  order?: InputMaybe<Array<EventTemplateSortInput>>;
  where?: InputMaybe<EventTemplateFilterInput>;
};


export type EventTemplatesOrderSumArgs = {
  order?: InputMaybe<Array<EventTemplateSortInput>>;
  where?: InputMaybe<EventTemplateFilterInput>;
};

export type Expense = {
  __typename?: 'expense';
  amount: Scalars['Decimal'];
  date: Scalars['LocalDate'];
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  paid: Scalars['Boolean'];
};

export type Expenses = {
  __typename?: 'expenses';
  /** Get Expenses amountAverage */
  amountAverage: Scalars['Decimal'];
  /** Get Expenses amountSum */
  amountSum: Scalars['Decimal'];
  /** Get Expenses any */
  any: Scalars['Boolean'];
  /** Get Expenses count */
  count: Scalars['Int'];
  /** Get Expenses idAverage */
  idAverage: Scalars['Decimal'];
  /** Get Expenses idSum */
  idSum: Scalars['Decimal'];
  /** Get $Expenses list */
  items: Array<Expense>;
};


export type ExpensesAmountAverageArgs = {
  order?: InputMaybe<Array<ExpenseSortInput>>;
  where?: InputMaybe<ExpenseFilterInput>;
};


export type ExpensesAmountSumArgs = {
  order?: InputMaybe<Array<ExpenseSortInput>>;
  where?: InputMaybe<ExpenseFilterInput>;
};


export type ExpensesAnyArgs = {
  where?: InputMaybe<ExpenseFilterInput>;
};


export type ExpensesCountArgs = {
  where?: InputMaybe<ExpenseFilterInput>;
};


export type ExpensesIdAverageArgs = {
  order?: InputMaybe<Array<ExpenseSortInput>>;
  where?: InputMaybe<ExpenseFilterInput>;
};


export type ExpensesIdSumArgs = {
  order?: InputMaybe<Array<ExpenseSortInput>>;
  where?: InputMaybe<ExpenseFilterInput>;
};


export type ExpensesItemsArgs = {
  order?: InputMaybe<Array<ExpenseSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ExpenseFilterInput>;
};

export type Fruit = {
  __typename?: 'fruit';
  categories: FruitCategories;
  groups: FruitGroups;
  harvests: Harvests;
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  sales: Sales;
};

export type FruitCategories = {
  __typename?: 'fruitCategories';
  /** Get fruitCategories any */
  any: Scalars['Boolean'];
  /** Get fruitCategories count */
  count: Scalars['Int'];
  /** Get $fruitCategories list */
  items: Array<FruitCategory>;
};


export type FruitCategoriesAnyArgs = {
  where?: InputMaybe<FruitCategoryFilterInput>;
};


export type FruitCategoriesCountArgs = {
  where?: InputMaybe<FruitCategoryFilterInput>;
};


export type FruitCategoriesItemsArgs = {
  order?: InputMaybe<Array<FruitCategorySortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FruitCategoryFilterInput>;
};

export type FruitCategory = {
  __typename?: 'fruitCategory';
  fruit: Fruit;
  fruitId: Scalars['Int'];
  harvestFruitCategories: HarvestFruitCategorys;
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  sales: Sales;
};

export type FruitGroup = {
  __typename?: 'fruitGroup';
  fruit: Fruit;
  fruitId: Scalars['Int'];
  harvestFruitGroupTemplates: HarvestFruitGroupTemplates;
  harvestFruitGroups: HarvestFruitGroups;
  id: Scalars['Int'];
  maintenanceLogFruitGroup?: Maybe<Array<MaintenanceLogFruitGroup>>;
  name: Scalars['String'];
  normalizedName: Scalars['String'];
};

export type FruitGroups = {
  __typename?: 'fruitGroups';
  /** Get FruitGroups any */
  any: Scalars['Boolean'];
  /** Get FruitGroups count */
  count: Scalars['Int'];
  /** Get $FruitGroups list */
  items: Array<FruitGroup>;
};


export type FruitGroupsAnyArgs = {
  where?: InputMaybe<FruitGroupFilterInput>;
};


export type FruitGroupsCountArgs = {
  where?: InputMaybe<FruitGroupFilterInput>;
};


export type FruitGroupsItemsArgs = {
  order?: InputMaybe<Array<FruitGroupSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FruitGroupFilterInput>;
};

export type Fruits = {
  __typename?: 'fruits';
  /** Get Fruits any */
  any: Scalars['Boolean'];
  /** Get Fruits count */
  count: Scalars['Int'];
  /** Get $Fruits list */
  items: Array<Fruit>;
};


export type FruitsAnyArgs = {
  where?: InputMaybe<FruitFilterInput>;
};


export type FruitsCountArgs = {
  where?: InputMaybe<FruitFilterInput>;
};


export type FruitsItemsArgs = {
  order?: InputMaybe<Array<FruitSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FruitFilterInput>;
};

export type Harvest = {
  __typename?: 'harvest';
  cartQuantity: Scalars['Int'];
  fruit: Fruit;
  fruitId: Scalars['Int'];
  harvestFruitCategories: HarvestFruitCategorys;
  harvestFruitGroups: HarvestFruitGroups;
  hideFromMultiUpdate: Scalars['Boolean'];
  id: Scalars['Int'];
  kg: Scalars['Decimal'];
  work: HarvestAgricultureWork;
  workId: Scalars['Int'];
};

export type HarvestAgricultureWork = {
  __typename?: 'harvestAgricultureWork';
  category: WorkCategories;
  endDate?: Maybe<Scalars['LocalDate']>;
  harvests: Harvests;
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  season: Season;
  seasonId: Scalars['Int'];
  startDate: Scalars['LocalDate'];
  type: AgricultureWorkTypes;
  workers: Workers;
};

export type HarvestAgricultureWorkTemplate = {
  __typename?: 'harvestAgricultureWorkTemplate';
  category: WorkCategories;
  endDate?: Maybe<Scalars['DateTime']>;
  harvests: HarvestTemplates;
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  season?: Maybe<Season>;
  seasonId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  type: AgricultureWorkTypes;
  workers: WorkerTemplates;
};

export type HarvestAgricultureWorkTemplates = {
  __typename?: 'harvestAgricultureWorkTemplates';
  /** Get HarvestAgricultureWorkTemplates any */
  any: Scalars['Boolean'];
  /** Get HarvestAgricultureWorkTemplates count */
  count: Scalars['Int'];
  /** Get $HarvestAgricultureWorkTemplates list */
  items: Array<HarvestAgricultureWorkTemplate>;
};


export type HarvestAgricultureWorkTemplatesAnyArgs = {
  where?: InputMaybe<HarvestAgricultureWorkTemplateFilterInput>;
};


export type HarvestAgricultureWorkTemplatesCountArgs = {
  where?: InputMaybe<HarvestAgricultureWorkTemplateFilterInput>;
};


export type HarvestAgricultureWorkTemplatesItemsArgs = {
  order?: InputMaybe<Array<HarvestAgricultureWorkTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestAgricultureWorkTemplateFilterInput>;
};

export type HarvestAgricultureWorks = {
  __typename?: 'harvestAgricultureWorks';
  /** Get HarvestAgricultureWorks any */
  any: Scalars['Boolean'];
  /** Get HarvestAgricultureWorks count */
  count: Scalars['Int'];
  /** Get $HarvestAgricultureWorks list */
  items: Array<HarvestAgricultureWork>;
};


export type HarvestAgricultureWorksAnyArgs = {
  where?: InputMaybe<HarvestAgricultureWorkFilterInput>;
};


export type HarvestAgricultureWorksCountArgs = {
  where?: InputMaybe<HarvestAgricultureWorkFilterInput>;
};


export type HarvestAgricultureWorksItemsArgs = {
  order?: InputMaybe<Array<HarvestAgricultureWorkSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestAgricultureWorkFilterInput>;
};

export type HarvestFruitCategory = {
  __typename?: 'harvestFruitCategory';
  fruitCategory: FruitCategory;
  fruitCategoryId: Scalars['Int'];
  harvest: Harvest;
  harvestId: Scalars['Int'];
  id: Scalars['Int'];
};

export type HarvestFruitCategoryTemplate = {
  __typename?: 'harvestFruitCategoryTemplate';
  fruitCategory: FruitCategory;
  fruitCategoryId: Scalars['Int'];
  harvest: HarvestTemplate;
  harvestId: Scalars['Int'];
  id: Scalars['Int'];
};

export type HarvestFruitCategoryTemplates = {
  __typename?: 'harvestFruitCategoryTemplates';
  /** Get HarvestFruitCategoryTemplates any */
  any: Scalars['Boolean'];
  /** Get HarvestFruitCategoryTemplates count */
  count: Scalars['Int'];
  /** Get $HarvestFruitCategoryTemplates list */
  items: Array<HarvestFruitCategoryTemplate>;
};


export type HarvestFruitCategoryTemplatesAnyArgs = {
  where?: InputMaybe<HarvestFruitCategoryTemplateFilterInput>;
};


export type HarvestFruitCategoryTemplatesCountArgs = {
  where?: InputMaybe<HarvestFruitCategoryTemplateFilterInput>;
};


export type HarvestFruitCategoryTemplatesItemsArgs = {
  order?: InputMaybe<Array<HarvestFruitCategoryTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestFruitCategoryTemplateFilterInput>;
};

export type HarvestFruitCategorys = {
  __typename?: 'harvestFruitCategorys';
  /** Get HarvestFruitCategorys any */
  any: Scalars['Boolean'];
  /** Get HarvestFruitCategorys count */
  count: Scalars['Int'];
  /** Get $HarvestFruitCategorys list */
  items: Array<HarvestFruitCategory>;
};


export type HarvestFruitCategorysAnyArgs = {
  where?: InputMaybe<HarvestFruitCategoryFilterInput>;
};


export type HarvestFruitCategorysCountArgs = {
  where?: InputMaybe<HarvestFruitCategoryFilterInput>;
};


export type HarvestFruitCategorysItemsArgs = {
  order?: InputMaybe<Array<HarvestFruitCategorySortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestFruitCategoryFilterInput>;
};

export type HarvestFruitGroup = {
  __typename?: 'harvestFruitGroup';
  fruitGroup: FruitGroup;
  fruitGroupId: Scalars['Int'];
  harvest: Harvest;
  harvestId: Scalars['Int'];
  id: Scalars['Int'];
};

export type HarvestFruitGroupTemplate = {
  __typename?: 'harvestFruitGroupTemplate';
  fruitGroup: FruitGroup;
  fruitGroupId: Scalars['Int'];
  harvest: HarvestTemplate;
  harvestId: Scalars['Int'];
  id: Scalars['Int'];
};

export type HarvestFruitGroupTemplates = {
  __typename?: 'harvestFruitGroupTemplates';
  /** Get HarvestFruitGroupTemplates any */
  any: Scalars['Boolean'];
  /** Get HarvestFruitGroupTemplates count */
  count: Scalars['Int'];
  /** Get $HarvestFruitGroupTemplates list */
  items: Array<HarvestFruitGroupTemplate>;
};


export type HarvestFruitGroupTemplatesAnyArgs = {
  where?: InputMaybe<HarvestFruitGroupTemplateFilterInput>;
};


export type HarvestFruitGroupTemplatesCountArgs = {
  where?: InputMaybe<HarvestFruitGroupTemplateFilterInput>;
};


export type HarvestFruitGroupTemplatesItemsArgs = {
  order?: InputMaybe<Array<HarvestFruitGroupTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestFruitGroupTemplateFilterInput>;
};

export type HarvestFruitGroups = {
  __typename?: 'harvestFruitGroups';
  /** Get HarvestFruitGroups any */
  any: Scalars['Boolean'];
  /** Get HarvestFruitGroups count */
  count: Scalars['Int'];
  /** Get $HarvestFruitGroups list */
  items: Array<HarvestFruitGroup>;
};


export type HarvestFruitGroupsAnyArgs = {
  where?: InputMaybe<HarvestFruitGroupFilterInput>;
};


export type HarvestFruitGroupsCountArgs = {
  where?: InputMaybe<HarvestFruitGroupFilterInput>;
};


export type HarvestFruitGroupsItemsArgs = {
  order?: InputMaybe<Array<HarvestFruitGroupSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestFruitGroupFilterInput>;
};

export type HarvestTemplate = {
  __typename?: 'harvestTemplate';
  cartQuantity?: Maybe<Scalars['Int']>;
  fruit?: Maybe<Fruit>;
  fruitId?: Maybe<Scalars['Int']>;
  harvestFruitCategories: HarvestFruitCategoryTemplates;
  harvestFruitGroups: HarvestFruitGroupTemplates;
  hideFromMultiUpdate: Scalars['Boolean'];
  id: Scalars['Int'];
  kg?: Maybe<Scalars['Decimal']>;
  work: WorkTemplate;
  workId: Scalars['Int'];
};

export type HarvestTemplates = {
  __typename?: 'harvestTemplates';
  /** Get HarvestTemplates any */
  any: Scalars['Boolean'];
  /** Get HarvestTemplates count */
  count: Scalars['Int'];
  /** Get $HarvestTemplates list */
  items: Array<HarvestTemplate>;
};


export type HarvestTemplatesAnyArgs = {
  where?: InputMaybe<HarvestTemplateFilterInput>;
};


export type HarvestTemplatesCountArgs = {
  where?: InputMaybe<HarvestTemplateFilterInput>;
};


export type HarvestTemplatesItemsArgs = {
  order?: InputMaybe<Array<HarvestTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestTemplateFilterInput>;
};

export type Harvests = {
  __typename?: 'harvests';
  /** Get Harvests any */
  any: Scalars['Boolean'];
  /** Get Harvests cartQuantityAverage */
  cartQuantityAverage: Scalars['Decimal'];
  /** Get Harvests cartQuantitySum */
  cartQuantitySum: Scalars['Decimal'];
  /** Get Harvests count */
  count: Scalars['Int'];
  /** Get $Harvests list */
  items: Array<Harvest>;
  /** Get Harvests kgAverage */
  kgAverage: Scalars['Decimal'];
  /** Get Harvests kgSum */
  kgSum: Scalars['Decimal'];
};


export type HarvestsAnyArgs = {
  where?: InputMaybe<HarvestFilterInput>;
};


export type HarvestsCartQuantityAverageArgs = {
  order?: InputMaybe<Array<HarvestSortInput>>;
  where?: InputMaybe<HarvestFilterInput>;
};


export type HarvestsCartQuantitySumArgs = {
  order?: InputMaybe<Array<HarvestSortInput>>;
  where?: InputMaybe<HarvestFilterInput>;
};


export type HarvestsCountArgs = {
  where?: InputMaybe<HarvestFilterInput>;
};


export type HarvestsItemsArgs = {
  order?: InputMaybe<Array<HarvestSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestFilterInput>;
};


export type HarvestsKgAverageArgs = {
  order?: InputMaybe<Array<HarvestSortInput>>;
  where?: InputMaybe<HarvestFilterInput>;
};


export type HarvestsKgSumArgs = {
  order?: InputMaybe<Array<HarvestSortInput>>;
  where?: InputMaybe<HarvestFilterInput>;
};

export type Income = {
  __typename?: 'income';
  amount: Scalars['Decimal'];
  bookings: Bookings;
  date: Scalars['LocalDate'];
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  paid: Scalars['Boolean'];
};

export type Incomes = {
  __typename?: 'incomes';
  /** Get Incomes amountAverage */
  amountAverage: Scalars['Decimal'];
  /** Get Incomes amountSum */
  amountSum: Scalars['Decimal'];
  /** Get Incomes any */
  any: Scalars['Boolean'];
  /** Get Incomes count */
  count: Scalars['Int'];
  /** Get Incomes idAverage */
  idAverage: Scalars['Decimal'];
  /** Get Incomes idSum */
  idSum: Scalars['Decimal'];
  /** Get $Incomes list */
  items: Array<Income>;
};


export type IncomesAmountAverageArgs = {
  order?: InputMaybe<Array<IncomeSortInput>>;
  where?: InputMaybe<IncomeFilterInput>;
};


export type IncomesAmountSumArgs = {
  order?: InputMaybe<Array<IncomeSortInput>>;
  where?: InputMaybe<IncomeFilterInput>;
};


export type IncomesAnyArgs = {
  where?: InputMaybe<IncomeFilterInput>;
};


export type IncomesCountArgs = {
  where?: InputMaybe<IncomeFilterInput>;
};


export type IncomesIdAverageArgs = {
  order?: InputMaybe<Array<IncomeSortInput>>;
  where?: InputMaybe<IncomeFilterInput>;
};


export type IncomesIdSumArgs = {
  order?: InputMaybe<Array<IncomeSortInput>>;
  where?: InputMaybe<IncomeFilterInput>;
};


export type IncomesItemsArgs = {
  order?: InputMaybe<Array<IncomeSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IncomeFilterInput>;
};

export type MaintenanceAgricultureWork = {
  __typename?: 'maintenanceAgricultureWork';
  category: WorkCategories;
  endDate?: Maybe<Scalars['LocalDate']>;
  id: Scalars['Int'];
  logs: MaintenanceLogs;
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  season: Season;
  seasonId: Scalars['Int'];
  startDate: Scalars['LocalDate'];
  type: AgricultureWorkTypes;
  workers: Workers;
};

export type MaintenanceAgricultureWorkTemplate = {
  __typename?: 'maintenanceAgricultureWorkTemplate';
  category: WorkCategories;
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  logs?: Maybe<Array<MaintenanceLogTemplate>>;
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  season?: Maybe<Season>;
  seasonId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  type: AgricultureWorkTypes;
  workers: WorkerTemplates;
};

export type MaintenanceAgricultureWorkTemplates = {
  __typename?: 'maintenanceAgricultureWorkTemplates';
  /** Get MaintenanceAgricultureWorkTemplates any */
  any: Scalars['Boolean'];
  /** Get MaintenanceAgricultureWorkTemplates count */
  count: Scalars['Int'];
  /** Get $MaintenanceAgricultureWorkTemplates list */
  items: Array<MaintenanceAgricultureWorkTemplate>;
};


export type MaintenanceAgricultureWorkTemplatesAnyArgs = {
  where?: InputMaybe<MaintenanceAgricultureWorkTemplateFilterInput>;
};


export type MaintenanceAgricultureWorkTemplatesCountArgs = {
  where?: InputMaybe<MaintenanceAgricultureWorkTemplateFilterInput>;
};


export type MaintenanceAgricultureWorkTemplatesItemsArgs = {
  order?: InputMaybe<Array<MaintenanceAgricultureWorkTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceAgricultureWorkTemplateFilterInput>;
};

export type MaintenanceAgricultureWorks = {
  __typename?: 'maintenanceAgricultureWorks';
  /** Get MaintenanceAgricultureWorks any */
  any: Scalars['Boolean'];
  /** Get MaintenanceAgricultureWorks count */
  count: Scalars['Int'];
  /** Get $MaintenanceAgricultureWorks list */
  items: Array<MaintenanceAgricultureWork>;
};


export type MaintenanceAgricultureWorksAnyArgs = {
  where?: InputMaybe<MaintenanceAgricultureWorkFilterInput>;
};


export type MaintenanceAgricultureWorksCountArgs = {
  where?: InputMaybe<MaintenanceAgricultureWorkFilterInput>;
};


export type MaintenanceAgricultureWorksItemsArgs = {
  order?: InputMaybe<Array<MaintenanceAgricultureWorkSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceAgricultureWorkFilterInput>;
};

export type MaintenanceLog = {
  __typename?: 'maintenanceLog';
  id: Scalars['Int'];
  investment?: Maybe<AgricultureWorkInvestment>;
  investmentId?: Maybe<Scalars['Int']>;
  maintenanceLogFruitGroups: MaintenanceLogFruitGroups;
  type: MaintenanceLogType;
  typeId: Scalars['Int'];
  work: MaintenanceAgricultureWork;
  workId: Scalars['Int'];
};

export type MaintenanceLogFruitGroup = {
  __typename?: 'maintenanceLogFruitGroup';
  fruitGroup: FruitGroup;
  fruitGroupId: Scalars['Int'];
  id: Scalars['Int'];
  log: MaintenanceLog;
  logId: Scalars['Int'];
};

export type MaintenanceLogFruitGroupTemplate = {
  __typename?: 'maintenanceLogFruitGroupTemplate';
  fruitGroup: FruitGroup;
  fruitGroupId: Scalars['Int'];
  id: Scalars['Int'];
  log: MaintenanceLogTemplate;
  logId: Scalars['Int'];
};

export type MaintenanceLogFruitGroupTemplates = {
  __typename?: 'maintenanceLogFruitGroupTemplates';
  /** Get MaintenanceLogFruitGroupTemplates any */
  any: Scalars['Boolean'];
  /** Get MaintenanceLogFruitGroupTemplates count */
  count: Scalars['Int'];
  /** Get MaintenanceLogFruitGroupTemplates fruitGroupIdAverage */
  fruitGroupIdAverage: Scalars['Decimal'];
  /** Get MaintenanceLogFruitGroupTemplates fruitGroupIdSum */
  fruitGroupIdSum: Scalars['Decimal'];
  /** Get MaintenanceLogFruitGroupTemplates idAverage */
  idAverage: Scalars['Decimal'];
  /** Get MaintenanceLogFruitGroupTemplates idSum */
  idSum: Scalars['Decimal'];
  /** Get $MaintenanceLogFruitGroupTemplates list */
  items: Array<MaintenanceLogFruitGroupTemplate>;
  /** Get MaintenanceLogFruitGroupTemplates logIdAverage */
  logIdAverage: Scalars['Decimal'];
  /** Get MaintenanceLogFruitGroupTemplates logIdSum */
  logIdSum: Scalars['Decimal'];
};


export type MaintenanceLogFruitGroupTemplatesAnyArgs = {
  where?: InputMaybe<MaintenanceLogFruitGroupTemplateFilterInput>;
};


export type MaintenanceLogFruitGroupTemplatesCountArgs = {
  where?: InputMaybe<MaintenanceLogFruitGroupTemplateFilterInput>;
};


export type MaintenanceLogFruitGroupTemplatesFruitGroupIdAverageArgs = {
  order?: InputMaybe<Array<MaintenanceLogFruitGroupTemplateSortInput>>;
  where?: InputMaybe<MaintenanceLogFruitGroupTemplateFilterInput>;
};


export type MaintenanceLogFruitGroupTemplatesFruitGroupIdSumArgs = {
  order?: InputMaybe<Array<MaintenanceLogFruitGroupTemplateSortInput>>;
  where?: InputMaybe<MaintenanceLogFruitGroupTemplateFilterInput>;
};


export type MaintenanceLogFruitGroupTemplatesIdAverageArgs = {
  order?: InputMaybe<Array<MaintenanceLogFruitGroupTemplateSortInput>>;
  where?: InputMaybe<MaintenanceLogFruitGroupTemplateFilterInput>;
};


export type MaintenanceLogFruitGroupTemplatesIdSumArgs = {
  order?: InputMaybe<Array<MaintenanceLogFruitGroupTemplateSortInput>>;
  where?: InputMaybe<MaintenanceLogFruitGroupTemplateFilterInput>;
};


export type MaintenanceLogFruitGroupTemplatesItemsArgs = {
  order?: InputMaybe<Array<MaintenanceLogFruitGroupTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceLogFruitGroupTemplateFilterInput>;
};


export type MaintenanceLogFruitGroupTemplatesLogIdAverageArgs = {
  order?: InputMaybe<Array<MaintenanceLogFruitGroupTemplateSortInput>>;
  where?: InputMaybe<MaintenanceLogFruitGroupTemplateFilterInput>;
};


export type MaintenanceLogFruitGroupTemplatesLogIdSumArgs = {
  order?: InputMaybe<Array<MaintenanceLogFruitGroupTemplateSortInput>>;
  where?: InputMaybe<MaintenanceLogFruitGroupTemplateFilterInput>;
};

export type MaintenanceLogFruitGroups = {
  __typename?: 'maintenanceLogFruitGroups';
  /** Get MaintenanceLogFruitGroups any */
  any: Scalars['Boolean'];
  /** Get MaintenanceLogFruitGroups count */
  count: Scalars['Int'];
  /** Get MaintenanceLogFruitGroups fruitGroupIdAverage */
  fruitGroupIdAverage: Scalars['Decimal'];
  /** Get MaintenanceLogFruitGroups fruitGroupIdSum */
  fruitGroupIdSum: Scalars['Decimal'];
  /** Get MaintenanceLogFruitGroups idAverage */
  idAverage: Scalars['Decimal'];
  /** Get MaintenanceLogFruitGroups idSum */
  idSum: Scalars['Decimal'];
  /** Get $MaintenanceLogFruitGroups list */
  items: Array<MaintenanceLogFruitGroup>;
  /** Get MaintenanceLogFruitGroups logIdAverage */
  logIdAverage: Scalars['Decimal'];
  /** Get MaintenanceLogFruitGroups logIdSum */
  logIdSum: Scalars['Decimal'];
};


export type MaintenanceLogFruitGroupsAnyArgs = {
  where?: InputMaybe<MaintenanceLogFruitGroupFilterInput>;
};


export type MaintenanceLogFruitGroupsCountArgs = {
  where?: InputMaybe<MaintenanceLogFruitGroupFilterInput>;
};


export type MaintenanceLogFruitGroupsFruitGroupIdAverageArgs = {
  order?: InputMaybe<Array<MaintenanceLogFruitGroupSortInput>>;
  where?: InputMaybe<MaintenanceLogFruitGroupFilterInput>;
};


export type MaintenanceLogFruitGroupsFruitGroupIdSumArgs = {
  order?: InputMaybe<Array<MaintenanceLogFruitGroupSortInput>>;
  where?: InputMaybe<MaintenanceLogFruitGroupFilterInput>;
};


export type MaintenanceLogFruitGroupsIdAverageArgs = {
  order?: InputMaybe<Array<MaintenanceLogFruitGroupSortInput>>;
  where?: InputMaybe<MaintenanceLogFruitGroupFilterInput>;
};


export type MaintenanceLogFruitGroupsIdSumArgs = {
  order?: InputMaybe<Array<MaintenanceLogFruitGroupSortInput>>;
  where?: InputMaybe<MaintenanceLogFruitGroupFilterInput>;
};


export type MaintenanceLogFruitGroupsItemsArgs = {
  order?: InputMaybe<Array<MaintenanceLogFruitGroupSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceLogFruitGroupFilterInput>;
};


export type MaintenanceLogFruitGroupsLogIdAverageArgs = {
  order?: InputMaybe<Array<MaintenanceLogFruitGroupSortInput>>;
  where?: InputMaybe<MaintenanceLogFruitGroupFilterInput>;
};


export type MaintenanceLogFruitGroupsLogIdSumArgs = {
  order?: InputMaybe<Array<MaintenanceLogFruitGroupSortInput>>;
  where?: InputMaybe<MaintenanceLogFruitGroupFilterInput>;
};

export type MaintenanceLogTemplate = {
  __typename?: 'maintenanceLogTemplate';
  id: Scalars['Int'];
  maintenanceLogFruitGroups: MaintenanceLogFruitGroupTemplates;
  type: MaintenanceLogType;
  typeId: Scalars['Int'];
  work: MaintenanceAgricultureWorkTemplate;
  workId: Scalars['Int'];
};

export type MaintenanceLogTemplates = {
  __typename?: 'maintenanceLogTemplates';
  /** Get MaintenanceLogTemplates any */
  any: Scalars['Boolean'];
  /** Get MaintenanceLogTemplates count */
  count: Scalars['Int'];
  /** Get MaintenanceLogTemplates idAverage */
  idAverage: Scalars['Decimal'];
  /** Get MaintenanceLogTemplates idSum */
  idSum: Scalars['Decimal'];
  /** Get $MaintenanceLogTemplates list */
  items: Array<MaintenanceLogTemplate>;
  /** Get MaintenanceLogTemplates typeIdAverage */
  typeIdAverage: Scalars['Decimal'];
  /** Get MaintenanceLogTemplates typeIdSum */
  typeIdSum: Scalars['Decimal'];
  /** Get MaintenanceLogTemplates workIdAverage */
  workIdAverage: Scalars['Decimal'];
  /** Get MaintenanceLogTemplates workIdSum */
  workIdSum: Scalars['Decimal'];
};


export type MaintenanceLogTemplatesAnyArgs = {
  where?: InputMaybe<MaintenanceLogTemplateFilterInput>;
};


export type MaintenanceLogTemplatesCountArgs = {
  where?: InputMaybe<MaintenanceLogTemplateFilterInput>;
};


export type MaintenanceLogTemplatesIdAverageArgs = {
  order?: InputMaybe<Array<MaintenanceLogTemplateSortInput>>;
  where?: InputMaybe<MaintenanceLogTemplateFilterInput>;
};


export type MaintenanceLogTemplatesIdSumArgs = {
  order?: InputMaybe<Array<MaintenanceLogTemplateSortInput>>;
  where?: InputMaybe<MaintenanceLogTemplateFilterInput>;
};


export type MaintenanceLogTemplatesItemsArgs = {
  order?: InputMaybe<Array<MaintenanceLogTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceLogTemplateFilterInput>;
};


export type MaintenanceLogTemplatesTypeIdAverageArgs = {
  order?: InputMaybe<Array<MaintenanceLogTemplateSortInput>>;
  where?: InputMaybe<MaintenanceLogTemplateFilterInput>;
};


export type MaintenanceLogTemplatesTypeIdSumArgs = {
  order?: InputMaybe<Array<MaintenanceLogTemplateSortInput>>;
  where?: InputMaybe<MaintenanceLogTemplateFilterInput>;
};


export type MaintenanceLogTemplatesWorkIdAverageArgs = {
  order?: InputMaybe<Array<MaintenanceLogTemplateSortInput>>;
  where?: InputMaybe<MaintenanceLogTemplateFilterInput>;
};


export type MaintenanceLogTemplatesWorkIdSumArgs = {
  order?: InputMaybe<Array<MaintenanceLogTemplateSortInput>>;
  where?: InputMaybe<MaintenanceLogTemplateFilterInput>;
};

export type MaintenanceLogType = {
  __typename?: 'maintenanceLogType';
  id: Scalars['Int'];
  maintenances: MaintenanceLogs;
  name: Scalars['String'];
  nameTranslationKey: Scalars['String'];
  normalizedName: Scalars['String'];
};

export type MaintenanceLogTypes = {
  __typename?: 'maintenanceLogTypes';
  /** Get MaintenanceLogTypes any */
  any: Scalars['Boolean'];
  /** Get MaintenanceLogTypes count */
  count: Scalars['Int'];
  /** Get MaintenanceLogTypes idAverage */
  idAverage: Scalars['Decimal'];
  /** Get MaintenanceLogTypes idSum */
  idSum: Scalars['Decimal'];
  /** Get $MaintenanceLogTypes list */
  items: Array<MaintenanceLogType>;
};


export type MaintenanceLogTypesAnyArgs = {
  where?: InputMaybe<MaintenanceLogTypeFilterInput>;
};


export type MaintenanceLogTypesCountArgs = {
  where?: InputMaybe<MaintenanceLogTypeFilterInput>;
};


export type MaintenanceLogTypesIdAverageArgs = {
  order?: InputMaybe<Array<MaintenanceLogTypeSortInput>>;
  where?: InputMaybe<MaintenanceLogTypeFilterInput>;
};


export type MaintenanceLogTypesIdSumArgs = {
  order?: InputMaybe<Array<MaintenanceLogTypeSortInput>>;
  where?: InputMaybe<MaintenanceLogTypeFilterInput>;
};


export type MaintenanceLogTypesItemsArgs = {
  order?: InputMaybe<Array<MaintenanceLogTypeSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceLogTypeFilterInput>;
};

export type MaintenanceLogs = {
  __typename?: 'maintenanceLogs';
  /** Get MaintenanceLogs any */
  any: Scalars['Boolean'];
  /** Get MaintenanceLogs count */
  count: Scalars['Int'];
  /** Get MaintenanceLogs idAverage */
  idAverage: Scalars['Decimal'];
  /** Get MaintenanceLogs idSum */
  idSum: Scalars['Decimal'];
  /** Get MaintenanceLogs investmentIdAverage */
  investmentIdAverage: Scalars['Decimal'];
  /** Get MaintenanceLogs investmentIdSum */
  investmentIdSum: Scalars['Decimal'];
  /** Get $MaintenanceLogs list */
  items: Array<MaintenanceLog>;
  /** Get MaintenanceLogs typeIdAverage */
  typeIdAverage: Scalars['Decimal'];
  /** Get MaintenanceLogs typeIdSum */
  typeIdSum: Scalars['Decimal'];
  /** Get MaintenanceLogs workIdAverage */
  workIdAverage: Scalars['Decimal'];
  /** Get MaintenanceLogs workIdSum */
  workIdSum: Scalars['Decimal'];
};


export type MaintenanceLogsAnyArgs = {
  where?: InputMaybe<MaintenanceLogFilterInput>;
};


export type MaintenanceLogsCountArgs = {
  where?: InputMaybe<MaintenanceLogFilterInput>;
};


export type MaintenanceLogsIdAverageArgs = {
  order?: InputMaybe<Array<MaintenanceLogSortInput>>;
  where?: InputMaybe<MaintenanceLogFilterInput>;
};


export type MaintenanceLogsIdSumArgs = {
  order?: InputMaybe<Array<MaintenanceLogSortInput>>;
  where?: InputMaybe<MaintenanceLogFilterInput>;
};


export type MaintenanceLogsInvestmentIdAverageArgs = {
  order?: InputMaybe<Array<MaintenanceLogSortInput>>;
  where?: InputMaybe<MaintenanceLogFilterInput>;
};


export type MaintenanceLogsInvestmentIdSumArgs = {
  order?: InputMaybe<Array<MaintenanceLogSortInput>>;
  where?: InputMaybe<MaintenanceLogFilterInput>;
};


export type MaintenanceLogsItemsArgs = {
  order?: InputMaybe<Array<MaintenanceLogSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceLogFilterInput>;
};


export type MaintenanceLogsTypeIdAverageArgs = {
  order?: InputMaybe<Array<MaintenanceLogSortInput>>;
  where?: InputMaybe<MaintenanceLogFilterInput>;
};


export type MaintenanceLogsTypeIdSumArgs = {
  order?: InputMaybe<Array<MaintenanceLogSortInput>>;
  where?: InputMaybe<MaintenanceLogFilterInput>;
};


export type MaintenanceLogsWorkIdAverageArgs = {
  order?: InputMaybe<Array<MaintenanceLogSortInput>>;
  where?: InputMaybe<MaintenanceLogFilterInput>;
};


export type MaintenanceLogsWorkIdSumArgs = {
  order?: InputMaybe<Array<MaintenanceLogSortInput>>;
  where?: InputMaybe<MaintenanceLogFilterInput>;
};

export type NotificationConfig = {
  __typename?: 'notificationConfig';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  isEmailNotificationEnabled: Scalars['Boolean'];
  isNtfyNotificationEnabled: Scalars['Boolean'];
  isPushNotificationEnabled: Scalars['Boolean'];
  notificationGroup: NotificationGroups;
  notificationType: NotificationTypes;
  user: User;
  userId: Scalars['Int'];
};

export type NotificationConfigs = {
  __typename?: 'notificationConfigs';
  /** Get notificationConfigs any */
  any: Scalars['Boolean'];
  /** Get notificationConfigs count */
  count: Scalars['Int'];
  /** Get $notificationConfigs list */
  items: Array<NotificationConfig>;
};


export type NotificationConfigsAnyArgs = {
  where?: InputMaybe<NotificationConfigFilterInput>;
};


export type NotificationConfigsCountArgs = {
  where?: InputMaybe<NotificationConfigFilterInput>;
};


export type NotificationConfigsItemsArgs = {
  order?: InputMaybe<Array<NotificationConfigSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NotificationConfigFilterInput>;
};

export type People = {
  __typename?: 'people';
  /** Get people any */
  any: Scalars['Boolean'];
  /** Get people count */
  count: Scalars['Int'];
  /** Get $people list */
  items: Array<Person>;
};


export type PeopleAnyArgs = {
  where?: InputMaybe<PersonFilterInput>;
};


export type PeopleCountArgs = {
  where?: InputMaybe<PersonFilterInput>;
};


export type PeopleItemsArgs = {
  order?: InputMaybe<Array<PersonSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PersonFilterInput>;
};

export type Person = {
  __typename?: 'person';
  bookingEvents: BookingEvents;
  bookings: Bookings;
  contactInfo: PersonContactInfos;
  /** Country info */
  country?: Maybe<Country>;
  countryCode?: Maybe<Scalars['String']>;
  eventTemplates: EventTemplates;
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  sales: Sales;
  tags: PersonTagLinks;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
  wallets: Wallets;
  workers: Workers;
};

export type PersonContactInfo = {
  __typename?: 'personContactInfo';
  id: Scalars['Int'];
  link?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  person: Person;
  personId: Scalars['Int'];
  value: Scalars['String'];
};

export type PersonContactInfos = {
  __typename?: 'personContactInfos';
  /** Get PersonContactInfos any */
  any: Scalars['Boolean'];
  /** Get PersonContactInfos count */
  count: Scalars['Int'];
  /** Get $PersonContactInfos list */
  items: Array<PersonContactInfo>;
};


export type PersonContactInfosAnyArgs = {
  where?: InputMaybe<PersonContactInfoFilterInput>;
};


export type PersonContactInfosCountArgs = {
  where?: InputMaybe<PersonContactInfoFilterInput>;
};


export type PersonContactInfosItemsArgs = {
  order?: InputMaybe<Array<PersonContactInfoSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PersonContactInfoFilterInput>;
};

export type PersonTag = {
  __typename?: 'personTag';
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  personTagLinks: PersonTagLinks;
};

export type PersonTagLink = {
  __typename?: 'personTagLink';
  id: Scalars['Int'];
  person: Person;
  personId: Scalars['Int'];
  tag: PersonTag;
  tagId: Scalars['Int'];
};

export type PersonTagLinks = {
  __typename?: 'personTagLinks';
  /** Get PersonTagLinks any */
  any: Scalars['Boolean'];
  /** Get PersonTagLinks count */
  count: Scalars['Int'];
  /** Get PersonTagLinks idAverage */
  idAverage: Scalars['Decimal'];
  /** Get PersonTagLinks idSum */
  idSum: Scalars['Decimal'];
  /** Get $PersonTagLinks list */
  items: Array<PersonTagLink>;
  /** Get PersonTagLinks personIdAverage */
  personIdAverage: Scalars['Decimal'];
  /** Get PersonTagLinks personIdSum */
  personIdSum: Scalars['Decimal'];
  /** Get PersonTagLinks tagIdAverage */
  tagIdAverage: Scalars['Decimal'];
  /** Get PersonTagLinks tagIdSum */
  tagIdSum: Scalars['Decimal'];
};


export type PersonTagLinksAnyArgs = {
  where?: InputMaybe<PersonTagLinkFilterInput>;
};


export type PersonTagLinksCountArgs = {
  where?: InputMaybe<PersonTagLinkFilterInput>;
};


export type PersonTagLinksIdAverageArgs = {
  order?: InputMaybe<Array<PersonTagLinkSortInput>>;
  where?: InputMaybe<PersonTagLinkFilterInput>;
};


export type PersonTagLinksIdSumArgs = {
  order?: InputMaybe<Array<PersonTagLinkSortInput>>;
  where?: InputMaybe<PersonTagLinkFilterInput>;
};


export type PersonTagLinksItemsArgs = {
  order?: InputMaybe<Array<PersonTagLinkSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PersonTagLinkFilterInput>;
};


export type PersonTagLinksPersonIdAverageArgs = {
  order?: InputMaybe<Array<PersonTagLinkSortInput>>;
  where?: InputMaybe<PersonTagLinkFilterInput>;
};


export type PersonTagLinksPersonIdSumArgs = {
  order?: InputMaybe<Array<PersonTagLinkSortInput>>;
  where?: InputMaybe<PersonTagLinkFilterInput>;
};


export type PersonTagLinksTagIdAverageArgs = {
  order?: InputMaybe<Array<PersonTagLinkSortInput>>;
  where?: InputMaybe<PersonTagLinkFilterInput>;
};


export type PersonTagLinksTagIdSumArgs = {
  order?: InputMaybe<Array<PersonTagLinkSortInput>>;
  where?: InputMaybe<PersonTagLinkFilterInput>;
};

export type PersonTags = {
  __typename?: 'personTags';
  /** Get PersonTags any */
  any: Scalars['Boolean'];
  /** Get PersonTags count */
  count: Scalars['Int'];
  /** Get PersonTags idAverage */
  idAverage: Scalars['Decimal'];
  /** Get PersonTags idSum */
  idSum: Scalars['Decimal'];
  /** Get $PersonTags list */
  items: Array<PersonTag>;
};


export type PersonTagsAnyArgs = {
  where?: InputMaybe<PersonTagFilterInput>;
};


export type PersonTagsCountArgs = {
  where?: InputMaybe<PersonTagFilterInput>;
};


export type PersonTagsIdAverageArgs = {
  order?: InputMaybe<Array<PersonTagSortInput>>;
  where?: InputMaybe<PersonTagFilterInput>;
};


export type PersonTagsIdSumArgs = {
  order?: InputMaybe<Array<PersonTagSortInput>>;
  where?: InputMaybe<PersonTagFilterInput>;
};


export type PersonTagsItemsArgs = {
  order?: InputMaybe<Array<PersonTagSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PersonTagFilterInput>;
};

export type PushNotificationSubscription = {
  __typename?: 'pushNotificationSubscription';
  auth: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endpoint: Scalars['String'];
  id: Scalars['Int'];
  p256dh: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['Int'];
};

export type PushNotificationSubscriptions = {
  __typename?: 'pushNotificationSubscriptions';
  /** Get PushNotificationSubscriptions any */
  any: Scalars['Boolean'];
  /** Get PushNotificationSubscriptions count */
  count: Scalars['Int'];
  /** Get PushNotificationSubscriptions idAverage */
  idAverage: Scalars['Decimal'];
  /** Get PushNotificationSubscriptions idSum */
  idSum: Scalars['Decimal'];
  /** Get $PushNotificationSubscriptions list */
  items: Array<PushNotificationSubscription>;
  /** Get PushNotificationSubscriptions userIdAverage */
  userIdAverage: Scalars['Decimal'];
  /** Get PushNotificationSubscriptions userIdSum */
  userIdSum: Scalars['Decimal'];
};


export type PushNotificationSubscriptionsAnyArgs = {
  where?: InputMaybe<PushNotificationSubscriptionFilterInput>;
};


export type PushNotificationSubscriptionsCountArgs = {
  where?: InputMaybe<PushNotificationSubscriptionFilterInput>;
};


export type PushNotificationSubscriptionsIdAverageArgs = {
  order?: InputMaybe<Array<PushNotificationSubscriptionSortInput>>;
  where?: InputMaybe<PushNotificationSubscriptionFilterInput>;
};


export type PushNotificationSubscriptionsIdSumArgs = {
  order?: InputMaybe<Array<PushNotificationSubscriptionSortInput>>;
  where?: InputMaybe<PushNotificationSubscriptionFilterInput>;
};


export type PushNotificationSubscriptionsItemsArgs = {
  order?: InputMaybe<Array<PushNotificationSubscriptionSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PushNotificationSubscriptionFilterInput>;
};


export type PushNotificationSubscriptionsUserIdAverageArgs = {
  order?: InputMaybe<Array<PushNotificationSubscriptionSortInput>>;
  where?: InputMaybe<PushNotificationSubscriptionFilterInput>;
};


export type PushNotificationSubscriptionsUserIdSumArgs = {
  order?: InputMaybe<Array<PushNotificationSubscriptionSortInput>>;
  where?: InputMaybe<PushNotificationSubscriptionFilterInput>;
};

export type Room = {
  __typename?: 'room';
  bookingDetails: BookingDetailss;
  bookings: Bookings;
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  roomType: RoomType;
  roomTypeId: Scalars['Int'];
  worklogs: AccommodationMaintenanceLogRooms;
};

export type RoomType = {
  __typename?: 'roomType';
  bookings: Bookings;
  channelDefultPrices: RoomTypeChannelDefultPrices;
  color?: Maybe<Scalars['String']>;
  defaultPrice?: Maybe<Scalars['Decimal']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  rooms: Rooms;
};

export type RoomTypeChannelDefultPrice = {
  __typename?: 'roomTypeChannelDefultPrice';
  channel: BookingChannel;
  channelId: Scalars['Int'];
  defaultPrice: Scalars['Decimal'];
  id: Scalars['Int'];
  roomType: RoomType;
  roomTypeId: Scalars['Int'];
};

export type RoomTypeChannelDefultPrices = {
  __typename?: 'roomTypeChannelDefultPrices';
  /** Get RoomTypeChannelDefultPrices any */
  any: Scalars['Boolean'];
  /** Get RoomTypeChannelDefultPrices channelIdAverage */
  channelIdAverage: Scalars['Decimal'];
  /** Get RoomTypeChannelDefultPrices channelIdSum */
  channelIdSum: Scalars['Decimal'];
  /** Get RoomTypeChannelDefultPrices count */
  count: Scalars['Int'];
  /** Get RoomTypeChannelDefultPrices defaultPriceAverage */
  defaultPriceAverage: Scalars['Decimal'];
  /** Get RoomTypeChannelDefultPrices defaultPriceSum */
  defaultPriceSum: Scalars['Decimal'];
  /** Get RoomTypeChannelDefultPrices idAverage */
  idAverage: Scalars['Decimal'];
  /** Get RoomTypeChannelDefultPrices idSum */
  idSum: Scalars['Decimal'];
  /** Get $RoomTypeChannelDefultPrices list */
  items: Array<RoomTypeChannelDefultPrice>;
  /** Get RoomTypeChannelDefultPrices roomTypeIdAverage */
  roomTypeIdAverage: Scalars['Decimal'];
  /** Get RoomTypeChannelDefultPrices roomTypeIdSum */
  roomTypeIdSum: Scalars['Decimal'];
};


export type RoomTypeChannelDefultPricesAnyArgs = {
  where?: InputMaybe<RoomTypeChannelDefultPriceFilterInput>;
};


export type RoomTypeChannelDefultPricesChannelIdAverageArgs = {
  order?: InputMaybe<Array<RoomTypeChannelDefultPriceSortInput>>;
  where?: InputMaybe<RoomTypeChannelDefultPriceFilterInput>;
};


export type RoomTypeChannelDefultPricesChannelIdSumArgs = {
  order?: InputMaybe<Array<RoomTypeChannelDefultPriceSortInput>>;
  where?: InputMaybe<RoomTypeChannelDefultPriceFilterInput>;
};


export type RoomTypeChannelDefultPricesCountArgs = {
  where?: InputMaybe<RoomTypeChannelDefultPriceFilterInput>;
};


export type RoomTypeChannelDefultPricesDefaultPriceAverageArgs = {
  order?: InputMaybe<Array<RoomTypeChannelDefultPriceSortInput>>;
  where?: InputMaybe<RoomTypeChannelDefultPriceFilterInput>;
};


export type RoomTypeChannelDefultPricesDefaultPriceSumArgs = {
  order?: InputMaybe<Array<RoomTypeChannelDefultPriceSortInput>>;
  where?: InputMaybe<RoomTypeChannelDefultPriceFilterInput>;
};


export type RoomTypeChannelDefultPricesIdAverageArgs = {
  order?: InputMaybe<Array<RoomTypeChannelDefultPriceSortInput>>;
  where?: InputMaybe<RoomTypeChannelDefultPriceFilterInput>;
};


export type RoomTypeChannelDefultPricesIdSumArgs = {
  order?: InputMaybe<Array<RoomTypeChannelDefultPriceSortInput>>;
  where?: InputMaybe<RoomTypeChannelDefultPriceFilterInput>;
};


export type RoomTypeChannelDefultPricesItemsArgs = {
  order?: InputMaybe<Array<RoomTypeChannelDefultPriceSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RoomTypeChannelDefultPriceFilterInput>;
};


export type RoomTypeChannelDefultPricesRoomTypeIdAverageArgs = {
  order?: InputMaybe<Array<RoomTypeChannelDefultPriceSortInput>>;
  where?: InputMaybe<RoomTypeChannelDefultPriceFilterInput>;
};


export type RoomTypeChannelDefultPricesRoomTypeIdSumArgs = {
  order?: InputMaybe<Array<RoomTypeChannelDefultPriceSortInput>>;
  where?: InputMaybe<RoomTypeChannelDefultPriceFilterInput>;
};

export type RoomTypes = {
  __typename?: 'roomTypes';
  /** Get RoomTypes any */
  any: Scalars['Boolean'];
  /** Get RoomTypes count */
  count: Scalars['Int'];
  /** Get RoomTypes defaultPriceAverage */
  defaultPriceAverage: Scalars['Decimal'];
  /** Get RoomTypes defaultPriceSum */
  defaultPriceSum: Scalars['Decimal'];
  /** Get RoomTypes idAverage */
  idAverage: Scalars['Decimal'];
  /** Get RoomTypes idSum */
  idSum: Scalars['Decimal'];
  /** Get $RoomTypes list */
  items: Array<RoomType>;
};


export type RoomTypesAnyArgs = {
  where?: InputMaybe<RoomTypeFilterInput>;
};


export type RoomTypesCountArgs = {
  where?: InputMaybe<RoomTypeFilterInput>;
};


export type RoomTypesDefaultPriceAverageArgs = {
  order?: InputMaybe<Array<RoomTypeSortInput>>;
  where?: InputMaybe<RoomTypeFilterInput>;
};


export type RoomTypesDefaultPriceSumArgs = {
  order?: InputMaybe<Array<RoomTypeSortInput>>;
  where?: InputMaybe<RoomTypeFilterInput>;
};


export type RoomTypesIdAverageArgs = {
  order?: InputMaybe<Array<RoomTypeSortInput>>;
  where?: InputMaybe<RoomTypeFilterInput>;
};


export type RoomTypesIdSumArgs = {
  order?: InputMaybe<Array<RoomTypeSortInput>>;
  where?: InputMaybe<RoomTypeFilterInput>;
};


export type RoomTypesItemsArgs = {
  order?: InputMaybe<Array<RoomTypeSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RoomTypeFilterInput>;
};

export type Rooms = {
  __typename?: 'rooms';
  /** Get Rooms any */
  any: Scalars['Boolean'];
  /** Get Rooms count */
  count: Scalars['Int'];
  /** Get Rooms idAverage */
  idAverage: Scalars['Decimal'];
  /** Get Rooms idSum */
  idSum: Scalars['Decimal'];
  /** Get $Rooms list */
  items: Array<Room>;
  /** Get Rooms orderAverage */
  orderAverage: Scalars['Decimal'];
  /** Get Rooms orderSum */
  orderSum: Scalars['Decimal'];
  /** Get Rooms roomTypeIdAverage */
  roomTypeIdAverage: Scalars['Decimal'];
  /** Get Rooms roomTypeIdSum */
  roomTypeIdSum: Scalars['Decimal'];
};


export type RoomsAnyArgs = {
  where?: InputMaybe<RoomFilterInput>;
};


export type RoomsCountArgs = {
  where?: InputMaybe<RoomFilterInput>;
};


export type RoomsIdAverageArgs = {
  order?: InputMaybe<Array<RoomSortInput>>;
  where?: InputMaybe<RoomFilterInput>;
};


export type RoomsIdSumArgs = {
  order?: InputMaybe<Array<RoomSortInput>>;
  where?: InputMaybe<RoomFilterInput>;
};


export type RoomsItemsArgs = {
  order?: InputMaybe<Array<RoomSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RoomFilterInput>;
};


export type RoomsOrderAverageArgs = {
  order?: InputMaybe<Array<RoomSortInput>>;
  where?: InputMaybe<RoomFilterInput>;
};


export type RoomsOrderSumArgs = {
  order?: InputMaybe<Array<RoomSortInput>>;
  where?: InputMaybe<RoomFilterInput>;
};


export type RoomsRoomTypeIdAverageArgs = {
  order?: InputMaybe<Array<RoomSortInput>>;
  where?: InputMaybe<RoomFilterInput>;
};


export type RoomsRoomTypeIdSumArgs = {
  order?: InputMaybe<Array<RoomSortInput>>;
  where?: InputMaybe<RoomFilterInput>;
};

export type SaleTemplate = {
  __typename?: 'saleTemplate';
  cartQuantity?: Maybe<Scalars['Int']>;
  category?: Maybe<FruitCategory>;
  categoryId?: Maybe<Scalars['Int']>;
  chamber?: Maybe<Scalars['Boolean']>;
  date?: Maybe<Scalars['DateTime']>;
  fruit?: Maybe<Fruit>;
  fruitId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  kg?: Maybe<Scalars['Decimal']>;
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  person?: Maybe<Person>;
  personId?: Maybe<Scalars['Int']>;
  pricePerKg?: Maybe<Scalars['Decimal']>;
  season?: Maybe<Season>;
  seasonId?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Decimal']>;
  type?: Maybe<SaleTypes>;
};

export type SaleTemplates = {
  __typename?: 'saleTemplates';
  /** Get SaleTemplates any */
  any: Scalars['Boolean'];
  /** Get SaleTemplates cartQuantityAverage */
  cartQuantityAverage: Scalars['Decimal'];
  /** Get SaleTemplates cartQuantitySum */
  cartQuantitySum: Scalars['Decimal'];
  /** Get SaleTemplates count */
  count: Scalars['Int'];
  /** Get $SaleTemplates list */
  items: Array<SaleTemplate>;
  /** Get SaleTemplates kgAverage */
  kgAverage: Scalars['Decimal'];
  /** Get SaleTemplates kgSum */
  kgSum: Scalars['Decimal'];
  /** Get SaleTemplates pricePerKgAverage */
  pricePerKgAverage: Scalars['Decimal'];
  /** Get SaleTemplates pricePerKgSum */
  pricePerKgSum: Scalars['Decimal'];
  /** Get SaleTemplates totalAverage */
  totalAverage: Scalars['Decimal'];
  /** Get SaleTemplates totalSum */
  totalSum: Scalars['Decimal'];
};


export type SaleTemplatesAnyArgs = {
  where?: InputMaybe<SaleTemplateFilterInput>;
};


export type SaleTemplatesCartQuantityAverageArgs = {
  order?: InputMaybe<Array<SaleTemplateSortInput>>;
  where?: InputMaybe<SaleTemplateFilterInput>;
};


export type SaleTemplatesCartQuantitySumArgs = {
  order?: InputMaybe<Array<SaleTemplateSortInput>>;
  where?: InputMaybe<SaleTemplateFilterInput>;
};


export type SaleTemplatesCountArgs = {
  where?: InputMaybe<SaleTemplateFilterInput>;
};


export type SaleTemplatesItemsArgs = {
  order?: InputMaybe<Array<SaleTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SaleTemplateFilterInput>;
};


export type SaleTemplatesKgAverageArgs = {
  order?: InputMaybe<Array<SaleTemplateSortInput>>;
  where?: InputMaybe<SaleTemplateFilterInput>;
};


export type SaleTemplatesKgSumArgs = {
  order?: InputMaybe<Array<SaleTemplateSortInput>>;
  where?: InputMaybe<SaleTemplateFilterInput>;
};


export type SaleTemplatesPricePerKgAverageArgs = {
  order?: InputMaybe<Array<SaleTemplateSortInput>>;
  where?: InputMaybe<SaleTemplateFilterInput>;
};


export type SaleTemplatesPricePerKgSumArgs = {
  order?: InputMaybe<Array<SaleTemplateSortInput>>;
  where?: InputMaybe<SaleTemplateFilterInput>;
};


export type SaleTemplatesTotalAverageArgs = {
  order?: InputMaybe<Array<SaleTemplateSortInput>>;
  where?: InputMaybe<SaleTemplateFilterInput>;
};


export type SaleTemplatesTotalSumArgs = {
  order?: InputMaybe<Array<SaleTemplateSortInput>>;
  where?: InputMaybe<SaleTemplateFilterInput>;
};

export type Sales = {
  __typename?: 'sales';
  /** Get Sales any */
  any: Scalars['Boolean'];
  /** Get Sales cartQuantityAverage */
  cartQuantityAverage: Scalars['Decimal'];
  /** Get Sales cartQuantitySum */
  cartQuantitySum: Scalars['Decimal'];
  /** Get Sales count */
  count: Scalars['Int'];
  /** Get $Sales list */
  items: Array<Sale>;
  /** Get Sales kgAverage */
  kgAverage: Scalars['Decimal'];
  /** Get Sales kgSum */
  kgSum: Scalars['Decimal'];
  /** Get Sales pricePerKgAverage */
  pricePerKgAverage: Scalars['Decimal'];
  /** Get Sales pricePerKgSum */
  pricePerKgSum: Scalars['Decimal'];
  /** Get Sales totalAverage */
  totalAverage: Scalars['Decimal'];
  /** Get Sales totalSum */
  totalSum: Scalars['Decimal'];
};


export type SalesAnyArgs = {
  where?: InputMaybe<SaleFilterInput>;
};


export type SalesCartQuantityAverageArgs = {
  order?: InputMaybe<Array<SaleSortInput>>;
  where?: InputMaybe<SaleFilterInput>;
};


export type SalesCartQuantitySumArgs = {
  order?: InputMaybe<Array<SaleSortInput>>;
  where?: InputMaybe<SaleFilterInput>;
};


export type SalesCountArgs = {
  where?: InputMaybe<SaleFilterInput>;
};


export type SalesItemsArgs = {
  order?: InputMaybe<Array<SaleSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SaleFilterInput>;
};


export type SalesKgAverageArgs = {
  order?: InputMaybe<Array<SaleSortInput>>;
  where?: InputMaybe<SaleFilterInput>;
};


export type SalesKgSumArgs = {
  order?: InputMaybe<Array<SaleSortInput>>;
  where?: InputMaybe<SaleFilterInput>;
};


export type SalesPricePerKgAverageArgs = {
  order?: InputMaybe<Array<SaleSortInput>>;
  where?: InputMaybe<SaleFilterInput>;
};


export type SalesPricePerKgSumArgs = {
  order?: InputMaybe<Array<SaleSortInput>>;
  where?: InputMaybe<SaleFilterInput>;
};


export type SalesTotalAverageArgs = {
  order?: InputMaybe<Array<SaleSortInput>>;
  where?: InputMaybe<SaleFilterInput>;
};


export type SalesTotalSumArgs = {
  order?: InputMaybe<Array<SaleSortInput>>;
  where?: InputMaybe<SaleFilterInput>;
};

export type Season = {
  __typename?: 'season';
  active: Scalars['Boolean'];
  bookings: Bookings;
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  sales: Sales;
  seasonYear: Scalars['Int'];
  works: Works;
};

export type Seasons = {
  __typename?: 'seasons';
  /** Get Seasons any */
  any: Scalars['Boolean'];
  /** Get Seasons count */
  count: Scalars['Int'];
  /** Get $Seasons list */
  items: Array<Season>;
};


export type SeasonsAnyArgs = {
  where?: InputMaybe<SeasonFilterInput>;
};


export type SeasonsCountArgs = {
  where?: InputMaybe<SeasonFilterInput>;
};


export type SeasonsItemsArgs = {
  order?: InputMaybe<Array<SeasonSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeasonFilterInput>;
};

export type User = {
  __typename?: 'user';
  authData: UserAuthDatas;
  forceReAuthentication: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  notificationConfigs?: Maybe<Array<NotificationConfig>>;
  pushNotificationSubscriptions?: Maybe<Array<PushNotificationSubscription>>;
  roles: UserRoles;
  status: Statuses;
  username: Scalars['String'];
};

export type UserAuthData = {
  __typename?: 'userAuthData';
  externalUserId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  identifier: Scalars['String'];
  provider: AuthProvider;
  user: User;
  userId: Scalars['Int'];
};

export type UserAuthDatas = {
  __typename?: 'userAuthDatas';
  /** Get UserAuthDatas any */
  any: Scalars['Boolean'];
  /** Get UserAuthDatas count */
  count: Scalars['Int'];
  /** Get $UserAuthDatas list */
  items: Array<UserAuthData>;
};


export type UserAuthDatasAnyArgs = {
  where?: InputMaybe<UserAuthDataFilterInput>;
};


export type UserAuthDatasCountArgs = {
  where?: InputMaybe<UserAuthDataFilterInput>;
};


export type UserAuthDatasItemsArgs = {
  order?: InputMaybe<Array<UserAuthDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserAuthDataFilterInput>;
};

export type UserRole = {
  __typename?: 'userRole';
  id: Scalars['Int'];
  role: Scalars['String'];
  user: User;
  userId: Scalars['Int'];
};

export type UserRoles = {
  __typename?: 'userRoles';
  /** Get UserRoles any */
  any: Scalars['Boolean'];
  /** Get UserRoles count */
  count: Scalars['Int'];
  /** Get $UserRoles list */
  items: Array<UserRole>;
};


export type UserRolesAnyArgs = {
  where?: InputMaybe<UserRoleFilterInput>;
};


export type UserRolesCountArgs = {
  where?: InputMaybe<UserRoleFilterInput>;
};


export type UserRolesItemsArgs = {
  order?: InputMaybe<Array<UserRoleSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserRoleFilterInput>;
};

export type Users = {
  __typename?: 'users';
  /** Get Users any */
  any: Scalars['Boolean'];
  /** Get Users count */
  count: Scalars['Int'];
  /** Get $Users list */
  items: Array<User>;
};


export type UsersAnyArgs = {
  where?: InputMaybe<UserFilterInput>;
};


export type UsersCountArgs = {
  where?: InputMaybe<UserFilterInput>;
};


export type UsersItemsArgs = {
  order?: InputMaybe<Array<UserSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserFilterInput>;
};

export type Wallet = {
  __typename?: 'wallet';
  archived: Scalars['Boolean'];
  /** Shows balance */
  balance: Scalars['Decimal'];
  deposit: Scalars['Decimal'];
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  person: Person;
  personId: Scalars['Int'];
  sales: Sales;
  transactions: WalletTransactions;
};

export type WalletTransaction = {
  __typename?: 'walletTransaction';
  amount: Scalars['Decimal'];
  id: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  transactionDate: Scalars['DateTime'];
  transactionId?: Maybe<Scalars['String']>;
  wallet: Wallet;
  walletId: Scalars['Int'];
};

export type WalletTransactions = {
  __typename?: 'walletTransactions';
  /** Get WalletTransactions amountAverage */
  amountAverage: Scalars['Decimal'];
  /** Get WalletTransactions amountSum */
  amountSum: Scalars['Decimal'];
  /** Get WalletTransactions any */
  any: Scalars['Boolean'];
  /** Get WalletTransactions count */
  count: Scalars['Int'];
  /** Get WalletTransactions idAverage */
  idAverage: Scalars['Decimal'];
  /** Get WalletTransactions idSum */
  idSum: Scalars['Decimal'];
  /** Get $WalletTransactions list */
  items: Array<WalletTransaction>;
  /** Get WalletTransactions walletIdAverage */
  walletIdAverage: Scalars['Decimal'];
  /** Get WalletTransactions walletIdSum */
  walletIdSum: Scalars['Decimal'];
};


export type WalletTransactionsAmountAverageArgs = {
  order?: InputMaybe<Array<WalletTransactionSortInput>>;
  where?: InputMaybe<WalletTransactionFilterInput>;
};


export type WalletTransactionsAmountSumArgs = {
  order?: InputMaybe<Array<WalletTransactionSortInput>>;
  where?: InputMaybe<WalletTransactionFilterInput>;
};


export type WalletTransactionsAnyArgs = {
  where?: InputMaybe<WalletTransactionFilterInput>;
};


export type WalletTransactionsCountArgs = {
  where?: InputMaybe<WalletTransactionFilterInput>;
};


export type WalletTransactionsIdAverageArgs = {
  order?: InputMaybe<Array<WalletTransactionSortInput>>;
  where?: InputMaybe<WalletTransactionFilterInput>;
};


export type WalletTransactionsIdSumArgs = {
  order?: InputMaybe<Array<WalletTransactionSortInput>>;
  where?: InputMaybe<WalletTransactionFilterInput>;
};


export type WalletTransactionsItemsArgs = {
  order?: InputMaybe<Array<WalletTransactionSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WalletTransactionFilterInput>;
};


export type WalletTransactionsWalletIdAverageArgs = {
  order?: InputMaybe<Array<WalletTransactionSortInput>>;
  where?: InputMaybe<WalletTransactionFilterInput>;
};


export type WalletTransactionsWalletIdSumArgs = {
  order?: InputMaybe<Array<WalletTransactionSortInput>>;
  where?: InputMaybe<WalletTransactionFilterInput>;
};

export type Wallets = {
  __typename?: 'wallets';
  /** Get Wallets any */
  any: Scalars['Boolean'];
  /** Get Wallets count */
  count: Scalars['Int'];
  /** Get Wallets depositAverage */
  depositAverage: Scalars['Decimal'];
  /** Get Wallets depositSum */
  depositSum: Scalars['Decimal'];
  /** Get Wallets idAverage */
  idAverage: Scalars['Decimal'];
  /** Get Wallets idSum */
  idSum: Scalars['Decimal'];
  /** Get $Wallets list */
  items: Array<Wallet>;
  /** Get Wallets personIdAverage */
  personIdAverage: Scalars['Decimal'];
  /** Get Wallets personIdSum */
  personIdSum: Scalars['Decimal'];
};


export type WalletsAnyArgs = {
  where?: InputMaybe<WalletFilterInput>;
};


export type WalletsCountArgs = {
  where?: InputMaybe<WalletFilterInput>;
};


export type WalletsDepositAverageArgs = {
  order?: InputMaybe<Array<WalletSortInput>>;
  where?: InputMaybe<WalletFilterInput>;
};


export type WalletsDepositSumArgs = {
  order?: InputMaybe<Array<WalletSortInput>>;
  where?: InputMaybe<WalletFilterInput>;
};


export type WalletsIdAverageArgs = {
  order?: InputMaybe<Array<WalletSortInput>>;
  where?: InputMaybe<WalletFilterInput>;
};


export type WalletsIdSumArgs = {
  order?: InputMaybe<Array<WalletSortInput>>;
  where?: InputMaybe<WalletFilterInput>;
};


export type WalletsItemsArgs = {
  order?: InputMaybe<Array<WalletSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WalletFilterInput>;
};


export type WalletsPersonIdAverageArgs = {
  order?: InputMaybe<Array<WalletSortInput>>;
  where?: InputMaybe<WalletFilterInput>;
};


export type WalletsPersonIdSumArgs = {
  order?: InputMaybe<Array<WalletSortInput>>;
  where?: InputMaybe<WalletFilterInput>;
};

export type Work = {
  __typename?: 'work';
  category: WorkCategories;
  endDate?: Maybe<Scalars['LocalDate']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  season: Season;
  seasonId: Scalars['Int'];
  startDate: Scalars['LocalDate'];
  workers: Workers;
};

export type WorkTemplate = {
  __typename?: 'workTemplate';
  category: WorkCategories;
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  season?: Maybe<Season>;
  seasonId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  workers: WorkerTemplates;
};

export type WorkTemplates = {
  __typename?: 'workTemplates';
  /** Get WorkTemplates any */
  any: Scalars['Boolean'];
  /** Get WorkTemplates count */
  count: Scalars['Int'];
  /** Get $WorkTemplates list */
  items: Array<WorkTemplate>;
};


export type WorkTemplatesAnyArgs = {
  where?: InputMaybe<WorkTemplateFilterInput>;
};


export type WorkTemplatesCountArgs = {
  where?: InputMaybe<WorkTemplateFilterInput>;
};


export type WorkTemplatesItemsArgs = {
  order?: InputMaybe<Array<WorkTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkTemplateFilterInput>;
};

export type Worker = {
  __typename?: 'worker';
  date: Scalars['LocalDate'];
  expense?: Maybe<Expense>;
  expenseId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  person: Person;
  personId: Scalars['Int'];
  price: Scalars['Decimal'];
  work: Work;
  workId: Scalars['Int'];
};

export type WorkerTemplate = {
  __typename?: 'workerTemplate';
  date?: Maybe<Scalars['DateTime']>;
  expense?: Maybe<Expense>;
  expenseId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  person?: Maybe<Person>;
  personId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Decimal']>;
  work: WorkTemplate;
  workId: Scalars['Int'];
};

export type WorkerTemplates = {
  __typename?: 'workerTemplates';
  /** Get WorkerTemplates any */
  any: Scalars['Boolean'];
  /** Get WorkerTemplates count */
  count: Scalars['Int'];
  /** Get $WorkerTemplates list */
  items: Array<WorkerTemplate>;
  /** Get WorkerTemplates priceAverage */
  priceAverage: Scalars['Decimal'];
  /** Get WorkerTemplates priceSum */
  priceSum: Scalars['Decimal'];
};


export type WorkerTemplatesAnyArgs = {
  where?: InputMaybe<WorkerTemplateFilterInput>;
};


export type WorkerTemplatesCountArgs = {
  where?: InputMaybe<WorkerTemplateFilterInput>;
};


export type WorkerTemplatesItemsArgs = {
  order?: InputMaybe<Array<WorkerTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkerTemplateFilterInput>;
};


export type WorkerTemplatesPriceAverageArgs = {
  order?: InputMaybe<Array<WorkerTemplateSortInput>>;
  where?: InputMaybe<WorkerTemplateFilterInput>;
};


export type WorkerTemplatesPriceSumArgs = {
  order?: InputMaybe<Array<WorkerTemplateSortInput>>;
  where?: InputMaybe<WorkerTemplateFilterInput>;
};

export type Workers = {
  __typename?: 'workers';
  /** Get Workers any */
  any: Scalars['Boolean'];
  /** Get Workers count */
  count: Scalars['Int'];
  /** Get $Workers list */
  items: Array<Worker>;
  /** Get Workers priceAverage */
  priceAverage: Scalars['Decimal'];
  /** Get Workers priceSum */
  priceSum: Scalars['Decimal'];
};


export type WorkersAnyArgs = {
  where?: InputMaybe<WorkerFilterInput>;
};


export type WorkersCountArgs = {
  where?: InputMaybe<WorkerFilterInput>;
};


export type WorkersItemsArgs = {
  order?: InputMaybe<Array<WorkerSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkerFilterInput>;
};


export type WorkersPriceAverageArgs = {
  order?: InputMaybe<Array<WorkerSortInput>>;
  where?: InputMaybe<WorkerFilterInput>;
};


export type WorkersPriceSumArgs = {
  order?: InputMaybe<Array<WorkerSortInput>>;
  where?: InputMaybe<WorkerFilterInput>;
};

export type Works = {
  __typename?: 'works';
  /** Get Works any */
  any: Scalars['Boolean'];
  /** Get Works count */
  count: Scalars['Int'];
  /** Get $Works list */
  items: Array<Work>;
};


export type WorksAnyArgs = {
  where?: InputMaybe<WorkFilterInput>;
};


export type WorksCountArgs = {
  where?: InputMaybe<WorkFilterInput>;
};


export type WorksItemsArgs = {
  order?: InputMaybe<Array<WorkSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkFilterInput>;
};

export type BookingAdditionalChargesDatalistQueryVariables = Exact<{
  where?: InputMaybe<BookingAdditionalChargeFilterInput>;
  order?: InputMaybe<Array<BookingAdditionalChargeSortInput> | BookingAdditionalChargeSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type BookingAdditionalChargesDatalistQuery = { __typename?: 'Query', bookingAdditionalCharges?: { __typename?: 'bookingAdditionalCharges', count: number, amountSum: any, items: Array<{ __typename?: 'bookingAdditionalCharge', amount: any, date: any, name: string, id: number, note?: string | null, isIncome: boolean, booking?: { __typename?: 'booking', id: number, inSeasonId: number } | null }> } | null };

export type BookingAdditinalChargesAddFromTemplateMutationVariables = Exact<{
  bookingId: Scalars['Int'];
  templateId: Scalars['Int'];
  count?: InputMaybe<Scalars['Int']>;
}>;


export type BookingAdditinalChargesAddFromTemplateMutation = { __typename?: 'Mutation', bookingAdditionalChargeFromTemplate?: Array<{ __typename?: 'bookingAdditionalCharge', id: number } | null> | null };

export type BookingAdditionalChargesFormDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type BookingAdditionalChargesFormDataQuery = { __typename?: 'Query', bookingAdditionalCharge?: { __typename?: 'bookingAdditionalCharge', bookingId: number, amount: any, date: any, name: string, id: number, note?: string | null, isIncome: boolean } | null };

export type SaveBookingAdditionalChargesMutationVariables = Exact<{
  model: BookingAdditionalChargeInput;
}>;


export type SaveBookingAdditionalChargesMutation = { __typename?: 'Mutation', bookingAdditionalCharge?: { __typename?: 'bookingAdditionalCharge', id: number } | null };

export type BookingAdditionalChargesViewDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type BookingAdditionalChargesViewDataQuery = { __typename?: 'Query', bookingAdditionalCharge?: { __typename?: 'bookingAdditionalCharge', amount: any, date: any, name: string, id: number, note?: string | null, isIncome: boolean, booking?: { __typename?: 'booking', id: number, inSeasonId: number } | null } | null };

export type AdditionalChargesTemplateDatalistQueryVariables = Exact<{
  where?: InputMaybe<BookingAdditionalChargesTemplateFilterInput>;
  order?: InputMaybe<Array<BookingAdditionalChargesTemplateSortInput> | BookingAdditionalChargesTemplateSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type AdditionalChargesTemplateDatalistQuery = { __typename?: 'Query', bookingAdditionalChargesTemplates?: { __typename?: 'bookingAdditionalChargesTemplates', count: number, items: Array<{ __typename?: 'bookingAdditionalChargesTemplate', amount: any, calculationType: BookingAdditionalChargesCalculationTypes, name: string, id: number, isIncome: boolean }> } | null };

export type GetBookingAdditionalChargesTemplateFormDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type GetBookingAdditionalChargesTemplateFormDataQuery = { __typename?: 'Query', bookingAdditionalChargesTemplate?: { __typename?: 'bookingAdditionalChargesTemplate', amount: any, calculationType: BookingAdditionalChargesCalculationTypes, name: string, id: number, isIncome: boolean } | null };

export type SaveBookingAdditionalChargesTemplateMutationVariables = Exact<{
  model: BookingAdditionalChargesTemplateInput;
}>;


export type SaveBookingAdditionalChargesTemplateMutation = { __typename?: 'Mutation', bookingAdditionalChargesTemplate?: { __typename?: 'bookingAdditionalChargesTemplate', id: number } | null };

export type CheckAvailabilityQueryVariables = Exact<{
  where?: InputMaybe<BookingDetailsFilterInput>;
  sort?: InputMaybe<Array<BookingDetailsSortInput> | BookingDetailsSortInput>;
  roomSort?: InputMaybe<Array<RoomSortInput> | RoomSortInput>;
  roomWhere?: InputMaybe<RoomFilterInput>;
}>;


export type CheckAvailabilityQuery = { __typename?: 'Query', rooms?: { __typename?: 'rooms', items: Array<{ __typename?: 'room', name: string, id: number, order?: number | null, roomType: { __typename?: 'roomType', color?: string | null, id: number, name: string, defaultPrice?: any | null }, bookingDetails: { __typename?: 'bookingDetailss', count: number, items: Array<{ __typename?: 'bookingDetails', price: any, date: any, id: number, booking: { __typename?: 'booking', inDate: any, outDate: any, inSeasonId: number, id: number, nights: number, roomType: { __typename?: 'roomType', id: number, name: string, color?: string | null } } }> } }> } | null, fistDate?: { __typename?: 'bookingDetails', date: any } | null, lastDate?: { __typename?: 'bookingDetails', date: any } | null };

export type BookingDatalistQueryVariables = Exact<{
  where?: InputMaybe<BookingFilterInput>;
  order?: InputMaybe<Array<BookingSortInput> | BookingSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  channelWhere?: InputMaybe<BookingBookingChannelFilterInput>;
}>;


export type BookingDatalistQuery = { __typename?: 'Query', bookings?: { __typename?: 'bookings', count: number, totalSum: any, totalAverage: any, guestCountAverage: any, guestCountSum: any, nightsAverage: any, nightsSum: any, items: Array<{ __typename?: 'booking', id: number, inDate: any, outDate: any, nights: number, isCancelled: boolean, hasConflict: boolean, bookingDate: any, children?: string | null, guestCount: number, inSeasonId: number, total: any, paidAmount?: any | null, person: { __typename?: 'person', name: string }, roomType: { __typename?: 'roomType', color?: string | null, name: string, id: number }, channel?: { __typename?: 'bookingBookingChannel', total: any, isCancelled: boolean, channel: { __typename?: 'bookingChannel', name: string } } | null, season: { __typename?: 'season', name: string }, details: { __typename?: 'bookingDetailss', priceSum: any, items: Array<{ __typename?: 'bookingDetails', price: any, room: { __typename?: 'room', name: string, roomType: { __typename?: 'roomType', color?: string | null, name: string, id: number } } }> }, additionalCharge: { __typename?: 'bookingAdditionalCharges', amountSum: any, count: number } }> } | null, bookingBookingChannels?: { __typename?: 'bookingBookingChannels', totalSum: any, totalAverage: any } | null };

export type BookingViewDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  lang: Scalars['String'];
}>;


export type BookingViewDataQuery = { __typename?: 'Query', booking?: { __typename?: 'booking', id: number, inDate: any, outDate: any, nights: number, isCancelled: boolean, isNoShowCancellation: boolean, cancelledDate?: any | null, hasConflict: boolean, children?: string | null, guestReservationLinkExtension?: string | null, guestCount: number, inSeasonId: number, bookingDate: any, note?: string | null, total: any, paidAmount?: any | null, person: { __typename?: 'person', name: string, id: number, countryCode?: string | null, contactInfo: { __typename?: 'personContactInfos', items: Array<{ __typename?: 'personContactInfo', name: string, link?: string | null, value: string, id: number }> }, country?: { __typename?: 'Country', alpha3Code: string, name: string, flag: string, translate?: string | null } | null }, roomType: { __typename?: 'roomType', color?: string | null, name: string, id: number }, channel?: { __typename?: 'bookingBookingChannel', total: any, externalReference?: string | null, isCancelled: boolean, channel: { __typename?: 'bookingChannel', name: string } } | null, season: { __typename?: 'season', name: string }, details: { __typename?: 'bookingDetailss', priceSum: any, items: Array<{ __typename?: 'bookingDetails', price: any, date: any, id: number, hasConflict: boolean, room: { __typename?: 'room', name: string, id: number, roomType: { __typename?: 'roomType', color?: string | null, name: string, id: number } } }> }, additionalCharge: { __typename?: 'bookingAdditionalCharges', amountSum: any, items: Array<{ __typename?: 'bookingAdditionalCharge', amount: any, date: any, name: string, id: number }> } } | null };

export type BookingChannelDatalistQueryVariables = Exact<{
  where?: InputMaybe<BookingChannelFilterInput>;
  order?: InputMaybe<Array<BookingChannelSortInput> | BookingChannelSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type BookingChannelDatalistQuery = { __typename?: 'Query', bookingChannels?: { __typename?: 'bookingChannels', count: number, items: Array<{ __typename?: 'bookingChannel', commission: any, type: CommissionTypes, name: string, id: number, roomTypeDefultPrices: { __typename?: 'roomTypeChannelDefultPrices', items: Array<{ __typename?: 'roomTypeChannelDefultPrice', defaultPrice: any, id: number, roomType: { __typename?: 'roomType', id: number, color?: string | null, name: string } }> } }> } | null };

export type GetChannelDropdownDataQueryVariables = Exact<{
  where?: InputMaybe<BookingChannelFilterInput>;
  order?: InputMaybe<Array<BookingChannelSortInput> | BookingChannelSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetChannelDropdownDataQuery = { __typename?: 'Query', bookingChannels?: { __typename?: 'bookingChannels', items: Array<{ __typename?: 'bookingChannel', commission: any, type: CommissionTypes, name: string, id: number, roomTypeDefultPrices: { __typename?: 'roomTypeChannelDefultPrices', items: Array<{ __typename?: 'roomTypeChannelDefultPrice', id: number, defaultPrice: any, roomType: { __typename?: 'roomType', name: string, id: number, color?: string | null } }> } }> } | null };

export type EventDatalistQueryVariables = Exact<{
  where?: InputMaybe<BookingEventFilterInput>;
  order?: InputMaybe<Array<BookingEventSortInput> | BookingEventSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type EventDatalistQuery = { __typename?: 'Query', bookingEvents?: { __typename?: 'bookingEvents', count: number, items: Array<{ __typename?: 'bookingEvent', id: number, date: any, note?: string | null, isDone: boolean, insertType: InsertTypes, name: string, group?: string | null, order: number, assigneeId?: number | null, assignee?: { __typename?: 'person', id: number, name: string } | null, booking?: { __typename?: 'booking', id: number, inDate: any, outDate: any, inSeasonId: number, seasonId: number, nights: number, guestCount: number, children?: string | null, season: { __typename?: 'season', id: number, name: string, active: boolean }, person: { __typename?: 'person', id: number, name: string }, details: { __typename?: 'bookingDetailss', items: Array<{ __typename?: 'bookingDetails', date: any, room: { __typename?: 'room', id: number, name: string, roomType: { __typename?: 'roomType', color?: string | null, name: string, id: number } } }> } } | null }> } | null };

export type EventFormDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  bookingId: Scalars['Int'];
}>;


export type EventFormDataQuery = { __typename?: 'Query', bookingEvent?: { __typename?: 'bookingEvent', bookingId?: number | null, isDone: boolean, date: any, note?: string | null, name: string, id: number, order: number, group?: string | null, assigneeId?: number | null, assignee?: { __typename?: 'person', id: number, name: string } | null, booking?: { __typename?: 'booking', id: number, inDate: any, outDate: any } | null } | null, booking?: { __typename?: 'booking', id: number, inDate: any, outDate: any } | null };

export type EventViewDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type EventViewDataQuery = { __typename?: 'Query', bookingEvent?: { __typename?: 'bookingEvent', bookingId?: number | null, isDone: boolean, date: any, note?: string | null, name: string, insertType: InsertTypes, id: number, group?: string | null, order: number, assigneeId?: number | null, assignee?: { __typename?: 'person', id: number, name: string } | null, booking?: { __typename?: 'booking', id: number, inDate: any, inSeasonId: number, outDate: any, season: { __typename?: 'season', id: number, name: string, active: boolean }, roomType: { __typename?: 'roomType', id: number, name: string, color?: string | null } } | null } | null };

export type RoomTypesDatalistQueryVariables = Exact<{
  where?: InputMaybe<RoomTypeFilterInput>;
  order?: InputMaybe<Array<RoomTypeSortInput> | RoomTypeSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type RoomTypesDatalistQuery = { __typename?: 'Query', roomTypes?: { __typename?: 'roomTypes', count: number, items: Array<{ __typename?: 'roomType', id: number, name: string, defaultPrice?: any | null, color?: string | null, rooms: { __typename?: 'rooms', count: number } }> } | null };

export type DeleteRoomTypeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type DeleteRoomTypeMutation = { __typename?: 'Mutation', roomTypeDelete: boolean };

export type RoomTypeDropdownQueryVariables = Exact<{
  where?: InputMaybe<RoomTypeFilterInput>;
  order?: InputMaybe<Array<RoomTypeSortInput> | RoomTypeSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type RoomTypeDropdownQuery = { __typename?: 'Query', roomTypes?: { __typename?: 'roomTypes', items: Array<{ __typename?: 'roomType', id: number, name: string, defaultPrice?: any | null, color?: string | null }> } | null };

export type RoomDatalistQueryVariables = Exact<{
  where?: InputMaybe<RoomFilterInput>;
  order?: InputMaybe<Array<RoomSortInput> | RoomSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type RoomDatalistQuery = { __typename?: 'Query', rooms?: { __typename?: 'rooms', count: number, items: Array<{ __typename?: 'room', id: number, name: string, order?: number | null, roomType: { __typename?: 'roomType', color?: string | null, name: string }, bookingDetails: { __typename?: 'bookingDetailss', any: boolean } }> } | null };

export type AccommodationInvestmentMaintenanceFormQueryVariables = Exact<{
  where?: InputMaybe<AccommodationWorkInvestmentFilterInput>;
  sort?: InputMaybe<Array<AccommodationWorkInvestmentSortInput> | AccommodationWorkInvestmentSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type AccommodationInvestmentMaintenanceFormQuery = { __typename?: 'Query', accommodationWorkInvestments?: { __typename?: 'accommodationWorkInvestments', items: Array<{ __typename?: 'accommodationWorkInvestment', id: number, name: string, total: any, startDate: any }> } | null };

export type RoomMaintenanceFormQueryVariables = Exact<{
  where?: InputMaybe<RoomFilterInput>;
  order?: InputMaybe<Array<RoomSortInput> | RoomSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type RoomMaintenanceFormQuery = { __typename?: 'Query', rooms?: { __typename?: 'rooms', items: Array<{ __typename?: 'room', id: number, name: string, roomType: { __typename?: 'roomType', id: number, name: string, color?: string | null } }> } | null };

export type AccommodationMaintenanceTypeDatalistQueryVariables = Exact<{
  where?: InputMaybe<AccommodationMaintenanceTypeFilterInput>;
  order?: InputMaybe<Array<AccommodationMaintenanceTypeSortInput> | AccommodationMaintenanceTypeSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type AccommodationMaintenanceTypeDatalistQuery = { __typename?: 'Query', accommodationMaintenanceTypes?: { __typename?: 'accommodationMaintenanceTypes', count: number, items: Array<{ __typename?: 'accommodationMaintenanceType', name: string, id: number, logs: { __typename?: 'accommodationMaintenanceLogs', any: boolean } }> } | null };

export type AccommodationMaintenanceTypeFromDataQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AccommodationMaintenanceTypeFromDataQuery = { __typename?: 'Query', accommodationMaintenanceType?: { __typename?: 'accommodationMaintenanceType', id: number, name: string } | null };

export type AccommodationMaintenanceTypeFromMutationVariables = Exact<{
  model: AccommodationMaintenanceTypeInput;
}>;


export type AccommodationMaintenanceTypeFromMutation = { __typename?: 'Mutation', accommodationMaintenanceType?: { __typename?: 'accommodationMaintenanceType', id: number, name: string } | null };

export type FruitDatalistQueryVariables = Exact<{
  where?: InputMaybe<FruitFilterInput>;
  order?: InputMaybe<Array<FruitSortInput> | FruitSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type FruitDatalistQuery = { __typename?: 'Query', fruits?: { __typename?: 'fruits', items: Array<{ __typename?: 'fruit', id: number, name: string }> } | null };

export type SaveFruitMutationVariables = Exact<{
  model: FruitInput;
}>;


export type SaveFruitMutation = { __typename?: 'Mutation', fruit?: { __typename?: 'fruit', id: number, name: string } | null };

export type GetFruitsAllQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFruitsAllQuery = { __typename?: 'Query', fruits?: { __typename?: 'fruits', items: Array<{ __typename?: 'fruit', id: number, name: string }> } | null };

export type TagsQueryVariables = Exact<{
  where?: InputMaybe<PersonTagFilterInput>;
  order?: InputMaybe<Array<PersonTagSortInput> | PersonTagSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type TagsQuery = { __typename?: 'Query', personTags?: { __typename?: 'personTags', items: Array<{ __typename?: 'personTag', id: number, name: string }> } | null };

export type WalletDatalistPageQueryVariables = Exact<{
  where?: InputMaybe<WalletFilterInput>;
  sort?: InputMaybe<Array<WalletSortInput> | WalletSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type WalletDatalistPageQuery = { __typename?: 'Query', wallets?: { __typename?: 'wallets', count: number, items: Array<{ __typename?: 'wallet', id: number, name: string, balance: any, archived: boolean, person: { __typename?: 'person', name: string } }> } | null };

export type WalletDropdownQueryVariables = Exact<{
  where?: InputMaybe<WalletFilterInput>;
  sort?: InputMaybe<Array<WalletSortInput> | WalletSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type WalletDropdownQuery = { __typename?: 'Query', wallets?: { __typename?: 'wallets', count: number, items: Array<{ __typename?: 'wallet', id: number, name: string, balance: any }> } | null };

export type GetTransactionsDataListQueryVariables = Exact<{
  where?: InputMaybe<WalletTransactionFilterInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<WalletTransactionSortInput> | WalletTransactionSortInput>;
}>;


export type GetTransactionsDataListQuery = { __typename?: 'Query', walletTransactions?: { __typename?: 'walletTransactions', count: number, amountSum: any, items: Array<{ __typename?: 'walletTransaction', walletId: number, id: number, amount: any, transactionDate: any, transactionId?: string | null, note?: string | null }> } | null };

export type SaveWalletTransactionMutationVariables = Exact<{
  model: WalletTransactionInput;
}>;


export type SaveWalletTransactionMutation = { __typename?: 'Mutation', walletTransaction?: { __typename?: 'walletTransaction', id: number } | null };

export type GetTransactionsViewQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetTransactionsViewQuery = { __typename?: 'Query', walletTransaction?: { __typename?: 'walletTransaction', walletId: number, id: number, amount: any, transactionDate: any, transactionId?: string | null, note?: string | null } | null };

export type SaveSeasonMutationMutationVariables = Exact<{
  model: SeasonInput;
}>;


export type SaveSeasonMutationMutation = { __typename?: 'Mutation', season?: { __typename?: 'season', name: string, id: number, active: boolean } | null };

export type WorkDatalistQueryVariables = Exact<{
  where?: InputMaybe<WorkFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<WorkSortInput> | WorkSortInput>;
}>;


export type WorkDatalistQuery = { __typename?: 'Query', works?: { __typename?: 'works', count: number, items: Array<{ __typename?: 'work', id: number, name: string, startDate: any, endDate?: any | null, category: WorkCategories, season: { __typename?: 'season', name: string } }> } | null };

export type WorkerDatalistQueryVariables = Exact<{
  where?: InputMaybe<WorkerFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<WorkerSortInput> | WorkerSortInput>;
}>;


export type WorkerDatalistQuery = { __typename?: 'Query', workers?: { __typename?: 'workers', count: number, priceSum: any, items: Array<{ __typename?: 'worker', id: number, price: any, work: { __typename?: 'work', name: string, startDate: any, endDate?: any | null, category: WorkCategories, season: { __typename?: 'season', name: string } } }> } | null };

export type SaleTemplateDatalistQueryVariables = Exact<{
  where?: InputMaybe<SaleTemplateFilterInput>;
  order?: InputMaybe<Array<SaleTemplateSortInput> | SaleTemplateSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type SaleTemplateDatalistQuery = { __typename?: 'Query', saleTemplates?: { __typename?: 'saleTemplates', items: Array<{ __typename?: 'saleTemplate', id: number, name: string }> } | null };

export type HarvestTemplateDatalistQueryVariables = Exact<{
  where?: InputMaybe<HarvestAgricultureWorkTemplateFilterInput>;
  order?: InputMaybe<Array<HarvestAgricultureWorkTemplateSortInput> | HarvestAgricultureWorkTemplateSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type HarvestTemplateDatalistQuery = { __typename?: 'Query', harvestAgricultureWorkTemplates?: { __typename?: 'harvestAgricultureWorkTemplates', items: Array<{ __typename?: 'harvestAgricultureWorkTemplate', id: number, name: string }> } | null };

export type BookingAttachmentsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<BookingAttachmentFilterInput>;
  order?: InputMaybe<Array<BookingAttachmentSortInput> | BookingAttachmentSortInput>;
}>;


export type BookingAttachmentsQuery = { __typename?: 'Query', bookingAttachments?: { __typename?: 'bookingAttachments', count: number, items: Array<{ __typename?: 'bookingAttachment', id: number, name: string, contentType: string, bookingId: number }> } | null };

export type BookingFormDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  roomTypeId?: InputMaybe<Scalars['Int']>;
}>;


export type BookingFormDataQuery = { __typename?: 'Query', booking?: { __typename?: 'booking', preferredRoomId?: number | null, isCancelled: boolean, isNoShowCancellation: boolean, cancelledDate?: any | null, nights: number, guestCount: number, children?: string | null, total: any, incomeId?: number | null, paidAmount?: any | null, note?: string | null, id: number, outDate: any, inDate: any, person: { __typename?: 'person', name: string, id: number }, season: { __typename?: 'season', id: number, name: string, active: boolean }, roomType: { __typename?: 'roomType', color?: string | null, defaultPrice?: any | null, name: string, id: number }, channel?: { __typename?: 'bookingBookingChannel', total: any, id: number, externalReference?: string | null, isCancelled: boolean, channel: { __typename?: 'bookingChannel', commission: any, type: CommissionTypes, name: string, id: number } } | null, preferredRoom?: { __typename?: 'room', roomTypeId: number, name: string, id: number } | null, details: { __typename?: 'bookingDetailss', items: Array<{ __typename?: 'bookingDetails', price: any, date: any, id: number, room: { __typename?: 'room', roomTypeId: number, name: string, id: number } }> }, additionalCharge: { __typename?: 'bookingAdditionalCharges', items: Array<{ __typename?: 'bookingAdditionalCharge', amount: any, date: any, name: string, id: number }> } } | null, rooms?: { __typename?: 'rooms', items: Array<{ __typename?: 'room', name: string, id: number, roomType: { __typename?: 'roomType', color?: string | null, defaultPrice?: any | null, name: string, id: number } }> } | null, season?: { __typename?: 'season', name: string, id: number, active: boolean } | null, personTag?: { __typename?: 'personTag', name: string, id: number } | null, roomType?: { __typename?: 'roomType', id: number, defaultPrice?: any | null, name: string, color?: string | null } | null };

export type BookingChannelFormDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type BookingChannelFormDataQuery = { __typename?: 'Query', bookingChannel?: { __typename?: 'bookingChannel', commission: any, type: CommissionTypes, name: string, color?: string | null, id: number, roomTypeDefultPrices: { __typename?: 'roomTypeChannelDefultPrices', items: Array<{ __typename?: 'roomTypeChannelDefultPrice', defaultPrice: any, id: number, roomType: { __typename?: 'roomType', id: number, color?: string | null, name: string } }> } } | null, roomTypes?: { __typename?: 'roomTypes', items: Array<{ __typename?: 'roomType', name: string, defaultPrice?: any | null, color?: string | null, id: number }> } | null };

export type SaveBookingChannelMutationVariables = Exact<{
  model: BookingChannelInput;
}>;


export type SaveBookingChannelMutation = { __typename?: 'Mutation', bookingChannel?: { __typename?: 'bookingChannel', id: number } | null };

export type EventTemplateDatalistPageQueryVariables = Exact<{
  where?: InputMaybe<EventTemplateFilterInput>;
  order?: InputMaybe<Array<EventTemplateSortInput> | EventTemplateSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type EventTemplateDatalistPageQuery = { __typename?: 'Query', eventTemplates?: { __typename?: 'eventTemplates', items: Array<{ __typename?: 'eventTemplate', id: number, name: string, onDay?: number | null, repeat: boolean, isSystem: boolean, isActive: boolean, changeDynamicly: boolean, order: number, assigneeId?: number | null, assignee?: { __typename?: 'person', id: number, name: string } | null }> } | null };

export type EventTemplateFormDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type EventTemplateFormDataQuery = { __typename?: 'Query', eventTemplate?: { __typename?: 'eventTemplate', id: number, name: string, onDay?: number | null, repeat: boolean, isSystem: boolean, isActive: boolean, changeDynamicly: boolean, order: number, assignee?: { __typename?: 'person', id: number, name: string } | null } | null };

export type SaveEventTemplateMutationVariables = Exact<{
  model: EventTemplateInput;
}>;


export type SaveEventTemplateMutation = { __typename?: 'Mutation', eventTemplate?: { __typename?: 'eventTemplate', id: number } | null };

export type RoomTypesFromDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type RoomTypesFromDataQuery = { __typename?: 'Query', roomType?: { __typename?: 'roomType', id: number, name: string, defaultPrice?: any | null, color?: string | null, channelDefultPrices: { __typename?: 'roomTypeChannelDefultPrices', items: Array<{ __typename?: 'roomTypeChannelDefultPrice', defaultPrice: any, id: number, channel: { __typename?: 'bookingChannel', id: number, name: string } }> } } | null };

export type SaveRoomTypeMutationVariables = Exact<{
  model: RoomTypeInput;
}>;


export type SaveRoomTypeMutation = { __typename?: 'Mutation', roomType?: { __typename?: 'roomType', id: number } | null };

export type RoomFormDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type RoomFormDataQuery = { __typename?: 'Query', room?: { __typename?: 'room', order?: number | null, name: string, id: number, roomType: { __typename?: 'roomType', id: number, name: string, color?: string | null } } | null };

export type RoomFormMutationVariables = Exact<{
  model: RoomInput;
}>;


export type RoomFormMutation = { __typename?: 'Mutation', room?: { __typename?: 'room', id: number } | null };

export type AccommodationInvestmentDatalistPageQueryVariables = Exact<{
  where?: InputMaybe<AccommodationWorkInvestmentFilterInput>;
  sort?: InputMaybe<Array<AccommodationWorkInvestmentSortInput> | AccommodationWorkInvestmentSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type AccommodationInvestmentDatalistPageQuery = { __typename?: 'Query', accommodationWorkInvestments?: { __typename?: 'accommodationWorkInvestments', count: number, totalSum: any, items: Array<{ __typename?: 'accommodationWorkInvestment', id: number, name: string, startDate: any, unit: Units, unitPrice: any, total: any, quantity: any, investmentType: InvestmentTypes, season: { __typename?: 'season', name: string } }> } | null };

export type AccommodationInvestmentFormPageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AccommodationInvestmentFormPageQuery = { __typename?: 'Query', accommodationWorkInvestment?: { __typename?: 'accommodationWorkInvestment', id: number, category: WorkCategories, startDate: any, note?: string | null, name: string, unit: Units, unitPrice: any, quantity: any, total: any, investmentType: InvestmentTypes, workers: { __typename?: 'workers', items: Array<{ __typename?: 'worker', id: number, price: any, person: { __typename?: 'person', id: number, name: string } }> }, season: { __typename?: 'season', id: number, name: string, active: boolean } } | null, season?: { __typename?: 'season', id: number, name: string, active: boolean } | null };

export type AccommodationInvestmentMutationVariables = Exact<{
  model: AccommodationWorkInvestmentInput;
}>;


export type AccommodationInvestmentMutation = { __typename?: 'Mutation', accommodationWorkInvestment?: { __typename?: 'accommodationWorkInvestment', id: number } | null };

export type AccommodationInvestmentViewPageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AccommodationInvestmentViewPageQuery = { __typename?: 'Query', accommodationWorkInvestment?: { __typename?: 'accommodationWorkInvestment', id: number, name: string, startDate: any, unit: Units, unitPrice: any, total: any, quantity: any, investmentType: InvestmentTypes, category: WorkCategories, type: AccommodationWorkTypes, note?: string | null, season: { __typename?: 'season', name: string, id: number, active: boolean }, workers: { __typename?: 'workers', items: Array<{ __typename?: 'worker', person: { __typename?: 'person', name: string, id: number } }> } } | null };

export type AccommodationMaintenanceDatalistQueryVariables = Exact<{
  where?: InputMaybe<AccommodationWorkMaintenanceFilterInput>;
  sort?: InputMaybe<Array<AccommodationWorkMaintenanceSortInput> | AccommodationWorkMaintenanceSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type AccommodationMaintenanceDatalistQuery = { __typename?: 'Query', accommodationWorkMaintenances?: { __typename?: 'accommodationWorkMaintenances', count: number, items: Array<{ __typename?: 'accommodationWorkMaintenance', id: number, startDate: any, endDate?: any | null, name: string, workers: { __typename?: 'workers', count: number, priceSum: any }, season: { __typename?: 'season', name: string }, logs: { __typename?: 'accommodationMaintenanceLogs', items: Array<{ __typename?: 'accommodationMaintenanceLog', id: number, maintenanceType: { __typename?: 'accommodationMaintenanceType', name: string }, investment?: { __typename?: 'accommodationWorkInvestment', name: string } | null }> } }> } | null };

export type AccommodationMaintenanceFormQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AccommodationMaintenanceFormQuery = { __typename?: 'Query', season?: { __typename?: 'season', id: number, name: string, active: boolean } | null, accommodationWorkMaintenance?: { __typename?: 'accommodationWorkMaintenance', id: number, startDate: any, endDate?: any | null, note?: string | null, name: string, workers: { __typename?: 'workers', items: Array<{ __typename?: 'worker', price: any, id: number, person: { __typename?: 'person', id: number, name: string } }> }, season: { __typename?: 'season', active: boolean, id: number, name: string }, logs: { __typename?: 'accommodationMaintenanceLogs', items: Array<{ __typename?: 'accommodationMaintenanceLog', id: number, maintenanceType: { __typename?: 'accommodationMaintenanceType', name: string, id: number }, investment?: { __typename?: 'accommodationWorkInvestment', id: number, name: string, investmentType: InvestmentTypes, unit: Units, unitPrice: any, total: any } | null, logRooms: { __typename?: 'accommodationMaintenanceLogRooms', items: Array<{ __typename?: 'accommodationMaintenanceLogRoom', id: number, room: { __typename?: 'room', id: number, name: string, roomType: { __typename?: 'roomType', name: string, id: number, color?: string | null } } }> } }> } } | null };

export type SaveAccommodationMaintenanceFormMutationVariables = Exact<{
  model: AccommodationWorkMaintenanceInput;
}>;


export type SaveAccommodationMaintenanceFormMutation = { __typename?: 'Mutation', accommodationWorkMaintenance?: { __typename?: 'accommodationWorkMaintenance', id: number } | null };

export type AccommodationMaintenanceViewPageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AccommodationMaintenanceViewPageQuery = { __typename?: 'Query', accommodationWorkMaintenance?: { __typename?: 'accommodationWorkMaintenance', id: number, note?: string | null, startDate: any, endDate?: any | null, name: string, workers: { __typename?: 'workers', items: Array<{ __typename?: 'worker', date: any, price: any, id: number, person: { __typename?: 'person', name: string, id: number } }> }, season: { __typename?: 'season', name: string, id: number }, logs: { __typename?: 'accommodationMaintenanceLogs', items: Array<{ __typename?: 'accommodationMaintenanceLog', id: number, maintenanceType: { __typename?: 'accommodationMaintenanceType', name: string, id: number }, investment?: { __typename?: 'accommodationWorkInvestment', name: string, id: number, total: any, investmentType: InvestmentTypes, startDate: any } | null, logRooms: { __typename?: 'accommodationMaintenanceLogRooms', items: Array<{ __typename?: 'accommodationMaintenanceLogRoom', room: { __typename?: 'room', name: string, roomType: { __typename?: 'roomType', color?: string | null, name: string } } }> } }> } } | null };

export type GetFruitQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type GetFruitQuery = { __typename?: 'Query', fruit?: { __typename?: 'fruit', id: number, name: string, categories: { __typename?: 'fruitCategories', items: Array<{ __typename?: 'fruitCategory', name: string, id: number }> }, groups: { __typename?: 'fruitGroups', items: Array<{ __typename?: 'fruitGroup', name: string, id: number }> } } | null };

export type SaleFormDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  templateId?: InputMaybe<Scalars['Int']>;
}>;


export type SaleFormDataQuery = { __typename?: 'Query', season?: { __typename?: 'season', id: number, name: string, active: boolean } | null, sale?: { __typename?: 'Sale', name: string, date: any, kg: any, pricePerKg: any, total: any, cartQuantity: number, chamber: boolean, type?: SaleTypes | null, note?: string | null, season: { __typename?: 'season', name: string, id: number, active: boolean }, person: { __typename?: 'person', name: string, id: number }, wallet?: { __typename?: 'wallet', name: string, id: number, balance: any } | null, fruit: { __typename?: 'fruit', name: string, id: number }, category?: { __typename?: 'fruitCategory', name: string, id: number } | null } | null, saleTemplate?: { __typename?: 'saleTemplate', name: string, date?: any | null, kg?: any | null, pricePerKg?: any | null, total?: any | null, cartQuantity?: number | null, chamber?: boolean | null, type?: SaleTypes | null, note?: string | null, season?: { __typename?: 'season', name: string, id: number, active: boolean } | null, person?: { __typename?: 'person', name: string, id: number } | null, fruit?: { __typename?: 'fruit', name: string, id: number } | null, category?: { __typename?: 'fruitCategory', name: string, id: number } | null } | null };

export type SaleViewPageQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type SaleViewPageQuery = { __typename?: 'Query', sale?: { __typename?: 'Sale', id: number, name: string, date: any, kg: any, pricePerKg: any, total: any, cartQuantity: number, incomeId?: number | null, chamber: boolean, note?: string | null, type?: SaleTypes | null, person: { __typename?: 'person', id: number, name: string, countryCode?: string | null, country?: { __typename?: 'Country', alpha3Code: string, name: string, flag: string } | null }, wallet?: { __typename?: 'wallet', id: number, name: string, balance: any, archived: boolean } | null, category?: { __typename?: 'fruitCategory', id: number, name: string } | null, fruit: { __typename?: 'fruit', name: string, id: number }, season: { __typename?: 'season', id: number, name: string } } | null };

export type HarvestsDatalistQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestAgricultureWorkFilterInput>;
  order?: InputMaybe<Array<HarvestAgricultureWorkSortInput> | HarvestAgricultureWorkSortInput>;
}>;


export type HarvestsDatalistQuery = { __typename?: 'Query', harvestAgricultureWorks?: { __typename?: 'harvestAgricultureWorks', count: number, items: Array<{ __typename?: 'harvestAgricultureWork', id: number, startDate: any, harvests: { __typename?: 'harvests', kgSum: any, cartQuantitySum: any, items: Array<{ __typename?: 'harvest', id: number, fruit: { __typename?: 'fruit', name: string } }> }, season: { __typename?: 'season', name: string, id: number }, workers: { __typename?: 'workers', count: number, priceSum: any } }> } | null };

export type HarvestFormDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  templateId?: InputMaybe<Scalars['Int']>;
}>;


export type HarvestFormDataQuery = { __typename?: 'Query', season?: { __typename?: 'season', id: number, name: string, active: boolean } | null, harvestAgricultureWork?: { __typename?: 'harvestAgricultureWork', id: number, startDate: any, note?: string | null, name: string, season: { __typename?: 'season', id: number, name: string, active: boolean }, workers: { __typename?: 'workers', items: Array<{ __typename?: 'worker', id: number, price: any, person: { __typename?: 'person', id: number, name: string } }> }, harvests: { __typename?: 'harvests', items: Array<{ __typename?: 'harvest', id: number, kg: any, cartQuantity: number, hideFromMultiUpdate: boolean, fruit: { __typename?: 'fruit', id: number, name: string }, harvestFruitGroups: { __typename?: 'harvestFruitGroups', items: Array<{ __typename?: 'harvestFruitGroup', id: number, fruitGroup: { __typename?: 'fruitGroup', id: number, name: string } }> }, harvestFruitCategories: { __typename?: 'harvestFruitCategorys', items: Array<{ __typename?: 'harvestFruitCategory', id: number, fruitCategory: { __typename?: 'fruitCategory', id: number, name: string } }> } }> } } | null, harvestAgricultureWorkTemplate?: { __typename?: 'harvestAgricultureWorkTemplate', id: number, startDate?: any | null, note?: string | null, name: string, season?: { __typename?: 'season', id: number, name: string, active: boolean } | null, workers: { __typename?: 'workerTemplates', items: Array<{ __typename?: 'workerTemplate', id: number, price?: any | null, person?: { __typename?: 'person', id: number, name: string } | null }> }, harvests: { __typename?: 'harvestTemplates', items: Array<{ __typename?: 'harvestTemplate', id: number, kg?: any | null, cartQuantity?: number | null, hideFromMultiUpdate: boolean, fruit?: { __typename?: 'fruit', id: number, name: string } | null, harvestFruitGroups: { __typename?: 'harvestFruitGroupTemplates', items: Array<{ __typename?: 'harvestFruitGroupTemplate', id: number, fruitGroup: { __typename?: 'fruitGroup', id: number, name: string } }> }, harvestFruitCategories: { __typename?: 'harvestFruitCategoryTemplates', items: Array<{ __typename?: 'harvestFruitCategoryTemplate', id: number, fruitCategory: { __typename?: 'fruitCategory', id: number, name: string } }> } }> } } | null };

export type SaveHarvestMutationVariables = Exact<{
  model: HarvestAgricultureWorkInput;
}>;


export type SaveHarvestMutation = { __typename?: 'Mutation', harvestAgricultureWork?: { __typename?: 'harvestAgricultureWork', id: number } | null };

export type WorkViewPageQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type WorkViewPageQuery = { __typename?: 'Query', harvestAgricultureWork?: { __typename?: 'harvestAgricultureWork', id: number, startDate: any, name: string, note?: string | null, harvests: { __typename?: 'harvests', items: Array<{ __typename?: 'harvest', id: number, kg: any, cartQuantity: number, hideFromMultiUpdate: boolean, fruit: { __typename?: 'fruit', name: string, id: number }, harvestFruitGroups: { __typename?: 'harvestFruitGroups', items: Array<{ __typename?: 'harvestFruitGroup', id: number, fruitGroup: { __typename?: 'fruitGroup', name: string, id: number } }> }, harvestFruitCategories: { __typename?: 'harvestFruitCategorys', items: Array<{ __typename?: 'harvestFruitCategory', id: number, fruitCategory: { __typename?: 'fruitCategory', id: number, name: string } }> } }> }, season: { __typename?: 'season', name: string, id: number }, workers: { __typename?: 'workers', count: number, priceSum: any, items: Array<{ __typename?: 'worker', price: any, id: number, person: { __typename?: 'person', id: number, name: string } }> } } | null };

export type HarvestMultiUploadDataQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestFilterInput>;
  order?: InputMaybe<Array<HarvestSortInput> | HarvestSortInput>;
}>;


export type HarvestMultiUploadDataQuery = { __typename?: 'Query', harvests?: { __typename?: 'harvests', count: number, items: Array<{ __typename?: 'harvest', kg: any, cartQuantity: number, hideFromMultiUpdate: boolean, id: number, fruit: { __typename?: 'fruit', name: string, id: number }, harvestFruitCategories: { __typename?: 'harvestFruitCategorys', items: Array<{ __typename?: 'harvestFruitCategory', fruitCategory: { __typename?: 'fruitCategory', name: string } }> }, harvestFruitGroups: { __typename?: 'harvestFruitGroups', items: Array<{ __typename?: 'harvestFruitGroup', fruitGroup: { __typename?: 'fruitGroup', name: string } }> }, work: { __typename?: 'harvestAgricultureWork', id: number, startDate: any, season: { __typename?: 'season', name: string, id: number }, workers: { __typename?: 'workers', count: number, priceSum: any } } }> } | null };

export type HarvestMultiUpdateMutationVariables = Exact<{
  data: Array<HarvestMultiUpdateInput> | HarvestMultiUpdateInput;
}>;


export type HarvestMultiUpdateMutation = { __typename?: 'Mutation', harvestMultiUpdate?: boolean | null };

export type AgricultureWorkInvestmentDatalistQueryVariables = Exact<{
  where?: InputMaybe<AgricultureWorkInvestmentFilterInput>;
  sort?: InputMaybe<Array<AgricultureWorkInvestmentSortInput> | AgricultureWorkInvestmentSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type AgricultureWorkInvestmentDatalistQuery = { __typename?: 'Query', agricultureWorkInvestments?: { __typename?: 'agricultureWorkInvestments', count: number, totalSum: any, items: Array<{ __typename?: 'agricultureWorkInvestment', id: number, name: string, startDate: any, unit: Units, unitPrice: any, total: any, quantity: any, investmentType: InvestmentTypes, season: { __typename?: 'season', name: string }, workers: { __typename?: 'workers', items: Array<{ __typename?: 'worker', person: { __typename?: 'person', name: string } }> } }> } | null };

export type AgricultureWorkInvestmentFormItemQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AgricultureWorkInvestmentFormItemQuery = { __typename?: 'Query', agricultureWorkInvestment?: { __typename?: 'agricultureWorkInvestment', id: number, category: WorkCategories, startDate: any, note?: string | null, name: string, unit: Units, unitPrice: any, quantity: any, total: any, investmentType: InvestmentTypes, workers: { __typename?: 'workers', items: Array<{ __typename?: 'worker', id: number, price: any, person: { __typename?: 'person', id: number, name: string } }> }, season: { __typename?: 'season', id: number, name: string, active: boolean } } | null, season?: { __typename?: 'season', id: number, name: string, active: boolean } | null };

export type AgricultureWorkInvestmentMutationVariables = Exact<{
  model: AgricultureWorkInvestmentInput;
}>;


export type AgricultureWorkInvestmentMutation = { __typename?: 'Mutation', agricultureWorkInvestment?: { __typename?: 'agricultureWorkInvestment', id: number } | null };

export type AgricultureWorkInvestmentViewQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AgricultureWorkInvestmentViewQuery = { __typename?: 'Query', agricultureWorkInvestment?: { __typename?: 'agricultureWorkInvestment', id: number, name: string, startDate: any, unit: Units, unitPrice: any, total: any, quantity: any, investmentType: InvestmentTypes, category: WorkCategories, type: AgricultureWorkTypes, note?: string | null, season: { __typename?: 'season', name: string, id: number, active: boolean }, workers: { __typename?: 'workers', items: Array<{ __typename?: 'worker', person: { __typename?: 'person', name: string, id: number } }> } } | null };

export type MaintenanceAgricultureWorkDatalistQueryVariables = Exact<{
  where?: InputMaybe<MaintenanceAgricultureWorkFilterInput>;
  sort?: InputMaybe<Array<MaintenanceAgricultureWorkSortInput> | MaintenanceAgricultureWorkSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type MaintenanceAgricultureWorkDatalistQuery = { __typename?: 'Query', maintenanceAgricultureWorks?: { __typename?: 'maintenanceAgricultureWorks', count: number, items: Array<{ __typename?: 'maintenanceAgricultureWork', id: number, startDate: any, endDate?: any | null, name: string, workers: { __typename?: 'workers', count: number, priceSum: any }, season: { __typename?: 'season', name: string }, logs: { __typename?: 'maintenanceLogs', items: Array<{ __typename?: 'maintenanceLog', id: number, type: { __typename?: 'maintenanceLogType', name: string }, investment?: { __typename?: 'agricultureWorkInvestment', name: string } | null }> } }> } | null };

export type AgricultureMaintenanceFormDataQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AgricultureMaintenanceFormDataQuery = { __typename?: 'Query', season?: { __typename?: 'season', id: number, name: string, active: boolean } | null, maintenanceAgricultureWork?: { __typename?: 'maintenanceAgricultureWork', id: number, startDate: any, endDate?: any | null, note?: string | null, name: string, workers: { __typename?: 'workers', items: Array<{ __typename?: 'worker', price: any, id: number, person: { __typename?: 'person', id: number, name: string } }> }, season: { __typename?: 'season', active: boolean, id: number, name: string }, logs: { __typename?: 'maintenanceLogs', items: Array<{ __typename?: 'maintenanceLog', id: number, type: { __typename?: 'maintenanceLogType', name: string, id: number }, investment?: { __typename?: 'agricultureWorkInvestment', id: number, name: string, investmentType: InvestmentTypes, unit: Units, unitPrice: any, total: any } | null, maintenanceLogFruitGroups: { __typename?: 'maintenanceLogFruitGroups', items: Array<{ __typename?: 'maintenanceLogFruitGroup', id: number, fruitGroup: { __typename?: 'fruitGroup', name: string, id: number } }> } }> } } | null };

export type SaveMaintenanceMutationVariables = Exact<{
  model: MaintenanceAgricultureWorkInput;
}>;


export type SaveMaintenanceMutation = { __typename?: 'Mutation', maintenanceAgricultureWork?: { __typename?: 'maintenanceAgricultureWork', id: number } | null };

export type MaintenanceAgricultureWorkViewPageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MaintenanceAgricultureWorkViewPageQuery = { __typename?: 'Query', maintenanceAgricultureWork?: { __typename?: 'maintenanceAgricultureWork', id: number, note?: string | null, startDate: any, endDate?: any | null, name: string, workers: { __typename?: 'workers', items: Array<{ __typename?: 'worker', date: any, price: any, id: number, person: { __typename?: 'person', name: string, id: number } }> }, season: { __typename?: 'season', name: string, id: number }, logs: { __typename?: 'maintenanceLogs', items: Array<{ __typename?: 'maintenanceLog', id: number, type: { __typename?: 'maintenanceLogType', name: string, id: number }, investment?: { __typename?: 'agricultureWorkInvestment', name: string, id: number, total: any, investmentType: InvestmentTypes, startDate: any } | null, maintenanceLogFruitGroups: { __typename?: 'maintenanceLogFruitGroups', items: Array<{ __typename?: 'maintenanceLogFruitGroup', id: number, fruitGroup: { __typename?: 'fruitGroup', name: string, id: number } }> } }> } } | null };

export type PersonViewQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  lang: Scalars['String'];
}>;


export type PersonViewQuery = { __typename?: 'Query', person?: { __typename?: 'person', id: number, name: string, note?: string | null, countryCode?: string | null, contactInfo: { __typename?: 'personContactInfos', items: Array<{ __typename?: 'personContactInfo', value: string, link?: string | null, name: string, id: number, personId: number }> }, tags: { __typename?: 'personTagLinks', items: Array<{ __typename?: 'personTagLink', id: number, tag: { __typename?: 'personTag', id: number, name: string } }> }, country?: { __typename?: 'Country', alpha3Code: string, name: string, flag: string, translate?: string | null } | null, sales: { __typename?: 'sales', any: boolean }, workers: { __typename?: 'workers', any: boolean }, bookings: { __typename?: 'bookings', any: boolean }, wallets: { __typename?: 'wallets', any: boolean } } | null };

export type TagDatalistQueryVariables = Exact<{
  where?: InputMaybe<PersonTagFilterInput>;
  order?: InputMaybe<Array<PersonTagSortInput> | PersonTagSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type TagDatalistQuery = { __typename?: 'Query', personTags?: { __typename?: 'personTags', count: number, items: Array<{ __typename?: 'personTag', id: number, name: string }> } | null };

export type AddPersonToTagMutationVariables = Exact<{
  model: PersonTagLinkInput;
}>;


export type AddPersonToTagMutation = { __typename?: 'Mutation', personTagLink?: { __typename?: 'personTagLink', id: number } | null };

export type DeletePersonToTagMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PersonTagLinkFilterInput>;
}>;


export type DeletePersonToTagMutation = { __typename?: 'Mutation', personTagLinkDelete: boolean };

export type GetWalletFromPageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetWalletFromPageQuery = { __typename?: 'Query', wallet?: { __typename?: 'wallet', id: number, name: string, deposit: any, note?: string | null, archived: boolean, person: { __typename?: 'person', id: number, name: string } } | null };

export type GetWalletViewPageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetWalletViewPageQuery = { __typename?: 'Query', wallet?: { __typename?: 'wallet', id: number, name: string, balance: any, note?: string | null, archived: boolean, deposit: any, person: { __typename?: 'person', id: number, name: string, contactInfo: { __typename?: 'personContactInfos', items: Array<{ __typename?: 'personContactInfo', value: string, name: string, link?: string | null }> }, tags: { __typename?: 'personTagLinks', items: Array<{ __typename?: 'personTagLink', tag: { __typename?: 'personTag', name: string } }> } }, sales: { __typename?: 'sales', count: number, totalSum: any }, transactions: { __typename?: 'walletTransactions', count: number, amountSum: any, items: Array<{ __typename?: 'walletTransaction', amount: any, transactionId?: string | null, transactionDate: any, note?: string | null, id: number }> } } | null };

export type ApiTokenDataListSettingsPageQueryVariables = Exact<{
  where?: InputMaybe<ApiTokenFilterInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<ApiTokenSortInput> | ApiTokenSortInput>;
}>;


export type ApiTokenDataListSettingsPageQuery = { __typename?: 'Query', apiTokens?: { __typename?: 'apiTokens', count: number, items: Array<{ __typename?: 'apiToken', name: string, createdDate: any, expiredAt?: any | null, id: number, createdBy: { __typename?: 'user', name: string }, updatedBy?: { __typename?: 'user', name: string } | null }> } | null };

export type SaleTemplateFormDataQueryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type SaleTemplateFormDataQueryQuery = { __typename?: 'Query', saleTemplate?: { __typename?: 'saleTemplate', name: string, date?: any | null, kg?: any | null, pricePerKg?: any | null, total?: any | null, cartQuantity?: number | null, chamber?: boolean | null, type?: SaleTypes | null, note?: string | null, season?: { __typename?: 'season', name: string, id: number, active: boolean } | null, person?: { __typename?: 'person', name: string, id: number } | null, fruit?: { __typename?: 'fruit', name: string, id: number } | null, category?: { __typename?: 'fruitCategory', name: string, id: number } | null } | null };

export type HarvestTemplateFormDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type HarvestTemplateFormDataQuery = { __typename?: 'Query', harvestAgricultureWorkTemplate?: { __typename?: 'harvestAgricultureWorkTemplate', id: number, startDate?: any | null, note?: string | null, name: string, season?: { __typename?: 'season', id: number, name: string, active: boolean } | null, workers: { __typename?: 'workerTemplates', items: Array<{ __typename?: 'workerTemplate', id: number, price?: any | null, person?: { __typename?: 'person', id: number, name: string } | null }> }, harvests: { __typename?: 'harvestTemplates', items: Array<{ __typename?: 'harvestTemplate', id: number, kg?: any | null, cartQuantity?: number | null, hideFromMultiUpdate: boolean, fruit?: { __typename?: 'fruit', id: number, name: string } | null, harvestFruitGroups: { __typename?: 'harvestFruitGroupTemplates', items: Array<{ __typename?: 'harvestFruitGroupTemplate', id: number, fruitGroup: { __typename?: 'fruitGroup', id: number, name: string } }> }, harvestFruitCategories: { __typename?: 'harvestFruitCategoryTemplates', items: Array<{ __typename?: 'harvestFruitCategoryTemplate', id: number, fruitCategory: { __typename?: 'fruitCategory', id: number, name: string } }> } }> } } | null };

export type SaveHarvestTemplateMutationVariables = Exact<{
  model: HarvestAgricultureWorkTemplateInput;
}>;


export type SaveHarvestTemplateMutation = { __typename?: 'Mutation', harvestAgricultureWorkTemplate?: { __typename?: 'harvestAgricultureWorkTemplate', id: number } | null };

export type DeleteFruitMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FruitFilterInput>;
}>;


export type DeleteFruitMutation = { __typename?: 'Mutation', fruitDelete: boolean };

export type DeleteHarvestAgricultureWorkMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestAgricultureWorkFilterInput>;
}>;


export type DeleteHarvestAgricultureWorkMutation = { __typename?: 'Mutation', harvestAgricultureWorkDelete: boolean };

export type DeleteHarvestAgricultureWorkTemplateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestAgricultureWorkTemplateFilterInput>;
}>;


export type DeleteHarvestAgricultureWorkTemplateMutation = { __typename?: 'Mutation', harvestAgricultureWorkTemplateDelete: boolean };

export type AgricultureInvestmentIdNameQueryVariables = Exact<{
  where?: InputMaybe<AgricultureWorkInvestmentFilterInput>;
  sort?: InputMaybe<Array<AgricultureWorkInvestmentSortInput> | AgricultureWorkInvestmentSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type AgricultureInvestmentIdNameQuery = { __typename?: 'Query', agricultureWorkInvestments?: { __typename?: 'agricultureWorkInvestments', items: Array<{ __typename?: 'agricultureWorkInvestment', id: number, name: string, total: any, startDate: any }> } | null };

export type AgricultureMaintenanceLogTypeListQueryVariables = Exact<{
  where?: InputMaybe<MaintenanceLogTypeFilterInput>;
  order?: InputMaybe<Array<MaintenanceLogTypeSortInput> | MaintenanceLogTypeSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type AgricultureMaintenanceLogTypeListQuery = { __typename?: 'Query', maintenanceLogTypes?: { __typename?: 'maintenanceLogTypes', items: Array<{ __typename?: 'maintenanceLogType', id: number, name: string }> } | null };

export type AgricultureMaintenanceLogTypeItemQueryVariables = Exact<{
  where?: InputMaybe<MaintenanceLogTypeFilterInput>;
  id?: InputMaybe<Scalars['Int']>;
}>;


export type AgricultureMaintenanceLogTypeItemQuery = { __typename?: 'Query', maintenanceLogType?: { __typename?: 'maintenanceLogType', id: number, name: string } | null };

export type AgricultureMaintenaceLogTypeMutationMutationVariables = Exact<{
  model: MaintenanceLogTypeInput;
}>;


export type AgricultureMaintenaceLogTypeMutationMutation = { __typename?: 'Mutation', maintenanceLogType?: { __typename?: 'maintenanceLogType', id: number } | null };

export type AgricultureMaintenaceLogTypeDeleteMutationVariables = Exact<{
  where?: InputMaybe<MaintenanceLogTypeFilterInput>;
  id?: InputMaybe<Scalars['Int']>;
}>;


export type AgricultureMaintenaceLogTypeDeleteMutation = { __typename?: 'Mutation', maintenanceLogTypeDelete: boolean };

export type MaintenanceAgricultureWorkDeleteMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceAgricultureWorkFilterInput>;
}>;


export type MaintenanceAgricultureWorkDeleteMutation = { __typename?: 'Mutation', maintenanceAgricultureWorkDelete: boolean };

export type FruitCategoriesIdNameQueryVariables = Exact<{
  where?: InputMaybe<FruitCategoryFilterInput>;
  order?: InputMaybe<Array<FruitCategorySortInput> | FruitCategorySortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type FruitCategoriesIdNameQuery = { __typename?: 'Query', fruitCategories?: { __typename?: 'fruitCategories', items: Array<{ __typename?: 'fruitCategory', name: string, id: number }> } | null };

export type FruitGroupsIdNameQueryVariables = Exact<{
  where?: InputMaybe<FruitGroupFilterInput>;
  order?: InputMaybe<Array<FruitGroupSortInput> | FruitGroupSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type FruitGroupsIdNameQuery = { __typename?: 'Query', fruitGroups?: { __typename?: 'fruitGroups', items: Array<{ __typename?: 'fruitGroup', name: string, id: number }> } | null };

export type FruitsIdNameQueryVariables = Exact<{
  where?: InputMaybe<FruitFilterInput>;
  order?: InputMaybe<Array<FruitSortInput> | FruitSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type FruitsIdNameQuery = { __typename?: 'Query', fruits?: { __typename?: 'fruits', items: Array<{ __typename?: 'fruit', name: string, id: number }> } | null };

export type SaveSaleMutationVariables = Exact<{
  sale: SaleInput;
}>;


export type SaveSaleMutation = { __typename?: 'Mutation', sale?: { __typename?: 'Sale', id: number, name: string } | null };

export type DeleteSaleMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SaleFilterInput>;
}>;


export type DeleteSaleMutation = { __typename?: 'Mutation', saleDelete: boolean };

export type SaleTemplateMutationVariables = Exact<{
  saleTemplate: SaleTemplateInput;
}>;


export type SaleTemplateMutation = { __typename?: 'Mutation', saleTemplate?: { __typename?: 'saleTemplate', id: number, name: string } | null };

export type SaleDatalistQueryVariables = Exact<{
  where?: InputMaybe<SaleFilterInput>;
  order?: InputMaybe<Array<SaleSortInput> | SaleSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type SaleDatalistQuery = { __typename?: 'Query', sales?: { __typename?: 'sales', count: number, items: Array<{ __typename?: 'Sale', id: number, type?: SaleTypes | null, kg: any, pricePerKg: any, total: any, date: any, cartQuantity: number, chamber: boolean, person: { __typename?: 'person', id: number, name: string }, wallet?: { __typename?: 'wallet', id: number, name: string, balance: any, archived: boolean } | null, fruit: { __typename?: 'fruit', id: number, name: string }, season: { __typename?: 'season', id: number, name: string }, category?: { __typename?: 'fruitCategory', name: string, id: number } | null }> } | null };

export type SaleDatalistAndTotalQueryVariables = Exact<{
  where?: InputMaybe<SaleFilterInput>;
  order?: InputMaybe<Array<SaleSortInput> | SaleSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type SaleDatalistAndTotalQuery = { __typename?: 'Query', sales?: { __typename?: 'sales', totalSum: any, kgSum: any, pricePerKgAverage: any, cartQuantitySum: any, count: number, items: Array<{ __typename?: 'Sale', id: number, type?: SaleTypes | null, kg: any, pricePerKg: any, total: any, date: any, cartQuantity: number, chamber: boolean, person: { __typename?: 'person', id: number, name: string }, wallet?: { __typename?: 'wallet', id: number, name: string, balance: any, archived: boolean } | null, fruit: { __typename?: 'fruit', id: number, name: string }, season: { __typename?: 'season', id: number, name: string }, category?: { __typename?: 'fruitCategory', name: string, id: number } | null }> } | null };

export type DeleteSaleTemplateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SaleTemplateFilterInput>;
}>;


export type DeleteSaleTemplateMutation = { __typename?: 'Mutation', saleTemplateDelete: boolean };

export type SaleMultiUpdateMutationVariables = Exact<{
  data: Array<SaleMultiUpdateInput> | SaleMultiUpdateInput;
}>;


export type SaleMultiUpdateMutation = { __typename?: 'Mutation', saleMultiUpdate?: boolean | null };

export type PersonQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type PersonQuery = { __typename?: 'Query', person?: { __typename?: 'person', id: number, name: string, note?: string | null, countryCode?: string | null, contactInfo: { __typename?: 'personContactInfos', items: Array<{ __typename?: 'personContactInfo', value: string, link?: string | null, name: string, id: number, personId: number }> }, tags: { __typename?: 'personTagLinks', items: Array<{ __typename?: 'personTagLink', id: number, tag: { __typename?: 'personTag', id: number, name: string } }> }, country?: { __typename?: 'Country', alpha3Code: string, name: string, flag: string } | null } | null };

export type PersonListInfoQueryVariables = Exact<{
  where?: InputMaybe<PersonFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<PersonSortInput> | PersonSortInput>;
}>;


export type PersonListInfoQuery = { __typename?: 'Query', people?: { __typename?: 'people', count: number, items: Array<{ __typename?: 'person', id: number, name: string, note?: string | null, countryCode?: string | null, contactInfo: { __typename?: 'personContactInfos', items: Array<{ __typename?: 'personContactInfo', value: string, name: string, id: number, link?: string | null }> }, tags: { __typename?: 'personTagLinks', items: Array<{ __typename?: 'personTagLink', id: number, tag: { __typename?: 'personTag', id: number, name: string } }> }, country?: { __typename?: 'Country', alpha3Code: string, name: string, flag: string } | null }> } | null };

export type DeletePersonMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PersonFilterInput>;
}>;


export type DeletePersonMutation = { __typename?: 'Mutation', personDelete: boolean };

export type SavePersonMutationVariables = Exact<{
  person: PersonInput;
}>;


export type SavePersonMutation = { __typename?: 'Mutation', person?: { __typename?: 'person', id: number, name: string, note?: string | null, countryCode?: string | null, contactInfo: { __typename?: 'personContactInfos', items: Array<{ __typename?: 'personContactInfo', value: string, link?: string | null, name: string, id: number, personId: number }> } } | null };

export type TagMutationVariables = Exact<{
  model: PersonTagInput;
}>;


export type TagMutation = { __typename?: 'Mutation', personTag?: { __typename?: 'personTag', id: number } | null };

export type DeletePersonTagMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PersonTagFilterInput>;
}>;


export type DeletePersonTagMutation = { __typename?: 'Mutation', personTagDelete: boolean };

export type GetPersonTagQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PersonTagFilterInput>;
}>;


export type GetPersonTagQuery = { __typename?: 'Query', personTag?: { __typename?: 'personTag', name: string, id: number } | null };

export type SeasonItemQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type SeasonItemQuery = { __typename?: 'Query', season?: { __typename?: 'season', name: string, id: number, active: boolean } | null };

export type SeasonListInfoQueryVariables = Exact<{
  where?: InputMaybe<SeasonFilterInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<SeasonSortInput> | SeasonSortInput>;
}>;


export type SeasonListInfoQuery = { __typename?: 'Query', seasons?: { __typename?: 'seasons', count: number, items: Array<{ __typename?: 'season', id: number, name: string, active: boolean }> } | null };

export type DeleteHarvestsAgricultureWorkTemplateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HarvestAgricultureWorkFilterInput>;
}>;


export type DeleteHarvestsAgricultureWorkTemplateMutation = { __typename?: 'Mutation', harvestAgricultureWorkDelete: boolean };

export type UserDatalistQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserFilterInput>;
  order?: InputMaybe<Array<UserSortInput> | UserSortInput>;
}>;


export type UserDatalistQuery = { __typename?: 'Query', users?: { __typename?: 'users', count: number, items: Array<{ __typename?: 'user', name: string, username: string, status: Statuses, id: number }> } | null };

export type UserViewQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserFilterInput>;
  order?: InputMaybe<Array<UserSortInput> | UserSortInput>;
}>;


export type UserViewQuery = { __typename?: 'Query', user?: { __typename?: 'user', id: number, name: string, username: string, status: Statuses, roles: { __typename?: 'userRoles', items: Array<{ __typename?: 'userRole', role: string, id: number }> }, authData: { __typename?: 'userAuthDatas', items: Array<{ __typename?: 'userAuthData', id: number, provider: AuthProvider, identifier: string }> } } | null };

export type AllRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllRolesQuery = { __typename?: 'Query', allRoles: Array<string | null> };

export type UserFormQueryVariables = Exact<{
  id: Scalars['Int'];
  where?: InputMaybe<UserFilterInput>;
  order?: InputMaybe<Array<UserSortInput> | UserSortInput>;
}>;


export type UserFormQuery = { __typename?: 'Query', allRoles: Array<string | null>, user?: { __typename?: 'user', id: number, username: string, name: string, status: Statuses, roles: { __typename?: 'userRoles', items: Array<{ __typename?: 'userRole', id: number, role: string }> } } | null };


export const BookingAdditionalChargesDatalistDocument = gql`
    query BookingAdditionalChargesDatalist($where: BookingAdditionalChargeFilterInput, $order: [BookingAdditionalChargeSortInput!], $skip: Int, $take: Int) {
  bookingAdditionalCharges {
    count(where: $where)
    items(where: $where, skip: $skip, order: $order, take: $take) {
      amount
      date
      name
      id
      note
      isIncome
      booking {
        id
        inSeasonId
      }
    }
    amountSum(where: $where)
  }
}
    `;

/**
 * __useBookingAdditionalChargesDatalistQuery__
 *
 * To run a query within a React component, call `useBookingAdditionalChargesDatalistQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingAdditionalChargesDatalistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingAdditionalChargesDatalistQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useBookingAdditionalChargesDatalistQuery(baseOptions?: Apollo.QueryHookOptions<BookingAdditionalChargesDatalistQuery, BookingAdditionalChargesDatalistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingAdditionalChargesDatalistQuery, BookingAdditionalChargesDatalistQueryVariables>(BookingAdditionalChargesDatalistDocument, options);
      }
export function useBookingAdditionalChargesDatalistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingAdditionalChargesDatalistQuery, BookingAdditionalChargesDatalistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingAdditionalChargesDatalistQuery, BookingAdditionalChargesDatalistQueryVariables>(BookingAdditionalChargesDatalistDocument, options);
        }
export type BookingAdditionalChargesDatalistQueryHookResult = ReturnType<typeof useBookingAdditionalChargesDatalistQuery>;
export type BookingAdditionalChargesDatalistLazyQueryHookResult = ReturnType<typeof useBookingAdditionalChargesDatalistLazyQuery>;
export type BookingAdditionalChargesDatalistQueryResult = Apollo.QueryResult<BookingAdditionalChargesDatalistQuery, BookingAdditionalChargesDatalistQueryVariables>;
export const BookingAdditinalChargesAddFromTemplateDocument = gql`
    mutation BookingAdditinalChargesAddFromTemplate($bookingId: Int!, $templateId: Int!, $count: Int) {
  bookingAdditionalChargeFromTemplate(
    bookingId: $bookingId
    templateId: $templateId
    count: $count
  ) {
    id
  }
}
    `;
export type BookingAdditinalChargesAddFromTemplateMutationFn = Apollo.MutationFunction<BookingAdditinalChargesAddFromTemplateMutation, BookingAdditinalChargesAddFromTemplateMutationVariables>;

/**
 * __useBookingAdditinalChargesAddFromTemplateMutation__
 *
 * To run a mutation, you first call `useBookingAdditinalChargesAddFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingAdditinalChargesAddFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingAdditinalChargesAddFromTemplateMutation, { data, loading, error }] = useBookingAdditinalChargesAddFromTemplateMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      templateId: // value for 'templateId'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useBookingAdditinalChargesAddFromTemplateMutation(baseOptions?: Apollo.MutationHookOptions<BookingAdditinalChargesAddFromTemplateMutation, BookingAdditinalChargesAddFromTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookingAdditinalChargesAddFromTemplateMutation, BookingAdditinalChargesAddFromTemplateMutationVariables>(BookingAdditinalChargesAddFromTemplateDocument, options);
      }
export type BookingAdditinalChargesAddFromTemplateMutationHookResult = ReturnType<typeof useBookingAdditinalChargesAddFromTemplateMutation>;
export type BookingAdditinalChargesAddFromTemplateMutationResult = Apollo.MutationResult<BookingAdditinalChargesAddFromTemplateMutation>;
export type BookingAdditinalChargesAddFromTemplateMutationOptions = Apollo.BaseMutationOptions<BookingAdditinalChargesAddFromTemplateMutation, BookingAdditinalChargesAddFromTemplateMutationVariables>;
export const BookingAdditionalChargesFormDataDocument = gql`
    query BookingAdditionalChargesFormData($id: Int) {
  bookingAdditionalCharge(id: $id) {
    bookingId
    amount
    date
    name
    id
    note
    isIncome
  }
}
    `;

/**
 * __useBookingAdditionalChargesFormDataQuery__
 *
 * To run a query within a React component, call `useBookingAdditionalChargesFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingAdditionalChargesFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingAdditionalChargesFormDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingAdditionalChargesFormDataQuery(baseOptions?: Apollo.QueryHookOptions<BookingAdditionalChargesFormDataQuery, BookingAdditionalChargesFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingAdditionalChargesFormDataQuery, BookingAdditionalChargesFormDataQueryVariables>(BookingAdditionalChargesFormDataDocument, options);
      }
export function useBookingAdditionalChargesFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingAdditionalChargesFormDataQuery, BookingAdditionalChargesFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingAdditionalChargesFormDataQuery, BookingAdditionalChargesFormDataQueryVariables>(BookingAdditionalChargesFormDataDocument, options);
        }
export type BookingAdditionalChargesFormDataQueryHookResult = ReturnType<typeof useBookingAdditionalChargesFormDataQuery>;
export type BookingAdditionalChargesFormDataLazyQueryHookResult = ReturnType<typeof useBookingAdditionalChargesFormDataLazyQuery>;
export type BookingAdditionalChargesFormDataQueryResult = Apollo.QueryResult<BookingAdditionalChargesFormDataQuery, BookingAdditionalChargesFormDataQueryVariables>;
export const SaveBookingAdditionalChargesDocument = gql`
    mutation SaveBookingAdditionalCharges($model: BookingAdditionalChargeInput!) {
  bookingAdditionalCharge(model: $model) {
    id
  }
}
    `;
export type SaveBookingAdditionalChargesMutationFn = Apollo.MutationFunction<SaveBookingAdditionalChargesMutation, SaveBookingAdditionalChargesMutationVariables>;

/**
 * __useSaveBookingAdditionalChargesMutation__
 *
 * To run a mutation, you first call `useSaveBookingAdditionalChargesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBookingAdditionalChargesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBookingAdditionalChargesMutation, { data, loading, error }] = useSaveBookingAdditionalChargesMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useSaveBookingAdditionalChargesMutation(baseOptions?: Apollo.MutationHookOptions<SaveBookingAdditionalChargesMutation, SaveBookingAdditionalChargesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBookingAdditionalChargesMutation, SaveBookingAdditionalChargesMutationVariables>(SaveBookingAdditionalChargesDocument, options);
      }
export type SaveBookingAdditionalChargesMutationHookResult = ReturnType<typeof useSaveBookingAdditionalChargesMutation>;
export type SaveBookingAdditionalChargesMutationResult = Apollo.MutationResult<SaveBookingAdditionalChargesMutation>;
export type SaveBookingAdditionalChargesMutationOptions = Apollo.BaseMutationOptions<SaveBookingAdditionalChargesMutation, SaveBookingAdditionalChargesMutationVariables>;
export const BookingAdditionalChargesViewDataDocument = gql`
    query BookingAdditionalChargesViewData($id: Int) {
  bookingAdditionalCharge(id: $id) {
    amount
    date
    name
    id
    note
    isIncome
    booking {
      id
      inSeasonId
    }
  }
}
    `;

/**
 * __useBookingAdditionalChargesViewDataQuery__
 *
 * To run a query within a React component, call `useBookingAdditionalChargesViewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingAdditionalChargesViewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingAdditionalChargesViewDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingAdditionalChargesViewDataQuery(baseOptions?: Apollo.QueryHookOptions<BookingAdditionalChargesViewDataQuery, BookingAdditionalChargesViewDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingAdditionalChargesViewDataQuery, BookingAdditionalChargesViewDataQueryVariables>(BookingAdditionalChargesViewDataDocument, options);
      }
export function useBookingAdditionalChargesViewDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingAdditionalChargesViewDataQuery, BookingAdditionalChargesViewDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingAdditionalChargesViewDataQuery, BookingAdditionalChargesViewDataQueryVariables>(BookingAdditionalChargesViewDataDocument, options);
        }
export type BookingAdditionalChargesViewDataQueryHookResult = ReturnType<typeof useBookingAdditionalChargesViewDataQuery>;
export type BookingAdditionalChargesViewDataLazyQueryHookResult = ReturnType<typeof useBookingAdditionalChargesViewDataLazyQuery>;
export type BookingAdditionalChargesViewDataQueryResult = Apollo.QueryResult<BookingAdditionalChargesViewDataQuery, BookingAdditionalChargesViewDataQueryVariables>;
export const AdditionalChargesTemplateDatalistDocument = gql`
    query additionalChargesTemplateDatalist($where: BookingAdditionalChargesTemplateFilterInput, $order: [BookingAdditionalChargesTemplateSortInput!], $take: Int, $skip: Int) {
  bookingAdditionalChargesTemplates {
    items(order: $order, skip: $skip, take: $take, where: $where) {
      amount
      calculationType
      name
      id
      isIncome
    }
    count(where: $where)
  }
}
    `;

/**
 * __useAdditionalChargesTemplateDatalistQuery__
 *
 * To run a query within a React component, call `useAdditionalChargesTemplateDatalistQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdditionalChargesTemplateDatalistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdditionalChargesTemplateDatalistQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useAdditionalChargesTemplateDatalistQuery(baseOptions?: Apollo.QueryHookOptions<AdditionalChargesTemplateDatalistQuery, AdditionalChargesTemplateDatalistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdditionalChargesTemplateDatalistQuery, AdditionalChargesTemplateDatalistQueryVariables>(AdditionalChargesTemplateDatalistDocument, options);
      }
export function useAdditionalChargesTemplateDatalistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdditionalChargesTemplateDatalistQuery, AdditionalChargesTemplateDatalistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdditionalChargesTemplateDatalistQuery, AdditionalChargesTemplateDatalistQueryVariables>(AdditionalChargesTemplateDatalistDocument, options);
        }
export type AdditionalChargesTemplateDatalistQueryHookResult = ReturnType<typeof useAdditionalChargesTemplateDatalistQuery>;
export type AdditionalChargesTemplateDatalistLazyQueryHookResult = ReturnType<typeof useAdditionalChargesTemplateDatalistLazyQuery>;
export type AdditionalChargesTemplateDatalistQueryResult = Apollo.QueryResult<AdditionalChargesTemplateDatalistQuery, AdditionalChargesTemplateDatalistQueryVariables>;
export const GetBookingAdditionalChargesTemplateFormDataDocument = gql`
    query GetBookingAdditionalChargesTemplateFormData($id: Int) {
  bookingAdditionalChargesTemplate(id: $id) {
    amount
    calculationType
    name
    id
    isIncome
  }
}
    `;

/**
 * __useGetBookingAdditionalChargesTemplateFormDataQuery__
 *
 * To run a query within a React component, call `useGetBookingAdditionalChargesTemplateFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingAdditionalChargesTemplateFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingAdditionalChargesTemplateFormDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookingAdditionalChargesTemplateFormDataQuery(baseOptions?: Apollo.QueryHookOptions<GetBookingAdditionalChargesTemplateFormDataQuery, GetBookingAdditionalChargesTemplateFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingAdditionalChargesTemplateFormDataQuery, GetBookingAdditionalChargesTemplateFormDataQueryVariables>(GetBookingAdditionalChargesTemplateFormDataDocument, options);
      }
export function useGetBookingAdditionalChargesTemplateFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingAdditionalChargesTemplateFormDataQuery, GetBookingAdditionalChargesTemplateFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingAdditionalChargesTemplateFormDataQuery, GetBookingAdditionalChargesTemplateFormDataQueryVariables>(GetBookingAdditionalChargesTemplateFormDataDocument, options);
        }
export type GetBookingAdditionalChargesTemplateFormDataQueryHookResult = ReturnType<typeof useGetBookingAdditionalChargesTemplateFormDataQuery>;
export type GetBookingAdditionalChargesTemplateFormDataLazyQueryHookResult = ReturnType<typeof useGetBookingAdditionalChargesTemplateFormDataLazyQuery>;
export type GetBookingAdditionalChargesTemplateFormDataQueryResult = Apollo.QueryResult<GetBookingAdditionalChargesTemplateFormDataQuery, GetBookingAdditionalChargesTemplateFormDataQueryVariables>;
export const SaveBookingAdditionalChargesTemplateDocument = gql`
    mutation SaveBookingAdditionalChargesTemplate($model: BookingAdditionalChargesTemplateInput!) {
  bookingAdditionalChargesTemplate(model: $model) {
    id
  }
}
    `;
export type SaveBookingAdditionalChargesTemplateMutationFn = Apollo.MutationFunction<SaveBookingAdditionalChargesTemplateMutation, SaveBookingAdditionalChargesTemplateMutationVariables>;

/**
 * __useSaveBookingAdditionalChargesTemplateMutation__
 *
 * To run a mutation, you first call `useSaveBookingAdditionalChargesTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBookingAdditionalChargesTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBookingAdditionalChargesTemplateMutation, { data, loading, error }] = useSaveBookingAdditionalChargesTemplateMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useSaveBookingAdditionalChargesTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SaveBookingAdditionalChargesTemplateMutation, SaveBookingAdditionalChargesTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBookingAdditionalChargesTemplateMutation, SaveBookingAdditionalChargesTemplateMutationVariables>(SaveBookingAdditionalChargesTemplateDocument, options);
      }
export type SaveBookingAdditionalChargesTemplateMutationHookResult = ReturnType<typeof useSaveBookingAdditionalChargesTemplateMutation>;
export type SaveBookingAdditionalChargesTemplateMutationResult = Apollo.MutationResult<SaveBookingAdditionalChargesTemplateMutation>;
export type SaveBookingAdditionalChargesTemplateMutationOptions = Apollo.BaseMutationOptions<SaveBookingAdditionalChargesTemplateMutation, SaveBookingAdditionalChargesTemplateMutationVariables>;
export const CheckAvailabilityDocument = gql`
    query CheckAvailability($where: BookingDetailsFilterInput, $sort: [BookingDetailsSortInput!], $roomSort: [RoomSortInput!], $roomWhere: RoomFilterInput) {
  rooms {
    items(where: $roomWhere, order: $roomSort) {
      roomType {
        color
        id
        name
        defaultPrice
      }
      name
      id
      order
      bookingDetails {
        items(where: $where, order: $sort) {
          price
          booking {
            inDate
            outDate
            inSeasonId
            id
            nights
            roomType {
              id
              name
              color
            }
          }
          date
          id
        }
        count(where: $where)
      }
    }
  }
  fistDate: bookingDetails(order: [{date: ASC}], where: $where) {
    date
  }
  lastDate: bookingDetails(order: [{date: DESC}], where: $where) {
    date
  }
}
    `;

/**
 * __useCheckAvailabilityQuery__
 *
 * To run a query within a React component, call `useCheckAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckAvailabilityQuery({
 *   variables: {
 *      where: // value for 'where'
 *      sort: // value for 'sort'
 *      roomSort: // value for 'roomSort'
 *      roomWhere: // value for 'roomWhere'
 *   },
 * });
 */
export function useCheckAvailabilityQuery(baseOptions?: Apollo.QueryHookOptions<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>(CheckAvailabilityDocument, options);
      }
export function useCheckAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>(CheckAvailabilityDocument, options);
        }
export type CheckAvailabilityQueryHookResult = ReturnType<typeof useCheckAvailabilityQuery>;
export type CheckAvailabilityLazyQueryHookResult = ReturnType<typeof useCheckAvailabilityLazyQuery>;
export type CheckAvailabilityQueryResult = Apollo.QueryResult<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>;
export const BookingDatalistDocument = gql`
    query BookingDatalist($where: BookingFilterInput, $order: [BookingSortInput!], $skip: Int, $take: Int, $channelWhere: BookingBookingChannelFilterInput) {
  bookings {
    count(where: $where)
    items(where: $where, skip: $skip, order: $order, take: $take) {
      id
      person {
        name
      }
      inDate
      outDate
      nights
      isCancelled
      hasConflict
      bookingDate
      children
      guestCount
      inSeasonId
      total
      paidAmount
      roomType {
        color
        name
        id
      }
      channel {
        channel {
          name
        }
        total
        isCancelled
      }
      season {
        name
      }
      details {
        items {
          price
          room {
            name
            roomType {
              color
              name
              id
            }
          }
        }
        priceSum
      }
      additionalCharge {
        amountSum
        count
      }
    }
    totalSum(where: $where)
    totalAverage(where: $where)
    guestCountAverage(where: $where)
    guestCountSum(where: $where)
    nightsAverage(where: $where)
    nightsSum(where: $where)
  }
  bookingBookingChannels {
    totalSum(where: $channelWhere)
    totalAverage(where: $channelWhere)
  }
}
    `;

/**
 * __useBookingDatalistQuery__
 *
 * To run a query within a React component, call `useBookingDatalistQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingDatalistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingDatalistQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      channelWhere: // value for 'channelWhere'
 *   },
 * });
 */
export function useBookingDatalistQuery(baseOptions?: Apollo.QueryHookOptions<BookingDatalistQuery, BookingDatalistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingDatalistQuery, BookingDatalistQueryVariables>(BookingDatalistDocument, options);
      }
export function useBookingDatalistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingDatalistQuery, BookingDatalistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingDatalistQuery, BookingDatalistQueryVariables>(BookingDatalistDocument, options);
        }
export type BookingDatalistQueryHookResult = ReturnType<typeof useBookingDatalistQuery>;
export type BookingDatalistLazyQueryHookResult = ReturnType<typeof useBookingDatalistLazyQuery>;
export type BookingDatalistQueryResult = Apollo.QueryResult<BookingDatalistQuery, BookingDatalistQueryVariables>;
export const BookingViewDataDocument = gql`
    query BookingViewData($id: String, $lang: String!) {
  booking(ref: $id) {
    id
    person {
      name
      id
      contactInfo {
        items {
          name
          link
          value
          id
        }
      }
      countryCode
      country {
        alpha3Code
        name
        flag
        translate(lang: $lang)
      }
    }
    inDate
    outDate
    nights
    isCancelled
    isNoShowCancellation
    cancelledDate
    hasConflict
    children
    guestReservationLinkExtension
    guestCount
    inSeasonId
    bookingDate
    note
    total
    paidAmount
    roomType {
      color
      name
      id
    }
    channel {
      channel {
        name
      }
      total
      externalReference
      isCancelled
    }
    season {
      name
    }
    details {
      items {
        room {
          name
          roomType {
            color
            name
            id
          }
          id
        }
        price
        date
        id
        hasConflict
      }
      priceSum
    }
    additionalCharge {
      items {
        amount
        date
        name
        id
      }
      amountSum
    }
  }
}
    `;

/**
 * __useBookingViewDataQuery__
 *
 * To run a query within a React component, call `useBookingViewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingViewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingViewDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useBookingViewDataQuery(baseOptions: Apollo.QueryHookOptions<BookingViewDataQuery, BookingViewDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingViewDataQuery, BookingViewDataQueryVariables>(BookingViewDataDocument, options);
      }
export function useBookingViewDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingViewDataQuery, BookingViewDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingViewDataQuery, BookingViewDataQueryVariables>(BookingViewDataDocument, options);
        }
export type BookingViewDataQueryHookResult = ReturnType<typeof useBookingViewDataQuery>;
export type BookingViewDataLazyQueryHookResult = ReturnType<typeof useBookingViewDataLazyQuery>;
export type BookingViewDataQueryResult = Apollo.QueryResult<BookingViewDataQuery, BookingViewDataQueryVariables>;
export const BookingChannelDatalistDocument = gql`
    query BookingChannelDatalist($where: BookingChannelFilterInput, $order: [BookingChannelSortInput!], $skip: Int, $take: Int) {
  bookingChannels {
    count(where: $where)
    items(where: $where, skip: $skip, take: $take, order: $order) {
      commission
      type
      name
      id
      roomTypeDefultPrices {
        items {
          roomType {
            id
            color
            name
          }
          defaultPrice
          id
        }
      }
    }
  }
}
    `;

/**
 * __useBookingChannelDatalistQuery__
 *
 * To run a query within a React component, call `useBookingChannelDatalistQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingChannelDatalistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingChannelDatalistQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useBookingChannelDatalistQuery(baseOptions?: Apollo.QueryHookOptions<BookingChannelDatalistQuery, BookingChannelDatalistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingChannelDatalistQuery, BookingChannelDatalistQueryVariables>(BookingChannelDatalistDocument, options);
      }
export function useBookingChannelDatalistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingChannelDatalistQuery, BookingChannelDatalistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingChannelDatalistQuery, BookingChannelDatalistQueryVariables>(BookingChannelDatalistDocument, options);
        }
export type BookingChannelDatalistQueryHookResult = ReturnType<typeof useBookingChannelDatalistQuery>;
export type BookingChannelDatalistLazyQueryHookResult = ReturnType<typeof useBookingChannelDatalistLazyQuery>;
export type BookingChannelDatalistQueryResult = Apollo.QueryResult<BookingChannelDatalistQuery, BookingChannelDatalistQueryVariables>;
export const GetChannelDropdownDataDocument = gql`
    query GetChannelDropdownData($where: BookingChannelFilterInput, $order: [BookingChannelSortInput!], $skip: Int, $take: Int) {
  bookingChannels {
    items(order: $order, skip: $skip, take: $take, where: $where) {
      commission
      type
      name
      id
      roomTypeDefultPrices {
        items {
          roomType {
            name
            id
            color
          }
          id
          defaultPrice
        }
      }
    }
  }
}
    `;

/**
 * __useGetChannelDropdownDataQuery__
 *
 * To run a query within a React component, call `useGetChannelDropdownDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelDropdownDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelDropdownDataQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetChannelDropdownDataQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelDropdownDataQuery, GetChannelDropdownDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelDropdownDataQuery, GetChannelDropdownDataQueryVariables>(GetChannelDropdownDataDocument, options);
      }
export function useGetChannelDropdownDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelDropdownDataQuery, GetChannelDropdownDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelDropdownDataQuery, GetChannelDropdownDataQueryVariables>(GetChannelDropdownDataDocument, options);
        }
export type GetChannelDropdownDataQueryHookResult = ReturnType<typeof useGetChannelDropdownDataQuery>;
export type GetChannelDropdownDataLazyQueryHookResult = ReturnType<typeof useGetChannelDropdownDataLazyQuery>;
export type GetChannelDropdownDataQueryResult = Apollo.QueryResult<GetChannelDropdownDataQuery, GetChannelDropdownDataQueryVariables>;
export const EventDatalistDocument = gql`
    query EventDatalist($where: BookingEventFilterInput, $order: [BookingEventSortInput!], $skip: Int, $take: Int) {
  bookingEvents {
    count(where: $where)
    items(where: $where, order: $order, skip: $skip, take: $take) {
      id
      date
      note
      isDone
      insertType
      name
      group
      order
      assigneeId
      assignee {
        id
        name
      }
      booking {
        id
        inDate
        outDate
        inSeasonId
        seasonId
        nights
        guestCount
        children
        season {
          id
          name
          active
        }
        person {
          id
          name
        }
        details {
          items {
            date
            room {
              id
              name
              roomType {
                color
                name
                id
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useEventDatalistQuery__
 *
 * To run a query within a React component, call `useEventDatalistQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventDatalistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventDatalistQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useEventDatalistQuery(baseOptions?: Apollo.QueryHookOptions<EventDatalistQuery, EventDatalistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventDatalistQuery, EventDatalistQueryVariables>(EventDatalistDocument, options);
      }
export function useEventDatalistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventDatalistQuery, EventDatalistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventDatalistQuery, EventDatalistQueryVariables>(EventDatalistDocument, options);
        }
export type EventDatalistQueryHookResult = ReturnType<typeof useEventDatalistQuery>;
export type EventDatalistLazyQueryHookResult = ReturnType<typeof useEventDatalistLazyQuery>;
export type EventDatalistQueryResult = Apollo.QueryResult<EventDatalistQuery, EventDatalistQueryVariables>;
export const EventFormDataDocument = gql`
    query EventFormData($id: Int, $bookingId: Int!) {
  bookingEvent(id: $id) {
    bookingId
    isDone
    date
    note
    name
    id
    order
    group
    assigneeId
    assignee {
      id
      name
    }
    booking {
      id
      inDate
      outDate
    }
  }
  booking(id: $bookingId) {
    id
    inDate
    outDate
  }
}
    `;

/**
 * __useEventFormDataQuery__
 *
 * To run a query within a React component, call `useEventFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventFormDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useEventFormDataQuery(baseOptions: Apollo.QueryHookOptions<EventFormDataQuery, EventFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventFormDataQuery, EventFormDataQueryVariables>(EventFormDataDocument, options);
      }
export function useEventFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventFormDataQuery, EventFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventFormDataQuery, EventFormDataQueryVariables>(EventFormDataDocument, options);
        }
export type EventFormDataQueryHookResult = ReturnType<typeof useEventFormDataQuery>;
export type EventFormDataLazyQueryHookResult = ReturnType<typeof useEventFormDataLazyQuery>;
export type EventFormDataQueryResult = Apollo.QueryResult<EventFormDataQuery, EventFormDataQueryVariables>;
export const EventViewDataDocument = gql`
    query EventViewData($id: Int) {
  bookingEvent(id: $id) {
    bookingId
    isDone
    date
    note
    name
    insertType
    id
    group
    order
    assigneeId
    assignee {
      id
      name
    }
    booking {
      id
      inDate
      inSeasonId
      outDate
      season {
        id
        name
        active
      }
      roomType {
        id
        name
        color
      }
    }
  }
}
    `;

/**
 * __useEventViewDataQuery__
 *
 * To run a query within a React component, call `useEventViewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventViewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventViewDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventViewDataQuery(baseOptions?: Apollo.QueryHookOptions<EventViewDataQuery, EventViewDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventViewDataQuery, EventViewDataQueryVariables>(EventViewDataDocument, options);
      }
export function useEventViewDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventViewDataQuery, EventViewDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventViewDataQuery, EventViewDataQueryVariables>(EventViewDataDocument, options);
        }
export type EventViewDataQueryHookResult = ReturnType<typeof useEventViewDataQuery>;
export type EventViewDataLazyQueryHookResult = ReturnType<typeof useEventViewDataLazyQuery>;
export type EventViewDataQueryResult = Apollo.QueryResult<EventViewDataQuery, EventViewDataQueryVariables>;
export const RoomTypesDatalistDocument = gql`
    query RoomTypesDatalist($where: RoomTypeFilterInput, $order: [RoomTypeSortInput!], $skip: Int, $take: Int) {
  roomTypes {
    count(where: $where)
    items(order: $order, skip: $skip, take: $take, where: $where) {
      id
      name
      defaultPrice
      color
      rooms {
        count
      }
    }
  }
}
    `;

/**
 * __useRoomTypesDatalistQuery__
 *
 * To run a query within a React component, call `useRoomTypesDatalistQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomTypesDatalistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomTypesDatalistQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useRoomTypesDatalistQuery(baseOptions?: Apollo.QueryHookOptions<RoomTypesDatalistQuery, RoomTypesDatalistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomTypesDatalistQuery, RoomTypesDatalistQueryVariables>(RoomTypesDatalistDocument, options);
      }
export function useRoomTypesDatalistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomTypesDatalistQuery, RoomTypesDatalistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomTypesDatalistQuery, RoomTypesDatalistQueryVariables>(RoomTypesDatalistDocument, options);
        }
export type RoomTypesDatalistQueryHookResult = ReturnType<typeof useRoomTypesDatalistQuery>;
export type RoomTypesDatalistLazyQueryHookResult = ReturnType<typeof useRoomTypesDatalistLazyQuery>;
export type RoomTypesDatalistQueryResult = Apollo.QueryResult<RoomTypesDatalistQuery, RoomTypesDatalistQueryVariables>;
export const DeleteRoomTypeDocument = gql`
    mutation DeleteRoomType($id: Int) {
  roomTypeDelete(id: $id)
}
    `;
export type DeleteRoomTypeMutationFn = Apollo.MutationFunction<DeleteRoomTypeMutation, DeleteRoomTypeMutationVariables>;

/**
 * __useDeleteRoomTypeMutation__
 *
 * To run a mutation, you first call `useDeleteRoomTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoomTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoomTypeMutation, { data, loading, error }] = useDeleteRoomTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRoomTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoomTypeMutation, DeleteRoomTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoomTypeMutation, DeleteRoomTypeMutationVariables>(DeleteRoomTypeDocument, options);
      }
export type DeleteRoomTypeMutationHookResult = ReturnType<typeof useDeleteRoomTypeMutation>;
export type DeleteRoomTypeMutationResult = Apollo.MutationResult<DeleteRoomTypeMutation>;
export type DeleteRoomTypeMutationOptions = Apollo.BaseMutationOptions<DeleteRoomTypeMutation, DeleteRoomTypeMutationVariables>;
export const RoomTypeDropdownDocument = gql`
    query RoomTypeDropdown($where: RoomTypeFilterInput, $order: [RoomTypeSortInput!], $skip: Int, $take: Int) {
  roomTypes {
    items(order: $order, skip: $skip, take: $take, where: $where) {
      id
      name
      defaultPrice
      color
    }
  }
}
    `;

/**
 * __useRoomTypeDropdownQuery__
 *
 * To run a query within a React component, call `useRoomTypeDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomTypeDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomTypeDropdownQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useRoomTypeDropdownQuery(baseOptions?: Apollo.QueryHookOptions<RoomTypeDropdownQuery, RoomTypeDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomTypeDropdownQuery, RoomTypeDropdownQueryVariables>(RoomTypeDropdownDocument, options);
      }
export function useRoomTypeDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomTypeDropdownQuery, RoomTypeDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomTypeDropdownQuery, RoomTypeDropdownQueryVariables>(RoomTypeDropdownDocument, options);
        }
export type RoomTypeDropdownQueryHookResult = ReturnType<typeof useRoomTypeDropdownQuery>;
export type RoomTypeDropdownLazyQueryHookResult = ReturnType<typeof useRoomTypeDropdownLazyQuery>;
export type RoomTypeDropdownQueryResult = Apollo.QueryResult<RoomTypeDropdownQuery, RoomTypeDropdownQueryVariables>;
export const RoomDatalistDocument = gql`
    query RoomDatalist($where: RoomFilterInput, $order: [RoomSortInput!], $skip: Int, $take: Int) {
  rooms {
    count(where: $where)
    items(order: $order, skip: $skip, take: $take, where: $where) {
      id
      name
      roomType {
        color
        name
      }
      order
      bookingDetails {
        any
      }
    }
  }
}
    `;

/**
 * __useRoomDatalistQuery__
 *
 * To run a query within a React component, call `useRoomDatalistQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomDatalistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomDatalistQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useRoomDatalistQuery(baseOptions?: Apollo.QueryHookOptions<RoomDatalistQuery, RoomDatalistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomDatalistQuery, RoomDatalistQueryVariables>(RoomDatalistDocument, options);
      }
export function useRoomDatalistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomDatalistQuery, RoomDatalistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomDatalistQuery, RoomDatalistQueryVariables>(RoomDatalistDocument, options);
        }
export type RoomDatalistQueryHookResult = ReturnType<typeof useRoomDatalistQuery>;
export type RoomDatalistLazyQueryHookResult = ReturnType<typeof useRoomDatalistLazyQuery>;
export type RoomDatalistQueryResult = Apollo.QueryResult<RoomDatalistQuery, RoomDatalistQueryVariables>;
export const AccommodationInvestmentMaintenanceFormDocument = gql`
    query AccommodationInvestmentMaintenanceForm($where: AccommodationWorkInvestmentFilterInput, $sort: [AccommodationWorkInvestmentSortInput!], $skip: Int, $take: Int) {
  accommodationWorkInvestments {
    items(where: $where, skip: $skip, take: $take, order: $sort) {
      id
      name
      total
      startDate
    }
  }
}
    `;

/**
 * __useAccommodationInvestmentMaintenanceFormQuery__
 *
 * To run a query within a React component, call `useAccommodationInvestmentMaintenanceFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationInvestmentMaintenanceFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationInvestmentMaintenanceFormQuery({
 *   variables: {
 *      where: // value for 'where'
 *      sort: // value for 'sort'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useAccommodationInvestmentMaintenanceFormQuery(baseOptions?: Apollo.QueryHookOptions<AccommodationInvestmentMaintenanceFormQuery, AccommodationInvestmentMaintenanceFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccommodationInvestmentMaintenanceFormQuery, AccommodationInvestmentMaintenanceFormQueryVariables>(AccommodationInvestmentMaintenanceFormDocument, options);
      }
export function useAccommodationInvestmentMaintenanceFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccommodationInvestmentMaintenanceFormQuery, AccommodationInvestmentMaintenanceFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccommodationInvestmentMaintenanceFormQuery, AccommodationInvestmentMaintenanceFormQueryVariables>(AccommodationInvestmentMaintenanceFormDocument, options);
        }
export type AccommodationInvestmentMaintenanceFormQueryHookResult = ReturnType<typeof useAccommodationInvestmentMaintenanceFormQuery>;
export type AccommodationInvestmentMaintenanceFormLazyQueryHookResult = ReturnType<typeof useAccommodationInvestmentMaintenanceFormLazyQuery>;
export type AccommodationInvestmentMaintenanceFormQueryResult = Apollo.QueryResult<AccommodationInvestmentMaintenanceFormQuery, AccommodationInvestmentMaintenanceFormQueryVariables>;
export const RoomMaintenanceFormDocument = gql`
    query RoomMaintenanceForm($where: RoomFilterInput, $order: [RoomSortInput!], $skip: Int, $take: Int) {
  rooms {
    items(where: $where, skip: $skip, take: $take, order: $order) {
      id
      roomType {
        id
        name
        color
      }
      name
    }
  }
}
    `;

/**
 * __useRoomMaintenanceFormQuery__
 *
 * To run a query within a React component, call `useRoomMaintenanceFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomMaintenanceFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomMaintenanceFormQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useRoomMaintenanceFormQuery(baseOptions?: Apollo.QueryHookOptions<RoomMaintenanceFormQuery, RoomMaintenanceFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomMaintenanceFormQuery, RoomMaintenanceFormQueryVariables>(RoomMaintenanceFormDocument, options);
      }
export function useRoomMaintenanceFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomMaintenanceFormQuery, RoomMaintenanceFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomMaintenanceFormQuery, RoomMaintenanceFormQueryVariables>(RoomMaintenanceFormDocument, options);
        }
export type RoomMaintenanceFormQueryHookResult = ReturnType<typeof useRoomMaintenanceFormQuery>;
export type RoomMaintenanceFormLazyQueryHookResult = ReturnType<typeof useRoomMaintenanceFormLazyQuery>;
export type RoomMaintenanceFormQueryResult = Apollo.QueryResult<RoomMaintenanceFormQuery, RoomMaintenanceFormQueryVariables>;
export const AccommodationMaintenanceTypeDatalistDocument = gql`
    query AccommodationMaintenanceTypeDatalist($where: AccommodationMaintenanceTypeFilterInput, $order: [AccommodationMaintenanceTypeSortInput!], $skip: Int, $take: Int) {
  accommodationMaintenanceTypes {
    items(where: $where, order: $order, skip: $skip, take: $take) {
      name
      id
      logs {
        any
      }
    }
    count(where: $where)
  }
}
    `;

/**
 * __useAccommodationMaintenanceTypeDatalistQuery__
 *
 * To run a query within a React component, call `useAccommodationMaintenanceTypeDatalistQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationMaintenanceTypeDatalistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationMaintenanceTypeDatalistQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useAccommodationMaintenanceTypeDatalistQuery(baseOptions?: Apollo.QueryHookOptions<AccommodationMaintenanceTypeDatalistQuery, AccommodationMaintenanceTypeDatalistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccommodationMaintenanceTypeDatalistQuery, AccommodationMaintenanceTypeDatalistQueryVariables>(AccommodationMaintenanceTypeDatalistDocument, options);
      }
export function useAccommodationMaintenanceTypeDatalistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccommodationMaintenanceTypeDatalistQuery, AccommodationMaintenanceTypeDatalistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccommodationMaintenanceTypeDatalistQuery, AccommodationMaintenanceTypeDatalistQueryVariables>(AccommodationMaintenanceTypeDatalistDocument, options);
        }
export type AccommodationMaintenanceTypeDatalistQueryHookResult = ReturnType<typeof useAccommodationMaintenanceTypeDatalistQuery>;
export type AccommodationMaintenanceTypeDatalistLazyQueryHookResult = ReturnType<typeof useAccommodationMaintenanceTypeDatalistLazyQuery>;
export type AccommodationMaintenanceTypeDatalistQueryResult = Apollo.QueryResult<AccommodationMaintenanceTypeDatalistQuery, AccommodationMaintenanceTypeDatalistQueryVariables>;
export const AccommodationMaintenanceTypeFromDataDocument = gql`
    query AccommodationMaintenanceTypeFromData($id: Int!) {
  accommodationMaintenanceType(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useAccommodationMaintenanceTypeFromDataQuery__
 *
 * To run a query within a React component, call `useAccommodationMaintenanceTypeFromDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationMaintenanceTypeFromDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationMaintenanceTypeFromDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccommodationMaintenanceTypeFromDataQuery(baseOptions: Apollo.QueryHookOptions<AccommodationMaintenanceTypeFromDataQuery, AccommodationMaintenanceTypeFromDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccommodationMaintenanceTypeFromDataQuery, AccommodationMaintenanceTypeFromDataQueryVariables>(AccommodationMaintenanceTypeFromDataDocument, options);
      }
export function useAccommodationMaintenanceTypeFromDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccommodationMaintenanceTypeFromDataQuery, AccommodationMaintenanceTypeFromDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccommodationMaintenanceTypeFromDataQuery, AccommodationMaintenanceTypeFromDataQueryVariables>(AccommodationMaintenanceTypeFromDataDocument, options);
        }
export type AccommodationMaintenanceTypeFromDataQueryHookResult = ReturnType<typeof useAccommodationMaintenanceTypeFromDataQuery>;
export type AccommodationMaintenanceTypeFromDataLazyQueryHookResult = ReturnType<typeof useAccommodationMaintenanceTypeFromDataLazyQuery>;
export type AccommodationMaintenanceTypeFromDataQueryResult = Apollo.QueryResult<AccommodationMaintenanceTypeFromDataQuery, AccommodationMaintenanceTypeFromDataQueryVariables>;
export const AccommodationMaintenanceTypeFromDocument = gql`
    mutation AccommodationMaintenanceTypeFrom($model: AccommodationMaintenanceTypeInput!) {
  accommodationMaintenanceType(model: $model) {
    id
    name
  }
}
    `;
export type AccommodationMaintenanceTypeFromMutationFn = Apollo.MutationFunction<AccommodationMaintenanceTypeFromMutation, AccommodationMaintenanceTypeFromMutationVariables>;

/**
 * __useAccommodationMaintenanceTypeFromMutation__
 *
 * To run a mutation, you first call `useAccommodationMaintenanceTypeFromMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccommodationMaintenanceTypeFromMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accommodationMaintenanceTypeFromMutation, { data, loading, error }] = useAccommodationMaintenanceTypeFromMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useAccommodationMaintenanceTypeFromMutation(baseOptions?: Apollo.MutationHookOptions<AccommodationMaintenanceTypeFromMutation, AccommodationMaintenanceTypeFromMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccommodationMaintenanceTypeFromMutation, AccommodationMaintenanceTypeFromMutationVariables>(AccommodationMaintenanceTypeFromDocument, options);
      }
export type AccommodationMaintenanceTypeFromMutationHookResult = ReturnType<typeof useAccommodationMaintenanceTypeFromMutation>;
export type AccommodationMaintenanceTypeFromMutationResult = Apollo.MutationResult<AccommodationMaintenanceTypeFromMutation>;
export type AccommodationMaintenanceTypeFromMutationOptions = Apollo.BaseMutationOptions<AccommodationMaintenanceTypeFromMutation, AccommodationMaintenanceTypeFromMutationVariables>;
export const FruitDatalistDocument = gql`
    query FruitDatalist($where: FruitFilterInput, $order: [FruitSortInput!], $skip: Int, $take: Int) {
  fruits {
    items(where: $where, order: $order, skip: $skip, take: $take) {
      id
      name
    }
  }
}
    `;

/**
 * __useFruitDatalistQuery__
 *
 * To run a query within a React component, call `useFruitDatalistQuery` and pass it any options that fit your needs.
 * When your component renders, `useFruitDatalistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFruitDatalistQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useFruitDatalistQuery(baseOptions?: Apollo.QueryHookOptions<FruitDatalistQuery, FruitDatalistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FruitDatalistQuery, FruitDatalistQueryVariables>(FruitDatalistDocument, options);
      }
export function useFruitDatalistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FruitDatalistQuery, FruitDatalistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FruitDatalistQuery, FruitDatalistQueryVariables>(FruitDatalistDocument, options);
        }
export type FruitDatalistQueryHookResult = ReturnType<typeof useFruitDatalistQuery>;
export type FruitDatalistLazyQueryHookResult = ReturnType<typeof useFruitDatalistLazyQuery>;
export type FruitDatalistQueryResult = Apollo.QueryResult<FruitDatalistQuery, FruitDatalistQueryVariables>;
export const SaveFruitDocument = gql`
    mutation SaveFruit($model: FruitInput!) {
  fruit(model: $model) {
    id
    name
  }
}
    `;
export type SaveFruitMutationFn = Apollo.MutationFunction<SaveFruitMutation, SaveFruitMutationVariables>;

/**
 * __useSaveFruitMutation__
 *
 * To run a mutation, you first call `useSaveFruitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFruitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFruitMutation, { data, loading, error }] = useSaveFruitMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useSaveFruitMutation(baseOptions?: Apollo.MutationHookOptions<SaveFruitMutation, SaveFruitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFruitMutation, SaveFruitMutationVariables>(SaveFruitDocument, options);
      }
export type SaveFruitMutationHookResult = ReturnType<typeof useSaveFruitMutation>;
export type SaveFruitMutationResult = Apollo.MutationResult<SaveFruitMutation>;
export type SaveFruitMutationOptions = Apollo.BaseMutationOptions<SaveFruitMutation, SaveFruitMutationVariables>;
export const GetFruitsAllDocument = gql`
    query getFruitsAll {
  fruits {
    items {
      id
      name
    }
  }
}
    `;

/**
 * __useGetFruitsAllQuery__
 *
 * To run a query within a React component, call `useGetFruitsAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFruitsAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFruitsAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFruitsAllQuery(baseOptions?: Apollo.QueryHookOptions<GetFruitsAllQuery, GetFruitsAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFruitsAllQuery, GetFruitsAllQueryVariables>(GetFruitsAllDocument, options);
      }
export function useGetFruitsAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFruitsAllQuery, GetFruitsAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFruitsAllQuery, GetFruitsAllQueryVariables>(GetFruitsAllDocument, options);
        }
export type GetFruitsAllQueryHookResult = ReturnType<typeof useGetFruitsAllQuery>;
export type GetFruitsAllLazyQueryHookResult = ReturnType<typeof useGetFruitsAllLazyQuery>;
export type GetFruitsAllQueryResult = Apollo.QueryResult<GetFruitsAllQuery, GetFruitsAllQueryVariables>;
export const TagsDocument = gql`
    query Tags($where: PersonTagFilterInput, $order: [PersonTagSortInput!], $skip: Int, $take: Int) {
  personTags {
    items(where: $where, order: $order, skip: $skip, take: $take) {
      id
      name
    }
  }
}
    `;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const WalletDatalistPageDocument = gql`
    query WalletDatalistPage($where: WalletFilterInput, $sort: [WalletSortInput!], $take: Int, $skip: Int) {
  wallets {
    items(where: $where, order: $sort, skip: $skip, take: $take) {
      person {
        name
      }
      id
      name
      balance
      archived
    }
    count(where: $where)
  }
}
    `;

/**
 * __useWalletDatalistPageQuery__
 *
 * To run a query within a React component, call `useWalletDatalistPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletDatalistPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletDatalistPageQuery({
 *   variables: {
 *      where: // value for 'where'
 *      sort: // value for 'sort'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useWalletDatalistPageQuery(baseOptions?: Apollo.QueryHookOptions<WalletDatalistPageQuery, WalletDatalistPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletDatalistPageQuery, WalletDatalistPageQueryVariables>(WalletDatalistPageDocument, options);
      }
export function useWalletDatalistPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletDatalistPageQuery, WalletDatalistPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletDatalistPageQuery, WalletDatalistPageQueryVariables>(WalletDatalistPageDocument, options);
        }
export type WalletDatalistPageQueryHookResult = ReturnType<typeof useWalletDatalistPageQuery>;
export type WalletDatalistPageLazyQueryHookResult = ReturnType<typeof useWalletDatalistPageLazyQuery>;
export type WalletDatalistPageQueryResult = Apollo.QueryResult<WalletDatalistPageQuery, WalletDatalistPageQueryVariables>;
export const WalletDropdownDocument = gql`
    query WalletDropdown($where: WalletFilterInput, $sort: [WalletSortInput!], $take: Int, $skip: Int) {
  wallets {
    items(where: $where, order: $sort, skip: $skip, take: $take) {
      id
      name
      balance
    }
    count(where: $where)
  }
}
    `;

/**
 * __useWalletDropdownQuery__
 *
 * To run a query within a React component, call `useWalletDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletDropdownQuery({
 *   variables: {
 *      where: // value for 'where'
 *      sort: // value for 'sort'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useWalletDropdownQuery(baseOptions?: Apollo.QueryHookOptions<WalletDropdownQuery, WalletDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletDropdownQuery, WalletDropdownQueryVariables>(WalletDropdownDocument, options);
      }
export function useWalletDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletDropdownQuery, WalletDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletDropdownQuery, WalletDropdownQueryVariables>(WalletDropdownDocument, options);
        }
export type WalletDropdownQueryHookResult = ReturnType<typeof useWalletDropdownQuery>;
export type WalletDropdownLazyQueryHookResult = ReturnType<typeof useWalletDropdownLazyQuery>;
export type WalletDropdownQueryResult = Apollo.QueryResult<WalletDropdownQuery, WalletDropdownQueryVariables>;
export const GetTransactionsDataListDocument = gql`
    query GetTransactionsDataList($where: WalletTransactionFilterInput, $take: Int, $skip: Int, $sort: [WalletTransactionSortInput!]) {
  walletTransactions {
    items(where: $where, skip: $skip, take: $take, order: $sort) {
      walletId
      id
      amount
      transactionDate
      transactionId
      note
    }
    count(where: $where)
    amountSum(where: $where)
  }
}
    `;

/**
 * __useGetTransactionsDataListQuery__
 *
 * To run a query within a React component, call `useGetTransactionsDataListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsDataListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsDataListQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetTransactionsDataListQuery(baseOptions?: Apollo.QueryHookOptions<GetTransactionsDataListQuery, GetTransactionsDataListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionsDataListQuery, GetTransactionsDataListQueryVariables>(GetTransactionsDataListDocument, options);
      }
export function useGetTransactionsDataListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionsDataListQuery, GetTransactionsDataListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionsDataListQuery, GetTransactionsDataListQueryVariables>(GetTransactionsDataListDocument, options);
        }
export type GetTransactionsDataListQueryHookResult = ReturnType<typeof useGetTransactionsDataListQuery>;
export type GetTransactionsDataListLazyQueryHookResult = ReturnType<typeof useGetTransactionsDataListLazyQuery>;
export type GetTransactionsDataListQueryResult = Apollo.QueryResult<GetTransactionsDataListQuery, GetTransactionsDataListQueryVariables>;
export const SaveWalletTransactionDocument = gql`
    mutation SaveWalletTransaction($model: WalletTransactionInput!) {
  walletTransaction(model: $model) {
    id
  }
}
    `;
export type SaveWalletTransactionMutationFn = Apollo.MutationFunction<SaveWalletTransactionMutation, SaveWalletTransactionMutationVariables>;

/**
 * __useSaveWalletTransactionMutation__
 *
 * To run a mutation, you first call `useSaveWalletTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveWalletTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveWalletTransactionMutation, { data, loading, error }] = useSaveWalletTransactionMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useSaveWalletTransactionMutation(baseOptions?: Apollo.MutationHookOptions<SaveWalletTransactionMutation, SaveWalletTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveWalletTransactionMutation, SaveWalletTransactionMutationVariables>(SaveWalletTransactionDocument, options);
      }
export type SaveWalletTransactionMutationHookResult = ReturnType<typeof useSaveWalletTransactionMutation>;
export type SaveWalletTransactionMutationResult = Apollo.MutationResult<SaveWalletTransactionMutation>;
export type SaveWalletTransactionMutationOptions = Apollo.BaseMutationOptions<SaveWalletTransactionMutation, SaveWalletTransactionMutationVariables>;
export const GetTransactionsViewDocument = gql`
    query GetTransactionsView($id: Int!) {
  walletTransaction(id: $id) {
    walletId
    id
    amount
    transactionDate
    transactionId
    note
  }
}
    `;

/**
 * __useGetTransactionsViewQuery__
 *
 * To run a query within a React component, call `useGetTransactionsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTransactionsViewQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionsViewQuery, GetTransactionsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionsViewQuery, GetTransactionsViewQueryVariables>(GetTransactionsViewDocument, options);
      }
export function useGetTransactionsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionsViewQuery, GetTransactionsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionsViewQuery, GetTransactionsViewQueryVariables>(GetTransactionsViewDocument, options);
        }
export type GetTransactionsViewQueryHookResult = ReturnType<typeof useGetTransactionsViewQuery>;
export type GetTransactionsViewLazyQueryHookResult = ReturnType<typeof useGetTransactionsViewLazyQuery>;
export type GetTransactionsViewQueryResult = Apollo.QueryResult<GetTransactionsViewQuery, GetTransactionsViewQueryVariables>;
export const SaveSeasonMutationDocument = gql`
    mutation saveSeasonMutation($model: SeasonInput!) {
  season(model: $model) {
    name
    id
    active
  }
}
    `;
export type SaveSeasonMutationMutationFn = Apollo.MutationFunction<SaveSeasonMutationMutation, SaveSeasonMutationMutationVariables>;

/**
 * __useSaveSeasonMutationMutation__
 *
 * To run a mutation, you first call `useSaveSeasonMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSeasonMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSeasonMutationMutation, { data, loading, error }] = useSaveSeasonMutationMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useSaveSeasonMutationMutation(baseOptions?: Apollo.MutationHookOptions<SaveSeasonMutationMutation, SaveSeasonMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSeasonMutationMutation, SaveSeasonMutationMutationVariables>(SaveSeasonMutationDocument, options);
      }
export type SaveSeasonMutationMutationHookResult = ReturnType<typeof useSaveSeasonMutationMutation>;
export type SaveSeasonMutationMutationResult = Apollo.MutationResult<SaveSeasonMutationMutation>;
export type SaveSeasonMutationMutationOptions = Apollo.BaseMutationOptions<SaveSeasonMutationMutation, SaveSeasonMutationMutationVariables>;
export const WorkDatalistDocument = gql`
    query WorkDatalist($where: WorkFilterInput, $skip: Int, $take: Int, $order: [WorkSortInput!]) {
  works {
    count(where: $where)
    items(where: $where, skip: $skip, take: $take, order: $order) {
      id
      name
      startDate
      endDate
      season {
        name
      }
      category
    }
  }
}
    `;

/**
 * __useWorkDatalistQuery__
 *
 * To run a query within a React component, call `useWorkDatalistQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkDatalistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkDatalistQuery({
 *   variables: {
 *      where: // value for 'where'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useWorkDatalistQuery(baseOptions?: Apollo.QueryHookOptions<WorkDatalistQuery, WorkDatalistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkDatalistQuery, WorkDatalistQueryVariables>(WorkDatalistDocument, options);
      }
export function useWorkDatalistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkDatalistQuery, WorkDatalistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkDatalistQuery, WorkDatalistQueryVariables>(WorkDatalistDocument, options);
        }
export type WorkDatalistQueryHookResult = ReturnType<typeof useWorkDatalistQuery>;
export type WorkDatalistLazyQueryHookResult = ReturnType<typeof useWorkDatalistLazyQuery>;
export type WorkDatalistQueryResult = Apollo.QueryResult<WorkDatalistQuery, WorkDatalistQueryVariables>;
export const WorkerDatalistDocument = gql`
    query WorkerDatalist($where: WorkerFilterInput, $skip: Int, $take: Int, $order: [WorkerSortInput!]) {
  workers {
    count(where: $where)
    priceSum(where: $where)
    items(where: $where, skip: $skip, take: $take, order: $order) {
      work {
        name
        startDate
        endDate
        season {
          name
        }
        category
      }
      id
      price
    }
  }
}
    `;

/**
 * __useWorkerDatalistQuery__
 *
 * To run a query within a React component, call `useWorkerDatalistQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkerDatalistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkerDatalistQuery({
 *   variables: {
 *      where: // value for 'where'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useWorkerDatalistQuery(baseOptions?: Apollo.QueryHookOptions<WorkerDatalistQuery, WorkerDatalistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkerDatalistQuery, WorkerDatalistQueryVariables>(WorkerDatalistDocument, options);
      }
export function useWorkerDatalistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkerDatalistQuery, WorkerDatalistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkerDatalistQuery, WorkerDatalistQueryVariables>(WorkerDatalistDocument, options);
        }
export type WorkerDatalistQueryHookResult = ReturnType<typeof useWorkerDatalistQuery>;
export type WorkerDatalistLazyQueryHookResult = ReturnType<typeof useWorkerDatalistLazyQuery>;
export type WorkerDatalistQueryResult = Apollo.QueryResult<WorkerDatalistQuery, WorkerDatalistQueryVariables>;
export const SaleTemplateDatalistDocument = gql`
    query SaleTemplateDatalist($where: SaleTemplateFilterInput, $order: [SaleTemplateSortInput!], $skip: Int, $take: Int) {
  saleTemplates {
    items(where: $where, order: $order, skip: $skip, take: $take) {
      id
      name
    }
  }
}
    `;

/**
 * __useSaleTemplateDatalistQuery__
 *
 * To run a query within a React component, call `useSaleTemplateDatalistQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaleTemplateDatalistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaleTemplateDatalistQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useSaleTemplateDatalistQuery(baseOptions?: Apollo.QueryHookOptions<SaleTemplateDatalistQuery, SaleTemplateDatalistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaleTemplateDatalistQuery, SaleTemplateDatalistQueryVariables>(SaleTemplateDatalistDocument, options);
      }
export function useSaleTemplateDatalistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaleTemplateDatalistQuery, SaleTemplateDatalistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaleTemplateDatalistQuery, SaleTemplateDatalistQueryVariables>(SaleTemplateDatalistDocument, options);
        }
export type SaleTemplateDatalistQueryHookResult = ReturnType<typeof useSaleTemplateDatalistQuery>;
export type SaleTemplateDatalistLazyQueryHookResult = ReturnType<typeof useSaleTemplateDatalistLazyQuery>;
export type SaleTemplateDatalistQueryResult = Apollo.QueryResult<SaleTemplateDatalistQuery, SaleTemplateDatalistQueryVariables>;
export const HarvestTemplateDatalistDocument = gql`
    query HarvestTemplateDatalist($where: HarvestAgricultureWorkTemplateFilterInput, $order: [HarvestAgricultureWorkTemplateSortInput!], $take: Int, $skip: Int) {
  harvestAgricultureWorkTemplates {
    items(where: $where, order: $order, take: $take, skip: $skip) {
      id
      name
    }
  }
}
    `;

/**
 * __useHarvestTemplateDatalistQuery__
 *
 * To run a query within a React component, call `useHarvestTemplateDatalistQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestTemplateDatalistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestTemplateDatalistQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useHarvestTemplateDatalistQuery(baseOptions?: Apollo.QueryHookOptions<HarvestTemplateDatalistQuery, HarvestTemplateDatalistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HarvestTemplateDatalistQuery, HarvestTemplateDatalistQueryVariables>(HarvestTemplateDatalistDocument, options);
      }
export function useHarvestTemplateDatalistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestTemplateDatalistQuery, HarvestTemplateDatalistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HarvestTemplateDatalistQuery, HarvestTemplateDatalistQueryVariables>(HarvestTemplateDatalistDocument, options);
        }
export type HarvestTemplateDatalistQueryHookResult = ReturnType<typeof useHarvestTemplateDatalistQuery>;
export type HarvestTemplateDatalistLazyQueryHookResult = ReturnType<typeof useHarvestTemplateDatalistLazyQuery>;
export type HarvestTemplateDatalistQueryResult = Apollo.QueryResult<HarvestTemplateDatalistQuery, HarvestTemplateDatalistQueryVariables>;
export const BookingAttachmentsDocument = gql`
    query bookingAttachments($take: Int, $skip: Int, $filter: BookingAttachmentFilterInput, $order: [BookingAttachmentSortInput!]) {
  bookingAttachments {
    items(take: $take, skip: $skip, where: $filter, order: $order) {
      id
      name
      contentType
      bookingId
    }
    count(where: $filter)
  }
}
    `;

/**
 * __useBookingAttachmentsQuery__
 *
 * To run a query within a React component, call `useBookingAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingAttachmentsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useBookingAttachmentsQuery(baseOptions?: Apollo.QueryHookOptions<BookingAttachmentsQuery, BookingAttachmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingAttachmentsQuery, BookingAttachmentsQueryVariables>(BookingAttachmentsDocument, options);
      }
export function useBookingAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingAttachmentsQuery, BookingAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingAttachmentsQuery, BookingAttachmentsQueryVariables>(BookingAttachmentsDocument, options);
        }
export type BookingAttachmentsQueryHookResult = ReturnType<typeof useBookingAttachmentsQuery>;
export type BookingAttachmentsLazyQueryHookResult = ReturnType<typeof useBookingAttachmentsLazyQuery>;
export type BookingAttachmentsQueryResult = Apollo.QueryResult<BookingAttachmentsQuery, BookingAttachmentsQueryVariables>;
export const BookingFormDataDocument = gql`
    query BookingFormData($id: Int, $roomTypeId: Int) {
  booking(id: $id) {
    person {
      name
      id
    }
    season {
      id
      name
      active
    }
    roomType {
      color
      defaultPrice
      name
      id
    }
    preferredRoomId
    isCancelled
    isNoShowCancellation
    cancelledDate
    nights
    guestCount
    children
    total
    incomeId
    paidAmount
    note
    channel {
      channel {
        commission
        type
        name
        id
      }
      total
      id
      externalReference
      isCancelled
    }
    id
    outDate
    preferredRoom {
      roomTypeId
      name
      id
    }
    inDate
    details {
      items {
        room {
          roomTypeId
          name
          id
        }
        price
        date
        id
      }
    }
    additionalCharge {
      items {
        amount
        date
        name
        id
      }
    }
  }
  rooms {
    items {
      name
      id
      roomType {
        color
        defaultPrice
        name
        id
      }
    }
  }
  season(where: {active: {eq: true}}) {
    name
    id
    active
  }
  personTag(where: {name: {eq: "Gost"}}) {
    name
    id
  }
  roomType(id: $roomTypeId) {
    id
    defaultPrice
    name
    color
  }
}
    `;

/**
 * __useBookingFormDataQuery__
 *
 * To run a query within a React component, call `useBookingFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingFormDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      roomTypeId: // value for 'roomTypeId'
 *   },
 * });
 */
export function useBookingFormDataQuery(baseOptions?: Apollo.QueryHookOptions<BookingFormDataQuery, BookingFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingFormDataQuery, BookingFormDataQueryVariables>(BookingFormDataDocument, options);
      }
export function useBookingFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingFormDataQuery, BookingFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingFormDataQuery, BookingFormDataQueryVariables>(BookingFormDataDocument, options);
        }
export type BookingFormDataQueryHookResult = ReturnType<typeof useBookingFormDataQuery>;
export type BookingFormDataLazyQueryHookResult = ReturnType<typeof useBookingFormDataLazyQuery>;
export type BookingFormDataQueryResult = Apollo.QueryResult<BookingFormDataQuery, BookingFormDataQueryVariables>;
export const BookingChannelFormDataDocument = gql`
    query BookingChannelFormData($id: Int) {
  bookingChannel(id: $id) {
    commission
    type
    name
    color
    id
    roomTypeDefultPrices {
      items {
        roomType {
          id
          color
          name
        }
        defaultPrice
        id
      }
    }
  }
  roomTypes {
    items {
      name
      defaultPrice
      color
      id
    }
  }
}
    `;

/**
 * __useBookingChannelFormDataQuery__
 *
 * To run a query within a React component, call `useBookingChannelFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingChannelFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingChannelFormDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingChannelFormDataQuery(baseOptions?: Apollo.QueryHookOptions<BookingChannelFormDataQuery, BookingChannelFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingChannelFormDataQuery, BookingChannelFormDataQueryVariables>(BookingChannelFormDataDocument, options);
      }
export function useBookingChannelFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingChannelFormDataQuery, BookingChannelFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingChannelFormDataQuery, BookingChannelFormDataQueryVariables>(BookingChannelFormDataDocument, options);
        }
export type BookingChannelFormDataQueryHookResult = ReturnType<typeof useBookingChannelFormDataQuery>;
export type BookingChannelFormDataLazyQueryHookResult = ReturnType<typeof useBookingChannelFormDataLazyQuery>;
export type BookingChannelFormDataQueryResult = Apollo.QueryResult<BookingChannelFormDataQuery, BookingChannelFormDataQueryVariables>;
export const SaveBookingChannelDocument = gql`
    mutation SaveBookingChannel($model: BookingChannelInput!) {
  bookingChannel(model: $model) {
    id
  }
}
    `;
export type SaveBookingChannelMutationFn = Apollo.MutationFunction<SaveBookingChannelMutation, SaveBookingChannelMutationVariables>;

/**
 * __useSaveBookingChannelMutation__
 *
 * To run a mutation, you first call `useSaveBookingChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBookingChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBookingChannelMutation, { data, loading, error }] = useSaveBookingChannelMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useSaveBookingChannelMutation(baseOptions?: Apollo.MutationHookOptions<SaveBookingChannelMutation, SaveBookingChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBookingChannelMutation, SaveBookingChannelMutationVariables>(SaveBookingChannelDocument, options);
      }
export type SaveBookingChannelMutationHookResult = ReturnType<typeof useSaveBookingChannelMutation>;
export type SaveBookingChannelMutationResult = Apollo.MutationResult<SaveBookingChannelMutation>;
export type SaveBookingChannelMutationOptions = Apollo.BaseMutationOptions<SaveBookingChannelMutation, SaveBookingChannelMutationVariables>;
export const EventTemplateDatalistPageDocument = gql`
    query EventTemplateDatalistPage($where: EventTemplateFilterInput, $order: [EventTemplateSortInput!], $skip: Int, $take: Int) {
  eventTemplates {
    items(order: $order, skip: $skip, take: $take, where: $where) {
      id
      name
      onDay
      repeat
      isSystem
      isActive
      changeDynamicly
      order
      assigneeId
      assignee {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useEventTemplateDatalistPageQuery__
 *
 * To run a query within a React component, call `useEventTemplateDatalistPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventTemplateDatalistPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventTemplateDatalistPageQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useEventTemplateDatalistPageQuery(baseOptions?: Apollo.QueryHookOptions<EventTemplateDatalistPageQuery, EventTemplateDatalistPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventTemplateDatalistPageQuery, EventTemplateDatalistPageQueryVariables>(EventTemplateDatalistPageDocument, options);
      }
export function useEventTemplateDatalistPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventTemplateDatalistPageQuery, EventTemplateDatalistPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventTemplateDatalistPageQuery, EventTemplateDatalistPageQueryVariables>(EventTemplateDatalistPageDocument, options);
        }
export type EventTemplateDatalistPageQueryHookResult = ReturnType<typeof useEventTemplateDatalistPageQuery>;
export type EventTemplateDatalistPageLazyQueryHookResult = ReturnType<typeof useEventTemplateDatalistPageLazyQuery>;
export type EventTemplateDatalistPageQueryResult = Apollo.QueryResult<EventTemplateDatalistPageQuery, EventTemplateDatalistPageQueryVariables>;
export const EventTemplateFormDataDocument = gql`
    query EventTemplateFormData($id: Int) {
  eventTemplate(id: $id) {
    id
    name
    onDay
    repeat
    isSystem
    isActive
    changeDynamicly
    order
    assignee {
      id
      name
    }
  }
}
    `;

/**
 * __useEventTemplateFormDataQuery__
 *
 * To run a query within a React component, call `useEventTemplateFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventTemplateFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventTemplateFormDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventTemplateFormDataQuery(baseOptions?: Apollo.QueryHookOptions<EventTemplateFormDataQuery, EventTemplateFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventTemplateFormDataQuery, EventTemplateFormDataQueryVariables>(EventTemplateFormDataDocument, options);
      }
export function useEventTemplateFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventTemplateFormDataQuery, EventTemplateFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventTemplateFormDataQuery, EventTemplateFormDataQueryVariables>(EventTemplateFormDataDocument, options);
        }
export type EventTemplateFormDataQueryHookResult = ReturnType<typeof useEventTemplateFormDataQuery>;
export type EventTemplateFormDataLazyQueryHookResult = ReturnType<typeof useEventTemplateFormDataLazyQuery>;
export type EventTemplateFormDataQueryResult = Apollo.QueryResult<EventTemplateFormDataQuery, EventTemplateFormDataQueryVariables>;
export const SaveEventTemplateDocument = gql`
    mutation SaveEventTemplate($model: EventTemplateInput!) {
  eventTemplate(model: $model) {
    id
  }
}
    `;
export type SaveEventTemplateMutationFn = Apollo.MutationFunction<SaveEventTemplateMutation, SaveEventTemplateMutationVariables>;

/**
 * __useSaveEventTemplateMutation__
 *
 * To run a mutation, you first call `useSaveEventTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEventTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEventTemplateMutation, { data, loading, error }] = useSaveEventTemplateMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useSaveEventTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SaveEventTemplateMutation, SaveEventTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEventTemplateMutation, SaveEventTemplateMutationVariables>(SaveEventTemplateDocument, options);
      }
export type SaveEventTemplateMutationHookResult = ReturnType<typeof useSaveEventTemplateMutation>;
export type SaveEventTemplateMutationResult = Apollo.MutationResult<SaveEventTemplateMutation>;
export type SaveEventTemplateMutationOptions = Apollo.BaseMutationOptions<SaveEventTemplateMutation, SaveEventTemplateMutationVariables>;
export const RoomTypesFromDataDocument = gql`
    query RoomTypesFromData($id: Int) {
  roomType(id: $id) {
    id
    name
    defaultPrice
    color
    channelDefultPrices {
      items {
        channel {
          id
          name
        }
        defaultPrice
        id
      }
    }
  }
}
    `;

/**
 * __useRoomTypesFromDataQuery__
 *
 * To run a query within a React component, call `useRoomTypesFromDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomTypesFromDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomTypesFromDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoomTypesFromDataQuery(baseOptions?: Apollo.QueryHookOptions<RoomTypesFromDataQuery, RoomTypesFromDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomTypesFromDataQuery, RoomTypesFromDataQueryVariables>(RoomTypesFromDataDocument, options);
      }
export function useRoomTypesFromDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomTypesFromDataQuery, RoomTypesFromDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomTypesFromDataQuery, RoomTypesFromDataQueryVariables>(RoomTypesFromDataDocument, options);
        }
export type RoomTypesFromDataQueryHookResult = ReturnType<typeof useRoomTypesFromDataQuery>;
export type RoomTypesFromDataLazyQueryHookResult = ReturnType<typeof useRoomTypesFromDataLazyQuery>;
export type RoomTypesFromDataQueryResult = Apollo.QueryResult<RoomTypesFromDataQuery, RoomTypesFromDataQueryVariables>;
export const SaveRoomTypeDocument = gql`
    mutation SaveRoomType($model: RoomTypeInput!) {
  roomType(model: $model) {
    id
  }
}
    `;
export type SaveRoomTypeMutationFn = Apollo.MutationFunction<SaveRoomTypeMutation, SaveRoomTypeMutationVariables>;

/**
 * __useSaveRoomTypeMutation__
 *
 * To run a mutation, you first call `useSaveRoomTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveRoomTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveRoomTypeMutation, { data, loading, error }] = useSaveRoomTypeMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useSaveRoomTypeMutation(baseOptions?: Apollo.MutationHookOptions<SaveRoomTypeMutation, SaveRoomTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveRoomTypeMutation, SaveRoomTypeMutationVariables>(SaveRoomTypeDocument, options);
      }
export type SaveRoomTypeMutationHookResult = ReturnType<typeof useSaveRoomTypeMutation>;
export type SaveRoomTypeMutationResult = Apollo.MutationResult<SaveRoomTypeMutation>;
export type SaveRoomTypeMutationOptions = Apollo.BaseMutationOptions<SaveRoomTypeMutation, SaveRoomTypeMutationVariables>;
export const RoomFormDataDocument = gql`
    query RoomFormData($id: Int) {
  room(id: $id) {
    roomType {
      id
      name
      color
    }
    order
    name
    id
  }
}
    `;

/**
 * __useRoomFormDataQuery__
 *
 * To run a query within a React component, call `useRoomFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomFormDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoomFormDataQuery(baseOptions?: Apollo.QueryHookOptions<RoomFormDataQuery, RoomFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomFormDataQuery, RoomFormDataQueryVariables>(RoomFormDataDocument, options);
      }
export function useRoomFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomFormDataQuery, RoomFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomFormDataQuery, RoomFormDataQueryVariables>(RoomFormDataDocument, options);
        }
export type RoomFormDataQueryHookResult = ReturnType<typeof useRoomFormDataQuery>;
export type RoomFormDataLazyQueryHookResult = ReturnType<typeof useRoomFormDataLazyQuery>;
export type RoomFormDataQueryResult = Apollo.QueryResult<RoomFormDataQuery, RoomFormDataQueryVariables>;
export const RoomFormDocument = gql`
    mutation RoomForm($model: RoomInput!) {
  room(model: $model) {
    id
  }
}
    `;
export type RoomFormMutationFn = Apollo.MutationFunction<RoomFormMutation, RoomFormMutationVariables>;

/**
 * __useRoomFormMutation__
 *
 * To run a mutation, you first call `useRoomFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoomFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roomFormMutation, { data, loading, error }] = useRoomFormMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useRoomFormMutation(baseOptions?: Apollo.MutationHookOptions<RoomFormMutation, RoomFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RoomFormMutation, RoomFormMutationVariables>(RoomFormDocument, options);
      }
export type RoomFormMutationHookResult = ReturnType<typeof useRoomFormMutation>;
export type RoomFormMutationResult = Apollo.MutationResult<RoomFormMutation>;
export type RoomFormMutationOptions = Apollo.BaseMutationOptions<RoomFormMutation, RoomFormMutationVariables>;
export const AccommodationInvestmentDatalistPageDocument = gql`
    query AccommodationInvestmentDatalistPage($where: AccommodationWorkInvestmentFilterInput, $sort: [AccommodationWorkInvestmentSortInput!], $skip: Int, $take: Int) {
  accommodationWorkInvestments {
    items(where: $where, skip: $skip, take: $take, order: $sort) {
      id
      name
      startDate
      season {
        name
      }
      unit
      unitPrice
      total
      quantity
      investmentType
    }
    count(where: $where)
    totalSum(where: $where)
  }
}
    `;

/**
 * __useAccommodationInvestmentDatalistPageQuery__
 *
 * To run a query within a React component, call `useAccommodationInvestmentDatalistPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationInvestmentDatalistPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationInvestmentDatalistPageQuery({
 *   variables: {
 *      where: // value for 'where'
 *      sort: // value for 'sort'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useAccommodationInvestmentDatalistPageQuery(baseOptions?: Apollo.QueryHookOptions<AccommodationInvestmentDatalistPageQuery, AccommodationInvestmentDatalistPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccommodationInvestmentDatalistPageQuery, AccommodationInvestmentDatalistPageQueryVariables>(AccommodationInvestmentDatalistPageDocument, options);
      }
export function useAccommodationInvestmentDatalistPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccommodationInvestmentDatalistPageQuery, AccommodationInvestmentDatalistPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccommodationInvestmentDatalistPageQuery, AccommodationInvestmentDatalistPageQueryVariables>(AccommodationInvestmentDatalistPageDocument, options);
        }
export type AccommodationInvestmentDatalistPageQueryHookResult = ReturnType<typeof useAccommodationInvestmentDatalistPageQuery>;
export type AccommodationInvestmentDatalistPageLazyQueryHookResult = ReturnType<typeof useAccommodationInvestmentDatalistPageLazyQuery>;
export type AccommodationInvestmentDatalistPageQueryResult = Apollo.QueryResult<AccommodationInvestmentDatalistPageQuery, AccommodationInvestmentDatalistPageQueryVariables>;
export const AccommodationInvestmentFormPageDocument = gql`
    query AccommodationInvestmentFormPage($id: Int!) {
  accommodationWorkInvestment(id: $id) {
    id
    category
    workers {
      items {
        person {
          id
          name
        }
        id
        price
      }
    }
    startDate
    season {
      id
      name
      active
    }
    note
    name
    unit
    unitPrice
    quantity
    total
    investmentType
  }
  season(where: {active: {eq: true}}) {
    id
    name
    active
  }
}
    `;

/**
 * __useAccommodationInvestmentFormPageQuery__
 *
 * To run a query within a React component, call `useAccommodationInvestmentFormPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationInvestmentFormPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationInvestmentFormPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccommodationInvestmentFormPageQuery(baseOptions: Apollo.QueryHookOptions<AccommodationInvestmentFormPageQuery, AccommodationInvestmentFormPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccommodationInvestmentFormPageQuery, AccommodationInvestmentFormPageQueryVariables>(AccommodationInvestmentFormPageDocument, options);
      }
export function useAccommodationInvestmentFormPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccommodationInvestmentFormPageQuery, AccommodationInvestmentFormPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccommodationInvestmentFormPageQuery, AccommodationInvestmentFormPageQueryVariables>(AccommodationInvestmentFormPageDocument, options);
        }
export type AccommodationInvestmentFormPageQueryHookResult = ReturnType<typeof useAccommodationInvestmentFormPageQuery>;
export type AccommodationInvestmentFormPageLazyQueryHookResult = ReturnType<typeof useAccommodationInvestmentFormPageLazyQuery>;
export type AccommodationInvestmentFormPageQueryResult = Apollo.QueryResult<AccommodationInvestmentFormPageQuery, AccommodationInvestmentFormPageQueryVariables>;
export const AccommodationInvestmentDocument = gql`
    mutation AccommodationInvestment($model: AccommodationWorkInvestmentInput!) {
  accommodationWorkInvestment(model: $model) {
    id
  }
}
    `;
export type AccommodationInvestmentMutationFn = Apollo.MutationFunction<AccommodationInvestmentMutation, AccommodationInvestmentMutationVariables>;

/**
 * __useAccommodationInvestmentMutation__
 *
 * To run a mutation, you first call `useAccommodationInvestmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccommodationInvestmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accommodationInvestmentMutation, { data, loading, error }] = useAccommodationInvestmentMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useAccommodationInvestmentMutation(baseOptions?: Apollo.MutationHookOptions<AccommodationInvestmentMutation, AccommodationInvestmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccommodationInvestmentMutation, AccommodationInvestmentMutationVariables>(AccommodationInvestmentDocument, options);
      }
export type AccommodationInvestmentMutationHookResult = ReturnType<typeof useAccommodationInvestmentMutation>;
export type AccommodationInvestmentMutationResult = Apollo.MutationResult<AccommodationInvestmentMutation>;
export type AccommodationInvestmentMutationOptions = Apollo.BaseMutationOptions<AccommodationInvestmentMutation, AccommodationInvestmentMutationVariables>;
export const AccommodationInvestmentViewPageDocument = gql`
    query AccommodationInvestmentViewPage($id: Int!) {
  accommodationWorkInvestment(id: $id) {
    id
    name
    startDate
    season {
      name
      id
      active
    }
    unit
    unitPrice
    total
    quantity
    investmentType
    category
    type
    note
    workers {
      items {
        person {
          name
          id
        }
      }
    }
  }
}
    `;

/**
 * __useAccommodationInvestmentViewPageQuery__
 *
 * To run a query within a React component, call `useAccommodationInvestmentViewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationInvestmentViewPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationInvestmentViewPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccommodationInvestmentViewPageQuery(baseOptions: Apollo.QueryHookOptions<AccommodationInvestmentViewPageQuery, AccommodationInvestmentViewPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccommodationInvestmentViewPageQuery, AccommodationInvestmentViewPageQueryVariables>(AccommodationInvestmentViewPageDocument, options);
      }
export function useAccommodationInvestmentViewPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccommodationInvestmentViewPageQuery, AccommodationInvestmentViewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccommodationInvestmentViewPageQuery, AccommodationInvestmentViewPageQueryVariables>(AccommodationInvestmentViewPageDocument, options);
        }
export type AccommodationInvestmentViewPageQueryHookResult = ReturnType<typeof useAccommodationInvestmentViewPageQuery>;
export type AccommodationInvestmentViewPageLazyQueryHookResult = ReturnType<typeof useAccommodationInvestmentViewPageLazyQuery>;
export type AccommodationInvestmentViewPageQueryResult = Apollo.QueryResult<AccommodationInvestmentViewPageQuery, AccommodationInvestmentViewPageQueryVariables>;
export const AccommodationMaintenanceDatalistDocument = gql`
    query AccommodationMaintenanceDatalist($where: AccommodationWorkMaintenanceFilterInput, $sort: [AccommodationWorkMaintenanceSortInput!], $skip: Int, $take: Int) {
  accommodationWorkMaintenances {
    items(where: $where, skip: $skip, take: $take, order: $sort) {
      id
      workers {
        count
        priceSum
      }
      season {
        name
      }
      startDate
      endDate
      name
      logs {
        items {
          maintenanceType {
            name
          }
          investment {
            name
          }
          id
        }
      }
    }
    count(where: $where)
  }
}
    `;

/**
 * __useAccommodationMaintenanceDatalistQuery__
 *
 * To run a query within a React component, call `useAccommodationMaintenanceDatalistQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationMaintenanceDatalistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationMaintenanceDatalistQuery({
 *   variables: {
 *      where: // value for 'where'
 *      sort: // value for 'sort'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useAccommodationMaintenanceDatalistQuery(baseOptions?: Apollo.QueryHookOptions<AccommodationMaintenanceDatalistQuery, AccommodationMaintenanceDatalistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccommodationMaintenanceDatalistQuery, AccommodationMaintenanceDatalistQueryVariables>(AccommodationMaintenanceDatalistDocument, options);
      }
export function useAccommodationMaintenanceDatalistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccommodationMaintenanceDatalistQuery, AccommodationMaintenanceDatalistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccommodationMaintenanceDatalistQuery, AccommodationMaintenanceDatalistQueryVariables>(AccommodationMaintenanceDatalistDocument, options);
        }
export type AccommodationMaintenanceDatalistQueryHookResult = ReturnType<typeof useAccommodationMaintenanceDatalistQuery>;
export type AccommodationMaintenanceDatalistLazyQueryHookResult = ReturnType<typeof useAccommodationMaintenanceDatalistLazyQuery>;
export type AccommodationMaintenanceDatalistQueryResult = Apollo.QueryResult<AccommodationMaintenanceDatalistQuery, AccommodationMaintenanceDatalistQueryVariables>;
export const AccommodationMaintenanceFormDocument = gql`
    query AccommodationMaintenanceForm($id: Int!) {
  season(where: {active: {eq: true}}) {
    id
    name
    active
  }
  accommodationWorkMaintenance(id: $id) {
    id
    workers {
      items {
        person {
          id
          name
        }
        price
        id
      }
    }
    season {
      active
      id
      name
    }
    logs {
      items {
        id
        maintenanceType {
          name
          id
        }
        investment {
          id
          name
          investmentType
          unit
          unitPrice
          total
        }
        logRooms {
          items {
            id
            room {
              id
              roomType {
                name
                id
                color
              }
              name
            }
          }
        }
      }
    }
    startDate
    endDate
    note
    name
  }
}
    `;

/**
 * __useAccommodationMaintenanceFormQuery__
 *
 * To run a query within a React component, call `useAccommodationMaintenanceFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationMaintenanceFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationMaintenanceFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccommodationMaintenanceFormQuery(baseOptions: Apollo.QueryHookOptions<AccommodationMaintenanceFormQuery, AccommodationMaintenanceFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccommodationMaintenanceFormQuery, AccommodationMaintenanceFormQueryVariables>(AccommodationMaintenanceFormDocument, options);
      }
export function useAccommodationMaintenanceFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccommodationMaintenanceFormQuery, AccommodationMaintenanceFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccommodationMaintenanceFormQuery, AccommodationMaintenanceFormQueryVariables>(AccommodationMaintenanceFormDocument, options);
        }
export type AccommodationMaintenanceFormQueryHookResult = ReturnType<typeof useAccommodationMaintenanceFormQuery>;
export type AccommodationMaintenanceFormLazyQueryHookResult = ReturnType<typeof useAccommodationMaintenanceFormLazyQuery>;
export type AccommodationMaintenanceFormQueryResult = Apollo.QueryResult<AccommodationMaintenanceFormQuery, AccommodationMaintenanceFormQueryVariables>;
export const SaveAccommodationMaintenanceFormDocument = gql`
    mutation SaveAccommodationMaintenanceForm($model: AccommodationWorkMaintenanceInput!) {
  accommodationWorkMaintenance(model: $model) {
    id
  }
}
    `;
export type SaveAccommodationMaintenanceFormMutationFn = Apollo.MutationFunction<SaveAccommodationMaintenanceFormMutation, SaveAccommodationMaintenanceFormMutationVariables>;

/**
 * __useSaveAccommodationMaintenanceFormMutation__
 *
 * To run a mutation, you first call `useSaveAccommodationMaintenanceFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAccommodationMaintenanceFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAccommodationMaintenanceFormMutation, { data, loading, error }] = useSaveAccommodationMaintenanceFormMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useSaveAccommodationMaintenanceFormMutation(baseOptions?: Apollo.MutationHookOptions<SaveAccommodationMaintenanceFormMutation, SaveAccommodationMaintenanceFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAccommodationMaintenanceFormMutation, SaveAccommodationMaintenanceFormMutationVariables>(SaveAccommodationMaintenanceFormDocument, options);
      }
export type SaveAccommodationMaintenanceFormMutationHookResult = ReturnType<typeof useSaveAccommodationMaintenanceFormMutation>;
export type SaveAccommodationMaintenanceFormMutationResult = Apollo.MutationResult<SaveAccommodationMaintenanceFormMutation>;
export type SaveAccommodationMaintenanceFormMutationOptions = Apollo.BaseMutationOptions<SaveAccommodationMaintenanceFormMutation, SaveAccommodationMaintenanceFormMutationVariables>;
export const AccommodationMaintenanceViewPageDocument = gql`
    query AccommodationMaintenanceViewPage($id: Int!) {
  accommodationWorkMaintenance(id: $id) {
    id
    note
    workers {
      items {
        person {
          name
          id
        }
        date
        price
        id
      }
    }
    season {
      name
      id
    }
    startDate
    endDate
    name
    logs {
      items {
        maintenanceType {
          name
          id
        }
        investment {
          name
          id
          total
          investmentType
          startDate
        }
        id
        logRooms {
          items {
            room {
              roomType {
                color
                name
              }
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAccommodationMaintenanceViewPageQuery__
 *
 * To run a query within a React component, call `useAccommodationMaintenanceViewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationMaintenanceViewPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationMaintenanceViewPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccommodationMaintenanceViewPageQuery(baseOptions: Apollo.QueryHookOptions<AccommodationMaintenanceViewPageQuery, AccommodationMaintenanceViewPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccommodationMaintenanceViewPageQuery, AccommodationMaintenanceViewPageQueryVariables>(AccommodationMaintenanceViewPageDocument, options);
      }
export function useAccommodationMaintenanceViewPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccommodationMaintenanceViewPageQuery, AccommodationMaintenanceViewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccommodationMaintenanceViewPageQuery, AccommodationMaintenanceViewPageQueryVariables>(AccommodationMaintenanceViewPageDocument, options);
        }
export type AccommodationMaintenanceViewPageQueryHookResult = ReturnType<typeof useAccommodationMaintenanceViewPageQuery>;
export type AccommodationMaintenanceViewPageLazyQueryHookResult = ReturnType<typeof useAccommodationMaintenanceViewPageLazyQuery>;
export type AccommodationMaintenanceViewPageQueryResult = Apollo.QueryResult<AccommodationMaintenanceViewPageQuery, AccommodationMaintenanceViewPageQueryVariables>;
export const GetFruitDocument = gql`
    query GetFruit($id: Int) {
  fruit(id: $id) {
    id
    name
    categories {
      items {
        name
        id
      }
    }
    groups {
      items {
        name
        id
      }
    }
  }
}
    `;

/**
 * __useGetFruitQuery__
 *
 * To run a query within a React component, call `useGetFruitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFruitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFruitQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFruitQuery(baseOptions?: Apollo.QueryHookOptions<GetFruitQuery, GetFruitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFruitQuery, GetFruitQueryVariables>(GetFruitDocument, options);
      }
export function useGetFruitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFruitQuery, GetFruitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFruitQuery, GetFruitQueryVariables>(GetFruitDocument, options);
        }
export type GetFruitQueryHookResult = ReturnType<typeof useGetFruitQuery>;
export type GetFruitLazyQueryHookResult = ReturnType<typeof useGetFruitLazyQuery>;
export type GetFruitQueryResult = Apollo.QueryResult<GetFruitQuery, GetFruitQueryVariables>;
export const SaleFormDataDocument = gql`
    query saleFormData($id: Int, $templateId: Int) {
  season(where: {active: {eq: true}}) {
    id
    name
    active
  }
  sale(id: $id) {
    name
    season {
      name
      id
      active
    }
    date
    person {
      name
      id
    }
    wallet {
      name
      id
      balance
    }
    fruit {
      name
      id
    }
    kg
    pricePerKg
    total
    category {
      name
      id
    }
    cartQuantity
    chamber
    type
    note
  }
  saleTemplate(id: $templateId) {
    name
    season {
      name
      id
      active
    }
    date
    person {
      name
      id
    }
    fruit {
      name
      id
    }
    kg
    pricePerKg
    total
    category {
      name
      id
    }
    cartQuantity
    chamber
    type
    note
  }
}
    `;

/**
 * __useSaleFormDataQuery__
 *
 * To run a query within a React component, call `useSaleFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaleFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaleFormDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useSaleFormDataQuery(baseOptions?: Apollo.QueryHookOptions<SaleFormDataQuery, SaleFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaleFormDataQuery, SaleFormDataQueryVariables>(SaleFormDataDocument, options);
      }
export function useSaleFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaleFormDataQuery, SaleFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaleFormDataQuery, SaleFormDataQueryVariables>(SaleFormDataDocument, options);
        }
export type SaleFormDataQueryHookResult = ReturnType<typeof useSaleFormDataQuery>;
export type SaleFormDataLazyQueryHookResult = ReturnType<typeof useSaleFormDataLazyQuery>;
export type SaleFormDataQueryResult = Apollo.QueryResult<SaleFormDataQuery, SaleFormDataQueryVariables>;
export const SaleViewPageDocument = gql`
    query saleViewPage($id: Int) {
  sale(id: $id) {
    id
    name
    date
    kg
    pricePerKg
    total
    person {
      id
      name
      countryCode
      country {
        alpha3Code
        name
        flag
      }
    }
    wallet {
      id
      name
      balance
      archived
    }
    category {
      id
      name
    }
    cartQuantity
    incomeId
    chamber
    note
    type
    fruit {
      name
      id
    }
    season {
      id
      name
    }
  }
}
    `;

/**
 * __useSaleViewPageQuery__
 *
 * To run a query within a React component, call `useSaleViewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaleViewPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaleViewPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaleViewPageQuery(baseOptions?: Apollo.QueryHookOptions<SaleViewPageQuery, SaleViewPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaleViewPageQuery, SaleViewPageQueryVariables>(SaleViewPageDocument, options);
      }
export function useSaleViewPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaleViewPageQuery, SaleViewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaleViewPageQuery, SaleViewPageQueryVariables>(SaleViewPageDocument, options);
        }
export type SaleViewPageQueryHookResult = ReturnType<typeof useSaleViewPageQuery>;
export type SaleViewPageLazyQueryHookResult = ReturnType<typeof useSaleViewPageLazyQuery>;
export type SaleViewPageQueryResult = Apollo.QueryResult<SaleViewPageQuery, SaleViewPageQueryVariables>;
export const HarvestsDatalistDocument = gql`
    query harvestsDatalist($take: Int, $skip: Int, $where: HarvestAgricultureWorkFilterInput, $order: [HarvestAgricultureWorkSortInput!]) {
  harvestAgricultureWorks {
    count(where: $where)
    items(order: $order, skip: $skip, take: $take, where: $where) {
      id
      startDate
      harvests {
        kgSum
        cartQuantitySum
        items {
          id
          fruit {
            name
          }
        }
      }
      season {
        name
        id
      }
      workers {
        count
        priceSum
      }
    }
  }
}
    `;

/**
 * __useHarvestsDatalistQuery__
 *
 * To run a query within a React component, call `useHarvestsDatalistQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestsDatalistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestsDatalistQuery({
 *   variables: {
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useHarvestsDatalistQuery(baseOptions?: Apollo.QueryHookOptions<HarvestsDatalistQuery, HarvestsDatalistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HarvestsDatalistQuery, HarvestsDatalistQueryVariables>(HarvestsDatalistDocument, options);
      }
export function useHarvestsDatalistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestsDatalistQuery, HarvestsDatalistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HarvestsDatalistQuery, HarvestsDatalistQueryVariables>(HarvestsDatalistDocument, options);
        }
export type HarvestsDatalistQueryHookResult = ReturnType<typeof useHarvestsDatalistQuery>;
export type HarvestsDatalistLazyQueryHookResult = ReturnType<typeof useHarvestsDatalistLazyQuery>;
export type HarvestsDatalistQueryResult = Apollo.QueryResult<HarvestsDatalistQuery, HarvestsDatalistQueryVariables>;
export const HarvestFormDataDocument = gql`
    query harvestFormData($id: Int, $templateId: Int) {
  season(where: {active: {eq: true}}) {
    id
    name
    active
  }
  harvestAgricultureWork(id: $id) {
    id
    season {
      id
      name
      active
    }
    startDate
    note
    name
    id
    workers {
      items {
        person {
          id
          name
        }
        id
        price
      }
    }
    harvests {
      items {
        id
        kg
        cartQuantity
        hideFromMultiUpdate
        fruit {
          id
          name
        }
        harvestFruitGroups {
          items {
            id
            fruitGroup {
              id
              name
            }
          }
        }
        harvestFruitCategories {
          items {
            id
            fruitCategory {
              id
              name
            }
          }
        }
      }
    }
  }
  harvestAgricultureWorkTemplate(id: $templateId) {
    id
    season {
      id
      name
      active
    }
    startDate
    note
    name
    workers {
      items {
        person {
          id
          name
        }
        id
        price
      }
    }
    harvests {
      items {
        id
        kg
        cartQuantity
        hideFromMultiUpdate
        fruit {
          id
          name
        }
        harvestFruitGroups {
          items {
            id
            fruitGroup {
              id
              name
            }
          }
        }
        harvestFruitCategories {
          items {
            id
            fruitCategory {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useHarvestFormDataQuery__
 *
 * To run a query within a React component, call `useHarvestFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestFormDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useHarvestFormDataQuery(baseOptions?: Apollo.QueryHookOptions<HarvestFormDataQuery, HarvestFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HarvestFormDataQuery, HarvestFormDataQueryVariables>(HarvestFormDataDocument, options);
      }
export function useHarvestFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestFormDataQuery, HarvestFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HarvestFormDataQuery, HarvestFormDataQueryVariables>(HarvestFormDataDocument, options);
        }
export type HarvestFormDataQueryHookResult = ReturnType<typeof useHarvestFormDataQuery>;
export type HarvestFormDataLazyQueryHookResult = ReturnType<typeof useHarvestFormDataLazyQuery>;
export type HarvestFormDataQueryResult = Apollo.QueryResult<HarvestFormDataQuery, HarvestFormDataQueryVariables>;
export const SaveHarvestDocument = gql`
    mutation SaveHarvest($model: HarvestAgricultureWorkInput!) {
  harvestAgricultureWork(model: $model) {
    id
  }
}
    `;
export type SaveHarvestMutationFn = Apollo.MutationFunction<SaveHarvestMutation, SaveHarvestMutationVariables>;

/**
 * __useSaveHarvestMutation__
 *
 * To run a mutation, you first call `useSaveHarvestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveHarvestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveHarvestMutation, { data, loading, error }] = useSaveHarvestMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useSaveHarvestMutation(baseOptions?: Apollo.MutationHookOptions<SaveHarvestMutation, SaveHarvestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveHarvestMutation, SaveHarvestMutationVariables>(SaveHarvestDocument, options);
      }
export type SaveHarvestMutationHookResult = ReturnType<typeof useSaveHarvestMutation>;
export type SaveHarvestMutationResult = Apollo.MutationResult<SaveHarvestMutation>;
export type SaveHarvestMutationOptions = Apollo.BaseMutationOptions<SaveHarvestMutation, SaveHarvestMutationVariables>;
export const WorkViewPageDocument = gql`
    query workViewPage($id: Int) {
  harvestAgricultureWork(id: $id) {
    id
    startDate
    name
    note
    harvests {
      items {
        id
        kg
        fruit {
          name
          id
        }
        cartQuantity
        hideFromMultiUpdate
        harvestFruitGroups {
          items {
            id
            fruitGroup {
              name
              id
            }
          }
        }
        harvestFruitCategories {
          items {
            id
            fruitCategory {
              id
              name
            }
          }
        }
      }
    }
    season {
      name
      id
    }
    workers {
      count
      priceSum
      items {
        person {
          id
          name
        }
        price
        id
      }
    }
  }
}
    `;

/**
 * __useWorkViewPageQuery__
 *
 * To run a query within a React component, call `useWorkViewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkViewPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkViewPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorkViewPageQuery(baseOptions?: Apollo.QueryHookOptions<WorkViewPageQuery, WorkViewPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkViewPageQuery, WorkViewPageQueryVariables>(WorkViewPageDocument, options);
      }
export function useWorkViewPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkViewPageQuery, WorkViewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkViewPageQuery, WorkViewPageQueryVariables>(WorkViewPageDocument, options);
        }
export type WorkViewPageQueryHookResult = ReturnType<typeof useWorkViewPageQuery>;
export type WorkViewPageLazyQueryHookResult = ReturnType<typeof useWorkViewPageLazyQuery>;
export type WorkViewPageQueryResult = Apollo.QueryResult<WorkViewPageQuery, WorkViewPageQueryVariables>;
export const HarvestMultiUploadDataDocument = gql`
    query harvestMultiUploadData($take: Int, $skip: Int, $where: HarvestFilterInput, $order: [HarvestSortInput!]) {
  harvests {
    count(where: $where)
    items(where: $where, order: $order, skip: $skip, take: $take) {
      fruit {
        name
        id
      }
      harvestFruitCategories {
        items {
          fruitCategory {
            name
          }
        }
      }
      harvestFruitGroups {
        items {
          fruitGroup {
            name
          }
        }
      }
      kg
      cartQuantity
      hideFromMultiUpdate
      id
      work {
        id
        startDate
        season {
          name
          id
        }
        workers {
          count
          priceSum
        }
      }
    }
  }
}
    `;

/**
 * __useHarvestMultiUploadDataQuery__
 *
 * To run a query within a React component, call `useHarvestMultiUploadDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestMultiUploadDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestMultiUploadDataQuery({
 *   variables: {
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useHarvestMultiUploadDataQuery(baseOptions?: Apollo.QueryHookOptions<HarvestMultiUploadDataQuery, HarvestMultiUploadDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HarvestMultiUploadDataQuery, HarvestMultiUploadDataQueryVariables>(HarvestMultiUploadDataDocument, options);
      }
export function useHarvestMultiUploadDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestMultiUploadDataQuery, HarvestMultiUploadDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HarvestMultiUploadDataQuery, HarvestMultiUploadDataQueryVariables>(HarvestMultiUploadDataDocument, options);
        }
export type HarvestMultiUploadDataQueryHookResult = ReturnType<typeof useHarvestMultiUploadDataQuery>;
export type HarvestMultiUploadDataLazyQueryHookResult = ReturnType<typeof useHarvestMultiUploadDataLazyQuery>;
export type HarvestMultiUploadDataQueryResult = Apollo.QueryResult<HarvestMultiUploadDataQuery, HarvestMultiUploadDataQueryVariables>;
export const HarvestMultiUpdateDocument = gql`
    mutation harvestMultiUpdate($data: [HarvestMultiUpdateInput!]!) {
  harvestMultiUpdate(harvests: $data)
}
    `;
export type HarvestMultiUpdateMutationFn = Apollo.MutationFunction<HarvestMultiUpdateMutation, HarvestMultiUpdateMutationVariables>;

/**
 * __useHarvestMultiUpdateMutation__
 *
 * To run a mutation, you first call `useHarvestMultiUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHarvestMultiUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [harvestMultiUpdateMutation, { data, loading, error }] = useHarvestMultiUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useHarvestMultiUpdateMutation(baseOptions?: Apollo.MutationHookOptions<HarvestMultiUpdateMutation, HarvestMultiUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HarvestMultiUpdateMutation, HarvestMultiUpdateMutationVariables>(HarvestMultiUpdateDocument, options);
      }
export type HarvestMultiUpdateMutationHookResult = ReturnType<typeof useHarvestMultiUpdateMutation>;
export type HarvestMultiUpdateMutationResult = Apollo.MutationResult<HarvestMultiUpdateMutation>;
export type HarvestMultiUpdateMutationOptions = Apollo.BaseMutationOptions<HarvestMultiUpdateMutation, HarvestMultiUpdateMutationVariables>;
export const AgricultureWorkInvestmentDatalistDocument = gql`
    query AgricultureWorkInvestmentDatalist($where: AgricultureWorkInvestmentFilterInput, $sort: [AgricultureWorkInvestmentSortInput!], $skip: Int, $take: Int) {
  agricultureWorkInvestments {
    items(where: $where, skip: $skip, take: $take, order: $sort) {
      id
      name
      startDate
      season {
        name
      }
      unit
      unitPrice
      total
      quantity
      investmentType
      workers {
        items {
          person {
            name
          }
        }
      }
    }
    count(where: $where)
    totalSum(where: $where, order: $sort)
  }
}
    `;

/**
 * __useAgricultureWorkInvestmentDatalistQuery__
 *
 * To run a query within a React component, call `useAgricultureWorkInvestmentDatalistQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgricultureWorkInvestmentDatalistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgricultureWorkInvestmentDatalistQuery({
 *   variables: {
 *      where: // value for 'where'
 *      sort: // value for 'sort'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useAgricultureWorkInvestmentDatalistQuery(baseOptions?: Apollo.QueryHookOptions<AgricultureWorkInvestmentDatalistQuery, AgricultureWorkInvestmentDatalistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgricultureWorkInvestmentDatalistQuery, AgricultureWorkInvestmentDatalistQueryVariables>(AgricultureWorkInvestmentDatalistDocument, options);
      }
export function useAgricultureWorkInvestmentDatalistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgricultureWorkInvestmentDatalistQuery, AgricultureWorkInvestmentDatalistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgricultureWorkInvestmentDatalistQuery, AgricultureWorkInvestmentDatalistQueryVariables>(AgricultureWorkInvestmentDatalistDocument, options);
        }
export type AgricultureWorkInvestmentDatalistQueryHookResult = ReturnType<typeof useAgricultureWorkInvestmentDatalistQuery>;
export type AgricultureWorkInvestmentDatalistLazyQueryHookResult = ReturnType<typeof useAgricultureWorkInvestmentDatalistLazyQuery>;
export type AgricultureWorkInvestmentDatalistQueryResult = Apollo.QueryResult<AgricultureWorkInvestmentDatalistQuery, AgricultureWorkInvestmentDatalistQueryVariables>;
export const AgricultureWorkInvestmentFormItemDocument = gql`
    query AgricultureWorkInvestmentFormItem($id: Int!) {
  agricultureWorkInvestment(id: $id) {
    id
    category
    workers {
      items {
        person {
          id
          name
        }
        id
        price
      }
    }
    startDate
    season {
      id
      name
      active
    }
    note
    name
    unit
    unitPrice
    quantity
    total
    investmentType
  }
  season(where: {active: {eq: true}}) {
    id
    name
    active
  }
}
    `;

/**
 * __useAgricultureWorkInvestmentFormItemQuery__
 *
 * To run a query within a React component, call `useAgricultureWorkInvestmentFormItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgricultureWorkInvestmentFormItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgricultureWorkInvestmentFormItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgricultureWorkInvestmentFormItemQuery(baseOptions: Apollo.QueryHookOptions<AgricultureWorkInvestmentFormItemQuery, AgricultureWorkInvestmentFormItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgricultureWorkInvestmentFormItemQuery, AgricultureWorkInvestmentFormItemQueryVariables>(AgricultureWorkInvestmentFormItemDocument, options);
      }
export function useAgricultureWorkInvestmentFormItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgricultureWorkInvestmentFormItemQuery, AgricultureWorkInvestmentFormItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgricultureWorkInvestmentFormItemQuery, AgricultureWorkInvestmentFormItemQueryVariables>(AgricultureWorkInvestmentFormItemDocument, options);
        }
export type AgricultureWorkInvestmentFormItemQueryHookResult = ReturnType<typeof useAgricultureWorkInvestmentFormItemQuery>;
export type AgricultureWorkInvestmentFormItemLazyQueryHookResult = ReturnType<typeof useAgricultureWorkInvestmentFormItemLazyQuery>;
export type AgricultureWorkInvestmentFormItemQueryResult = Apollo.QueryResult<AgricultureWorkInvestmentFormItemQuery, AgricultureWorkInvestmentFormItemQueryVariables>;
export const AgricultureWorkInvestmentDocument = gql`
    mutation AgricultureWorkInvestment($model: AgricultureWorkInvestmentInput!) {
  agricultureWorkInvestment(model: $model) {
    id
  }
}
    `;
export type AgricultureWorkInvestmentMutationFn = Apollo.MutationFunction<AgricultureWorkInvestmentMutation, AgricultureWorkInvestmentMutationVariables>;

/**
 * __useAgricultureWorkInvestmentMutation__
 *
 * To run a mutation, you first call `useAgricultureWorkInvestmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgricultureWorkInvestmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agricultureWorkInvestmentMutation, { data, loading, error }] = useAgricultureWorkInvestmentMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useAgricultureWorkInvestmentMutation(baseOptions?: Apollo.MutationHookOptions<AgricultureWorkInvestmentMutation, AgricultureWorkInvestmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AgricultureWorkInvestmentMutation, AgricultureWorkInvestmentMutationVariables>(AgricultureWorkInvestmentDocument, options);
      }
export type AgricultureWorkInvestmentMutationHookResult = ReturnType<typeof useAgricultureWorkInvestmentMutation>;
export type AgricultureWorkInvestmentMutationResult = Apollo.MutationResult<AgricultureWorkInvestmentMutation>;
export type AgricultureWorkInvestmentMutationOptions = Apollo.BaseMutationOptions<AgricultureWorkInvestmentMutation, AgricultureWorkInvestmentMutationVariables>;
export const AgricultureWorkInvestmentViewDocument = gql`
    query AgricultureWorkInvestmentView($id: Int!) {
  agricultureWorkInvestment(id: $id) {
    id
    name
    startDate
    season {
      name
      id
      active
    }
    unit
    unitPrice
    total
    quantity
    investmentType
    category
    type
    note
    workers {
      items {
        person {
          name
          id
        }
      }
    }
  }
}
    `;

/**
 * __useAgricultureWorkInvestmentViewQuery__
 *
 * To run a query within a React component, call `useAgricultureWorkInvestmentViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgricultureWorkInvestmentViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgricultureWorkInvestmentViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgricultureWorkInvestmentViewQuery(baseOptions: Apollo.QueryHookOptions<AgricultureWorkInvestmentViewQuery, AgricultureWorkInvestmentViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgricultureWorkInvestmentViewQuery, AgricultureWorkInvestmentViewQueryVariables>(AgricultureWorkInvestmentViewDocument, options);
      }
export function useAgricultureWorkInvestmentViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgricultureWorkInvestmentViewQuery, AgricultureWorkInvestmentViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgricultureWorkInvestmentViewQuery, AgricultureWorkInvestmentViewQueryVariables>(AgricultureWorkInvestmentViewDocument, options);
        }
export type AgricultureWorkInvestmentViewQueryHookResult = ReturnType<typeof useAgricultureWorkInvestmentViewQuery>;
export type AgricultureWorkInvestmentViewLazyQueryHookResult = ReturnType<typeof useAgricultureWorkInvestmentViewLazyQuery>;
export type AgricultureWorkInvestmentViewQueryResult = Apollo.QueryResult<AgricultureWorkInvestmentViewQuery, AgricultureWorkInvestmentViewQueryVariables>;
export const MaintenanceAgricultureWorkDatalistDocument = gql`
    query MaintenanceAgricultureWorkDatalist($where: MaintenanceAgricultureWorkFilterInput, $sort: [MaintenanceAgricultureWorkSortInput!], $skip: Int, $take: Int) {
  maintenanceAgricultureWorks {
    items(where: $where, skip: $skip, take: $take, order: $sort) {
      id
      workers {
        count
        priceSum
      }
      season {
        name
      }
      startDate
      endDate
      name
      logs {
        items {
          type {
            name
          }
          investment {
            name
          }
          id
        }
      }
    }
    count(where: $where)
  }
}
    `;

/**
 * __useMaintenanceAgricultureWorkDatalistQuery__
 *
 * To run a query within a React component, call `useMaintenanceAgricultureWorkDatalistQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaintenanceAgricultureWorkDatalistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaintenanceAgricultureWorkDatalistQuery({
 *   variables: {
 *      where: // value for 'where'
 *      sort: // value for 'sort'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useMaintenanceAgricultureWorkDatalistQuery(baseOptions?: Apollo.QueryHookOptions<MaintenanceAgricultureWorkDatalistQuery, MaintenanceAgricultureWorkDatalistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaintenanceAgricultureWorkDatalistQuery, MaintenanceAgricultureWorkDatalistQueryVariables>(MaintenanceAgricultureWorkDatalistDocument, options);
      }
export function useMaintenanceAgricultureWorkDatalistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaintenanceAgricultureWorkDatalistQuery, MaintenanceAgricultureWorkDatalistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaintenanceAgricultureWorkDatalistQuery, MaintenanceAgricultureWorkDatalistQueryVariables>(MaintenanceAgricultureWorkDatalistDocument, options);
        }
export type MaintenanceAgricultureWorkDatalistQueryHookResult = ReturnType<typeof useMaintenanceAgricultureWorkDatalistQuery>;
export type MaintenanceAgricultureWorkDatalistLazyQueryHookResult = ReturnType<typeof useMaintenanceAgricultureWorkDatalistLazyQuery>;
export type MaintenanceAgricultureWorkDatalistQueryResult = Apollo.QueryResult<MaintenanceAgricultureWorkDatalistQuery, MaintenanceAgricultureWorkDatalistQueryVariables>;
export const AgricultureMaintenanceFormDataDocument = gql`
    query AgricultureMaintenanceFormData($id: Int!) {
  season(where: {active: {eq: true}}) {
    id
    name
    active
  }
  maintenanceAgricultureWork(id: $id) {
    id
    workers {
      items {
        person {
          id
          name
        }
        price
        id
      }
    }
    season {
      active
      id
      name
    }
    logs {
      items {
        id
        type {
          name
          id
        }
        investment {
          id
          name
          investmentType
          unit
          unitPrice
          total
        }
        maintenanceLogFruitGroups {
          items {
            id
            fruitGroup {
              name
              id
            }
          }
        }
      }
    }
    startDate
    endDate
    note
    name
  }
}
    `;

/**
 * __useAgricultureMaintenanceFormDataQuery__
 *
 * To run a query within a React component, call `useAgricultureMaintenanceFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgricultureMaintenanceFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgricultureMaintenanceFormDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgricultureMaintenanceFormDataQuery(baseOptions: Apollo.QueryHookOptions<AgricultureMaintenanceFormDataQuery, AgricultureMaintenanceFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgricultureMaintenanceFormDataQuery, AgricultureMaintenanceFormDataQueryVariables>(AgricultureMaintenanceFormDataDocument, options);
      }
export function useAgricultureMaintenanceFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgricultureMaintenanceFormDataQuery, AgricultureMaintenanceFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgricultureMaintenanceFormDataQuery, AgricultureMaintenanceFormDataQueryVariables>(AgricultureMaintenanceFormDataDocument, options);
        }
export type AgricultureMaintenanceFormDataQueryHookResult = ReturnType<typeof useAgricultureMaintenanceFormDataQuery>;
export type AgricultureMaintenanceFormDataLazyQueryHookResult = ReturnType<typeof useAgricultureMaintenanceFormDataLazyQuery>;
export type AgricultureMaintenanceFormDataQueryResult = Apollo.QueryResult<AgricultureMaintenanceFormDataQuery, AgricultureMaintenanceFormDataQueryVariables>;
export const SaveMaintenanceDocument = gql`
    mutation SaveMaintenance($model: MaintenanceAgricultureWorkInput!) {
  maintenanceAgricultureWork(model: $model) {
    id
  }
}
    `;
export type SaveMaintenanceMutationFn = Apollo.MutationFunction<SaveMaintenanceMutation, SaveMaintenanceMutationVariables>;

/**
 * __useSaveMaintenanceMutation__
 *
 * To run a mutation, you first call `useSaveMaintenanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMaintenanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMaintenanceMutation, { data, loading, error }] = useSaveMaintenanceMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useSaveMaintenanceMutation(baseOptions?: Apollo.MutationHookOptions<SaveMaintenanceMutation, SaveMaintenanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMaintenanceMutation, SaveMaintenanceMutationVariables>(SaveMaintenanceDocument, options);
      }
export type SaveMaintenanceMutationHookResult = ReturnType<typeof useSaveMaintenanceMutation>;
export type SaveMaintenanceMutationResult = Apollo.MutationResult<SaveMaintenanceMutation>;
export type SaveMaintenanceMutationOptions = Apollo.BaseMutationOptions<SaveMaintenanceMutation, SaveMaintenanceMutationVariables>;
export const MaintenanceAgricultureWorkViewPageDocument = gql`
    query MaintenanceAgricultureWorkViewPage($id: Int!) {
  maintenanceAgricultureWork(id: $id) {
    id
    note
    workers {
      items {
        person {
          name
          id
        }
        date
        price
        id
      }
    }
    season {
      name
      id
    }
    startDate
    endDate
    name
    logs {
      items {
        type {
          name
          id
        }
        investment {
          name
          id
          total
          investmentType
          startDate
        }
        id
        maintenanceLogFruitGroups {
          items {
            id
            fruitGroup {
              name
              id
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMaintenanceAgricultureWorkViewPageQuery__
 *
 * To run a query within a React component, call `useMaintenanceAgricultureWorkViewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaintenanceAgricultureWorkViewPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaintenanceAgricultureWorkViewPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMaintenanceAgricultureWorkViewPageQuery(baseOptions: Apollo.QueryHookOptions<MaintenanceAgricultureWorkViewPageQuery, MaintenanceAgricultureWorkViewPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaintenanceAgricultureWorkViewPageQuery, MaintenanceAgricultureWorkViewPageQueryVariables>(MaintenanceAgricultureWorkViewPageDocument, options);
      }
export function useMaintenanceAgricultureWorkViewPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaintenanceAgricultureWorkViewPageQuery, MaintenanceAgricultureWorkViewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaintenanceAgricultureWorkViewPageQuery, MaintenanceAgricultureWorkViewPageQueryVariables>(MaintenanceAgricultureWorkViewPageDocument, options);
        }
export type MaintenanceAgricultureWorkViewPageQueryHookResult = ReturnType<typeof useMaintenanceAgricultureWorkViewPageQuery>;
export type MaintenanceAgricultureWorkViewPageLazyQueryHookResult = ReturnType<typeof useMaintenanceAgricultureWorkViewPageLazyQuery>;
export type MaintenanceAgricultureWorkViewPageQueryResult = Apollo.QueryResult<MaintenanceAgricultureWorkViewPageQuery, MaintenanceAgricultureWorkViewPageQueryVariables>;
export const PersonViewDocument = gql`
    query personView($id: Int, $lang: String!) {
  person(where: {id: {eq: $id}}) {
    id
    name
    note
    contactInfo {
      items {
        value
        link
        name
        id
        personId
      }
    }
    tags {
      items {
        id
        tag {
          id
          name
        }
      }
    }
    countryCode
    country {
      alpha3Code
      name
      flag
      translate(lang: $lang)
    }
    sales {
      any
    }
    workers {
      any
    }
    bookings {
      any
    }
    wallets {
      any
    }
  }
}
    `;

/**
 * __usePersonViewQuery__
 *
 * To run a query within a React component, call `usePersonViewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function usePersonViewQuery(baseOptions: Apollo.QueryHookOptions<PersonViewQuery, PersonViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonViewQuery, PersonViewQueryVariables>(PersonViewDocument, options);
      }
export function usePersonViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonViewQuery, PersonViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonViewQuery, PersonViewQueryVariables>(PersonViewDocument, options);
        }
export type PersonViewQueryHookResult = ReturnType<typeof usePersonViewQuery>;
export type PersonViewLazyQueryHookResult = ReturnType<typeof usePersonViewLazyQuery>;
export type PersonViewQueryResult = Apollo.QueryResult<PersonViewQuery, PersonViewQueryVariables>;
export const TagDatalistDocument = gql`
    query TagDatalist($where: PersonTagFilterInput, $order: [PersonTagSortInput!], $skip: Int, $take: Int) {
  personTags {
    items(where: $where, order: $order, skip: $skip, take: $take) {
      id
      name
    }
    count(where: $where)
  }
}
    `;

/**
 * __useTagDatalistQuery__
 *
 * To run a query within a React component, call `useTagDatalistQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagDatalistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagDatalistQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useTagDatalistQuery(baseOptions?: Apollo.QueryHookOptions<TagDatalistQuery, TagDatalistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagDatalistQuery, TagDatalistQueryVariables>(TagDatalistDocument, options);
      }
export function useTagDatalistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagDatalistQuery, TagDatalistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagDatalistQuery, TagDatalistQueryVariables>(TagDatalistDocument, options);
        }
export type TagDatalistQueryHookResult = ReturnType<typeof useTagDatalistQuery>;
export type TagDatalistLazyQueryHookResult = ReturnType<typeof useTagDatalistLazyQuery>;
export type TagDatalistQueryResult = Apollo.QueryResult<TagDatalistQuery, TagDatalistQueryVariables>;
export const AddPersonToTagDocument = gql`
    mutation AddPersonToTag($model: PersonTagLinkInput!) {
  personTagLink(model: $model) {
    id
  }
}
    `;
export type AddPersonToTagMutationFn = Apollo.MutationFunction<AddPersonToTagMutation, AddPersonToTagMutationVariables>;

/**
 * __useAddPersonToTagMutation__
 *
 * To run a mutation, you first call `useAddPersonToTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPersonToTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPersonToTagMutation, { data, loading, error }] = useAddPersonToTagMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useAddPersonToTagMutation(baseOptions?: Apollo.MutationHookOptions<AddPersonToTagMutation, AddPersonToTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPersonToTagMutation, AddPersonToTagMutationVariables>(AddPersonToTagDocument, options);
      }
export type AddPersonToTagMutationHookResult = ReturnType<typeof useAddPersonToTagMutation>;
export type AddPersonToTagMutationResult = Apollo.MutationResult<AddPersonToTagMutation>;
export type AddPersonToTagMutationOptions = Apollo.BaseMutationOptions<AddPersonToTagMutation, AddPersonToTagMutationVariables>;
export const DeletePersonToTagDocument = gql`
    mutation DeletePersonToTag($id: Int, $where: PersonTagLinkFilterInput) {
  personTagLinkDelete(id: $id, where: $where)
}
    `;
export type DeletePersonToTagMutationFn = Apollo.MutationFunction<DeletePersonToTagMutation, DeletePersonToTagMutationVariables>;

/**
 * __useDeletePersonToTagMutation__
 *
 * To run a mutation, you first call `useDeletePersonToTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonToTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonToTagMutation, { data, loading, error }] = useDeletePersonToTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeletePersonToTagMutation(baseOptions?: Apollo.MutationHookOptions<DeletePersonToTagMutation, DeletePersonToTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePersonToTagMutation, DeletePersonToTagMutationVariables>(DeletePersonToTagDocument, options);
      }
export type DeletePersonToTagMutationHookResult = ReturnType<typeof useDeletePersonToTagMutation>;
export type DeletePersonToTagMutationResult = Apollo.MutationResult<DeletePersonToTagMutation>;
export type DeletePersonToTagMutationOptions = Apollo.BaseMutationOptions<DeletePersonToTagMutation, DeletePersonToTagMutationVariables>;
export const GetWalletFromPageDocument = gql`
    query GetWalletFromPage($id: Int!) {
  wallet(id: $id) {
    id
    name
    deposit
    note
    archived
    person {
      id
      name
    }
  }
}
    `;

/**
 * __useGetWalletFromPageQuery__
 *
 * To run a query within a React component, call `useGetWalletFromPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWalletFromPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWalletFromPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWalletFromPageQuery(baseOptions: Apollo.QueryHookOptions<GetWalletFromPageQuery, GetWalletFromPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWalletFromPageQuery, GetWalletFromPageQueryVariables>(GetWalletFromPageDocument, options);
      }
export function useGetWalletFromPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWalletFromPageQuery, GetWalletFromPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWalletFromPageQuery, GetWalletFromPageQueryVariables>(GetWalletFromPageDocument, options);
        }
export type GetWalletFromPageQueryHookResult = ReturnType<typeof useGetWalletFromPageQuery>;
export type GetWalletFromPageLazyQueryHookResult = ReturnType<typeof useGetWalletFromPageLazyQuery>;
export type GetWalletFromPageQueryResult = Apollo.QueryResult<GetWalletFromPageQuery, GetWalletFromPageQueryVariables>;
export const GetWalletViewPageDocument = gql`
    query GetWalletViewPage($id: Int!) {
  wallet(id: $id) {
    id
    name
    balance
    note
    archived
    deposit
    person {
      id
      name
      contactInfo {
        items {
          value
          name
          link
        }
      }
      tags {
        items {
          tag {
            name
          }
        }
      }
    }
    sales {
      count
      totalSum
    }
    transactions {
      count
      amountSum
      items {
        amount
        transactionId
        transactionDate
        note
        id
      }
    }
  }
}
    `;

/**
 * __useGetWalletViewPageQuery__
 *
 * To run a query within a React component, call `useGetWalletViewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWalletViewPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWalletViewPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWalletViewPageQuery(baseOptions: Apollo.QueryHookOptions<GetWalletViewPageQuery, GetWalletViewPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWalletViewPageQuery, GetWalletViewPageQueryVariables>(GetWalletViewPageDocument, options);
      }
export function useGetWalletViewPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWalletViewPageQuery, GetWalletViewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWalletViewPageQuery, GetWalletViewPageQueryVariables>(GetWalletViewPageDocument, options);
        }
export type GetWalletViewPageQueryHookResult = ReturnType<typeof useGetWalletViewPageQuery>;
export type GetWalletViewPageLazyQueryHookResult = ReturnType<typeof useGetWalletViewPageLazyQuery>;
export type GetWalletViewPageQueryResult = Apollo.QueryResult<GetWalletViewPageQuery, GetWalletViewPageQueryVariables>;
export const ApiTokenDataListSettingsPageDocument = gql`
    query ApiTokenDataListSettingsPage($where: ApiTokenFilterInput, $take: Int, $skip: Int, $order: [ApiTokenSortInput!]) {
  apiTokens {
    items(where: $where, take: $take, skip: $skip, order: $order) {
      name
      createdDate
      expiredAt
      id
      createdBy {
        name
      }
      updatedBy {
        name
      }
    }
    count(where: $where)
  }
}
    `;

/**
 * __useApiTokenDataListSettingsPageQuery__
 *
 * To run a query within a React component, call `useApiTokenDataListSettingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiTokenDataListSettingsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiTokenDataListSettingsPageQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useApiTokenDataListSettingsPageQuery(baseOptions?: Apollo.QueryHookOptions<ApiTokenDataListSettingsPageQuery, ApiTokenDataListSettingsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiTokenDataListSettingsPageQuery, ApiTokenDataListSettingsPageQueryVariables>(ApiTokenDataListSettingsPageDocument, options);
      }
export function useApiTokenDataListSettingsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiTokenDataListSettingsPageQuery, ApiTokenDataListSettingsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiTokenDataListSettingsPageQuery, ApiTokenDataListSettingsPageQueryVariables>(ApiTokenDataListSettingsPageDocument, options);
        }
export type ApiTokenDataListSettingsPageQueryHookResult = ReturnType<typeof useApiTokenDataListSettingsPageQuery>;
export type ApiTokenDataListSettingsPageLazyQueryHookResult = ReturnType<typeof useApiTokenDataListSettingsPageLazyQuery>;
export type ApiTokenDataListSettingsPageQueryResult = Apollo.QueryResult<ApiTokenDataListSettingsPageQuery, ApiTokenDataListSettingsPageQueryVariables>;
export const SaleTemplateFormDataQueryDocument = gql`
    query SaleTemplateFormDataQuery($id: Int) {
  saleTemplate(id: $id) {
    name
    season {
      name
      id
      active
    }
    date
    person {
      name
      id
    }
    fruit {
      name
      id
    }
    kg
    pricePerKg
    total
    category {
      name
      id
    }
    cartQuantity
    chamber
    type
    note
  }
}
    `;

/**
 * __useSaleTemplateFormDataQueryQuery__
 *
 * To run a query within a React component, call `useSaleTemplateFormDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaleTemplateFormDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaleTemplateFormDataQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaleTemplateFormDataQueryQuery(baseOptions?: Apollo.QueryHookOptions<SaleTemplateFormDataQueryQuery, SaleTemplateFormDataQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaleTemplateFormDataQueryQuery, SaleTemplateFormDataQueryQueryVariables>(SaleTemplateFormDataQueryDocument, options);
      }
export function useSaleTemplateFormDataQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaleTemplateFormDataQueryQuery, SaleTemplateFormDataQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaleTemplateFormDataQueryQuery, SaleTemplateFormDataQueryQueryVariables>(SaleTemplateFormDataQueryDocument, options);
        }
export type SaleTemplateFormDataQueryQueryHookResult = ReturnType<typeof useSaleTemplateFormDataQueryQuery>;
export type SaleTemplateFormDataQueryLazyQueryHookResult = ReturnType<typeof useSaleTemplateFormDataQueryLazyQuery>;
export type SaleTemplateFormDataQueryQueryResult = Apollo.QueryResult<SaleTemplateFormDataQueryQuery, SaleTemplateFormDataQueryQueryVariables>;
export const HarvestTemplateFormDataDocument = gql`
    query HarvestTemplateFormData($id: Int) {
  harvestAgricultureWorkTemplate(id: $id) {
    id
    season {
      id
      name
      active
    }
    startDate
    note
    name
    workers {
      items {
        person {
          id
          name
        }
        id
        price
      }
    }
    harvests {
      items {
        id
        kg
        cartQuantity
        hideFromMultiUpdate
        fruit {
          id
          name
        }
        harvestFruitGroups {
          items {
            id
            fruitGroup {
              id
              name
            }
          }
        }
        harvestFruitCategories {
          items {
            id
            fruitCategory {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useHarvestTemplateFormDataQuery__
 *
 * To run a query within a React component, call `useHarvestTemplateFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestTemplateFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestTemplateFormDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHarvestTemplateFormDataQuery(baseOptions?: Apollo.QueryHookOptions<HarvestTemplateFormDataQuery, HarvestTemplateFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HarvestTemplateFormDataQuery, HarvestTemplateFormDataQueryVariables>(HarvestTemplateFormDataDocument, options);
      }
export function useHarvestTemplateFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestTemplateFormDataQuery, HarvestTemplateFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HarvestTemplateFormDataQuery, HarvestTemplateFormDataQueryVariables>(HarvestTemplateFormDataDocument, options);
        }
export type HarvestTemplateFormDataQueryHookResult = ReturnType<typeof useHarvestTemplateFormDataQuery>;
export type HarvestTemplateFormDataLazyQueryHookResult = ReturnType<typeof useHarvestTemplateFormDataLazyQuery>;
export type HarvestTemplateFormDataQueryResult = Apollo.QueryResult<HarvestTemplateFormDataQuery, HarvestTemplateFormDataQueryVariables>;
export const SaveHarvestTemplateDocument = gql`
    mutation SaveHarvestTemplate($model: HarvestAgricultureWorkTemplateInput!) {
  harvestAgricultureWorkTemplate(model: $model) {
    id
  }
}
    `;
export type SaveHarvestTemplateMutationFn = Apollo.MutationFunction<SaveHarvestTemplateMutation, SaveHarvestTemplateMutationVariables>;

/**
 * __useSaveHarvestTemplateMutation__
 *
 * To run a mutation, you first call `useSaveHarvestTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveHarvestTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveHarvestTemplateMutation, { data, loading, error }] = useSaveHarvestTemplateMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useSaveHarvestTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SaveHarvestTemplateMutation, SaveHarvestTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveHarvestTemplateMutation, SaveHarvestTemplateMutationVariables>(SaveHarvestTemplateDocument, options);
      }
export type SaveHarvestTemplateMutationHookResult = ReturnType<typeof useSaveHarvestTemplateMutation>;
export type SaveHarvestTemplateMutationResult = Apollo.MutationResult<SaveHarvestTemplateMutation>;
export type SaveHarvestTemplateMutationOptions = Apollo.BaseMutationOptions<SaveHarvestTemplateMutation, SaveHarvestTemplateMutationVariables>;
export const DeleteFruitDocument = gql`
    mutation DeleteFruit($id: Int, $where: FruitFilterInput) {
  fruitDelete(id: $id, where: $where)
}
    `;
export type DeleteFruitMutationFn = Apollo.MutationFunction<DeleteFruitMutation, DeleteFruitMutationVariables>;

/**
 * __useDeleteFruitMutation__
 *
 * To run a mutation, you first call `useDeleteFruitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFruitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFruitMutation, { data, loading, error }] = useDeleteFruitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteFruitMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFruitMutation, DeleteFruitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFruitMutation, DeleteFruitMutationVariables>(DeleteFruitDocument, options);
      }
export type DeleteFruitMutationHookResult = ReturnType<typeof useDeleteFruitMutation>;
export type DeleteFruitMutationResult = Apollo.MutationResult<DeleteFruitMutation>;
export type DeleteFruitMutationOptions = Apollo.BaseMutationOptions<DeleteFruitMutation, DeleteFruitMutationVariables>;
export const DeleteHarvestAgricultureWorkDocument = gql`
    mutation DeleteHarvestAgricultureWork($id: Int, $where: HarvestAgricultureWorkFilterInput) {
  harvestAgricultureWorkDelete(id: $id, where: $where)
}
    `;
export type DeleteHarvestAgricultureWorkMutationFn = Apollo.MutationFunction<DeleteHarvestAgricultureWorkMutation, DeleteHarvestAgricultureWorkMutationVariables>;

/**
 * __useDeleteHarvestAgricultureWorkMutation__
 *
 * To run a mutation, you first call `useDeleteHarvestAgricultureWorkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHarvestAgricultureWorkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHarvestAgricultureWorkMutation, { data, loading, error }] = useDeleteHarvestAgricultureWorkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteHarvestAgricultureWorkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHarvestAgricultureWorkMutation, DeleteHarvestAgricultureWorkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHarvestAgricultureWorkMutation, DeleteHarvestAgricultureWorkMutationVariables>(DeleteHarvestAgricultureWorkDocument, options);
      }
export type DeleteHarvestAgricultureWorkMutationHookResult = ReturnType<typeof useDeleteHarvestAgricultureWorkMutation>;
export type DeleteHarvestAgricultureWorkMutationResult = Apollo.MutationResult<DeleteHarvestAgricultureWorkMutation>;
export type DeleteHarvestAgricultureWorkMutationOptions = Apollo.BaseMutationOptions<DeleteHarvestAgricultureWorkMutation, DeleteHarvestAgricultureWorkMutationVariables>;
export const DeleteHarvestAgricultureWorkTemplateDocument = gql`
    mutation DeleteHarvestAgricultureWorkTemplate($id: Int, $where: HarvestAgricultureWorkTemplateFilterInput) {
  harvestAgricultureWorkTemplateDelete(id: $id, where: $where)
}
    `;
export type DeleteHarvestAgricultureWorkTemplateMutationFn = Apollo.MutationFunction<DeleteHarvestAgricultureWorkTemplateMutation, DeleteHarvestAgricultureWorkTemplateMutationVariables>;

/**
 * __useDeleteHarvestAgricultureWorkTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteHarvestAgricultureWorkTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHarvestAgricultureWorkTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHarvestAgricultureWorkTemplateMutation, { data, loading, error }] = useDeleteHarvestAgricultureWorkTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteHarvestAgricultureWorkTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHarvestAgricultureWorkTemplateMutation, DeleteHarvestAgricultureWorkTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHarvestAgricultureWorkTemplateMutation, DeleteHarvestAgricultureWorkTemplateMutationVariables>(DeleteHarvestAgricultureWorkTemplateDocument, options);
      }
export type DeleteHarvestAgricultureWorkTemplateMutationHookResult = ReturnType<typeof useDeleteHarvestAgricultureWorkTemplateMutation>;
export type DeleteHarvestAgricultureWorkTemplateMutationResult = Apollo.MutationResult<DeleteHarvestAgricultureWorkTemplateMutation>;
export type DeleteHarvestAgricultureWorkTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteHarvestAgricultureWorkTemplateMutation, DeleteHarvestAgricultureWorkTemplateMutationVariables>;
export const AgricultureInvestmentIdNameDocument = gql`
    query AgricultureInvestmentIdName($where: AgricultureWorkInvestmentFilterInput, $sort: [AgricultureWorkInvestmentSortInput!], $skip: Int, $take: Int) {
  agricultureWorkInvestments {
    items(where: $where, skip: $skip, take: $take, order: $sort) {
      id
      name
      total
      startDate
    }
  }
}
    `;

/**
 * __useAgricultureInvestmentIdNameQuery__
 *
 * To run a query within a React component, call `useAgricultureInvestmentIdNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgricultureInvestmentIdNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgricultureInvestmentIdNameQuery({
 *   variables: {
 *      where: // value for 'where'
 *      sort: // value for 'sort'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useAgricultureInvestmentIdNameQuery(baseOptions?: Apollo.QueryHookOptions<AgricultureInvestmentIdNameQuery, AgricultureInvestmentIdNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgricultureInvestmentIdNameQuery, AgricultureInvestmentIdNameQueryVariables>(AgricultureInvestmentIdNameDocument, options);
      }
export function useAgricultureInvestmentIdNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgricultureInvestmentIdNameQuery, AgricultureInvestmentIdNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgricultureInvestmentIdNameQuery, AgricultureInvestmentIdNameQueryVariables>(AgricultureInvestmentIdNameDocument, options);
        }
export type AgricultureInvestmentIdNameQueryHookResult = ReturnType<typeof useAgricultureInvestmentIdNameQuery>;
export type AgricultureInvestmentIdNameLazyQueryHookResult = ReturnType<typeof useAgricultureInvestmentIdNameLazyQuery>;
export type AgricultureInvestmentIdNameQueryResult = Apollo.QueryResult<AgricultureInvestmentIdNameQuery, AgricultureInvestmentIdNameQueryVariables>;
export const AgricultureMaintenanceLogTypeListDocument = gql`
    query AgricultureMaintenanceLogTypeList($where: MaintenanceLogTypeFilterInput, $order: [MaintenanceLogTypeSortInput!], $skip: Int, $take: Int) {
  maintenanceLogTypes {
    items(where: $where, order: $order, skip: $skip, take: $take) {
      id
      name
    }
  }
}
    `;

/**
 * __useAgricultureMaintenanceLogTypeListQuery__
 *
 * To run a query within a React component, call `useAgricultureMaintenanceLogTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgricultureMaintenanceLogTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgricultureMaintenanceLogTypeListQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useAgricultureMaintenanceLogTypeListQuery(baseOptions?: Apollo.QueryHookOptions<AgricultureMaintenanceLogTypeListQuery, AgricultureMaintenanceLogTypeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgricultureMaintenanceLogTypeListQuery, AgricultureMaintenanceLogTypeListQueryVariables>(AgricultureMaintenanceLogTypeListDocument, options);
      }
export function useAgricultureMaintenanceLogTypeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgricultureMaintenanceLogTypeListQuery, AgricultureMaintenanceLogTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgricultureMaintenanceLogTypeListQuery, AgricultureMaintenanceLogTypeListQueryVariables>(AgricultureMaintenanceLogTypeListDocument, options);
        }
export type AgricultureMaintenanceLogTypeListQueryHookResult = ReturnType<typeof useAgricultureMaintenanceLogTypeListQuery>;
export type AgricultureMaintenanceLogTypeListLazyQueryHookResult = ReturnType<typeof useAgricultureMaintenanceLogTypeListLazyQuery>;
export type AgricultureMaintenanceLogTypeListQueryResult = Apollo.QueryResult<AgricultureMaintenanceLogTypeListQuery, AgricultureMaintenanceLogTypeListQueryVariables>;
export const AgricultureMaintenanceLogTypeItemDocument = gql`
    query AgricultureMaintenanceLogTypeItem($where: MaintenanceLogTypeFilterInput, $id: Int) {
  maintenanceLogType(where: $where, id: $id) {
    id
    name
  }
}
    `;

/**
 * __useAgricultureMaintenanceLogTypeItemQuery__
 *
 * To run a query within a React component, call `useAgricultureMaintenanceLogTypeItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgricultureMaintenanceLogTypeItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgricultureMaintenanceLogTypeItemQuery({
 *   variables: {
 *      where: // value for 'where'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgricultureMaintenanceLogTypeItemQuery(baseOptions?: Apollo.QueryHookOptions<AgricultureMaintenanceLogTypeItemQuery, AgricultureMaintenanceLogTypeItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgricultureMaintenanceLogTypeItemQuery, AgricultureMaintenanceLogTypeItemQueryVariables>(AgricultureMaintenanceLogTypeItemDocument, options);
      }
export function useAgricultureMaintenanceLogTypeItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgricultureMaintenanceLogTypeItemQuery, AgricultureMaintenanceLogTypeItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgricultureMaintenanceLogTypeItemQuery, AgricultureMaintenanceLogTypeItemQueryVariables>(AgricultureMaintenanceLogTypeItemDocument, options);
        }
export type AgricultureMaintenanceLogTypeItemQueryHookResult = ReturnType<typeof useAgricultureMaintenanceLogTypeItemQuery>;
export type AgricultureMaintenanceLogTypeItemLazyQueryHookResult = ReturnType<typeof useAgricultureMaintenanceLogTypeItemLazyQuery>;
export type AgricultureMaintenanceLogTypeItemQueryResult = Apollo.QueryResult<AgricultureMaintenanceLogTypeItemQuery, AgricultureMaintenanceLogTypeItemQueryVariables>;
export const AgricultureMaintenaceLogTypeMutationDocument = gql`
    mutation AgricultureMaintenaceLogTypeMutation($model: MaintenanceLogTypeInput!) {
  maintenanceLogType(model: $model) {
    id
  }
}
    `;
export type AgricultureMaintenaceLogTypeMutationMutationFn = Apollo.MutationFunction<AgricultureMaintenaceLogTypeMutationMutation, AgricultureMaintenaceLogTypeMutationMutationVariables>;

/**
 * __useAgricultureMaintenaceLogTypeMutationMutation__
 *
 * To run a mutation, you first call `useAgricultureMaintenaceLogTypeMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgricultureMaintenaceLogTypeMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agricultureMaintenaceLogTypeMutationMutation, { data, loading, error }] = useAgricultureMaintenaceLogTypeMutationMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useAgricultureMaintenaceLogTypeMutationMutation(baseOptions?: Apollo.MutationHookOptions<AgricultureMaintenaceLogTypeMutationMutation, AgricultureMaintenaceLogTypeMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AgricultureMaintenaceLogTypeMutationMutation, AgricultureMaintenaceLogTypeMutationMutationVariables>(AgricultureMaintenaceLogTypeMutationDocument, options);
      }
export type AgricultureMaintenaceLogTypeMutationMutationHookResult = ReturnType<typeof useAgricultureMaintenaceLogTypeMutationMutation>;
export type AgricultureMaintenaceLogTypeMutationMutationResult = Apollo.MutationResult<AgricultureMaintenaceLogTypeMutationMutation>;
export type AgricultureMaintenaceLogTypeMutationMutationOptions = Apollo.BaseMutationOptions<AgricultureMaintenaceLogTypeMutationMutation, AgricultureMaintenaceLogTypeMutationMutationVariables>;
export const AgricultureMaintenaceLogTypeDeleteDocument = gql`
    mutation AgricultureMaintenaceLogTypeDelete($where: MaintenanceLogTypeFilterInput, $id: Int) {
  maintenanceLogTypeDelete(id: $id, where: $where)
}
    `;
export type AgricultureMaintenaceLogTypeDeleteMutationFn = Apollo.MutationFunction<AgricultureMaintenaceLogTypeDeleteMutation, AgricultureMaintenaceLogTypeDeleteMutationVariables>;

/**
 * __useAgricultureMaintenaceLogTypeDeleteMutation__
 *
 * To run a mutation, you first call `useAgricultureMaintenaceLogTypeDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgricultureMaintenaceLogTypeDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agricultureMaintenaceLogTypeDeleteMutation, { data, loading, error }] = useAgricultureMaintenaceLogTypeDeleteMutation({
 *   variables: {
 *      where: // value for 'where'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgricultureMaintenaceLogTypeDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AgricultureMaintenaceLogTypeDeleteMutation, AgricultureMaintenaceLogTypeDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AgricultureMaintenaceLogTypeDeleteMutation, AgricultureMaintenaceLogTypeDeleteMutationVariables>(AgricultureMaintenaceLogTypeDeleteDocument, options);
      }
export type AgricultureMaintenaceLogTypeDeleteMutationHookResult = ReturnType<typeof useAgricultureMaintenaceLogTypeDeleteMutation>;
export type AgricultureMaintenaceLogTypeDeleteMutationResult = Apollo.MutationResult<AgricultureMaintenaceLogTypeDeleteMutation>;
export type AgricultureMaintenaceLogTypeDeleteMutationOptions = Apollo.BaseMutationOptions<AgricultureMaintenaceLogTypeDeleteMutation, AgricultureMaintenaceLogTypeDeleteMutationVariables>;
export const MaintenanceAgricultureWorkDeleteDocument = gql`
    mutation MaintenanceAgricultureWorkDelete($id: Int, $where: MaintenanceAgricultureWorkFilterInput) {
  maintenanceAgricultureWorkDelete(id: $id, where: $where)
}
    `;
export type MaintenanceAgricultureWorkDeleteMutationFn = Apollo.MutationFunction<MaintenanceAgricultureWorkDeleteMutation, MaintenanceAgricultureWorkDeleteMutationVariables>;

/**
 * __useMaintenanceAgricultureWorkDeleteMutation__
 *
 * To run a mutation, you first call `useMaintenanceAgricultureWorkDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMaintenanceAgricultureWorkDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [maintenanceAgricultureWorkDeleteMutation, { data, loading, error }] = useMaintenanceAgricultureWorkDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMaintenanceAgricultureWorkDeleteMutation(baseOptions?: Apollo.MutationHookOptions<MaintenanceAgricultureWorkDeleteMutation, MaintenanceAgricultureWorkDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MaintenanceAgricultureWorkDeleteMutation, MaintenanceAgricultureWorkDeleteMutationVariables>(MaintenanceAgricultureWorkDeleteDocument, options);
      }
export type MaintenanceAgricultureWorkDeleteMutationHookResult = ReturnType<typeof useMaintenanceAgricultureWorkDeleteMutation>;
export type MaintenanceAgricultureWorkDeleteMutationResult = Apollo.MutationResult<MaintenanceAgricultureWorkDeleteMutation>;
export type MaintenanceAgricultureWorkDeleteMutationOptions = Apollo.BaseMutationOptions<MaintenanceAgricultureWorkDeleteMutation, MaintenanceAgricultureWorkDeleteMutationVariables>;
export const FruitCategoriesIdNameDocument = gql`
    query fruitCategoriesIdName($where: FruitCategoryFilterInput, $order: [FruitCategorySortInput!], $take: Int, $skip: Int) {
  fruitCategories {
    items(where: $where, take: $take, skip: $skip, order: $order) {
      name
      id
    }
  }
}
    `;

/**
 * __useFruitCategoriesIdNameQuery__
 *
 * To run a query within a React component, call `useFruitCategoriesIdNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useFruitCategoriesIdNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFruitCategoriesIdNameQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useFruitCategoriesIdNameQuery(baseOptions?: Apollo.QueryHookOptions<FruitCategoriesIdNameQuery, FruitCategoriesIdNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FruitCategoriesIdNameQuery, FruitCategoriesIdNameQueryVariables>(FruitCategoriesIdNameDocument, options);
      }
export function useFruitCategoriesIdNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FruitCategoriesIdNameQuery, FruitCategoriesIdNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FruitCategoriesIdNameQuery, FruitCategoriesIdNameQueryVariables>(FruitCategoriesIdNameDocument, options);
        }
export type FruitCategoriesIdNameQueryHookResult = ReturnType<typeof useFruitCategoriesIdNameQuery>;
export type FruitCategoriesIdNameLazyQueryHookResult = ReturnType<typeof useFruitCategoriesIdNameLazyQuery>;
export type FruitCategoriesIdNameQueryResult = Apollo.QueryResult<FruitCategoriesIdNameQuery, FruitCategoriesIdNameQueryVariables>;
export const FruitGroupsIdNameDocument = gql`
    query fruitGroupsIdName($where: FruitGroupFilterInput, $order: [FruitGroupSortInput!], $take: Int, $skip: Int) {
  fruitGroups {
    items(where: $where, take: $take, skip: $skip, order: $order) {
      name
      id
    }
  }
}
    `;

/**
 * __useFruitGroupsIdNameQuery__
 *
 * To run a query within a React component, call `useFruitGroupsIdNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useFruitGroupsIdNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFruitGroupsIdNameQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useFruitGroupsIdNameQuery(baseOptions?: Apollo.QueryHookOptions<FruitGroupsIdNameQuery, FruitGroupsIdNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FruitGroupsIdNameQuery, FruitGroupsIdNameQueryVariables>(FruitGroupsIdNameDocument, options);
      }
export function useFruitGroupsIdNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FruitGroupsIdNameQuery, FruitGroupsIdNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FruitGroupsIdNameQuery, FruitGroupsIdNameQueryVariables>(FruitGroupsIdNameDocument, options);
        }
export type FruitGroupsIdNameQueryHookResult = ReturnType<typeof useFruitGroupsIdNameQuery>;
export type FruitGroupsIdNameLazyQueryHookResult = ReturnType<typeof useFruitGroupsIdNameLazyQuery>;
export type FruitGroupsIdNameQueryResult = Apollo.QueryResult<FruitGroupsIdNameQuery, FruitGroupsIdNameQueryVariables>;
export const FruitsIdNameDocument = gql`
    query fruitsIdName($where: FruitFilterInput, $order: [FruitSortInput!], $take: Int, $skip: Int) {
  fruits {
    items(where: $where, take: $take, skip: $skip, order: $order) {
      name
      id
    }
  }
}
    `;

/**
 * __useFruitsIdNameQuery__
 *
 * To run a query within a React component, call `useFruitsIdNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useFruitsIdNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFruitsIdNameQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useFruitsIdNameQuery(baseOptions?: Apollo.QueryHookOptions<FruitsIdNameQuery, FruitsIdNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FruitsIdNameQuery, FruitsIdNameQueryVariables>(FruitsIdNameDocument, options);
      }
export function useFruitsIdNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FruitsIdNameQuery, FruitsIdNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FruitsIdNameQuery, FruitsIdNameQueryVariables>(FruitsIdNameDocument, options);
        }
export type FruitsIdNameQueryHookResult = ReturnType<typeof useFruitsIdNameQuery>;
export type FruitsIdNameLazyQueryHookResult = ReturnType<typeof useFruitsIdNameLazyQuery>;
export type FruitsIdNameQueryResult = Apollo.QueryResult<FruitsIdNameQuery, FruitsIdNameQueryVariables>;
export const SaveSaleDocument = gql`
    mutation saveSale($sale: SaleInput!) {
  sale(model: $sale) {
    id
    name
  }
}
    `;
export type SaveSaleMutationFn = Apollo.MutationFunction<SaveSaleMutation, SaveSaleMutationVariables>;

/**
 * __useSaveSaleMutation__
 *
 * To run a mutation, you first call `useSaveSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSaleMutation, { data, loading, error }] = useSaveSaleMutation({
 *   variables: {
 *      sale: // value for 'sale'
 *   },
 * });
 */
export function useSaveSaleMutation(baseOptions?: Apollo.MutationHookOptions<SaveSaleMutation, SaveSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSaleMutation, SaveSaleMutationVariables>(SaveSaleDocument, options);
      }
export type SaveSaleMutationHookResult = ReturnType<typeof useSaveSaleMutation>;
export type SaveSaleMutationResult = Apollo.MutationResult<SaveSaleMutation>;
export type SaveSaleMutationOptions = Apollo.BaseMutationOptions<SaveSaleMutation, SaveSaleMutationVariables>;
export const DeleteSaleDocument = gql`
    mutation DeleteSale($id: Int, $where: SaleFilterInput) {
  saleDelete(id: $id, where: $where)
}
    `;
export type DeleteSaleMutationFn = Apollo.MutationFunction<DeleteSaleMutation, DeleteSaleMutationVariables>;

/**
 * __useDeleteSaleMutation__
 *
 * To run a mutation, you first call `useDeleteSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSaleMutation, { data, loading, error }] = useDeleteSaleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteSaleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSaleMutation, DeleteSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSaleMutation, DeleteSaleMutationVariables>(DeleteSaleDocument, options);
      }
export type DeleteSaleMutationHookResult = ReturnType<typeof useDeleteSaleMutation>;
export type DeleteSaleMutationResult = Apollo.MutationResult<DeleteSaleMutation>;
export type DeleteSaleMutationOptions = Apollo.BaseMutationOptions<DeleteSaleMutation, DeleteSaleMutationVariables>;
export const SaleTemplateDocument = gql`
    mutation SaleTemplate($saleTemplate: SaleTemplateInput!) {
  saleTemplate(model: $saleTemplate) {
    id
    name
  }
}
    `;
export type SaleTemplateMutationFn = Apollo.MutationFunction<SaleTemplateMutation, SaleTemplateMutationVariables>;

/**
 * __useSaleTemplateMutation__
 *
 * To run a mutation, you first call `useSaleTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaleTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saleTemplateMutation, { data, loading, error }] = useSaleTemplateMutation({
 *   variables: {
 *      saleTemplate: // value for 'saleTemplate'
 *   },
 * });
 */
export function useSaleTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SaleTemplateMutation, SaleTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaleTemplateMutation, SaleTemplateMutationVariables>(SaleTemplateDocument, options);
      }
export type SaleTemplateMutationHookResult = ReturnType<typeof useSaleTemplateMutation>;
export type SaleTemplateMutationResult = Apollo.MutationResult<SaleTemplateMutation>;
export type SaleTemplateMutationOptions = Apollo.BaseMutationOptions<SaleTemplateMutation, SaleTemplateMutationVariables>;
export const SaleDatalistDocument = gql`
    query saleDatalist($where: SaleFilterInput, $order: [SaleSortInput!], $take: Int, $skip: Int) {
  sales {
    items(order: $order, skip: $skip, take: $take, where: $where) {
      id
      type
      person {
        id
        name
      }
      wallet {
        id
        name
        balance
        archived
      }
      fruit {
        id
        name
      }
      season {
        id
        name
      }
      kg
      pricePerKg
      total
      date
      category {
        name
        id
      }
      cartQuantity
      chamber
    }
    count(where: $where)
  }
}
    `;

/**
 * __useSaleDatalistQuery__
 *
 * To run a query within a React component, call `useSaleDatalistQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaleDatalistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaleDatalistQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useSaleDatalistQuery(baseOptions?: Apollo.QueryHookOptions<SaleDatalistQuery, SaleDatalistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaleDatalistQuery, SaleDatalistQueryVariables>(SaleDatalistDocument, options);
      }
export function useSaleDatalistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaleDatalistQuery, SaleDatalistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaleDatalistQuery, SaleDatalistQueryVariables>(SaleDatalistDocument, options);
        }
export type SaleDatalistQueryHookResult = ReturnType<typeof useSaleDatalistQuery>;
export type SaleDatalistLazyQueryHookResult = ReturnType<typeof useSaleDatalistLazyQuery>;
export type SaleDatalistQueryResult = Apollo.QueryResult<SaleDatalistQuery, SaleDatalistQueryVariables>;
export const SaleDatalistAndTotalDocument = gql`
    query saleDatalistAndTotal($where: SaleFilterInput, $order: [SaleSortInput!], $take: Int, $skip: Int) {
  sales {
    items(order: $order, skip: $skip, take: $take, where: $where) {
      id
      type
      person {
        id
        name
      }
      wallet {
        id
        name
        balance
        archived
      }
      fruit {
        id
        name
      }
      season {
        id
        name
      }
      kg
      pricePerKg
      total
      date
      category {
        name
        id
      }
      cartQuantity
      chamber
    }
    totalSum(order: $order, where: $where)
    kgSum(order: $order, where: $where)
    pricePerKgAverage(order: $order, where: $where)
    cartQuantitySum(order: $order, where: $where)
    count(where: $where)
  }
}
    `;

/**
 * __useSaleDatalistAndTotalQuery__
 *
 * To run a query within a React component, call `useSaleDatalistAndTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaleDatalistAndTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaleDatalistAndTotalQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useSaleDatalistAndTotalQuery(baseOptions?: Apollo.QueryHookOptions<SaleDatalistAndTotalQuery, SaleDatalistAndTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaleDatalistAndTotalQuery, SaleDatalistAndTotalQueryVariables>(SaleDatalistAndTotalDocument, options);
      }
export function useSaleDatalistAndTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaleDatalistAndTotalQuery, SaleDatalistAndTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaleDatalistAndTotalQuery, SaleDatalistAndTotalQueryVariables>(SaleDatalistAndTotalDocument, options);
        }
export type SaleDatalistAndTotalQueryHookResult = ReturnType<typeof useSaleDatalistAndTotalQuery>;
export type SaleDatalistAndTotalLazyQueryHookResult = ReturnType<typeof useSaleDatalistAndTotalLazyQuery>;
export type SaleDatalistAndTotalQueryResult = Apollo.QueryResult<SaleDatalistAndTotalQuery, SaleDatalistAndTotalQueryVariables>;
export const DeleteSaleTemplateDocument = gql`
    mutation DeleteSaleTemplate($id: Int, $where: SaleTemplateFilterInput) {
  saleTemplateDelete(id: $id, where: $where)
}
    `;
export type DeleteSaleTemplateMutationFn = Apollo.MutationFunction<DeleteSaleTemplateMutation, DeleteSaleTemplateMutationVariables>;

/**
 * __useDeleteSaleTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteSaleTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSaleTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSaleTemplateMutation, { data, loading, error }] = useDeleteSaleTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteSaleTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSaleTemplateMutation, DeleteSaleTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSaleTemplateMutation, DeleteSaleTemplateMutationVariables>(DeleteSaleTemplateDocument, options);
      }
export type DeleteSaleTemplateMutationHookResult = ReturnType<typeof useDeleteSaleTemplateMutation>;
export type DeleteSaleTemplateMutationResult = Apollo.MutationResult<DeleteSaleTemplateMutation>;
export type DeleteSaleTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteSaleTemplateMutation, DeleteSaleTemplateMutationVariables>;
export const SaleMultiUpdateDocument = gql`
    mutation SaleMultiUpdate($data: [SaleMultiUpdateInput!]!) {
  saleMultiUpdate(sales: $data)
}
    `;
export type SaleMultiUpdateMutationFn = Apollo.MutationFunction<SaleMultiUpdateMutation, SaleMultiUpdateMutationVariables>;

/**
 * __useSaleMultiUpdateMutation__
 *
 * To run a mutation, you first call `useSaleMultiUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaleMultiUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saleMultiUpdateMutation, { data, loading, error }] = useSaleMultiUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaleMultiUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SaleMultiUpdateMutation, SaleMultiUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaleMultiUpdateMutation, SaleMultiUpdateMutationVariables>(SaleMultiUpdateDocument, options);
      }
export type SaleMultiUpdateMutationHookResult = ReturnType<typeof useSaleMultiUpdateMutation>;
export type SaleMultiUpdateMutationResult = Apollo.MutationResult<SaleMultiUpdateMutation>;
export type SaleMultiUpdateMutationOptions = Apollo.BaseMutationOptions<SaleMultiUpdateMutation, SaleMultiUpdateMutationVariables>;
export const PersonDocument = gql`
    query person($id: Int) {
  person(where: {id: {eq: $id}}) {
    id
    name
    note
    contactInfo {
      items {
        value
        link
        name
        id
        personId
      }
    }
    tags {
      items {
        id
        tag {
          id
          name
        }
      }
    }
    countryCode
    country {
      alpha3Code
      name
      flag
    }
  }
}
    `;

/**
 * __usePersonQuery__
 *
 * To run a query within a React component, call `usePersonQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePersonQuery(baseOptions?: Apollo.QueryHookOptions<PersonQuery, PersonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonQuery, PersonQueryVariables>(PersonDocument, options);
      }
export function usePersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonQuery, PersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonQuery, PersonQueryVariables>(PersonDocument, options);
        }
export type PersonQueryHookResult = ReturnType<typeof usePersonQuery>;
export type PersonLazyQueryHookResult = ReturnType<typeof usePersonLazyQuery>;
export type PersonQueryResult = Apollo.QueryResult<PersonQuery, PersonQueryVariables>;
export const PersonListInfoDocument = gql`
    query personListInfo($where: PersonFilterInput, $skip: Int, $take: Int, $order: [PersonSortInput!]) {
  people {
    items(where: $where, take: $take, skip: $skip, order: $order) {
      id
      name
      note
      contactInfo {
        items {
          value
          name
          id
          link
        }
      }
      tags {
        items {
          id
          tag {
            id
            name
          }
        }
      }
      countryCode
      country {
        alpha3Code
        name
        flag
      }
    }
    count(where: $where)
  }
}
    `;

/**
 * __usePersonListInfoQuery__
 *
 * To run a query within a React component, call `usePersonListInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonListInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonListInfoQuery({
 *   variables: {
 *      where: // value for 'where'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePersonListInfoQuery(baseOptions?: Apollo.QueryHookOptions<PersonListInfoQuery, PersonListInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonListInfoQuery, PersonListInfoQueryVariables>(PersonListInfoDocument, options);
      }
export function usePersonListInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonListInfoQuery, PersonListInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonListInfoQuery, PersonListInfoQueryVariables>(PersonListInfoDocument, options);
        }
export type PersonListInfoQueryHookResult = ReturnType<typeof usePersonListInfoQuery>;
export type PersonListInfoLazyQueryHookResult = ReturnType<typeof usePersonListInfoLazyQuery>;
export type PersonListInfoQueryResult = Apollo.QueryResult<PersonListInfoQuery, PersonListInfoQueryVariables>;
export const DeletePersonDocument = gql`
    mutation DeletePerson($id: Int, $where: PersonFilterInput) {
  personDelete(id: $id, where: $where)
}
    `;
export type DeletePersonMutationFn = Apollo.MutationFunction<DeletePersonMutation, DeletePersonMutationVariables>;

/**
 * __useDeletePersonMutation__
 *
 * To run a mutation, you first call `useDeletePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonMutation, { data, loading, error }] = useDeletePersonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeletePersonMutation(baseOptions?: Apollo.MutationHookOptions<DeletePersonMutation, DeletePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePersonMutation, DeletePersonMutationVariables>(DeletePersonDocument, options);
      }
export type DeletePersonMutationHookResult = ReturnType<typeof useDeletePersonMutation>;
export type DeletePersonMutationResult = Apollo.MutationResult<DeletePersonMutation>;
export type DeletePersonMutationOptions = Apollo.BaseMutationOptions<DeletePersonMutation, DeletePersonMutationVariables>;
export const SavePersonDocument = gql`
    mutation savePerson($person: PersonInput!) {
  person(model: $person) {
    id
    name
    note
    contactInfo {
      items {
        value
        link
        name
        id
        personId
      }
    }
    countryCode
  }
}
    `;
export type SavePersonMutationFn = Apollo.MutationFunction<SavePersonMutation, SavePersonMutationVariables>;

/**
 * __useSavePersonMutation__
 *
 * To run a mutation, you first call `useSavePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePersonMutation, { data, loading, error }] = useSavePersonMutation({
 *   variables: {
 *      person: // value for 'person'
 *   },
 * });
 */
export function useSavePersonMutation(baseOptions?: Apollo.MutationHookOptions<SavePersonMutation, SavePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePersonMutation, SavePersonMutationVariables>(SavePersonDocument, options);
      }
export type SavePersonMutationHookResult = ReturnType<typeof useSavePersonMutation>;
export type SavePersonMutationResult = Apollo.MutationResult<SavePersonMutation>;
export type SavePersonMutationOptions = Apollo.BaseMutationOptions<SavePersonMutation, SavePersonMutationVariables>;
export const TagDocument = gql`
    mutation Tag($model: PersonTagInput!) {
  personTag(model: $model) {
    id
  }
}
    `;
export type TagMutationFn = Apollo.MutationFunction<TagMutation, TagMutationVariables>;

/**
 * __useTagMutation__
 *
 * To run a mutation, you first call `useTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagMutation, { data, loading, error }] = useTagMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useTagMutation(baseOptions?: Apollo.MutationHookOptions<TagMutation, TagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagMutation, TagMutationVariables>(TagDocument, options);
      }
export type TagMutationHookResult = ReturnType<typeof useTagMutation>;
export type TagMutationResult = Apollo.MutationResult<TagMutation>;
export type TagMutationOptions = Apollo.BaseMutationOptions<TagMutation, TagMutationVariables>;
export const DeletePersonTagDocument = gql`
    mutation DeletePersonTag($id: Int, $where: PersonTagFilterInput) {
  personTagDelete(id: $id, where: $where)
}
    `;
export type DeletePersonTagMutationFn = Apollo.MutationFunction<DeletePersonTagMutation, DeletePersonTagMutationVariables>;

/**
 * __useDeletePersonTagMutation__
 *
 * To run a mutation, you first call `useDeletePersonTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonTagMutation, { data, loading, error }] = useDeletePersonTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeletePersonTagMutation(baseOptions?: Apollo.MutationHookOptions<DeletePersonTagMutation, DeletePersonTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePersonTagMutation, DeletePersonTagMutationVariables>(DeletePersonTagDocument, options);
      }
export type DeletePersonTagMutationHookResult = ReturnType<typeof useDeletePersonTagMutation>;
export type DeletePersonTagMutationResult = Apollo.MutationResult<DeletePersonTagMutation>;
export type DeletePersonTagMutationOptions = Apollo.BaseMutationOptions<DeletePersonTagMutation, DeletePersonTagMutationVariables>;
export const GetPersonTagDocument = gql`
    query GetPersonTag($id: Int, $where: PersonTagFilterInput) {
  personTag(id: $id, where: $where) {
    name
    id
  }
}
    `;

/**
 * __useGetPersonTagQuery__
 *
 * To run a query within a React component, call `useGetPersonTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPersonTagQuery(baseOptions?: Apollo.QueryHookOptions<GetPersonTagQuery, GetPersonTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonTagQuery, GetPersonTagQueryVariables>(GetPersonTagDocument, options);
      }
export function useGetPersonTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonTagQuery, GetPersonTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonTagQuery, GetPersonTagQueryVariables>(GetPersonTagDocument, options);
        }
export type GetPersonTagQueryHookResult = ReturnType<typeof useGetPersonTagQuery>;
export type GetPersonTagLazyQueryHookResult = ReturnType<typeof useGetPersonTagLazyQuery>;
export type GetPersonTagQueryResult = Apollo.QueryResult<GetPersonTagQuery, GetPersonTagQueryVariables>;
export const SeasonItemDocument = gql`
    query seasonItem($id: Int) {
  season(where: {id: {eq: $id}}) {
    name
    id
    active
  }
}
    `;

/**
 * __useSeasonItemQuery__
 *
 * To run a query within a React component, call `useSeasonItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeasonItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeasonItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSeasonItemQuery(baseOptions?: Apollo.QueryHookOptions<SeasonItemQuery, SeasonItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeasonItemQuery, SeasonItemQueryVariables>(SeasonItemDocument, options);
      }
export function useSeasonItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeasonItemQuery, SeasonItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeasonItemQuery, SeasonItemQueryVariables>(SeasonItemDocument, options);
        }
export type SeasonItemQueryHookResult = ReturnType<typeof useSeasonItemQuery>;
export type SeasonItemLazyQueryHookResult = ReturnType<typeof useSeasonItemLazyQuery>;
export type SeasonItemQueryResult = Apollo.QueryResult<SeasonItemQuery, SeasonItemQueryVariables>;
export const SeasonListInfoDocument = gql`
    query seasonListInfo($where: SeasonFilterInput, $take: Int, $skip: Int, $order: [SeasonSortInput!]) {
  seasons {
    items(order: $order, skip: $skip, take: $take, where: $where) {
      id
      name
      active
    }
    count(where: $where)
  }
}
    `;

/**
 * __useSeasonListInfoQuery__
 *
 * To run a query within a React component, call `useSeasonListInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeasonListInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeasonListInfoQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSeasonListInfoQuery(baseOptions?: Apollo.QueryHookOptions<SeasonListInfoQuery, SeasonListInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeasonListInfoQuery, SeasonListInfoQueryVariables>(SeasonListInfoDocument, options);
      }
export function useSeasonListInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeasonListInfoQuery, SeasonListInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeasonListInfoQuery, SeasonListInfoQueryVariables>(SeasonListInfoDocument, options);
        }
export type SeasonListInfoQueryHookResult = ReturnType<typeof useSeasonListInfoQuery>;
export type SeasonListInfoLazyQueryHookResult = ReturnType<typeof useSeasonListInfoLazyQuery>;
export type SeasonListInfoQueryResult = Apollo.QueryResult<SeasonListInfoQuery, SeasonListInfoQueryVariables>;
export const DeleteHarvestsAgricultureWorkTemplateDocument = gql`
    mutation DeleteHarvestsAgricultureWorkTemplate($id: Int, $where: HarvestAgricultureWorkFilterInput) {
  harvestAgricultureWorkDelete(where: $where, id: $id)
}
    `;
export type DeleteHarvestsAgricultureWorkTemplateMutationFn = Apollo.MutationFunction<DeleteHarvestsAgricultureWorkTemplateMutation, DeleteHarvestsAgricultureWorkTemplateMutationVariables>;

/**
 * __useDeleteHarvestsAgricultureWorkTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteHarvestsAgricultureWorkTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHarvestsAgricultureWorkTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHarvestsAgricultureWorkTemplateMutation, { data, loading, error }] = useDeleteHarvestsAgricultureWorkTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteHarvestsAgricultureWorkTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHarvestsAgricultureWorkTemplateMutation, DeleteHarvestsAgricultureWorkTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHarvestsAgricultureWorkTemplateMutation, DeleteHarvestsAgricultureWorkTemplateMutationVariables>(DeleteHarvestsAgricultureWorkTemplateDocument, options);
      }
export type DeleteHarvestsAgricultureWorkTemplateMutationHookResult = ReturnType<typeof useDeleteHarvestsAgricultureWorkTemplateMutation>;
export type DeleteHarvestsAgricultureWorkTemplateMutationResult = Apollo.MutationResult<DeleteHarvestsAgricultureWorkTemplateMutation>;
export type DeleteHarvestsAgricultureWorkTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteHarvestsAgricultureWorkTemplateMutation, DeleteHarvestsAgricultureWorkTemplateMutationVariables>;
export const UserDatalistDocument = gql`
    query UserDatalist($skip: Int, $take: Int, $where: UserFilterInput, $order: [UserSortInput!]) {
  users {
    items(order: $order, skip: $skip, take: $take, where: $where) {
      name
      username
      status
      id
    }
    count(where: $where)
  }
}
    `;

/**
 * __useUserDatalistQuery__
 *
 * To run a query within a React component, call `useUserDatalistQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDatalistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDatalistQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserDatalistQuery(baseOptions?: Apollo.QueryHookOptions<UserDatalistQuery, UserDatalistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDatalistQuery, UserDatalistQueryVariables>(UserDatalistDocument, options);
      }
export function useUserDatalistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDatalistQuery, UserDatalistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDatalistQuery, UserDatalistQueryVariables>(UserDatalistDocument, options);
        }
export type UserDatalistQueryHookResult = ReturnType<typeof useUserDatalistQuery>;
export type UserDatalistLazyQueryHookResult = ReturnType<typeof useUserDatalistLazyQuery>;
export type UserDatalistQueryResult = Apollo.QueryResult<UserDatalistQuery, UserDatalistQueryVariables>;
export const UserViewDocument = gql`
    query UserView($id: Int, $where: UserFilterInput, $order: [UserSortInput!]) {
  user(order: $order, id: $id, where: $where) {
    id
    name
    username
    status
    roles {
      items {
        role
        id
      }
    }
    authData {
      items {
        id
        provider
        identifier
      }
    }
  }
}
    `;

/**
 * __useUserViewQuery__
 *
 * To run a query within a React component, call `useUserViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserViewQuery(baseOptions?: Apollo.QueryHookOptions<UserViewQuery, UserViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserViewQuery, UserViewQueryVariables>(UserViewDocument, options);
      }
export function useUserViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserViewQuery, UserViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserViewQuery, UserViewQueryVariables>(UserViewDocument, options);
        }
export type UserViewQueryHookResult = ReturnType<typeof useUserViewQuery>;
export type UserViewLazyQueryHookResult = ReturnType<typeof useUserViewLazyQuery>;
export type UserViewQueryResult = Apollo.QueryResult<UserViewQuery, UserViewQueryVariables>;
export const AllRolesDocument = gql`
    query AllRoles {
  allRoles
}
    `;

/**
 * __useAllRolesQuery__
 *
 * To run a query within a React component, call `useAllRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllRolesQuery(baseOptions?: Apollo.QueryHookOptions<AllRolesQuery, AllRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllRolesQuery, AllRolesQueryVariables>(AllRolesDocument, options);
      }
export function useAllRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllRolesQuery, AllRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllRolesQuery, AllRolesQueryVariables>(AllRolesDocument, options);
        }
export type AllRolesQueryHookResult = ReturnType<typeof useAllRolesQuery>;
export type AllRolesLazyQueryHookResult = ReturnType<typeof useAllRolesLazyQuery>;
export type AllRolesQueryResult = Apollo.QueryResult<AllRolesQuery, AllRolesQueryVariables>;
export const UserFormDocument = gql`
    query userForm($id: Int!, $where: UserFilterInput, $order: [UserSortInput!]) {
  allRoles
  user(id: $id, where: $where, order: $order) {
    id
    username
    name
    status
    roles {
      items {
        id
        role
      }
    }
  }
}
    `;

/**
 * __useUserFormQuery__
 *
 * To run a query within a React component, call `useUserFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserFormQuery(baseOptions: Apollo.QueryHookOptions<UserFormQuery, UserFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFormQuery, UserFormQueryVariables>(UserFormDocument, options);
      }
export function useUserFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFormQuery, UserFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFormQuery, UserFormQueryVariables>(UserFormDocument, options);
        }
export type UserFormQueryHookResult = ReturnType<typeof useUserFormQuery>;
export type UserFormLazyQueryHookResult = ReturnType<typeof useUserFormLazyQuery>;
export type UserFormQueryResult = Apollo.QueryResult<UserFormQuery, UserFormQueryVariables>;